export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  ArrivalDisplayRegistrationKey: any;
  BigInt: number;
  CurrencyCodeISO4217: string;
  CustomResourceSubCategoryType: any;
  Date: string;
  DateTime: any;
  Decimal: string;
  DocumentBody: any;
  IANATimezone: any;
  IPAddress: any;
  IPAddressCIDR: any;
  ISO8601Duration: string;
  ISO8601Timestamp: any;
  ISO8601_Duration: any;
  ISODateTime: string;
  IsoDateOnlyString: any;
  IsoLocalTimeString: any;
  JSON: any;
  Json: any;
  LocalDate: string;
  LocalEndTime: string;
  LocalTime: any;
  Markdown: string;
  MimeType: any;
  QueryOrchestratorPlaceholder: any;
  TODO: any;
  Time: any;
  UUID: any;
  UUIDv4: any;
  UtcTime: string;
  Void: void;
  WorkflowEmail: any;
};

export type AbstractAnsweredTicketQuestionExpectingChoices = {
  choices: Array<AbstractTicketAnswerChoice>;
  question: AbstractTicketQuestionExpectingChoices;
};

export type AbstractTicketAnswerChoice = TicketAnswerMenuChoice | TicketQuestionOption;

export type AbstractTicketQuestionExpectingChoices = {
  chooseOnlyOneOption: Scalars['Boolean'];
  id: Scalars['ID'];
  options: Array<AbstractTicketQuestionOption>;
  prompt: Scalars['String'];
  required: Scalars['Boolean'];
};

export type AbstractTicketQuestionOption = {
  description?: Maybe<Scalars['Markdown']>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type AccessPassResolvedPlaces = Campus | Level | Location | Organization | Space;

export type AccessPlace = {
  __typename?: 'AccessPlace';
  id: Scalars['ID'];
  type: AccessPlaceType;
};

export const AccessPlaceType = {
  CAMPUS: 'CAMPUS',
  LEVEL: 'LEVEL',
  LOCATION: 'LOCATION',
  ORGANIZATION: 'ORGANIZATION',
  SPACE: 'SPACE'
} as const;

export type AccessPlaceType = typeof AccessPlaceType[keyof typeof AccessPlaceType];
export type AccountReservee = {
  __typename?: 'AccountReservee';
  email: Scalars['String'];
  participationStatus?: Maybe<ParticipationStatus>;
  user?: Maybe<AccountUser>;
  visitorId?: Maybe<Scalars['ID']>;
};

export type AccountUser = {
  __typename?: 'AccountUser';
  assignments?: Maybe<Array<Maybe<DraftDeskAssignmentSchedule>>>;
  avatar?: Maybe<Scalars['String']>;
  canAndShouldAskForPresencePermissionInMobile: CanAndShouldAskForPresencePermissionInMobileResponse;
  canSelfEdit?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['String']>;
  defaultLocation?: Maybe<Location>;
  department?: Maybe<Scalars['String']>;
  draftAccessLevel?: Maybe<DraftAccessLevel>;
  email?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  geofenceFeatureEnabled: Scalars['Boolean'];
  givenName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isMyFavorite?: Maybe<Scalars['Boolean']>;
  managerId?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  primaryEmail?: Maybe<Email>;
  reservationsAtLocationGroupedByDateAscending: Array<UserDeskReservationByDate>;
  slug?: Maybe<Scalars['String']>;
  timeZone?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  workingHours?: Maybe<Array<Maybe<UserWorkingHour>>>;
};


export type AccountUserAssignmentsArgs = {
  draftId: Scalars['ID'];
};


export type AccountUserDraftAccessLevelArgs = {
  draftId: Scalars['ID'];
};


export type AccountUserReservationsAtLocationGroupedByDateAscendingArgs = {
  endTime: Scalars['ISODateTime'];
  locationId: Scalars['ID'];
  startTime: Scalars['ISODateTime'];
};

export type ActivitiesByLocation = {
  __typename?: 'ActivitiesByLocation';
  activities: Array<ActivityForCurrentUser>;
  locationId?: Maybe<Scalars['String']>;
};

export type ActivitiesForDateByLocationIdsInput = {
  date: Scalars['LocalDate'];
  joinedLimit?: InputMaybe<Scalars['Int']>;
  locationIds: Array<Scalars['String']>;
  timezone: Scalars['String'];
};

export type ActivitiesForDateRangeByLocationIdsInput = {
  endDate: Scalars['LocalDate'];
  joinedLimit?: InputMaybe<Scalars['Int']>;
  locationIds: Array<Scalars['String']>;
  startDate: Scalars['LocalDate'];
  timezone: Scalars['String'];
};

export type ActivitiesForTimeRangeByLocationIdsInput = {
  end: Scalars['ISODateTime'];
  joinedLimit?: InputMaybe<Scalars['Int']>;
  locationIds: Array<Scalars['String']>;
  start: Scalars['ISODateTime'];
  timezone: Scalars['String'];
};

export type ActivitiesForTimeRangeByLocationIdsPagingInput = {
  activityLimitPerDay?: InputMaybe<Scalars['Int']>;
};

export type ActivityCoverImagesObject = {
  __typename?: 'ActivityCoverImagesObject';
  birthday: Scalars['String'];
  celebration: Scalars['String'];
  drinks: Scalars['String'];
  funAndGames: Scalars['String'];
  funAndMusic: Scalars['String'];
  gathering: Scalars['String'];
  holiday: Scalars['String'];
  lunch: Scalars['String'];
};

export type ActivityForCurrentUser = {
  __typename?: 'ActivityForCurrentUser';
  activityLocation?: Maybe<Scalars['String']>;
  audienceLocationId: Scalars['ID'];
  canceledAt?: Maybe<Scalars['String']>;
  coverImage?: Maybe<ActivityImage>;
  coverImageUrl?: Maybe<Scalars['String']>;
  creator: User;
  description?: Maybe<Scalars['String']>;
  end: Scalars['ISODateTime'];
  id: Scalars['ID'];
  joined: ActivityJoinersList;
  start: Scalars['ISODateTime'];
  timezone: Scalars['String'];
  title: Scalars['String'];
  userRelationship: ActivityUserRelationship;
  virtualLocation?: Maybe<Scalars['String']>;
};

export type ActivityImage = {
  __typename?: 'ActivityImage';
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  isBuiltIn: Scalars['Boolean'];
  name: Scalars['String'];
  url: Scalars['String'];
};

export type ActivityJoinersList = {
  __typename?: 'ActivityJoinersList';
  joiners: Array<User>;
  totalCount: Scalars['Int'];
};

export type ActivityUserRelationship = {
  __typename?: 'ActivityUserRelationship';
  canManage: Scalars['Boolean'];
  isAttending: Scalars['Boolean'];
};

export type AddLevelToLocationResponse = {
  __typename?: 'AddLevelToLocationResponse';
  id: Scalars['Int'];
};

export type AddLevelsToLocationResponse = {
  __typename?: 'AddLevelsToLocationResponse';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type AddLevelsWithDetailsToLocationResponse = {
  __typename?: 'AddLevelsWithDetailsToLocationResponse';
  id: Scalars['ID'];
  levelNumber?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type AddLocationToOrganizationResponse = {
  __typename?: 'AddLocationToOrganizationResponse';
  id: Scalars['Int'];
};

export type AddMeetingServiceErrorResponse = {
  __typename?: 'AddMeetingServiceErrorResponse';
  reason?: Maybe<AddMeetingServiceErrorResponseReason>;
};

export const AddMeetingServiceErrorResponseReason = {
  CATEGORY_MISSING: 'CATEGORY_MISSING',
  /** This meeting service has kind=SPACE_REQUEST_FORM, and one of the desired spaces already has a request form */
  SPACE_ALREADY_HAS_REQUEST_FORM: 'SPACE_ALREADY_HAS_REQUEST_FORM'
} as const;

export type AddMeetingServiceErrorResponseReason = typeof AddMeetingServiceErrorResponseReason[keyof typeof AddMeetingServiceErrorResponseReason];
export type AddMeetingServiceInput = {
  /** At least one user or group is required when kind is MEETING_SERVICE */
  assignees?: InputMaybe<UsersAndGroupsInput>;
  /** Provide one object per building, describing the spaces where this service is available. Must have permission to manage services in these buildings. */
  availableInSpacesByBuilding?: InputMaybe<Array<MeetingServiceAvailableInSpacesByBuildingInput>>;
  categoryId: Scalars['ID'];
  /** The currency for all monetary amounts in this service, like on menu item unitPrice. Required, but can be omitted for backwards compatibility. Clients should always pick a default currency, even if the logic is "always USD". */
  currencyCode?: InputMaybe<Scalars['CurrencyCodeISO4217']>;
  description?: InputMaybe<Scalars['Markdown']>;
  kind?: TicketWorkflowKind;
  /** The existence of approvers means approval is required before notifying assignees */
  multipleApprovers?: InputMaybe<UsersAndGroupsInput>;
  name: Scalars['String'];
  /** List of questions to ask when this service is requested, in order */
  questions: Array<TicketQuestionInput>;
};

export type AddMeetingServiceResponse = AddMeetingServiceErrorResponse | AddMeetingServiceSuccessResponse;

export type AddMeetingServiceSuccessResponse = {
  __typename?: 'AddMeetingServiceSuccessResponse';
  meetingServiceId: Scalars['ID'];
};

export const AddMeetingServicesCategoryErrorReason = {
  NAME_IS_NOT_UNIQUE: 'NAME_IS_NOT_UNIQUE'
} as const;

export type AddMeetingServicesCategoryErrorReason = typeof AddMeetingServicesCategoryErrorReason[keyof typeof AddMeetingServicesCategoryErrorReason];
export type AddMeetingServicesCategoryErrorResponse = {
  __typename?: 'AddMeetingServicesCategoryErrorResponse';
  reason: AddMeetingServicesCategoryErrorReason;
};

export type AddMeetingServicesCategoryInput = {
  /** 'CAT', 'TEC', etc. */
  key: Scalars['String'];
  /** Name must be unique in org among meeting services categories */
  name: Scalars['String'];
};

export type AddMeetingServicesCategoryResponse = AddMeetingServicesCategoryErrorResponse | AddMeetingServicesCategorySuccessResponse;

export type AddMeetingServicesCategorySuccessResponse = {
  __typename?: 'AddMeetingServicesCategorySuccessResponse';
  meetingServicesCategoryId: Scalars['ID'];
};

export type AddOrganizationResponse = {
  __typename?: 'AddOrganizationResponse';
  id: Scalars['Int'];
};

export type AddSpaceToEventRequest = {
  endTime: Scalars['Date'];
  eventId: Scalars['String'];
  spaceId: Scalars['String'];
  startTime: Scalars['Date'];
};

export type AllSchedules = {
  __typename?: 'AllSchedules';
  schedules?: Maybe<Array<Maybe<WeeklyScheduleResult>>>;
};

export type AllocateStickersToOrgByDisplayCodeRequest = {
  displayCodes: Array<Scalars['Int']>;
  orgId: Scalars['ID'];
};

export type AllocateStickersToOrgRequest = {
  orgId: Scalars['ID'];
  stickerIds: Array<Scalars['ID']>;
};

export type Amenity = {
  __typename?: 'Amenity';
  /** If the account ID is null, this means it's a global amenity and available to all orgs */
  accountId?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  name: Scalars['String'];
  ownerTypes: Array<OwnerType>;
  updatedAt: Scalars['Date'];
};

export type AmenitySelectionConfiguration = {
  isDeskAmenity: Scalars['Boolean'];
  isSpaceAmenity: Scalars['Boolean'];
};

/** Splitting away from Amenity to avoid breaking changes. This will resolve to a default if amenity is not found */
export type AmenityWithDefault = {
  __typename?: 'AmenityWithDefault';
  /** If the account ID is null, this means it's a global amenity and available to all orgs */
  accountId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  name: Scalars['String'];
  ownerTypes?: Maybe<Array<OwnerType>>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type AnalyticsAuthorizationResponse = {
  __typename?: 'AnalyticsAuthorizationResponse';
  token: Scalars['String'];
};

/** An Announcement is an office message created for given location(s) in an organization. It can be acknowledged by each user in a given org/location, and updated/archived by an admin(?). */
export type Announcement = {
  __typename?: 'Announcement';
  /** Datetime of when annoucnement was instantly archived */
  archivedAt?: Maybe<Scalars['Date']>;
  /** User that created the announcement */
  author: User;
  /** Current content of the announcement */
  content: Scalars['String'];
  /** Datetime of creation */
  createdAt: Scalars['Date'];
  /** Datetime of end of announcement */
  endAt?: Maybe<Scalars['Date']>;
  /** Unique identifier */
  id: Scalars['ID'];
  /** List of locations for which the announcement has been published */
  locations: Array<Maybe<Location>>;
  /** Display name */
  name: Scalars['String'];
  /** Standard or priority announcement */
  priorityStatus: AnnouncementPriorityStatus;
  /** Datetime of start of announcement */
  startAt: Scalars['Date'];
  /** Current status of the announcement */
  status: AnnouncementStatus;
};

/** Acknowledgement of an announcement for a user at a location. */
export type AnnouncementAcknowledgement = {
  __typename?: 'AnnouncementAcknowledgement';
  announcementId: Scalars['ID'];
  date: Scalars['ISODateTime'];
  id: Scalars['ID'];
  locationId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type AnnouncementCreateInput = {
  content: Scalars['String'];
  distributions?: InputMaybe<Array<DistributionInput>>;
  endAt?: InputMaybe<Scalars['ISODateTime']>;
  locations: Array<Scalars['ID']>;
  name: Scalars['String'];
  priorityStatus?: InputMaybe<AnnouncementPriorityStatus>;
  shouldSendPushNotification?: InputMaybe<Scalars['Boolean']>;
  startAt?: InputMaybe<Scalars['ISODateTime']>;
};

/** Each announcement distribution will represent a service the announcement is cross posted to along with its recipients. */
export type AnnouncementDistribution = {
  __typename?: 'AnnouncementDistribution';
  distributionService: DistributionService;
  id: Scalars['ID'];
  recipients: Array<DistributionRecipient>;
  sentAt?: Maybe<Scalars['Date']>;
};

/** Each announcement distribution for location will represent a service the announcement is cross posted to along with its recipients and the announcement with its location. */
export type AnnouncementDistributionForLocation = {
  __typename?: 'AnnouncementDistributionForLocation';
  announcement?: Maybe<AnnouncementForLocation>;
  distributionService: DistributionService;
  id: Scalars['ID'];
  recipients: Array<DistributionRecipient>;
  sentAt?: Maybe<Scalars['Date']>;
};

/** An Announcement within a context of a specific location. */
export type AnnouncementForLocation = {
  __typename?: 'AnnouncementForLocation';
  /** Datetime of when annoucnement was instantly archived */
  archivedAt?: Maybe<Scalars['Date']>;
  /** User that created the announcement */
  author: User;
  /** Current content of the announcement */
  content: Scalars['String'];
  /** Datetime of creation */
  createdAt: Scalars['Date'];
  /** Datetime of end of announcement */
  endAt?: Maybe<Scalars['Date']>;
  /** Unique identifier */
  id: Scalars['ID'];
  /** List of locations for which the announcement has been published */
  locations: Array<Maybe<Location>>;
  /** Display name */
  name: Scalars['String'];
  /** Standard or priority announcement */
  priorityStatus: AnnouncementPriorityStatus;
  /** Datetime of start of announcement */
  startAt: Scalars['Date'];
  /** Current status of the announcement */
  status: AnnouncementStatus;
  /** When the requesting user has first viewed the announcement at this location */
  viewedAt?: Maybe<Scalars['String']>;
};

export const AnnouncementPriorityStatus = {
  PRIORITY: 'PRIORITY',
  STANDARD: 'STANDARD'
} as const;

export type AnnouncementPriorityStatus = typeof AnnouncementPriorityStatus[keyof typeof AnnouncementPriorityStatus];
export const AnnouncementStatus = {
  ACTIVE: 'ACTIVE',
  ARCHIVED: 'ARCHIVED',
  SCHEDULED: 'SCHEDULED'
} as const;

export type AnnouncementStatus = typeof AnnouncementStatus[keyof typeof AnnouncementStatus];
export type AnnouncementUpdateInput = {
  content: Scalars['String'];
  endAt?: InputMaybe<Scalars['ISODateTime']>;
  locations: Array<Scalars['ID']>;
  name: Scalars['String'];
  startAt?: InputMaybe<Scalars['ISODateTime']>;
};

/** View of an announcement for a user at a location. */
export type AnnouncementView = {
  __typename?: 'AnnouncementView';
  announcementId: Scalars['ID'];
  date: Scalars['ISODateTime'];
  id: Scalars['ID'];
  locationId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type AnnouncementViewAcknowledgeCount = {
  __typename?: 'AnnouncementViewAcknowledgeCount';
  acknowledgeCount: Scalars['Int'];
  viewCount: Scalars['Int'];
};

export type AnnouncementViewAcknowledgeCountWithId = {
  __typename?: 'AnnouncementViewAcknowledgeCountWithId';
  acknowledgeCount: Scalars['Int'];
  id: Scalars['ID'];
  viewCount: Scalars['Int'];
};

export type AnonymityModeToggleInput = {
  organizationId: Scalars['ID'];
};

export type AnsweredTicketQuestion = {
  question: TicketQuestion;
};

export type AnsweredTicketQuestionExpectingChoices = AbstractAnsweredTicketQuestionExpectingChoices & AnsweredTicketQuestion & {
  __typename?: 'AnsweredTicketQuestionExpectingChoices';
  choices: Array<TicketQuestionOption>;
  question: TicketQuestionExpectingChoices;
};

export type AnsweredTicketQuestionExpectingFiles = AnsweredTicketQuestion & {
  __typename?: 'AnsweredTicketQuestionExpectingFiles';
  files: Array<TicketFile>;
  question: TicketQuestionExpectingFiles;
};

export type AnsweredTicketQuestionExpectingMenuChoices = AbstractAnsweredTicketQuestionExpectingChoices & AnsweredTicketQuestion & {
  __typename?: 'AnsweredTicketQuestionExpectingMenuChoices';
  choices: Array<TicketAnswerMenuChoice>;
  question: TicketQuestionExpectingMenuChoices;
  /** The total price for everything selected on this menu, after any surcharges/taxes. */
  totalPrice?: Maybe<Money>;
};

export type AnsweredTicketQuestionExpectingText = AnsweredTicketQuestion & {
  __typename?: 'AnsweredTicketQuestionExpectingText';
  answer: Scalars['String'];
  question: TicketQuestionExpectingText;
};

export type AnsweredTicketQuestionInput = {
  choices?: InputMaybe<TicketAnswerExpectingChoicesInput>;
  files?: InputMaybe<TicketAnswerExpectingFilesInput>;
  menuChoices?: InputMaybe<TicketAnswerExpectingMenuChoicesInput>;
  text?: InputMaybe<TicketAnswerExpectingTextInput>;
  /** Optional questions are allowed to omit their answers entirely, but this is useful if you want to remove an existing answer. */
  unanswered?: InputMaybe<UnansweredTicketQuestionInput>;
};

export type ApiOrganizationExternalAccount = {
  __typename?: 'ApiOrganizationExternalAccount';
  accessToken?: Maybe<Scalars['String']>;
  accountId: Scalars['ID'];
  domain?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  state?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type App = EventAuditLogActor & {
  __typename?: 'App';
  id: Scalars['ID'];
};

export const ApproveMeetingServiceRequestErrorReason = {
  CONFLICT: 'CONFLICT'
} as const;

export type ApproveMeetingServiceRequestErrorReason = typeof ApproveMeetingServiceRequestErrorReason[keyof typeof ApproveMeetingServiceRequestErrorReason];
export type ApproveMeetingServiceRequestErrorResponse = {
  __typename?: 'ApproveMeetingServiceRequestErrorResponse';
  reason: ApproveMeetingServiceRequestErrorReason;
};

export type ApproveMeetingServiceRequestInput = {
  latestChangeId: Scalars['ID'];
  meetingServiceRequestId: Scalars['ID'];
};

export type ApproveMeetingServiceRequestResponse = ApproveMeetingServiceRequestErrorResponse | ApproveMeetingServiceRequestSuccessResponse;

export type ApproveMeetingServiceRequestSuccessResponse = {
  __typename?: 'ApproveMeetingServiceRequestSuccessResponse';
  _?: Maybe<Scalars['Void']>;
};

export type ArrivalDisplay = {
  __typename?: 'ArrivalDisplay';
  /** @deprecated No longer supported */
  arrivalDisplayDeviceStatusReport?: Maybe<DeviceStatusReport>;
  badgePrinter?: Maybe<BadgePrinter>;
  /**
   * the device status of the associated badge printer
   * @deprecated No longer supported
   */
  badgePrinterDeviceStatusReport?: Maybe<DeviceStatusReport>;
  /** @deprecated prefer traversing tree to badge printer to get IP address */
  badgePrinterIPAddress: Scalars['String'];
  /** The date this arrival display was created */
  createdAt: Scalars['ISODateTime'];
  id: Scalars['ID'];
  isGuestImageCaptureEnabled: Scalars['Boolean'];
  isGuestSelfRegistrationEnabled: Scalars['Boolean'];
  /** The last time the device reported in */
  lastCheckinTime?: Maybe<Scalars['ISODateTime']>;
  /** location where display resides */
  location: Location;
  /** Name of this arrival display */
  name: Scalars['String'];
  /** True if the registration key has been consumed */
  registrationConsumed: Scalars['Boolean'];
  /** ISO datetime representing when the registration key was consumed */
  registrationConsumedAt?: Maybe<Scalars['ISODateTime']>;
  /** ISO datetime encoded expiration of the active device registration key */
  registrationExpiresAt?: Maybe<Scalars['ISODateTime']>;
  /** One-time registration key used to connect arrival display for first authentication, nullable */
  registrationKey?: Maybe<Scalars['ArrivalDisplayRegistrationKey']>;
};

export type ArrivalDisplayRegistrationResponse = {
  __typename?: 'ArrivalDisplayRegistrationResponse';
  authorization: DeviceAuthorizationResponse;
  certKey: Scalars['String'];
  device: ArrivalDisplay;
  id: Scalars['ID'];
};

export type ArrivalDisplayRescueResponse = {
  __typename?: 'ArrivalDisplayRescueResponse';
  authorization?: Maybe<DeviceAuthorizationResponse>;
  id: Scalars['ID'];
  isPaired: Scalars['Boolean'];
};

export type ArrivalDisplaySettings = {
  __typename?: 'ArrivalDisplaySettings';
  badgePrinterIPAddress: Scalars['String'];
  guestImageCaptureEnabled: Scalars['Boolean'];
  guestSelfRegistrationEnabled: Scalars['Boolean'];
};

export type AssignStickerRequest = {
  assignments: Array<StickerAssignmentInput>;
};

export type AssignStickerResponse = {
  __typename?: 'AssignStickerResponse';
  assignments: Array<StickerAssignment>;
};

export type AssignStickerToDeskByShortCodeRequest = {
  deskId: Scalars['Int'];
  stickerShortCode: Scalars['String'];
};

export type AssignStickerToDeskByShortCodeResponse = {
  __typename?: 'AssignStickerToDeskByShortCodeResponse';
  deskId: Scalars['Int'];
  stickerShortCode: Scalars['String'];
};

export type AssignedBookability = {
  __typename?: 'AssignedBookability';
  bookable?: Maybe<Scalars['Int']>;
  notBookable?: Maybe<Scalars['Int']>;
};

export type AssignedUser = {
  __typename?: 'AssignedUser';
  email?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

export type Assignee = {
  __typename?: 'Assignee';
  avatar?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type AssigneeInput = {
  email?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type Assignment = {
  __typename?: 'Assignment';
  assignee: Assignee;
  id?: Maybe<Scalars['ID']>;
  recurrence: Scalars['String'];
};

export type AssignmentData = {
  __typename?: 'AssignmentData';
  new?: Maybe<AssignmentState>;
  previous?: Maybe<AssignmentState>;
};

export type AssignmentInput = {
  assignee: AssigneeInput;
  recurrence: Scalars['String'];
};

export type AssignmentState = {
  __typename?: 'AssignmentState';
  id: Scalars['ID'];
  name: Scalars['String'];
  neighborhood?: Maybe<Scalars['String']>;
  recurrence: Scalars['String'];
  zone: Scalars['String'];
};

export type AuditUserObject = {
  __typename?: 'AuditUserObject';
  avatar?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export const AuthContextAccountUserRole = {
  ADMIN: 'ADMIN',
  MEMBER: 'MEMBER',
  OWNER: 'OWNER'
} as const;

export type AuthContextAccountUserRole = typeof AuthContextAccountUserRole[keyof typeof AuthContextAccountUserRole];
export const AuthContextAppScope = {
  BASIC_READ: 'BASIC_READ',
  BASIC_WRITE: 'BASIC_WRITE',
  PRIVILEGED: 'PRIVILEGED'
} as const;

export type AuthContextAppScope = typeof AuthContextAppScope[keyof typeof AuthContextAppScope];
export const AuthContextOrganizationScope = {
  BASIC_READ: 'BASIC_READ',
  BASIC_WRITE: 'BASIC_WRITE'
} as const;

export type AuthContextOrganizationScope = typeof AuthContextOrganizationScope[keyof typeof AuthContextOrganizationScope];
export type AuthMethod = {
  __typename?: 'AuthMethod';
  type: Scalars['String'];
  uri?: Maybe<Scalars['String']>;
};

export type AuthorizationResponse = {
  __typename?: 'AuthorizationResponse';
  bearerToken: Scalars['String'];
  id: Scalars['ID'];
  organizationId: Scalars['ID'];
  refreshToken: Scalars['String'];
  userId: Scalars['ID'];
};

export type AutoAllocateStickersToOrgRequest = {
  orgId: Scalars['ID'];
  quantity: Scalars['Int'];
  startingDisplayCode: Scalars['Int'];
};

export type AutoDeskBookingAttemptedResponseType = {
  __typename?: 'AutoDeskBookingAttemptedResponseType';
  autoDeskBookingAttemptFailed: Scalars['Boolean'];
  id: Scalars['ID'];
  localDate: Scalars['LocalDate'];
};

export type AutoDeskBookingInternalResponse = {
  __typename?: 'AutoDeskBookingInternalResponse';
  locationIds: Array<Scalars['ID']>;
  orgId: Scalars['ID'];
};

export type AutoDeskBookingOrgInput = {
  enabled: Scalars['Boolean'];
  locationIds: Array<InputMaybe<Scalars['String']>>;
};

export type AutoDeskBookingOrgResponse = {
  __typename?: 'AutoDeskBookingOrgResponse';
  enabled: Scalars['Boolean'];
  locationIds: Array<Scalars['String']>;
};

/** Auto desk booking run failure report */
export type AutoDeskBookingProcessFailureReportCommand = {
  /** Explanation of failure. Open field. Stack trace could also be provided. */
  failureBody: Scalars['String'];
  /** Code for convenient grouping of failures by type. Convention is entirely up to the client software. */
  failureCode: Scalars['String'];
};

export type AutoDeskBookingResponse = {
  __typename?: 'AutoDeskBookingResponse';
  autoDeskBooking: Scalars['Boolean'];
};

export type AutoDeskBookingScheduleResponse = {
  __typename?: 'AutoDeskBookingScheduleResponse';
  localDate: Scalars['LocalDate'];
  reservation?: Maybe<Reservation>;
};

/** Failed booking a user report */
export type AutoDeskBookingUserBatchFailureReportCommand = {
  /** Explanation of failure. Open field. Stack trace could also be provided. */
  failureBody: Scalars['String'];
  /** Code for convenient grouping of failures by type. Convention is entirely up to the client software. */
  failureCode: Scalars['String'];
  /** Date of attempted booking */
  localBookingDate: Scalars['LocalDate'];
  /** ID of failed booking location */
  locationId: Scalars['ID'];
  /** ID of organization */
  tenantId: Scalars['ID'];
  /** ID of user */
  userId: Scalars['ID'];
};

export const Availability = {
  /** Currently available */
  AVAILABLE: 'AVAILABLE',
  /** Resource has been booked */
  BOOKED: 'BOOKED',
  /** Resource marked as unavailable for booking */
  UNAVAILABLE: 'UNAVAILABLE',
  /** Resource marked as unknown due to desk inexistence */
  UNKNOWN: 'UNKNOWN'
} as const;

export type Availability = typeof Availability[keyof typeof Availability];
export type BadgeCsvUploadRow = {
  __typename?: 'BadgeCSVUploadRow';
  email: Scalars['String'];
  timestamp: Scalars['Int'];
};

export type BadgeCsvUploadStatusError = {
  __typename?: 'BadgeCSVUploadStatusError';
  reason: Scalars['String'];
  row?: Maybe<BadgeCsvUploadRow>;
};

export type BadgePrinter = {
  __typename?: 'BadgePrinter';
  arrivalDisplays?: Maybe<Array<Maybe<ArrivalDisplay>>>;
  /** The date this badge printer was created */
  createdAt: Scalars['ISODateTime'];
  id: Scalars['ID'];
  ipAddress: Scalars['String'];
  location: Location;
  /** Name of this badge printer */
  name: Scalars['String'];
};

export type BatchUnlinkKisiLocksFromRobinLevelsInput = {
  remoteLockIds: Array<Scalars['String']>;
};

export type BatchUnlinkKisiLocksFromRobinLevelsResponse = {
  __typename?: 'BatchUnlinkKisiLocksFromRobinLevelsResponse';
  uuid?: Maybe<Scalars['ID']>;
};

export type BatchUnlinkKisiLocksFromRobinLocationsInput = {
  remoteLockIds: Array<Scalars['String']>;
};

export type BatchUnlinkKisiLocksFromRobinLocationsResponse = {
  __typename?: 'BatchUnlinkKisiLocksFromRobinLocationsResponse';
  uuid?: Maybe<Scalars['ID']>;
};

export type BeginFileUploadsForTicketAnswerErrorResponse = {
  __typename?: 'BeginFileUploadsForTicketAnswerErrorResponse';
  _?: Maybe<Scalars['Void']>;
};

export type BeginFileUploadsForTicketAnswerInput = {
  /** List of files to request upload URLs for */
  files: Array<TicketFileUploadInput>;
  /** The ID of the question being answered */
  questionId: Scalars['ID'];
};

export type BeginFileUploadsForTicketAnswerResponse = BeginFileUploadsForTicketAnswerErrorResponse | BeginFileUploadsForTicketAnswerSuccessResponse;

export type BeginFileUploadsForTicketAnswerSuccessResponse = {
  __typename?: 'BeginFileUploadsForTicketAnswerSuccessResponse';
  destinations: Array<TicketFileUploadDestination>;
};

export type BookedSchedulingAggregateOfDesks = {
  __typename?: 'BookedSchedulingAggregateOfDesks';
  /** Total number of desks of type Assigned that are booked */
  deskAssignedBookedTotal: Scalars['Int'];
  /** Total number of booked desks */
  deskBookedTotal: Scalars['Int'];
  /** Total number of desks of type Hot that are booked */
  deskHotBookedTotal: Scalars['Int'];
  /** Total number of desks of type Hotel that are booked */
  deskHotelBookedTotal: Scalars['Int'];
  /** Total number of desks of type Shared that are booked */
  deskSharedBookedTotal: Scalars['Int'];
  /** Represents the end time window for assessed desk booking status */
  endTime: Scalars['Date'];
  /** Represents the start time window for assessed desk booking status */
  startTime: Scalars['Date'];
};

export const BookingPolicyType = {
  /** Indicate the desk may be indefinitely assigned to a particular user. */
  ASSIGNED: 'ASSIGNED',
  /** Indicate that the desk is available to be booked for short term use. */
  HOT: 'HOT',
  /** Indicate that the desk may be reserved for a defined period duration. */
  HOTELED: 'HOTELED',
  /** Indicate that the desk may be reverse hoteled on an excluded assigned reservation. */
  REVERSE_HOTEL: 'REVERSE_HOTEL',
  /** Indicate that more people can be assigned to a single desk. Only used in combination with either ASSIGNED or HOTELED types */
  SHARED: 'SHARED'
} as const;

export type BookingPolicyType = typeof BookingPolicyType[keyof typeof BookingPolicyType];
export const BookingStatus = {
  APPROVAL_REQUIRED: 'APPROVAL_REQUIRED',
  ASSIGNED: 'ASSIGNED',
  NON_RESERVABLE: 'NON_RESERVABLE',
  ON_DEMAND: 'ON_DEMAND',
  RESERVABLE: 'RESERVABLE'
} as const;

export type BookingStatus = typeof BookingStatus[keyof typeof BookingStatus];
export const BookingType = {
  APPROVAL_REQUIRED: 'APPROVAL_REQUIRED',
  ASSIGNED: 'ASSIGNED',
  NON_RESERVABLE: 'NON_RESERVABLE',
  ON_DEMAND: 'ON_DEMAND',
  RESERVABLE: 'RESERVABLE'
} as const;

export type BookingType = typeof BookingType[keyof typeof BookingType];
export type BookingWindowPolicy = {
  __typename?: 'BookingWindowPolicy';
  affectedGroups: Array<BookingWindowPolicyAffectedGroup>;
  affectedUsers: Array<BookingWindowPolicyAffectedUser>;
  defaultDuration: Scalars['ISO8601Duration'];
  id: Scalars['ID'];
  name: Scalars['String'];
  targets: Array<BookingWindowPolicyTarget>;
};

export type BookingWindowPolicyAffectedGroup = {
  __typename?: 'BookingWindowPolicyAffectedGroup';
  anchorDays: Array<DayOfWeek>;
  duration: Scalars['ISO8601Duration'];
  group: Group;
};

export type BookingWindowPolicyAffectedGroupInput = {
  anchorDays: Array<DayOfWeek>;
  duration: Scalars['ISO8601Duration'];
  id: Scalars['ID'];
};

export type BookingWindowPolicyAffectedUser = {
  __typename?: 'BookingWindowPolicyAffectedUser';
  anchorDays: Array<DayOfWeek>;
  duration: Scalars['ISO8601Duration'];
  user: AccountUser;
};

export type BookingWindowPolicyAffectedUserInput = {
  anchorDays: Array<DayOfWeek>;
  duration: Scalars['ISO8601Duration'];
  id: Scalars['ID'];
};

export type BookingWindowPolicyDefinitionInput = {
  affectedGroups: Array<BookingWindowPolicyAffectedGroupInput>;
  affectedUsers: Array<BookingWindowPolicyAffectedUserInput>;
  defaultDuration: Scalars['ISO8601Duration'];
  name: Scalars['String'];
  targets: Array<BookingWindowPolicyTargetInput>;
};

export type BookingWindowPolicyInfo = {
  __typename?: 'BookingWindowPolicyInfo';
  defaultAnchorDays?: Maybe<Array<Maybe<DayOfWeek>>>;
  defaultDuration?: Maybe<Scalars['String']>;
  policyAnchorDays?: Maybe<Array<Maybe<DayOfWeek>>>;
  policyDuration?: Maybe<Scalars['String']>;
};

export type BookingWindowPolicyTarget = Level | Zone;

export type BookingWindowPolicyTargetInput = {
  id: Scalars['ID'];
  type: BookingWindowPolicyTargetType;
};

export const BookingWindowPolicyTargetType = {
  LEVEL: 'LEVEL',
  ZONE: 'ZONE'
} as const;

export type BookingWindowPolicyTargetType = typeof BookingWindowPolicyTargetType[keyof typeof BookingWindowPolicyTargetType];
export const BrivoTenancy = {
  EU: 'EU',
  US: 'US'
} as const;

export type BrivoTenancy = typeof BrivoTenancy[keyof typeof BrivoTenancy];
export type Building = {
  __typename?: 'Building';
  id: Scalars['ID'];
  label: Scalars['String'];
};

export type BuildingGeofence = {
  __typename?: 'BuildingGeofence';
  buildingId: Scalars['ID'];
  geojson: BuildingGeofenceGeoJson;
  id: Scalars['ID'];
};

export type BuildingGeofenceGeoJson = {
  __typename?: 'BuildingGeofenceGeoJSON';
  geometry: BuildingGeofenceGeoJsonGeometry;
  id: Scalars['ID'];
  properties: BuildingGeofenceGeoJsonProperties;
  type: GeoJsonType;
};

export type BuildingGeofenceGeoJsonGeometry = {
  __typename?: 'BuildingGeofenceGeoJSONGeometry';
  coordinates: Array<Scalars['Float']>;
  type: BuildingGeofenceGeoJsonGeometryType;
};

export const BuildingGeofenceGeoJsonGeometryType = {
  POINT: 'Point'
} as const;

export type BuildingGeofenceGeoJsonGeometryType = typeof BuildingGeofenceGeoJsonGeometryType[keyof typeof BuildingGeofenceGeoJsonGeometryType];
export type BuildingGeofenceGeoJsonProperties = {
  __typename?: 'BuildingGeofenceGeoJSONProperties';
  id: Scalars['ID'];
  radius: Scalars['Float'];
};

/** Response for a single reservation in bulk confirmation */
export type BulkResourceReservationConfirmationItem = {
  __typename?: 'BulkResourceReservationConfirmationItem';
  reservationId: Scalars['ID'];
  result: ResourceReservationConfirmationResponse;
};

/** Response for bulk reservation confirmation */
export type BulkResourceReservationConfirmationResponse = {
  __typename?: 'BulkResourceReservationConfirmationResponse';
  /** Results for each reservation confirmation attempt */
  confirmations: Array<BulkResourceReservationConfirmationItem>;
  /** Number of failed confirmations */
  failureCount: Scalars['Int'];
  /** Number of successful confirmations */
  successCount: Scalars['Int'];
  /** Total number of reservations processed */
  totalProcessed: Scalars['Int'];
};

export type ByWeekDayValue = {
  offset?: InputMaybe<Scalars['Int']>;
  weekday: RecurringReservationDayOfWeek;
};

export type Calendar = {
  __typename?: 'Calendar';
  calendarId: Scalars['String'];
  createdAt?: Maybe<Scalars['Date']>;
  remoteType: Scalars['String'];
  spaceId: Scalars['ID'];
  spaceResourceEmail?: Maybe<Scalars['String']>;
  spaceResourceId?: Maybe<Scalars['String']>;
  subscriberExpiresAt?: Maybe<Scalars['Date']>;
  subscriberId?: Maybe<Scalars['String']>;
  syncToken?: Maybe<Scalars['String']>;
};

export const CalendarHealthEnum = {
  /** Calendar is functioning correctly */
  HEALTHY: 'HEALTHY',
  /** Calendar has sync or other issues */
  UNHEALTHY: 'UNHEALTHY'
} as const;

export type CalendarHealthEnum = typeof CalendarHealthEnum[keyof typeof CalendarHealthEnum];
export type Campus = {
  __typename?: 'Campus';
  /** Total desks on the floor - excluding inactive. */
  activeDeskCount?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Date'];
  /** Total desks within the campus that fit within various scheduling type and status buckets */
  deskSchedulingAggregates: SchedulingAggregateOfDesks;
  id: Scalars['ID'];
  locations: Array<Location>;
  name: Scalars['String'];
  /** @deprecated Use `activeDeskCount` instead */
  totalDesks: Scalars['Int'];
  updatedAt: Scalars['Date'];
};

export type CancelResourceReservationCompleteCancelResponseType = {
  __typename?: 'CancelResourceReservationCompleteCancelResponseType';
  /** eventType is null when no state is updated but result is still successful */
  eventType?: Maybe<Scalars['ID']>;
  reservationId: Scalars['ID'];
  /** value is -1 when no state is updated but result is still successful */
  value: Scalars['Int'];
};

export type CancelledVisitOrReservationResult = {
  __typename?: 'CancelledVisitOrReservationResult';
  error?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  success: Scalars['Boolean'];
};

export const ChangeAnswersOnMeetingServiceRequestErrorReason = {
  CONFLICT: 'CONFLICT'
} as const;

export type ChangeAnswersOnMeetingServiceRequestErrorReason = typeof ChangeAnswersOnMeetingServiceRequestErrorReason[keyof typeof ChangeAnswersOnMeetingServiceRequestErrorReason];
export type ChangeAnswersOnMeetingServiceRequestErrorResponse = {
  __typename?: 'ChangeAnswersOnMeetingServiceRequestErrorResponse';
  reason: ChangeAnswersOnMeetingServiceRequestErrorReason;
};

export type ChangeAnswersOnMeetingServiceRequestInput = {
  /** The answers to the questions on the MeetingService, like in RequestMeetingServiceForDraftEventAtSpaceInput. Supports partial updates by omitting answers, but it's fine to include unchanged answers. */
  answers: Array<AnsweredTicketQuestionInput>;
  meetingServiceRequestId: Scalars['ID'];
  /** The completed form ID before any changes - for concurrency control. If there was no completed form due to lack of answers, pass in null. Omitting this field is an error. */
  previousCompletedFormId?: InputMaybe<Scalars['ID']>;
};

export type ChangeAnswersOnMeetingServiceRequestResponse = ChangeAnswersOnMeetingServiceRequestErrorResponse | ChangeAnswersOnMeetingServiceRequestSuccessResponse;

/** Clients should refetch affected service request to get the latest data */
export type ChangeAnswersOnMeetingServiceRequestSuccessResponse = {
  __typename?: 'ChangeAnswersOnMeetingServiceRequestSuccessResponse';
  _?: Maybe<Scalars['Void']>;
};

export type ChangeBrivoLockLinksInput = {
  locks: Array<ChangeBrivoLockLinksInputLocks>;
};

export type ChangeBrivoLockLinksInputLocks = {
  remoteLockId: Scalars['ID'];
  robinLevelId?: InputMaybe<Scalars['Int']>;
  robinLocationId?: InputMaybe<Scalars['Int']>;
};

export type ChangeBrivoLockLinksResponse = {
  __typename?: 'ChangeBrivoLockLinksResponse';
  uuid: Scalars['ID'];
};

export type ChangeGallagherDoorLinksForIntegrationInput = {
  doors: Array<ChangeGallagherDoorLinksForIntegrationInputDoors>;
};

export type ChangeGallagherDoorLinksForIntegrationInputDoors = {
  remoteDoorId: Scalars['ID'];
  robinLevelId?: InputMaybe<Scalars['Int']>;
  robinLocationId?: InputMaybe<Scalars['Int']>;
};

export type ChangeGallagherDoorLinksForIntegrationResponse = {
  __typename?: 'ChangeGallagherDoorLinksForIntegrationResponse';
  uuid: Scalars['ID'];
};

export type ChangeGeneaDoorLinksInput = {
  doors: Array<ChangeGeneaDoorLinksInputLocks>;
};

export type ChangeGeneaDoorLinksInputLocks = {
  remoteDoorId: Scalars['ID'];
  robinLevelId?: InputMaybe<Scalars['Int']>;
  robinLocationId?: InputMaybe<Scalars['Int']>;
};

export type ChangeGeneaLockLinksResponse = {
  __typename?: 'ChangeGeneaLockLinksResponse';
  uuid: Scalars['ID'];
};

export type ChangeGenetecDoorLinksForIntegrationInput = {
  doors: Array<ChangeGenetecDoorLinksForIntegrationInputDoors>;
};

export type ChangeGenetecDoorLinksForIntegrationInputDoors = {
  remoteDoorId: Scalars['ID'];
  robinLevelId?: InputMaybe<Scalars['Int']>;
  robinLocationId?: InputMaybe<Scalars['Int']>;
};

export type ChangeGenetecDoorLinksForIntegrationResponse = {
  __typename?: 'ChangeGenetecDoorLinksForIntegrationResponse';
  uuid: Scalars['ID'];
};

export type ChangeKisiLockLinkToRobinLevelInput = {
  remoteLockId: Scalars['String'];
  robinLevelId: Scalars['Int'];
};

export type ChangeKisiLockLinkToRobinLevelResponse = {
  __typename?: 'ChangeKisiLockLinkToRobinLevelResponse';
  uuid?: Maybe<Scalars['ID']>;
};

export type ChangeKisiLockLinkToRobinLocationInput = {
  remoteLockId: Scalars['String'];
  robinLocationId: Scalars['Int'];
};

export type ChangeKisiLockLinkToRobinLocationResponse = {
  __typename?: 'ChangeKisiLockLinkToRobinLocationResponse';
  uuid?: Maybe<Scalars['ID']>;
};

export type ChangeOpenpathLockLinksInput = {
  locks: Array<ChangeOpenpathLockLinksInputLocks>;
};

export type ChangeOpenpathLockLinksInputLocks = {
  remoteLockId: Scalars['String'];
  robinLevelId?: InputMaybe<Scalars['Int']>;
  robinLocationId?: InputMaybe<Scalars['Int']>;
};

export type ChangeOpenpathLockLinksResponse = {
  __typename?: 'ChangeOpenpathLockLinksResponse';
  uuid: Scalars['ID'];
};

export type ChangeVerkadaDoorLinksInput = {
  doors: Array<ChangeVerkadaDoorLinksInputDoors>;
};

export type ChangeVerkadaDoorLinksInputDoors = {
  remoteDoorId: Scalars['ID'];
  robinLevelId?: InputMaybe<Scalars['Int']>;
  robinLocationId?: InputMaybe<Scalars['Int']>;
};

export type ChangeVerkadaLockLinksResponse = {
  __typename?: 'ChangeVerkadaLockLinksResponse';
  uuid: Scalars['ID'];
};

export type ChatMessage = {
  __typename?: 'ChatMessage';
  id: Scalars['ID'];
  message: Scalars['String'];
  sentAt: Scalars['ISODateTime'];
  sentByUser: UserWithDefault;
};

export type CheckInStatus = {
  __typename?: 'CheckInStatus';
  checkInComplete: Scalars['Boolean'];
  checkInPossibleFuture: Scalars['Boolean'];
  checkInPossibleNow: Scalars['Boolean'];
};

export type CheckOrganizationNameAvailabilityResponse = {
  __typename?: 'CheckOrganizationNameAvailabilityResponse';
  available: Scalars['Boolean'];
};

export type ClientOptionsInput = {
  notifyRecipient?: InputMaybe<Scalars['Boolean']>;
};

export const ClientType = {
  DASHBOARD_WEB: 'DASHBOARD_WEB',
  KIOSK: 'KIOSK',
  OTHER: 'OTHER',
  ROBIN_MOBILE: 'ROBIN_MOBILE'
} as const;

export type ClientType = typeof ClientType[keyof typeof ClientType];
export type ColorDefinition = NeighborhoodColorDefinition | PublishedNeighborhoodColorDefinition;

export type CompletedTicketForm = {
  __typename?: 'CompletedTicketForm';
  id: Scalars['ID'];
  questions: Array<AnsweredTicketQuestion>;
};

export const ConfirmationClientType = {
  BADGE: 'BADGE',
  DASHBOARD_WEB: 'DASHBOARD_WEB',
  KIOSK: 'KIOSK',
  OTHER: 'OTHER',
  QR_SCAN: 'QR_SCAN',
  ROBIN_MOBILE: 'ROBIN_MOBILE',
  SLACK: 'SLACK',
  TEAMS: 'TEAMS',
  WIFI: 'WIFI'
} as const;

export type ConfirmationClientType = typeof ConfirmationClientType[keyof typeof ConfirmationClientType];
export const ConfirmationMethod = {
  LOCAL: 'LOCAL',
  REMOTE: 'REMOTE'
} as const;

export type ConfirmationMethod = typeof ConfirmationMethod[keyof typeof ConfirmationMethod];
export type ConnectGallagherAccountForCurrentTenantInput = {
  apiKey: Scalars['String'];
  emailFieldIdentifier?: InputMaybe<Scalars['String']>;
  tenancy: GallagherTenancy;
};

export type ConnectGallagherAccountForCurrentTenantResponse = {
  __typename?: 'ConnectGallagherAccountForCurrentTenantResponse';
  uuid: Scalars['ID'];
};

export type ConnectGeneaAccountForCurrentTenantInput = {
  apiKey: Scalars['String'];
  tenancy?: InputMaybe<GeneaTenancy>;
};

export type ConnectGeneaAccountForCurrentTenantResponse = {
  __typename?: 'ConnectGeneaAccountForCurrentTenantResponse';
  uuid: Scalars['ID'];
};

export type ConnectGenericConnectorAccountInput = {
  vendor: Scalars['String'];
};

export type ConnectGenericConnectorAccountResponse = {
  __typename?: 'ConnectGenericConnectorAccountResponse';
  uuid: Scalars['ID'];
};

export type ConnectGenetecAccountForCurrentTenantInput = {
  apiUrl: Scalars['String'];
  password: Scalars['String'];
  username: Scalars['String'];
};

export type ConnectGenetecAccountForCurrentTenantResponse = {
  __typename?: 'ConnectGenetecAccountForCurrentTenantResponse';
  uuid: Scalars['ID'];
};

export type ConnectKisiAccountInput = {
  apiKey: Scalars['String'];
};

export type ConnectKisiAccountResponse = {
  __typename?: 'ConnectKisiAccountResponse';
  uuid: Scalars['ID'];
};

export type ConnectOpenpathAccountInput = {
  email: Scalars['String'];
  otp?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
};

export type ConnectOpenpathAccountResponse = {
  __typename?: 'ConnectOpenpathAccountResponse';
  uuid: Scalars['ID'];
};

export type ConnectRipplingAccountForOrganizationAuthDataInput = {
  access_token: Scalars['String'];
  account_id: Scalars['String'];
  expires_in: Scalars['Int'];
  id_token: Scalars['String'];
  refresh_token: Scalars['String'];
  scope: Scalars['String'];
  token_type: Scalars['String'];
  uid: Scalars['String'];
};

export type ConnectRipplingAccountForOrganizationInput = {
  authData: ConnectRipplingAccountForOrganizationAuthDataInput;
  organizationId: Scalars['ID'];
};

export type ConnectRipplingAccountForOrganizationResponse = {
  __typename?: 'ConnectRipplingAccountForOrganizationResponse';
  id: Scalars['ID'];
};

export type ConnectVerkadaAccountForCurrentTenantInput = {
  apiKey: Scalars['String'];
  tenancy: VerkadaTenancy;
};

export type ConnectVerkadaAccountForCurrentTenantResponse = {
  __typename?: 'ConnectVerkadaAccountForCurrentTenantResponse';
  uuid: Scalars['ID'];
};

export type ConvertGroupToExternalRipplingGroupInput = {
  slug: Scalars['ID'];
};

export type ConvertGroupToExternalRipplingGroupResponse = {
  __typename?: 'ConvertGroupToExternalRipplingGroupResponse';
  externalId: Scalars['String'];
  id: Scalars['ID'];
  slug: Scalars['String'];
};

export type CountMeetingServiceRequestsInput = {
  filters?: InputMaybe<ListMeetingServiceRequestsFiltersInput>;
};

export type CountMeetingServiceRequestsResponse = {
  __typename?: 'CountMeetingServiceRequestsResponse';
  count: Scalars['Int'];
};

export type CountMeetingServicesCategoriesInput = {
  filters?: InputMaybe<ListMeetingServicesCategoriesFiltersInput>;
};

export type CountMeetingServicesCategoriesResponse = {
  __typename?: 'CountMeetingServicesCategoriesResponse';
  count: Scalars['Int'];
};

export type CountMeetingServicesInput = {
  filters?: InputMaybe<ListMeetingServicesFiltersInput>;
};

export type CountMeetingServicesResponse = {
  __typename?: 'CountMeetingServicesResponse';
  count: Scalars['Int'];
};

export type CreateActivityInput = {
  activityLocation?: InputMaybe<Scalars['String']>;
  audienceLocationId: Scalars['ID'];
  /** The ID of the image to link to the activity */
  coverImageId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  end: Scalars['ISODateTime'];
  externalEventId?: InputMaybe<Scalars['String']>;
  start: Scalars['ISODateTime'];
  timezone: Scalars['String'];
  title: Scalars['String'];
  /** Should be a URL */
  virtualLocation?: InputMaybe<Scalars['String']>;
};

export type CreateActivityReturnType = {
  __typename?: 'CreateActivityReturnType';
  id: Scalars['String'];
};

export type CreateAndMapBuildingsFromRipplingBuildingsInput = {
  address: Scalars['String'];
  name: Scalars['String'];
  ripplingBuildingId?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
};

export type CreateAndMapBuildingsFromRipplingInput = {
  buildings: Array<CreateAndMapBuildingsFromRipplingBuildingsInput>;
  organizationId: Scalars['ID'];
};

export type CreateAndMapBuildingsFromRipplingResponse = {
  __typename?: 'CreateAndMapBuildingsFromRipplingResponse';
  id: Scalars['ID'];
};

export type CreateBadgeCsvUploadLinkInput = {
  locationId: Scalars['Int'];
  vendor: Scalars['String'];
};

export type CreateBadgeCsvUploadLinkResponse = {
  __typename?: 'CreateBadgeCSVUploadLinkResponse';
  link: Scalars['String'];
  uuid: Scalars['ID'];
};

export type CreateBookingWindowPolicyInput = {
  locationId: Scalars['ID'];
  policy?: InputMaybe<BookingWindowPolicyDefinitionInput>;
};

export type CreateDeliveryInput = {
  additionalNotes?: InputMaybe<Scalars['String']>;
  base64LabelImage?: InputMaybe<Scalars['String']>;
  carrier?: InputMaybe<Scalars['String']>;
  deliveryZoneId: Scalars['String'];
  recipient?: InputMaybe<RecipientInput>;
  status?: InputMaybe<DeliveryStatus>;
};

export type CreateDeliveryZoneInput = {
  levelId?: InputMaybe<Scalars['ID']>;
  locationId: Scalars['String'];
  name: Scalars['String'];
  spaceId?: InputMaybe<Scalars['ID']>;
};

export type CreateDraftResponse = {
  __typename?: 'CreateDraftResponse';
  draftCreated?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};

export type CreateGenericHealthCheckpointResponse = {
  __typename?: 'CreateGenericHealthCheckpointResponse';
  id: Scalars['String'];
};

export type CreateGroupAndMakeItExternalRipplingGroupInput = {
  description: Scalars['String'];
  isPrivate: Scalars['Boolean'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type CreateGroupAndMakeItExternalRipplingGroupResponse = {
  __typename?: 'CreateGroupAndMakeItExternalRipplingGroupResponse';
  id: Scalars['ID'];
  slug: Scalars['String'];
};

export type CreateLevelInput = {
  levelNumber: Scalars['Int'];
  name: Scalars['String'];
};

export type CreateNeighborhoodResponse = {
  __typename?: 'CreateNeighborhoodResponse';
  id: Scalars['ID'];
};

export type CreateRobinOrganizationFromRipplingOAuthDataInput = {
  code: Scalars['String'];
};

export type CreateRobinOrganizationFromRipplingOAuthDataResponse = {
  __typename?: 'CreateRobinOrganizationFromRipplingOAuthDataResponse';
  organizationId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type CreateWorkAreaInput = {
  deskIds: Array<Scalars['ID']>;
  name: Scalars['String'];
};

export type CurrentUserAndOrgs = {
  __typename?: 'CurrentUserAndOrgs';
  /** If true, user can see approval notifications for the organization specified in the tenant-id header. */
  canSeeApprovalNotificationsForCurrentTenant: Scalars['Boolean'];
  hasActivitiesCreateForCurrentTenant: Scalars['Boolean'];
  hasActivitiesManageForCurrentTenant: Scalars['Boolean'];
  hasAmenitiesManageForCurrentTenant: Scalars['Boolean'];
  hasAnalyticsPermissionForCurrentTenant: Scalars['Boolean'];
  hasAnnouncementsManageForCurrentTenant: Scalars['Boolean'];
  hasBillingPermissionForCurrentTenant: Scalars['Boolean'];
  hasCheckpointsViewPermissionForCurrentTenant: Scalars['Boolean'];
  hasDevicesManageForCurrentTenant: Scalars['Boolean'];
  hasDevicesViewForCurrentTenant: Scalars['Boolean'];
  hasGroupsManageForCurrentTenant: Scalars['Boolean'];
  hasListUserPermissionForCurrentTenant: Scalars['Boolean'];
  hasManageUserPermissionForCurrentTenant: Scalars['Boolean'];
  hasOfficeAccessManagePermissionForCurrentTenant: Scalars['Boolean'];
  hasOfficeAccessViewPermissionForCurrentTenant: Scalars['Boolean'];
  /** If true, there are pending approval notifications for the organization specified in the tenant-id header. */
  hasPendingApprovalNotificationsForOrganization?: Maybe<Scalars['Boolean']>;
  hasPlacesManageForCurrentTenant: Scalars['Boolean'];
  hasRolesManagePermissionForCurrentTenant: Scalars['Boolean'];
  hasScenarioPlanningManagePermissionForCurrentTenant: Scalars['Boolean'];
  hasSeatsCoworkingReserveForCurrentTenant: Scalars['Boolean'];
  hasSeatsReservePublicPermissionForCurrentTenant: Scalars['Boolean'];
  hasSpacesReservePublicPermissionForCurrentTenant: Scalars['Boolean'];
  hasViewVisitsTabForCurrentTenant: Scalars['Boolean'];
  hasVisitsManageForCurrentTenant: Scalars['Boolean'];
  hasWorkPoliciesManagePermissionForCurrentTenant: Scalars['Boolean'];
  hasWorkplaceServicesManagePermissionForCurrentTenant: Scalars['Boolean'];
  hasWorkweekViewForCurrentTenant: Scalars['Boolean'];
  organizations: Array<Organization>;
  /** @deprecated Use hasPendingApprovalNotificationsForOrganization instead, only returns 0 or 1 */
  totalPendingApprovalNotificationsForOrganization: Scalars['Int'];
  user: User;
  /** @deprecated This is intended to only be used for Pendo segmentation. Use the other fields on CurrentUserAndOrgs for permissions */
  userDefaultRoleSlugsForCurrentTenant: Array<UserDefaultRoleSlug>;
  userId: Scalars['ID'];
};

export type CursoredPaginationResponse = {
  __typename?: 'CursoredPaginationResponse';
  cursor?: Maybe<Scalars['String']>;
  hasMore: Scalars['Boolean'];
  limit: Scalars['Int'];
};

export type CustomField = {
  __typename?: 'CustomField';
  choices?: Maybe<Array<CustomFieldChoice>>;
  id: Scalars['ID'];
  label: Scalars['String'];
  required?: Maybe<Scalars['Boolean']>;
  showOnBadge?: Maybe<Scalars['Boolean']>;
  type: CustomFieldType;
  value?: Maybe<Scalars['Json']>;
};

export type CustomFieldChoice = {
  __typename?: 'CustomFieldChoice';
  id: Scalars['ID'];
  label: Scalars['String'];
};

export type CustomFieldInput = {
  choices?: InputMaybe<Array<CustomFieldInputChoice>>;
  id: Scalars['ID'];
  label: Scalars['String'];
  required?: InputMaybe<Scalars['Boolean']>;
  showOnBadge?: InputMaybe<Scalars['Boolean']>;
  type: CustomFieldType;
  value?: InputMaybe<Scalars['Json']>;
};

export type CustomFieldInputChoice = {
  id: Scalars['ID'];
  label: Scalars['String'];
};

export const CustomFieldType = {
  LONG_TEXT: 'LONG_TEXT',
  SHORT_TEXT: 'SHORT_TEXT',
  SINGLE_SELECT: 'SINGLE_SELECT'
} as const;

export type CustomFieldType = typeof CustomFieldType[keyof typeof CustomFieldType];
export type CustomResource = {
  __typename?: 'CustomResource';
  amenities: Array<Amenity>;
  amenityIds: Array<Scalars['ID']>;
  bookingType?: Maybe<WeeklyBookingType>;
  capacity: Scalars['Int'];
  customResourceInstanceId: Scalars['ID'];
  floor: Level;
  floorId: Scalars['ID'];
  icon?: Maybe<IconType>;
  imageUrl?: Maybe<Scalars['String']>;
  isAccessible: Scalars['Boolean'];
  location: Location;
  locationId: Scalars['ID'];
  name: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  originatingCustomResourceTemplateId: Scalars['ID'];
  policyConfiguration?: Maybe<CustomResourcePolicyDocumentType>;
  resourceGroupId?: Maybe<Scalars['ID']>;
  resourceGroupName?: Maybe<Scalars['String']>;
  subCategory: Scalars['String'];
};

export type CustomResourceInstance = {
  __typename?: 'CustomResourceInstance';
  amenityIds?: Maybe<Array<Scalars['ID']>>;
  bookingType?: Maybe<ResourceWeeklyBookingType>;
  capacity?: Maybe<Scalars['Int']>;
  decorId: Scalars['ID'];
  floorId?: Maybe<Scalars['ID']>;
  imageUrl?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  ownerId: Scalars['ID'];
  ownerType: Scalars['String'];
  policies?: Maybe<ResourcePolicy>;
  subCategory?: Maybe<Scalars['String']>;
  zoneId?: Maybe<Scalars['ID']>;
};

export type CustomResourceInstanceInput = {
  amenityIds?: InputMaybe<Array<Scalars['ID']>>;
  bookingType?: InputMaybe<ResourceWeeklyBookingTypeInput>;
  capacity?: InputMaybe<Scalars['Int']>;
  decorId: Scalars['ID'];
  floorId?: InputMaybe<Scalars['ID']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isAccessible?: InputMaybe<Scalars['Boolean']>;
  locationId?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  ownerId: Scalars['ID'];
  ownerType: Scalars['String'];
  policies?: InputMaybe<LayoutResourcePolicyInput>;
  subCategory?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['ID']>;
};

export type CustomResourceInstancePrePublishChangeType = {
  __typename?: 'CustomResourceInstancePrePublishChangeType';
  amenityIds: Array<Scalars['ID']>;
  bookingType?: Maybe<WeeklyBookingType>;
  capacity: Scalars['Int'];
  customResourceInstanceId: Scalars['ID'];
  floorId: Scalars['ID'];
  locationId: Scalars['ID'];
  name: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  originatingCustomResourceTemplateId: Scalars['ID'];
  policyConfiguration?: Maybe<CustomResourcePolicyDocumentType>;
  resourceGroupId?: Maybe<Scalars['ID']>;
  resourceGroupName?: Maybe<Scalars['String']>;
  subCategory: Scalars['String'];
};

export type CustomResourcePolicyDocument = {
  __typename?: 'CustomResourcePolicyDocument';
  abandonedResourceProtection: PolicyEnabledWithDurationType;
  advanceCheckInWindow: PolicyEnabledWithDurationType;
  advancedBookingThreshold: PolicyEnabledWithDurationType;
  allowOverlappingBookings: Scalars['Boolean'];
  bookingPrivacy: Scalars['Boolean'];
  id: Scalars['ID'];
  /** This is true when the policy represents the robin default policy, meaning no user document has been set */
  isDefaultDocument: Scalars['Boolean'];
  localCheckInOnly: Scalars['Boolean'];
  maxBookingLength: PolicyEnabledWithDurationType;
  preventBookingFromKiosk: Scalars['Boolean'];
  recurrence: Scalars['Boolean'];
  /** @deprecated This policy is deprecated */
  requireCheckIn: Scalars['Boolean'];
  resourceSharing: Scalars['Boolean'];
  restrictBookingToWorkingHours: Scalars['Boolean'];
};

export type CustomResourcePolicyDocumentCommand = {
  abandonedResourceProtection: PolicyEnabledWithDurationCommand;
  advanceCheckInWindow: PolicyEnabledWithDurationCommand;
  advancedBookingThreshold: PolicyEnabledWithDurationCommand;
  allowOverlappingBookings: Scalars['Boolean'];
  bookingPrivacy: Scalars['Boolean'];
  localCheckInOnly: Scalars['Boolean'];
  maxBookingLength: PolicyEnabledWithDurationCommand;
  preventBookingFromKiosk: Scalars['Boolean'];
  recurrence: Scalars['Boolean'];
  requireCheckIn?: InputMaybe<Scalars['Boolean']>;
  resourceSharing: Scalars['Boolean'];
  restrictBookingToWorkingHours: Scalars['Boolean'];
};

export type CustomResourcePolicyDocumentType = {
  __typename?: 'CustomResourcePolicyDocumentType';
  abandonedResourceProtection: PolicyEnabledWithDurationType;
  advanceCheckInWindow: PolicyEnabledWithDurationType;
  advancedBookingThreshold: PolicyEnabledWithDurationType;
  allowOverlappingBookings: Scalars['Boolean'];
  bookingPrivacy: Scalars['Boolean'];
  localCheckInOnly: Scalars['Boolean'];
  maxBookingLength: PolicyEnabledWithDurationType;
  preventBookingFromKiosk: Scalars['Boolean'];
  recurrence: Scalars['Boolean'];
  requireCheckIn: Scalars['Boolean'];
  resourceSharing: Scalars['Boolean'];
  restrictBookingToWorkingHours: Scalars['Boolean'];
};

export type CustomResourceReservationByDateLinkType = {
  __typename?: 'CustomResourceReservationByDateLinkType';
  duration: Scalars['ISO8601_Duration'];
  id: Scalars['ID'];
  localDate: Scalars['IsoDateOnlyString'];
  localStartTime: Scalars['IsoLocalTimeString'];
  reservations: Array<ResourceReservation>;
  resourceInstanceId: Scalars['ID'];
};

export type CustomResourceReservationLinkType = {
  __typename?: 'CustomResourceReservationLinkType';
  id: Scalars['ID'];
  reservationSummary: Array<ReservationSummary>;
  reservations: Array<ResourceReservation>;
  resourceInstanceId: Scalars['ID'];
};

export type CustomResourceReservationsGroupedByDateResponseType = {
  __typename?: 'CustomResourceReservationsGroupedByDateResponseType';
  id: Scalars['ID'];
  resourceReservationsByDate: Array<CustomResourceReservationByDateLinkType>;
};

export type CustomResourceReservationsRangeResponseType = {
  __typename?: 'CustomResourceReservationsRangeResponseType';
  id: Scalars['ID'];
  localRangeEndDate: Scalars['IsoDateOnlyString'];
  localRangeStartDate: Scalars['IsoDateOnlyString'];
  resourceReservations: Array<CustomResourceReservationLinkType>;
};

export type CustomResourceTemplate = {
  __typename?: 'CustomResourceTemplate';
  amenities: Array<AmenityWithDefault>;
  associatedAmenities: Array<Scalars['ID']>;
  description?: Maybe<Scalars['String']>;
  icon?: Maybe<IconType>;
  id: Scalars['ID'];
  policyDocument: CustomResourcePolicyDocument;
  resourceCategory: Scalars['String'];
  resourceCategorySingular?: Maybe<Scalars['String']>;
  subCategories: Array<Scalars['CustomResourceSubCategoryType']>;
  /** This is true when the template represents a robin default template, such as parking spots and lockers */
  systemDefault: Scalars['Boolean'];
};

export type CustomVisitForm = {
  __typename?: 'CustomVisitForm';
  guestInviteFields?: Maybe<Array<CustomField>>;
  id?: Maybe<Scalars['ID']>;
  locationIds?: Maybe<Array<Scalars['ID']>>;
  locations?: Maybe<Array<Location>>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['ISODateTime']>;
  updatedBy?: Maybe<UserWithDefault>;
  visitFields?: Maybe<Array<CustomField>>;
};

export type CustomVisitFormInput = {
  guestInviteFields?: InputMaybe<Array<CustomFieldInput>>;
  locationIds?: InputMaybe<Array<Scalars['ID']>>;
  name?: InputMaybe<Scalars['String']>;
  visitFields?: InputMaybe<Array<CustomFieldInput>>;
};

export type CustomVisitFormLocationResponse = {
  __typename?: 'CustomVisitFormLocationResponse';
  linkedLocations?: Maybe<Array<Location>>;
  unlinkedLocations?: Maybe<Array<Location>>;
};

export type CustomVisitFormOrderBy = {
  field?: InputMaybe<CustomVisitFormOrderByField>;
  ordinality?: InputMaybe<Ordinality>;
};

export const CustomVisitFormOrderByField = {
  FORMNAME: 'FormName',
  NUMBEROFLINKEDLOCATIONS: 'NumberOfLinkedLocations',
  UPDATEDAT: 'UpdatedAt'
} as const;

export type CustomVisitFormOrderByField = typeof CustomVisitFormOrderByField[keyof typeof CustomVisitFormOrderByField];
export type CustomWorkingHours = DateSpecificWorkingHours & {
  __typename?: 'CustomWorkingHours';
  date: Scalars['Date'];
  id: Scalars['ID'];
  reason?: Maybe<Scalars['String']>;
  timeFrames: Array<TimeFrame>;
};

export type CustomWorkingHoursBulkUpdateInput = {
  date: Scalars['LocalDate'];
  end?: InputMaybe<Scalars['LocalEndTime']>;
  id?: InputMaybe<Scalars['ID']>;
  reason?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['LocalEndTime']>;
};

/** `date` is formated as YYYY-MM-DD while `start` and `end` are formated as HH:MM from 00:00 -> 24:00. `start` is inclusive and `end` is exclusive in the time range If `start` and `end` is `null`, that denotes an all day closure */
export type CustomWorkingHoursInput = {
  date: Scalars['LocalDate'];
  end?: InputMaybe<Scalars['LocalEndTime']>;
  locationId: Scalars['ID'];
  reason?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['LocalEndTime']>;
};

/** `date` is formated as YYYY-MM-DD while `start` and `end` are formated as HH:MM from 00:00 -> 24:00. `start` is inclusive and `end` is exclusive in the time range If `start` and `end` is `null`, that denotes an all day closure */
export type CustomWorkingHoursUpdateInput = {
  date: Scalars['LocalDate'];
  end?: InputMaybe<Scalars['LocalEndTime']>;
  reason?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['LocalEndTime']>;
};

export type Customizations = {
  __typename?: 'Customizations';
  failBody?: Maybe<Scalars['String']>;
  failHeadline?: Maybe<Scalars['String']>;
  failureEmails: Array<Scalars['String']>;
  passBody?: Maybe<Scalars['String']>;
  passHeadline?: Maybe<Scalars['String']>;
};

export const Device_Type = {
  UNKNOWN: 'UNKNOWN',
  VISITOR_ARRIVAL: 'VISITOR_ARRIVAL',
  VISITOR_BADGE_PRINTER: 'VISITOR_BADGE_PRINTER'
} as const;

export type Device_Type = typeof Device_Type[keyof typeof Device_Type];
export type DailyActivitiesSummary = {
  __typename?: 'DailyActivitiesSummary';
  activities: Array<ActivityForCurrentUser>;
  date: Scalars['Date'];
  totalActivities: Scalars['Int'];
};

export type DateFilterInput = {
  endTimeInclusive?: InputMaybe<Scalars['ISODateTime']>;
  startTimeExclusive?: InputMaybe<Scalars['ISODateTime']>;
};

export type DateFilterMandatoryInput = {
  endInclusivity?: InputMaybe<TimeInclusivityType>;
  endTime?: InputMaybe<Scalars['ISODateTime']>;
  startInclusivity?: InputMaybe<TimeInclusivityType>;
  startTime?: InputMaybe<Scalars['ISODateTime']>;
};

export type DateFilterOptionalInput = {
  endTime?: InputMaybe<Scalars['ISODateTime']>;
  startTime?: InputMaybe<Scalars['ISODateTime']>;
};

export type DateGroupedUserReservations = {
  __typename?: 'DateGroupedUserReservations';
  reservationsByDate: Array<UserDeskReservationByDate>;
  users: Array<Reservee>;
};

export type DateRangeInput = {
  endTime: Scalars['ISODateTime'];
  startTime: Scalars['ISODateTime'];
  timeZone?: InputMaybe<Scalars['String']>;
};

export type DateRangeWithTimeZone = {
  end: DateWithTimezone;
  start: DateWithTimezone;
};

export type DateSpecificWorkingHours = {
  date: Scalars['Date'];
  timeFrames: Array<TimeFrame>;
};

export type DateTimezone = {
  __typename?: 'DateTimezone';
  date: Scalars['Date'];
  timezone: Scalars['String'];
};

export type DateWithTimezone = {
  dateTime: Scalars['String'];
  timeZone: Scalars['String'];
};

export const DayOfWeek = {
  FRIDAY: 'FRIDAY',
  MONDAY: 'MONDAY',
  SATURDAY: 'SATURDAY',
  SUNDAY: 'SUNDAY',
  THURSDAY: 'THURSDAY',
  TUESDAY: 'TUESDAY',
  WEDNESDAY: 'WEDNESDAY'
} as const;

export type DayOfWeek = typeof DayOfWeek[keyof typeof DayOfWeek];
export type DaysOfWeekGroupedByResourceReservation = {
  __typename?: 'DaysOfWeekGroupedByResourceReservation';
  daysOfWeek: Array<RecurringReservationDayOfWeek>;
  reservationId: Scalars['ID'];
};

export type DefaultLocationAndLevel = {
  __typename?: 'DefaultLocationAndLevel';
  levelId?: Maybe<Scalars['ID']>;
  locationId?: Maybe<Scalars['ID']>;
  suggestedLevelId?: Maybe<Scalars['ID']>;
  suggestedLocationId?: Maybe<Scalars['ID']>;
};

export type DeleteExternalRipplingGroupInput = {
  slug: Scalars['String'];
};

export type DeleteExternalRipplingGroupResponse = {
  __typename?: 'DeleteExternalRipplingGroupResponse';
  id: Scalars['ID'];
  slug: Scalars['String'];
};

export type DeleteMeetingServicesCategoryErrorResponse = {
  __typename?: 'DeleteMeetingServicesCategoryErrorResponse';
  reason: DeleteMeetingServicesCategoryErrorResponseReason;
};

export const DeleteMeetingServicesCategoryErrorResponseReason = {
  /** The category has meeting services associated with it and cannot be deleted */
  HAS_SERVICES: 'HAS_SERVICES'
} as const;

export type DeleteMeetingServicesCategoryErrorResponseReason = typeof DeleteMeetingServicesCategoryErrorResponseReason[keyof typeof DeleteMeetingServicesCategoryErrorResponseReason];
export type DeleteMeetingServicesCategoryResponse = DeleteMeetingServicesCategoryErrorResponse | DeleteMeetingServicesCategorySuccessResponse;

export type DeleteMeetingServicesCategorySuccessResponse = {
  __typename?: 'DeleteMeetingServicesCategorySuccessResponse';
  _?: Maybe<Scalars['Void']>;
};

export type DeliveriesOrderBy = {
  field?: InputMaybe<DeliveriesOrderByField>;
  ordinality?: InputMaybe<Ordinality>;
};

export const DeliveriesOrderByField = {
  CREATEDAT: 'createdAt',
  DELIVERYZONENAME: 'deliveryZoneName',
  LASTNOTIFIEDAT: 'lastNotifiedAt',
  RECIPIENTNAME: 'recipientName',
  STATUS: 'status'
} as const;

export type DeliveriesOrderByField = typeof DeliveriesOrderByField[keyof typeof DeliveriesOrderByField];
export type DeliveriesPermittedLocations = {
  __typename?: 'DeliveriesPermittedLocations';
  canManage: Array<DeliveryLocation>;
  canView: Array<DeliveryLocation>;
};

export type Delivery = {
  __typename?: 'Delivery';
  additionalNotes?: Maybe<Scalars['String']>;
  carrier?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  createdBy?: Maybe<User>;
  deletedAt?: Maybe<Scalars['Date']>;
  deliveryZone: DeliveryZone;
  id: Scalars['ID'];
  labelImageURL?: Maybe<Scalars['String']>;
  lastNotifiedAt?: Maybe<Scalars['Date']>;
  magicLink?: Maybe<Scalars['String']>;
  pickedUpAt?: Maybe<Scalars['Date']>;
  recipient?: Maybe<Recipient>;
  status: DeliveryStatus;
};

export type DeliveryFilterOptions = {
  deliveryZoneIds?: InputMaybe<Array<Scalars['ID']>>;
  endDate?: InputMaybe<Scalars['ISODateTime']>;
  idContains?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  locationIds?: InputMaybe<Array<Scalars['ID']>>;
  recipientIds?: InputMaybe<Array<Scalars['ID']>>;
  startDate?: InputMaybe<Scalars['ISODateTime']>;
  statuses?: InputMaybe<Array<DeliveryStatus>>;
};

export type DeliveryLevel = {
  __typename?: 'DeliveryLevel';
  id: Scalars['ID'];
  locationId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  spaces: Array<DeliverySpace>;
};

export type DeliveryLocation = {
  __typename?: 'DeliveryLocation';
  id: Scalars['ID'];
  levels: Array<DeliveryLevel>;
  name?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};

export type DeliverySpace = {
  __typename?: 'DeliverySpace';
  id: Scalars['ID'];
  levelId?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export const DeliveryStatus = {
  PENDING: 'PENDING',
  PICKED_UP: 'PICKED_UP',
  UNKNOWN_RECIPIENT: 'UNKNOWN_RECIPIENT',
  WRONG_RECIPIENT: 'WRONG_RECIPIENT'
} as const;

export type DeliveryStatus = typeof DeliveryStatus[keyof typeof DeliveryStatus];
export const DeliveryTextType = {
  PHOTORECOGNIZER: 'PhotoRecognizer'
} as const;

export type DeliveryTextType = typeof DeliveryTextType[keyof typeof DeliveryTextType];
export type DeliveryZone = {
  __typename?: 'DeliveryZone';
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  level?: Maybe<DeliveryLevel>;
  levelId?: Maybe<Scalars['ID']>;
  location?: Maybe<DeliveryLocation>;
  locationId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  space?: Maybe<DeliverySpace>;
  spaceId?: Maybe<Scalars['ID']>;
  tenantId: Scalars['ID'];
};

export type DeliveryZoneFilterOptions = {
  levelIds?: InputMaybe<Array<Scalars['ID']>>;
  locationIds?: InputMaybe<Array<Scalars['ID']>>;
  spaceIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type Desk = {
  __typename?: 'Desk';
  amenities: Array<DeskAmenity>;
  assignees: Array<AccountUser>;
  availabilityFor?: Maybe<Availability>;
  availabilityWithOverlappingReservations: DeskAvailabilityWithOverlappingReservations;
  /** @deprecated Deprecated in favor of availabilityFor */
  availableAt?: Maybe<Availability>;
  canDelegate: Scalars['Boolean'];
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  instantAvailabilityAt: InstantAvailability;
  isDisabled?: Maybe<Scalars['Boolean']>;
  /** Indicate whether the desk has been explicitly marked as not available. */
  isReservable: Scalars['Boolean'];
  level?: Maybe<Level>;
  location: Location;
  name: Scalars['String'];
  permissions: Array<Permission>;
  rawType: Array<DeskType>;
  reservationPolicies?: Maybe<DeskReservationPolicies>;
  /** Get the shared desk schedule for this desk */
  schedule?: Maybe<SharedDeskSchedule>;
  settings?: Maybe<Array<Setting>>;
  space: Space;
  state: DeskState;
  stickers: Array<Sticker>;
  /** Specify the type of booking supported for this desk (Assigned, Hot, Hoteled). */
  type: BookingPolicyType;
  updatedAt: Scalars['Date'];
  windowedAvailability: Array<WindowAvailability>;
  zone?: Maybe<Zone>;
};


export type DeskAvailabilityForArgs = {
  duration?: InputMaybe<Scalars['Int']>;
  startTime: Scalars['Date'];
  userId: Scalars['ID'];
};


export type DeskAvailabilityWithOverlappingReservationsArgs = {
  durationInMinutes?: InputMaybe<Scalars['Int']>;
  time?: InputMaybe<Scalars['Date']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type DeskAvailableAtArgs = {
  time?: InputMaybe<Scalars['Date']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type DeskCanDelegateArgs = {
  endTime: Scalars['Date'];
  startTime: Scalars['Date'];
};


export type DeskInstantAvailabilityAtArgs = {
  time?: InputMaybe<Scalars['Date']>;
};


export type DeskScheduleArgs = {
  userId?: InputMaybe<Scalars['ID']>;
};


export type DeskStateArgs = {
  endTime: Scalars['Date'];
  recurrence?: InputMaybe<Scalars['String']>;
  startTime: Scalars['Date'];
  userId?: InputMaybe<Scalars['Int']>;
};


export type DeskWindowedAvailabilityArgs = {
  intervalInMinutes: Scalars['Int'];
  numberOfWindows: Scalars['Int'];
  startTime?: InputMaybe<Scalars['Date']>;
};

export type DeskAmenity = {
  __typename?: 'DeskAmenity';
  amenityId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  name: Scalars['String'];
  quantity: Scalars['Int'];
  updatedAt: Scalars['Date'];
};

export type DeskAssignee = {
  __typename?: 'DeskAssignee';
  email?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

export type DeskAssignmentSchedule = {
  __typename?: 'DeskAssignmentSchedule';
  floor: Floor;
  id: Scalars['ID'];
  label: Scalars['String'];
  recurrence: Scalars['String'];
};

export type DeskAvailability = {
  __typename?: 'DeskAvailability';
  id: Scalars['ID'];
  nextAvailableMeta: NextAvailableMeta;
  status: Availability;
  unbookableReasons: Array<DeskunbookableReasons>;
};

export type DeskAvailabilityByDate = {
  __typename?: 'DeskAvailabilityByDate';
  availability: Availability;
  date: Scalars['LocalDate'];
  deskId: Scalars['ID'];
  overlappingReservations: Array<Reservation>;
  unbookableReasons: Array<Maybe<DeskunbookableReasons>>;
};

export type DeskAvailabilityByLevelId = {
  __typename?: 'DeskAvailabilityByLevelId';
  availableDeskIds: Array<Scalars['Int']>;
  busyDeskIds: Array<Scalars['Int']>;
  forbiddenDeskIds: Array<Scalars['Int']>;
};

export type DeskAvailabilityLocalizedDate = {
  __typename?: 'DeskAvailabilityLocalizedDate';
  availability: Availability;
  dates: Array<Scalars['LocalDate']>;
  deskId: Scalars['ID'];
  timezone: Scalars['IANATimezone'];
  /** Specify the type of booking supported for this desk (Assigned, Hot, Hoteled). */
  type: BookingPolicyType;
  unbookableReasons: Array<Maybe<DeskunbookableReasons>>;
};

export type DeskAvailabilityMultiDay = {
  __typename?: 'DeskAvailabilityMultiDay';
  availabilities: Array<DeskAvailabilityLocalizedDate>;
  deskId: Scalars['ID'];
  timezone: Scalars['IANATimezone'];
  type: BookingPolicyType;
};

export type DeskAvailabilityWithOverlappingReservations = {
  __typename?: 'DeskAvailabilityWithOverlappingReservations';
  availability: Availability;
  overlappingReservations: Array<Reservation>;
};

export type DeskChangeInput = {
  id: Scalars['ID'];
  state?: InputMaybe<DeskEntityStateInput>;
  type: EntityType;
};

export type DeskConfirmation = {
  __typename?: 'DeskConfirmation';
  confirmationWindowEnd?: Maybe<Scalars['Date']>;
  confirmationWindowStart?: Maybe<Scalars['Date']>;
  confirmedAt?: Maybe<Scalars['String']>;
  deviceId?: Maybe<Scalars['ID']>;
  method?: Maybe<ConfirmationMethod>;
  seatReservationId: Scalars['ID'];
  status: DeskConfirmationStatus;
  unconfirmableReasons: Array<UnconfirmableReason>;
  user?: Maybe<User>;
};

export const DeskConfirmationStatus = {
  /** Desk reservation cannot be confirmed */
  CANNOT_CONFIRM: 'CANNOT_CONFIRM',
  /** Desk reservation has been confirmed */
  CONFIRMED: 'CONFIRMED',
  /** Desk reservation has been declined */
  DECLINED: 'DECLINED',
  /** Desk reservation has not been confirmed */
  UNCONFIRMED: 'UNCONFIRMED'
} as const;

export type DeskConfirmationStatus = typeof DeskConfirmationStatus[keyof typeof DeskConfirmationStatus];
export const DeskConfirmationType = {
  COMPASS: 'Compass',
  DASHBOARD: 'Dashboard',
  DOORBADGESWIPE: 'DoorBadgeSwipe',
  EMAIL: 'Email',
  GEOFENCE: 'Geofence',
  IP: 'IP',
  NFC: 'NFC',
  QR: 'QR',
  SLACK: 'Slack',
  TEAMS: 'Teams'
} as const;

export type DeskConfirmationType = typeof DeskConfirmationType[keyof typeof DeskConfirmationType];
export type DeskEntity = {
  __typename?: 'DeskEntity';
  data?: Maybe<DeskEntityData>;
  id: Scalars['ID'];
  previousState?: Maybe<DeskEntityState>;
  state: DeskEntityState;
  type: EntityType;
};

export type DeskEntityData = {
  __typename?: 'DeskEntityData';
  amenities?: Maybe<Array<Maybe<DeskAmenity>>>;
  floor?: Maybe<Level>;
  id: Scalars['ID'];
  name: Scalars['String'];
  zone: Zone;
};

export type DeskEntityState = {
  __typename?: 'DeskEntityState';
  assignments: Array<Assignment>;
  id: Scalars['ID'];
  isDisabled?: Maybe<Scalars['Boolean']>;
  isReservable: Scalars['Boolean'];
  reservationTypes: Array<Scalars['String']>;
};

export type DeskEntityStateInput = {
  assignments: Array<AssignmentInput>;
  isReservable: Scalars['Boolean'];
  reservationTypes: Array<DeskType>;
};

export const DeskFilters = {
  DISABLED: 'DISABLED',
  ENABLED: 'ENABLED'
} as const;

export type DeskFilters = typeof DeskFilters[keyof typeof DeskFilters];
export type DeskReservabilityChangedAuditMetadata = {
  __typename?: 'DeskReservabilityChangedAuditMetadata';
  desk: MetadataDeskObject;
  isReservable: Scalars['Boolean'];
  newDeskIsReservable?: Maybe<Scalars['Boolean']>;
  oldDeskIsReservable?: Maybe<Scalars['Boolean']>;
};

export type DeskReservationCheckinPolicies = {
  __typename?: 'DeskReservationCheckinPolicies';
  assignedCheckInEnabled?: Maybe<Scalars['Boolean']>;
  checkInWindow?: Maybe<Scalars['String']>;
  /** there are other checkin policies available, but we only expose this one */
  enforceLocalCheckinOnly: Scalars['Boolean'];
  id: Scalars['ID'];
};

export type DeskReservationFilter = {
  types?: InputMaybe<Array<BookingPolicyType>>;
};

export type DeskReservationInstancesBySeriesId = {
  __typename?: 'DeskReservationInstancesBySeriesId';
  reservations: Array<Reservation>;
  seriesId: Scalars['ID'];
};

export type DeskReservationPolicies = {
  __typename?: 'DeskReservationPolicies';
  abandonedDeskProtectionEnabled?: Maybe<Scalars['Boolean']>;
  abandonedDeskProtectionThreshold?: Maybe<Scalars['String']>;
  allowExclusions?: Maybe<Scalars['Boolean']>;
  allowOverlappingReservations?: Maybe<Scalars['Boolean']>;
  bookingWindowPolicyDuration?: Maybe<Scalars['String']>;
  bookingWindowPolicyInfo?: Maybe<BookingWindowPolicyInfo>;
  /** If this is null, checkin policies are not enabled for the desk */
  checkinPolicies?: Maybe<DeskReservationCheckinPolicies>;
  id: Scalars['ID'];
  seatReservationAdvancedBookingThreshold?: Maybe<Scalars['String']>;
  seatReservationMaxLength?: Maybe<Scalars['String']>;
  seatReservationTypesAllowed?: Maybe<Scalars['String']>;
  seatReservationVisibilityEnabled?: Maybe<Scalars['Boolean']>;
};


export type DeskReservationPoliciesBookingWindowPolicyDurationArgs = {
  startTime: Scalars['Date'];
};

export const DeskReservationVisibility = {
  EVERYONE: 'EVERYONE',
  JUST_ME: 'JUST_ME'
} as const;

export type DeskReservationVisibility = typeof DeskReservationVisibility[keyof typeof DeskReservationVisibility];
export type DeskSchedule = {
  __typename?: 'DeskSchedule';
  avatar?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  lastName?: Maybe<Scalars['String']>;
  recurrence: Scalars['String'];
  uniqueId: Scalars['ID'];
  userId?: Maybe<Scalars['ID']>;
};

export type DeskState = {
  __typename?: 'DeskState';
  availability: DeskAvailability;
  exclusions: Array<Exclusion>;
  id: Scalars['ID'];
  primaryReservation?: Maybe<Reservation>;
  reservations: Array<Reservation>;
};

export type DeskStatistics = {
  __typename?: 'DeskStatistics';
  new: Statistics;
  previous: Statistics;
};

export const DeskType = {
  ASSIGNED: 'assigned',
  HOT: 'hot',
  HOTELED: 'hoteled',
  SHARED: 'shared'
} as const;

export type DeskType = typeof DeskType[keyof typeof DeskType];
export type DeskTypeChangedAuditMetadata = {
  __typename?: 'DeskTypeChangedAuditMetadata';
  desk: MetadataDeskObject;
  newDeskType?: Maybe<Array<Scalars['String']>>;
  oldDeskType?: Maybe<Array<Scalars['String']>>;
  type: Array<Scalars['String']>;
};

export const DeskUnbookableReasonType = {
  BOOKING_WINDOW_POLICY: 'BOOKING_WINDOW_POLICY',
  LACKING_PERMISSIONS: 'LACKING_PERMISSIONS',
  MAX_CAPACITY_REACHED: 'MAX_CAPACITY_REACHED',
  NO_ACCESS: 'NO_ACCESS',
  SCHEDULE_VIOLATED: 'SCHEDULE_VIOLATED',
  SEAT_RESERVATION_ADVANCED_BOOKING_THRESHOLD: 'SEAT_RESERVATION_ADVANCED_BOOKING_THRESHOLD',
  SEAT_RESERVATION_MAX_LENGTH: 'SEAT_RESERVATION_MAX_LENGTH',
  SEAT_RESERVATION_RECURRENCE_ALLOWED: 'SEAT_RESERVATION_RECURRENCE_ALLOWED',
  SEAT_RESERVATION_WORKING_HOURS_RESTRICTED: 'SEAT_RESERVATION_WORKING_HOURS_RESTRICTED',
  UNKNOWN: 'UNKNOWN',
  VIOLATE_HOT_DESK_POLICY: 'VIOLATE_HOT_DESK_POLICY'
} as const;

export type DeskUnbookableReasonType = typeof DeskUnbookableReasonType[keyof typeof DeskUnbookableReasonType];
export type DeskWithAssignees = {
  __typename?: 'DeskWithAssignees';
  assignees: Array<DeskAssignee>;
  isDisabled: Scalars['Boolean'];
  isReservable: Scalars['Boolean'];
  permissions: Array<Permission>;
  seatId: Scalars['ID'];
  seatType: Array<BookingPolicyType>;
};

export type DeskunbookableReasons = {
  __typename?: 'DeskunbookableReasons';
  reason: DeskUnbookableReasonType;
  value?: Maybe<Scalars['String']>;
};

export type Device = EventAuditLogActor & {
  __typename?: 'Device';
  id: Scalars['ID'];
};

export type DeviceAuthorizationResponse = {
  __typename?: 'DeviceAuthorizationResponse';
  bearerToken: Scalars['String'];
  deviceName: Scalars['String'];
  deviceType: Device_Type;
  /** device ID */
  id: Scalars['ID'];
  location: Location;
  organizationId: Scalars['ID'];
  refreshToken: Scalars['String'];
};

export const DeviceFeatureFlagType = {
  /** Feature flag for enabling badge printing from an arrival display */
  ARRIVAL_DISPLAY_BADGE_PRINTING: 'ARRIVAL_DISPLAY_BADGE_PRINTING',
  /** Enables using custom visit types on devices like the Arrival Display or GuestUI */
  CUSTOM_VISIT_TYPES: 'CUSTOM_VISIT_TYPES',
  /** Language selection feature flag for project global */
  LANGUAGE_SELECTION_ENABLED: 'LANGUAGE_SELECTION_ENABLED',
  /** Language selection feature flag for a location global */
  LOCATION_LANGUAGE_SELECTION_ENABLED: 'LOCATION_LANGUAGE_SELECTION_ENABLED',
  /** Enables the ability to capture images to be used on visitor badges */
  VISITOR_BADGE_IMAGES: 'VISITOR_BADGE_IMAGES'
} as const;

export type DeviceFeatureFlagType = typeof DeviceFeatureFlagType[keyof typeof DeviceFeatureFlagType];
export const DeviceStatus = {
  OFFLINE: 'OFFLINE',
  ONLINE: 'ONLINE',
  UNKNOWN: 'UNKNOWN'
} as const;

export type DeviceStatus = typeof DeviceStatus[keyof typeof DeviceStatus];
export const DeviceStatusInput = {
  OFFLINE: 'OFFLINE',
  ONLINE: 'ONLINE'
} as const;

export type DeviceStatusInput = typeof DeviceStatusInput[keyof typeof DeviceStatusInput];
export type DeviceStatusReport = {
  __typename?: 'DeviceStatusReport';
  lastCheckinMessage?: Maybe<Scalars['String']>;
  lastCheckinResult?: Maybe<DeviceStatusInput>;
  lastCheckinTime?: Maybe<Scalars['String']>;
  status: DeviceStatus;
};

export type DisableGeofenceFeatureForBuildingInput = {
  buildingId: Scalars['ID'];
};

export type DisableSpacesResults = {
  __typename?: 'DisableSpacesResults';
  failedIds: Array<Scalars['Int']>;
  successfulIds: Array<Scalars['Int']>;
};

export type DisconnectBrivoAccountResponse = {
  __typename?: 'DisconnectBrivoAccountResponse';
  uuid: Scalars['ID'];
};

export type DisconnectGallagherAccountByIntegrationUuidInput = {
  integrationUuid: Scalars['ID'];
};

export type DisconnectGallagherAccountByIntegrationUuidResponse = {
  __typename?: 'DisconnectGallagherAccountByIntegrationUuidResponse';
  uuid: Scalars['ID'];
};

export type DisconnectGeneaAccountByIntegrationUuidInput = {
  integrationUuid: Scalars['ID'];
};

export type DisconnectGeneaAccountByIntegrationUuidResponse = {
  __typename?: 'DisconnectGeneaAccountByIntegrationUuidResponse';
  uuid: Scalars['ID'];
};

export type DisconnectGenetecAccountByIntegrationUuidInput = {
  integrationUuid: Scalars['ID'];
};

export type DisconnectGenetecAccountByIntegrationUuidResponse = {
  __typename?: 'DisconnectGenetecAccountByIntegrationUuidResponse';
  uuid: Scalars['ID'];
};

export type DisconnectOpenpathAccountResponse = {
  __typename?: 'DisconnectOpenpathAccountResponse';
  uuid: Scalars['ID'];
};

export type DisconnectVerkadaAccountByIntegrationUuidInput = {
  integrationUuid: Scalars['ID'];
};

export type DisconnectVerkadaAccountByIntegrationUuidResponse = {
  __typename?: 'DisconnectVerkadaAccountByIntegrationUuidResponse';
  uuid: Scalars['ID'];
};

export type DisconnnectKisiAccountResponse = {
  __typename?: 'DisconnnectKisiAccountResponse';
  uuid: Scalars['ID'];
};

export type DistributionInput = {
  distributionService: DistributionService;
  id?: InputMaybe<Scalars['ID']>;
  recipients: Array<DistributionRecipientInput>;
};

/** display -> what is shown to user (ie slack channel name) value -> identifier data used to cross post (ie slack channel conversationId) */
export type DistributionRecipient = {
  __typename?: 'DistributionRecipient';
  display?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  value: Scalars['String'];
};

export type DistributionRecipientInput = {
  display?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  value: Scalars['String'];
};

export const DistributionService = {
  EMAIL: 'EMAIL',
  SLACK: 'SLACK',
  TEAMS: 'TEAMS'
} as const;

export type DistributionService = typeof DistributionService[keyof typeof DistributionService];
export type Draft = {
  __typename?: 'Draft';
  floorName?: Maybe<Scalars['String']>;
  hasAuditLogs?: Maybe<Scalars['Boolean']>;
  hasConflicts?: Maybe<Scalars['Boolean']>;
  hasReviewData?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isLocked: Scalars['Boolean'];
  lastUpdated?: Maybe<DraftAuditInfo>;
  levelId: Scalars['ID'];
  locationId: Scalars['ID'];
  name: Scalars['String'];
  organizationId: Scalars['ID'];
  owner?: Maybe<DraftAuditInfo>;
  reviewVersion?: Maybe<Scalars['Int']>;
  settings: Array<DraftSettings>;
  status: DraftStatus;
  version: Scalars['Int'];
};

export const DraftAccessLevel = {
  COLLABORATOR: 'collaborator',
  EDITOR: 'editor',
  VIEWER: 'viewer'
} as const;

export type DraftAccessLevel = typeof DraftAccessLevel[keyof typeof DraftAccessLevel];
export type DraftAccountUser = {
  __typename?: 'DraftAccountUser';
  assignments?: Maybe<Array<Maybe<DraftDeskAssignmentSchedule>>>;
  avatar?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  primaryEmail?: Maybe<PrimaryEmail>;
  slug?: Maybe<Scalars['String']>;
};

export const DraftAuditEntityType = {
  COLLABORATOR: 'COLLABORATOR',
  DESK: 'DESK',
  DRAFT: 'DRAFT',
  NEIGHBORHOOD: 'NEIGHBORHOOD',
  QUEUE: 'QUEUE',
  SETTINGS: 'SETTINGS',
  USER_ASSIGNMENT: 'USER_ASSIGNMENT'
} as const;

export type DraftAuditEntityType = typeof DraftAuditEntityType[keyof typeof DraftAuditEntityType];
export type DraftAuditInfo = {
  __typename?: 'DraftAuditInfo';
  avatar?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  primaryEmail?: Maybe<PrimaryEmail>;
  userId: Scalars['ID'];
};

export type DraftAuditLog = {
  __typename?: 'DraftAuditLog';
  changeTimestamp: Scalars['String'];
  draftId: Scalars['ID'];
  entityId: Scalars['String'];
  entityType: DraftAuditEntityType;
  id: Scalars['ID'];
  isReleased: Scalars['Boolean'];
  metadata?: Maybe<DraftAuditLogMetadata>;
  operationType: DraftAuditOperationType;
  releasedAt?: Maybe<Scalars['String']>;
  user: AuditUserObject;
};

export type DraftAuditLogFilters = {
  endDate?: InputMaybe<Scalars['String']>;
  entityTypes?: InputMaybe<Array<DraftAuditEntityType>>;
  isReleased?: InputMaybe<Scalars['Boolean']>;
  operationTypes?: InputMaybe<Array<DraftAuditOperationType>>;
  sortOrder?: InputMaybe<DraftAuditLogSortOrder>;
  startDate?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type DraftAuditLogMetadata = DeskReservabilityChangedAuditMetadata | DeskTypeChangedAuditMetadata | DraftCollaboratorAccessLevelChangedAuditMetadata | DraftCollaboratorRemovedAuditMetadata | DraftCreatedAuditMetadata | DraftLockStatusChangedAuditMetadata | DraftPublishedAuditMetadata | DraftRenamedAuditMetadata | DraftSharedAuditMetadata | DraftShowNeighborhoodColorSettingUpdatedMetadata | NeighborhoodColorChangedAuditMetadata | NeighborhoodCreatedAuditMetadata | NeighborhoodDesksChangedAuditMetadata | NeighborhoodRemovedAuditMetadata | NeighborhoodRenamedAuditMetadata | UserAssignmentChangedAuditMetadata;

export const DraftAuditLogSortOrder = {
  ASC: 'ASC',
  DESC: 'DESC'
} as const;

export type DraftAuditLogSortOrder = typeof DraftAuditLogSortOrder[keyof typeof DraftAuditLogSortOrder];
export type DraftAuditLogsResponse = {
  __typename?: 'DraftAuditLogsResponse';
  auditLogs: Array<DraftAuditLog>;
  draftName: Scalars['String'];
  hasMore: Scalars['Boolean'];
  total: Scalars['Int'];
};

export const DraftAuditOperationType = {
  DESKS_ADDED_TO_NEIGHBORHOOD: 'DESKS_ADDED_TO_NEIGHBORHOOD',
  DESKS_REMOVED_FROM_NEIGHBORHOOD: 'DESKS_REMOVED_FROM_NEIGHBORHOOD',
  DESK_AVAILABILITY_CHANGED: 'DESK_AVAILABILITY_CHANGED',
  DESK_TYPE_CHANGED: 'DESK_TYPE_CHANGED',
  DRAFT_ACCESS_LEVEL_CHANGED: 'DRAFT_ACCESS_LEVEL_CHANGED',
  DRAFT_COLLABORATOR_REMOVED: 'DRAFT_COLLABORATOR_REMOVED',
  DRAFT_CREATED: 'DRAFT_CREATED',
  DRAFT_LOCK_STATUS_CHANGED: 'DRAFT_LOCK_STATUS_CHANGED',
  DRAFT_PUBLISHED: 'DRAFT_PUBLISHED',
  DRAFT_RENAMED: 'DRAFT_RENAMED',
  DRAFT_SHARED: 'DRAFT_SHARED',
  DRAFT_SHOW_NEIGHBORHOOD_COLOR_SETTING_UPDATED: 'DRAFT_SHOW_NEIGHBORHOOD_COLOR_SETTING_UPDATED',
  NEIGHBORHOOD_COLOR_CHANGED: 'NEIGHBORHOOD_COLOR_CHANGED',
  NEIGHBORHOOD_CREATED: 'NEIGHBORHOOD_CREATED',
  NEIGHBORHOOD_REMOVED: 'NEIGHBORHOOD_REMOVED',
  NEIGHBORHOOD_RENAMED: 'NEIGHBORHOOD_RENAMED',
  USER_ASSIGNED_TO_DESK: 'USER_ASSIGNED_TO_DESK',
  USER_UNASSIGNED_FROM_DESK: 'USER_UNASSIGNED_FROM_DESK'
} as const;

export type DraftAuditOperationType = typeof DraftAuditOperationType[keyof typeof DraftAuditOperationType];
export type DraftAuditPaginationInput = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};

export const DraftCollaboratorAccessLevel = {
  COLLABORATOR: 'collaborator',
  VIEWER: 'viewer'
} as const;

export type DraftCollaboratorAccessLevel = typeof DraftCollaboratorAccessLevel[keyof typeof DraftCollaboratorAccessLevel];
export type DraftCollaboratorAccessLevelChangedAuditMetadata = {
  __typename?: 'DraftCollaboratorAccessLevelChangedAuditMetadata';
  newValue: DraftAccessLevel;
  oldValue: DraftAccessLevel;
  user: AuditUserObject;
};

export type DraftCollaboratorRemovedAuditMetadata = {
  __typename?: 'DraftCollaboratorRemovedAuditMetadata';
  users: Array<AuditUserObject>;
};

export type DraftConflict = {
  __typename?: 'DraftConflict';
  draftChange?: Maybe<EntityState>;
  entityData?: Maybe<EntityData>;
  entityId: Scalars['ID'];
  entityType: DraftConflictEntityType;
  id: Scalars['ID'];
  liveState?: Maybe<EntityState>;
  reason: DraftConflictReason;
  type: DraftConflictType;
};

export const DraftConflictEntityType = {
  DESK: 'desk'
} as const;

export type DraftConflictEntityType = typeof DraftConflictEntityType[keyof typeof DraftConflictEntityType];
export const DraftConflictReason = {
  DESK_DELETED: 'desk_deleted',
  SNAPSHOT_LIVE_MISMATCH: 'snapshot_live_mismatch',
  USER_DELETED: 'user_deleted'
} as const;

export type DraftConflictReason = typeof DraftConflictReason[keyof typeof DraftConflictReason];
export const DraftConflictType = {
  ACTIONABLE: 'actionable',
  INFORMATIVE: 'informative'
} as const;

export type DraftConflictType = typeof DraftConflictType[keyof typeof DraftConflictType];
export type DraftCreatedAuditMetadata = {
  __typename?: 'DraftCreatedAuditMetadata';
  draftName: Scalars['String'];
  shouldKeepAssignments?: Maybe<Scalars['Boolean']>;
  shouldKeepNeighborhoods?: Maybe<Scalars['Boolean']>;
};

export type DraftDeskAssignmentSchedule = {
  __typename?: 'DraftDeskAssignmentSchedule';
  deskId: Scalars['ID'];
  floor?: Maybe<Level>;
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  recurrence: Scalars['String'];
  zone?: Maybe<Zone>;
};

export type DraftFiltersInput = {
  buildingId?: InputMaybe<Scalars['ID']>;
  floorId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Array<InputMaybe<DraftStatus>>>;
};

export type DraftInput = {
  levelId: Scalars['ID'];
  name: Scalars['String'];
  settings: Array<DraftSettingsInput>;
};

export type DraftLayoutInputEntity = {
  deletedResources?: InputMaybe<Array<Scalars['ID']>>;
  resourceGroups?: InputMaybe<Array<ResourceGroupInput>>;
  updatedResources?: InputMaybe<Array<DraftLayoutUpdateResourceInputEntity>>;
};

export type DraftLayoutUpdateResourceInputEntity = {
  id: Scalars['ID'];
  parcel?: InputMaybe<LayoutParcelInput>;
};

export type DraftLockStatusChangedAuditMetadata = {
  __typename?: 'DraftLockStatusChangedAuditMetadata';
  newValue: Scalars['Boolean'];
  oldValue: Scalars['Boolean'];
};

export type DraftMetadata = {
  __typename?: 'DraftMetadata';
  hasChanges?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isLocked: Scalars['Boolean'];
  lastUpdated?: Maybe<DraftAuditInfo>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<DraftAuditInfo>;
  version: Scalars['Int'];
};

export type DraftNeighborhoodResource = {
  __typename?: 'DraftNeighborhoodResource';
  id: Scalars['ID'];
  resourceId: Scalars['ID'];
  type: NeighborhoodResourceType;
};

export const DraftOrderByValues = {
  CREATEDAT: 'createdAt',
  CREATEDBY: 'createdBy',
  FLOORNAME: 'floorName',
  NAME: 'name',
  STATUS: 'status',
  TYPE: 'type',
  UPDATEDAT: 'updatedAt',
  UPDATEDBY: 'updatedBy'
} as const;

export type DraftOrderByValues = typeof DraftOrderByValues[keyof typeof DraftOrderByValues];
export type DraftPagingResult = {
  __typename?: 'DraftPagingResult';
  drafts: Array<Draft>;
  draftsTotal: Scalars['Int'];
  hasNextPage: Scalars['Boolean'];
  nextPageOffset: Scalars['Int'];
};

export type DraftPublishedAuditMetadata = {
  __typename?: 'DraftPublishedAuditMetadata';
  draftName: Scalars['String'];
  publishedAt?: Maybe<Scalars['String']>;
  publishedBy?: Maybe<Scalars['String']>;
};

export type DraftRenamedAuditMetadata = {
  __typename?: 'DraftRenamedAuditMetadata';
  newName: Scalars['String'];
  oldName: Scalars['String'];
};

export type DraftSettings = {
  __typename?: 'DraftSettings';
  type: DraftSettingsType;
  value?: Maybe<Scalars['String']>;
};

export type DraftSettingsInput = {
  booleanValue?: InputMaybe<Scalars['Boolean']>;
  name: DraftSettingsName;
  numberValue?: InputMaybe<Scalars['Float']>;
  stringValue?: InputMaybe<Scalars['String']>;
};

export const DraftSettingsName = {
  ASSIGNMENTS: 'ASSIGNMENTS',
  CONFLICTS: 'CONFLICTS',
  DEFAULT: 'DEFAULT',
  DISPOSABLE: 'DISPOSABLE',
  LAYOUT: 'LAYOUT',
  NEIGHBORHOODS: 'NEIGHBORHOODS'
} as const;

export type DraftSettingsName = typeof DraftSettingsName[keyof typeof DraftSettingsName];
export type DraftSettingsType = {
  __typename?: 'DraftSettingsType';
  name: Scalars['String'];
  valueType: SettingValueType;
};

export type DraftSharedAuditMetadata = {
  __typename?: 'DraftSharedAuditMetadata';
  permission: DraftCollaboratorAccessLevel;
  users: Array<AuditUserObject>;
};

export type DraftShowNeighborhoodColorSettingUpdatedMetadata = {
  __typename?: 'DraftShowNeighborhoodColorSettingUpdatedMetadata';
  newValue: Scalars['Boolean'];
  oldValue: Scalars['Boolean'];
};

export const DraftStatus = {
  DISCARDED: 'discarded',
  OPEN: 'open',
  PUBLISHED: 'published',
  PUBLISHING: 'publishing',
  PUBLISHING_FAILED: 'publishing_failed'
} as const;

export type DraftStatus = typeof DraftStatus[keyof typeof DraftStatus];
export type DraftStatusResponse = {
  __typename?: 'DraftStatusResponse';
  id: Scalars['ID'];
  status: DraftStatus;
};

export type DraftsSort = {
  field: DraftOrderByValues;
  order: SortDirection;
};

export type EditMeetingServicesCategoryChangesInput = {
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type EditMeetingServicesCategoryErrorResponse = {
  __typename?: 'EditMeetingServicesCategoryErrorResponse';
  reason: EditMeetingServicesCategoryErrorResponseReason;
};

export const EditMeetingServicesCategoryErrorResponseReason = {
  CATEGORY_MISSING: 'CATEGORY_MISSING',
  NAME_IS_NOT_UNIQUE: 'NAME_IS_NOT_UNIQUE'
} as const;

export type EditMeetingServicesCategoryErrorResponseReason = typeof EditMeetingServicesCategoryErrorResponseReason[keyof typeof EditMeetingServicesCategoryErrorResponseReason];
export type EditMeetingServicesCategoryInput = {
  changes: EditMeetingServicesCategoryChangesInput;
  meetingServicesCategoryId: Scalars['ID'];
};

export type EditMeetingServicesCategoryResponse = EditMeetingServicesCategoryErrorResponse | EditMeetingServicesCategorySuccessResponse;

export type EditMeetingServicesCategorySuccessResponse = {
  __typename?: 'EditMeetingServicesCategorySuccessResponse';
  _?: Maybe<Scalars['Void']>;
};

export type Email = {
  __typename?: 'Email';
  email: Scalars['String'];
  isVerified: Scalars['Boolean'];
};

/** Emails of users who are deactivated or not existing in the tenant will be grouped in `invalid` */
export type EmailCheckResponse = {
  __typename?: 'EmailCheckResponse';
  invalid: Array<Scalars['String']>;
  unverified: Array<Scalars['String']>;
  verified: Array<Scalars['String']>;
};

export type EmailConfiguration = {
  __typename?: 'EmailConfiguration';
  attachment?: Maybe<Scalars['String']>;
  headerBackgroundColorHexCode?: Maybe<Scalars['String']>;
  headerFontColorHexCode?: Maybe<Scalars['String']>;
  headerImageURL?: Maybe<Scalars['String']>;
  locationId: Scalars['ID'];
};

export type EmailConfigurationInput = {
  attachment?: InputMaybe<Scalars['String']>;
  base64EncodedHeaderImage?: InputMaybe<Scalars['String']>;
  headerBackgroundColorHexCode?: InputMaybe<Scalars['String']>;
  headerFontColorHexCode?: InputMaybe<Scalars['String']>;
  headerImageURL?: InputMaybe<Scalars['String']>;
};

export type EmployeeCredentialProvisioningProvider = {
  __typename?: 'EmployeeCredentialProvisioningProvider';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type EmployeeRegisteredForWaitlistVisitInput = {
  /** The employee ID. */
  employeeUserId: Scalars['ID'];
  /** The waitlist location ID. */
  waitlistLocationId: Scalars['ID'];
  /** The waitlist visit ID. */
  waitlistVisitId: Scalars['ID'];
};

export type EmployeeVisit = {
  __typename?: 'EmployeeVisit';
  confirmation: EmployeeVisitConfirmation;
  endTime: Scalars['ISODateTime'];
  id: Scalars['ID'];
  location?: Maybe<Location>;
  locationId: Scalars['ID'];
  scheduleId?: Maybe<Scalars['ID']>;
  startTime: Scalars['ISODateTime'];
  status: EmployeeVisitStatus;
  userId: Scalars['ID'];
};

export type EmployeeVisitConfirmation = {
  __typename?: 'EmployeeVisitConfirmation';
  confirmed_at?: Maybe<Scalars['ISODateTime']>;
  employeeVisitId: Scalars['ID'];
  status: EmployeeVisitConfirmationStatus;
};

export const EmployeeVisitConfirmationStatus = {
  CANCELED: 'CANCELED',
  CONFIRMED: 'CONFIRMED',
  UNKNOWN: 'UNKNOWN'
} as const;

export type EmployeeVisitConfirmationStatus = typeof EmployeeVisitConfirmationStatus[keyof typeof EmployeeVisitConfirmationStatus];
export const EmployeeVisitFilterSetting = {
  ACTIVE_ONLY: 'ACTIVE_ONLY',
  ALL: 'ALL',
  CANCELLED_ONLY: 'CANCELLED_ONLY'
} as const;

export type EmployeeVisitFilterSetting = typeof EmployeeVisitFilterSetting[keyof typeof EmployeeVisitFilterSetting];
export type EmployeeVisitMutations = {
  __typename?: 'EmployeeVisitMutations';
  excludeDaysFromAllSchedules?: Maybe<Scalars['Void']>;
  setWeeklySchedule?: Maybe<Scalars['ID']>;
};


export type EmployeeVisitMutationsExcludeDaysFromAllSchedulesArgs = {
  input?: InputMaybe<ExcludeAllDaysFromScheduleInput>;
};


export type EmployeeVisitMutationsSetWeeklyScheduleArgs = {
  input: SetWeeklyScheduleInput;
};

export type EmployeeVisitQueries = {
  __typename?: 'EmployeeVisitQueries';
  /** Get all of an employee's visits during a specific time range within a specific org */
  getAllEmployeeVisitsForEmployee: Array<EmployeeVisit>;
  getAllWeeklySchedulesForUser?: Maybe<AllSchedules>;
  getWeeklyScheduleForUser?: Maybe<WeeklyScheduleResult>;
};


export type EmployeeVisitQueriesGetAllEmployeeVisitsForEmployeeArgs = {
  employeeId: Scalars['ID'];
  endTime: Scalars['ISODateTime'];
  filterSetting?: InputMaybe<EmployeeVisitFilterSetting>;
  startTime: Scalars['ISODateTime'];
};


export type EmployeeVisitQueriesGetAllWeeklySchedulesForUserArgs = {
  userId: Scalars['String'];
};


export type EmployeeVisitQueriesGetWeeklyScheduleForUserArgs = {
  locationId: Scalars['String'];
  userId: Scalars['String'];
};

export type EmployeeVisitSchedule = {
  __typename?: 'EmployeeVisitSchedule';
  id?: Maybe<Scalars['String']>;
};

export const EmployeeVisitStatus = {
  CANCELLED: 'CANCELLED',
  CONFIRMED: 'CONFIRMED',
  UNCONFIRMED: 'UNCONFIRMED'
} as const;

export type EmployeeVisitStatus = typeof EmployeeVisitStatus[keyof typeof EmployeeVisitStatus];
export type EmployeeVisitsByDate = {
  __typename?: 'EmployeeVisitsByDate';
  date: Scalars['Date'];
  employeeVisits: Array<EmployeeVisit>;
};

export type EnableGeofenceFeatureForBuildingInput = {
  buildingId: Scalars['ID'];
};

export type EndOrCancelDelegatedReservationResponse = {
  __typename?: 'EndOrCancelDelegatedReservationResponse';
  reservationId: Scalars['ID'];
};

export type EndOrCancelReservationResponse = {
  __typename?: 'EndOrCancelReservationResponse';
  reservationId: Scalars['ID'];
};

export type EndReservationOrVisitInRangeResponse = {
  __typename?: 'EndReservationOrVisitInRangeResponse';
  reservationsCancelledAttempts?: Maybe<Array<Maybe<CancelledVisitOrReservationResult>>>;
  /** If true, all visits and reservations in range were successfully cancelled. If false there are one or more failures */
  success: Scalars['Boolean'];
  visitsCancelledAttempts?: Maybe<Array<Maybe<CancelledVisitOrReservationResult>>>;
};

export type Entity = {
  __typename?: 'Entity';
  data?: Maybe<EntityData>;
  id: Scalars['ID'];
  previousState?: Maybe<EntityState>;
  state: EntityState;
  type: EntityType;
};

export type EntityData = DeskEntityData;

export type EntityState = DeskEntityState;

export const EntityType = {
  DESK: 'DESK',
  NEIGHBORHOOD: 'NEIGHBORHOOD'
} as const;

export type EntityType = typeof EntityType[keyof typeof EntityType];
/** Actionable resolution guidance for the error */
export type ErrorResolution = {
  __typename?: 'ErrorResolution';
  action: Scalars['String'];
  description: Scalars['String'];
};

export type Evaluations = {
  workingHours?: InputMaybe<Scalars['Boolean']>;
};

export type Event = {
  __typename?: 'Event';
  creationType: EventCreationType;
  creatorEmail?: Maybe<Scalars['String']>;
  creatorId?: Maybe<Scalars['ID']>;
  description?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['String']>;
  eventWithCheckInStatus?: Maybe<EventWithCheckInStatus>;
  hasMeetingServiceRequests?: Maybe<Scalars['Boolean']>;
  /** Event Id */
  id: Scalars['ID'];
  invitees: Array<EventInvitee>;
  isAllDay: Scalars['Boolean'];
  isCandidateForSpaceSuggestions: Scalars['Boolean'];
  organizerEmail?: Maybe<Scalars['String']>;
  organizerId?: Maybe<Scalars['ID']>;
  recurrence?: Maybe<Scalars['String']>;
  seriesId?: Maybe<Scalars['String']>;
  spaces: Array<Space>;
  startTime?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['String']>;
  visibility?: Maybe<Scalars['String']>;
  whosInData: WhosInData;
};


export type EventWhosInDataArgs = {
  locationIds: Array<Scalars['ID']>;
};

export type EventAuditLog = {
  __typename?: 'EventAuditLog';
  actor: EventAuditLogActor;
  /** @deprecated Use actor instead */
  actorId?: Maybe<Scalars['ID']>;
  /** @deprecated Use actor instead */
  actorType: EventAuditLogActorType;
  changes: Array<EventAuditLogChange>;
  etag?: Maybe<Scalars['String']>;
  eventId: Scalars['ID'];
  id: Scalars['ID'];
  /** Tracks any changes to the invitee list */
  inviteeChanges: EventAuditLogInviteeChange;
  metadata?: Maybe<Scalars['String']>;
  operation: EventAuditLogOperation;
  spaceId: Scalars['ID'];
  timestamp: Scalars['ISODateTime'];
};

/** Interface for any actor that can perform operations on events */
export type EventAuditLogActor = {
  id?: Maybe<Scalars['ID']>;
};

/** Enum for actor types that can perform operations on events */
export const EventAuditLogActorType = {
  APP: 'APP',
  DEVICE: 'DEVICE',
  ORGANIZATION: 'ORGANIZATION',
  UNKNOWN: 'UNKNOWN',
  USER: 'USER'
} as const;

export type EventAuditLogActorType = typeof EventAuditLogActorType[keyof typeof EventAuditLogActorType];
export type EventAuditLogChange = {
  __typename?: 'EventAuditLogChange';
  fieldChanged: EventAuditLogFieldType;
  id: Scalars['ID'];
  newValue?: Maybe<Scalars['String']>;
  oldValue?: Maybe<Scalars['String']>;
};

/** Enum for event field types that can be changed */
export const EventAuditLogFieldType = {
  CREATED_AT: 'CREATED_AT',
  CREATION_TYPE: 'CREATION_TYPE',
  CREATOR_EMAIL: 'CREATOR_EMAIL',
  CREATOR_ID: 'CREATOR_ID',
  DESCRIPTION: 'DESCRIPTION',
  ENDED_AT: 'ENDED_AT',
  ENDED_AT_TIMEZONE: 'ENDED_AT_TIMEZONE',
  IS_ALL_DAY: 'IS_ALL_DAY',
  LOCATION: 'LOCATION',
  ORGANIZER_EMAIL: 'ORGANIZER_EMAIL',
  ORGANIZER_ID: 'ORGANIZER_ID',
  RECURRENCE: 'RECURRENCE',
  RECURRENCE_ID: 'RECURRENCE_ID',
  REMOTE_CALENDAR_MAILBOX_ADDRESS: 'REMOTE_CALENDAR_MAILBOX_ADDRESS',
  REMOTE_EVENT_ID: 'REMOTE_EVENT_ID',
  REMOTE_SERIES_ID: 'REMOTE_SERIES_ID',
  REMOTE_TYPE: 'REMOTE_TYPE',
  SEQUENCE: 'SEQUENCE',
  SERIES_ID: 'SERIES_ID',
  SHOW_AS: 'SHOW_AS',
  SPACE_ID: 'SPACE_ID',
  STARTED_AT: 'STARTED_AT',
  STARTED_AT_TIMEZONE: 'STARTED_AT_TIMEZONE',
  STATUS: 'STATUS',
  TITLE: 'TITLE',
  UID: 'UID',
  VISIBILITY: 'VISIBILITY'
} as const;

export type EventAuditLogFieldType = typeof EventAuditLogFieldType[keyof typeof EventAuditLogFieldType];
export type EventAuditLogFilterInput = {
  placeHierarchy?: InputMaybe<EventAuditLogPlaceHierarchyFilterInput>;
};

export type EventAuditLogInvitee = {
  __typename?: 'EventAuditLogInvitee';
  email: Scalars['String'];
};

export type EventAuditLogInviteeChange = {
  __typename?: 'EventAuditLogInviteeChange';
  addedInvitees: Array<EventAuditLogInvitee>;
  inviteeChanges: Array<EventAuditLogInviteeFieldChange>;
  removedInvitees: Array<EventAuditLogInvitee>;
};

export type EventAuditLogInviteeFieldChange = {
  __typename?: 'EventAuditLogInviteeFieldChange';
  fieldChanged: EventAuditLogInviteeFieldType;
  invitee: EventAuditLogInvitee;
  newValue: Scalars['String'];
  oldValue: Scalars['String'];
};

export const EventAuditLogInviteeFieldType = {
  RESPONSE_STATUS: 'RESPONSE_STATUS'
} as const;

export type EventAuditLogInviteeFieldType = typeof EventAuditLogInviteeFieldType[keyof typeof EventAuditLogInviteeFieldType];
/** Enum for operations that can be performed on events */
export const EventAuditLogOperation = {
  APPROVE_SPACE_RESERVATION_REQUEST: 'APPROVE_SPACE_RESERVATION_REQUEST',
  CANCEL: 'CANCEL',
  CONFIRM: 'CONFIRM',
  CREATE: 'CREATE',
  DELETE: 'DELETE',
  DENY_SPACE_RESERVATION_REQUEST: 'DENY_SPACE_RESERVATION_REQUEST',
  SYNC_CANCEL: 'SYNC_CANCEL',
  SYNC_CREATE: 'SYNC_CREATE',
  SYNC_DELETE: 'SYNC_DELETE',
  SYNC_UPDATE: 'SYNC_UPDATE',
  UNCONFIRM: 'UNCONFIRM',
  UPDATE: 'UPDATE'
} as const;

export type EventAuditLogOperation = typeof EventAuditLogOperation[keyof typeof EventAuditLogOperation];
export type EventAuditLogPaginationInput = {
  after?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
};

export type EventAuditLogPaginationOutput = {
  __typename?: 'EventAuditLogPaginationOutput';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
};

/** Filter options for event audit logs */
export type EventAuditLogPlaceHierarchyFilterInput = {
  buildingId?: InputMaybe<Scalars['Int']>;
  floorId?: InputMaybe<Scalars['Int']>;
  spaceId?: InputMaybe<Scalars['Int']>;
};

export type EventAuditLogTimeRangeInput = {
  endTime: Scalars['ISODateTime'];
  startTime: Scalars['ISODateTime'];
};

export type EventConfirmation = {
  __typename?: 'EventConfirmation';
  confirmedAt?: Maybe<Scalars['String']>;
  deviceId?: Maybe<Scalars['Int']>;
  eventId: Scalars['ID'];
  userId?: Maybe<Scalars['ID']>;
};

export const EventCreationType = {
  AUTOMATIC: 'AUTOMATIC',
  MANUAL: 'MANUAL',
  PROXIED: 'PROXIED',
  SYNCED: 'SYNCED',
  UNKNOWN: 'UNKNOWN'
} as const;

export type EventCreationType = typeof EventCreationType[keyof typeof EventCreationType];
/** When dealing with events that may not exist yet, the robinEventId is unknown. In this case, we only know the ical UID that we will set on the event when we create it. Note that referencing recurring events is not allowed, must reference a specific instance. */
export type EventInstanceReference = {
  ical?: InputMaybe<IcalInstanceReference>;
  robinEventId?: InputMaybe<Scalars['ID']>;
};

export type EventInvitee = {
  __typename?: 'EventInvitee';
  displayName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  eventId: Scalars['ID'];
  id?: Maybe<Scalars['ID']>;
  isOrganizer: Scalars['Boolean'];
  isResource: Scalars['Boolean'];
  /** Gets an onsite for an invitee in a specific location at event's date. */
  onsiteInLocation?: Maybe<EventInviteeOnsiteStatus>;
  /** Gets an onsite for an invitee in a specific location for a date */
  onsiteInLocationForDate?: Maybe<EventInviteeOnsiteStatus>;
  participationRole: EventParticipationRole;
  responseStatus: EventResponseStatus;
  spaceId?: Maybe<Scalars['ID']>;
  user?: Maybe<User>;
};


export type EventInviteeOnsiteInLocationArgs = {
  locationId: Scalars['ID'];
};


export type EventInviteeOnsiteInLocationForDateArgs = {
  date: Scalars['LocalDate'];
  locationId: Scalars['ID'];
};

export type EventInviteeOnsiteStatus = {
  __typename?: 'EventInviteeOnsiteStatus';
  /** The desk reservations for this onsite entry */
  deskReservations: Array<Reservation>;
  /** The ID of the day's response. */
  id: Scalars['ID'];
  /** The method used to set the current onsite status. */
  onsiteConfirmationMethod: OnsiteConfirmationMethod;
  /** The type of onsite entry */
  onsiteType: OnsiteType;
  /** Onsite type set at timestamp. */
  onsiteTypeSetAt?: Maybe<Scalars['ISODateTime']>;
};

export const EventParticipationRole = {
  CHAIR: 'CHAIR',
  NON_PARTICIPANT: 'NON_PARTICIPANT',
  OPTIONAL: 'OPTIONAL',
  REQUIRED: 'REQUIRED',
  UNKNOWN: 'UNKNOWN'
} as const;

export type EventParticipationRole = typeof EventParticipationRole[keyof typeof EventParticipationRole];
export const EventResponseStatus = {
  ACCEPTED: 'ACCEPTED',
  DECLINED: 'DECLINED',
  DELEGATED: 'DELEGATED',
  NOT_RESPONDED: 'NOT_RESPONDED',
  TENTATIVE: 'TENTATIVE',
  UNKNOWN: 'UNKNOWN'
} as const;

export type EventResponseStatus = typeof EventResponseStatus[keyof typeof EventResponseStatus];
export type EventTrackingOnlyResponse = {
  __typename?: 'EventTrackingOnlyResponse';
  /** eventType is null when no state is updated but result is still successful */
  eventType?: Maybe<Scalars['ID']>;
  /** value is -1 when no state is updated but result is still successful */
  value: Scalars['Int'];
};

export const EventUpdateFailReasons = {
  LACKING_EVENT_UPDATE_PERMISSIONS: 'LACKING_EVENT_UPDATE_PERMISSIONS',
  SPACE_DECLINED: 'SPACE_DECLINED',
  SPACE_UNAVAILABLE: 'SPACE_UNAVAILABLE',
  UNKNOWN: 'UNKNOWN'
} as const;

export type EventUpdateFailReasons = typeof EventUpdateFailReasons[keyof typeof EventUpdateFailReasons];
export type EventUpdatePermission = {
  __typename?: 'EventUpdatePermission';
  eventId: Scalars['String'];
  id: Scalars['String'];
  isPermitted: Scalars['Boolean'];
};

export type EventWithCheckInStatus = {
  __typename?: 'EventWithCheckInStatus';
  checkInEndTime: Scalars['String'];
  checkInStartTime: Scalars['String'];
  checkInStatus: CheckInStatus;
  inviteeEvent?: Maybe<InviteeEvent>;
  spaceId: Scalars['String'];
};

export type ExcludeAllDaysFromScheduleInput = {
  fri?: InputMaybe<Scalars['Boolean']>;
  mon?: InputMaybe<Scalars['Boolean']>;
  sat?: InputMaybe<Scalars['Boolean']>;
  sun?: InputMaybe<Scalars['Boolean']>;
  thu?: InputMaybe<Scalars['Boolean']>;
  tue?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['String'];
  wed?: InputMaybe<Scalars['Boolean']>;
};

export type Exclusion = {
  __typename?: 'Exclusion';
  endTime?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** @deprecated temporally broken because API currently provides series master id instead of the instance id */
  reservation?: Maybe<Reservation>;
  startTime: Scalars['String'];
};

/** Basic information about the external account */
export type ExternalAccountInfo = {
  __typename?: 'ExternalAccountInfo';
  id: Scalars['ID'];
  type: ExternalAccountType;
};

/** External account integration status information */
export type ExternalAccountStatus = {
  __typename?: 'ExternalAccountStatus';
  externalAccount: ExternalAccountInfo;
  status: IntegrationStatus;
};

/** External account integration types. */
export const ExternalAccountType = {
  GOOGLE: 'GOOGLE',
  MICROSOFT_GRAPH: 'MICROSOFT_GRAPH'
} as const;

export type ExternalAccountType = typeof ExternalAccountType[keyof typeof ExternalAccountType];
export type ExternalEvent = {
  __typename?: 'ExternalEvent';
  description: Scalars['String'];
  endDate: Scalars['ISODateTime'];
  id: Scalars['ID'];
  imageUrl: Scalars['String'];
  name: Scalars['String'];
  sourceUrl: Scalars['String'];
  startDate: Scalars['ISODateTime'];
  ticketUrl?: Maybe<Scalars['String']>;
  venue: ExternalEventVenue;
};

export type ExternalEventVenue = {
  __typename?: 'ExternalEventVenue';
  address: Scalars['String'];
  city: Scalars['String'];
  country: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  region: Scalars['String'];
};

export type ExternalIntegration = {
  __typename?: 'ExternalIntegration';
  archivedAt?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  enabled?: Maybe<Scalars['Boolean']>;
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  integrationJson?: Maybe<Scalars['Json']>;
  name?: Maybe<Scalars['String']>;
  tenantId: Scalars['ID'];
  updatedAt?: Maybe<Scalars['Date']>;
};

export const FeatureFlagType = {
  /** Enables category images for activities */
  ACTIVITIES_CATEGORY_IMAGES_SUPPORT: 'ACTIVITIES_CATEGORY_IMAGES_SUPPORT',
  /** Enable Chat Functionality on Activities */
  ACTIVITY_CHAT: 'ACTIVITY_CHAT',
  /** Enables add a space modal on web */
  ADD_SPACE_MODAL_WEB: 'ADD_SPACE_MODAL_WEB',
  /** Enables the ui for the auto desk booking for employee and admin */
  AUTO_DESK_BOOKING: 'AUTO_DESK_BOOKING',
  /** Enables the ui for booking multiples days in a week */
  BOOK_DESK_AHEAD: 'BOOK_DESK_AHEAD',
  /** Enables the bulk map uploads */
  BULK_MAP_UPLOADS: 'BULK_MAP_UPLOADS',
  /** Feature sends out notifications out when a calendar integration or space calendars are detected to be in a bad state */
  CALENDAR_HEALTH_NOTIFICATIONS: 'CALENDAR_HEALTH_NOTIFICATIONS',
  /** Enables the schedule Information tab for campus app */
  CAMPUS_APP: 'CAMPUS_APP',
  /** New booking flow */
  CONSOLIDATED_BOOKING_FLOW: 'CONSOLIDATED_BOOKING_FLOW',
  /** Enables creating, editing, and using custom fields for guest visits */
  CUSTOM_VISIT_FIELDS: 'CUSTOM_VISIT_FIELDS',
  /** Enables adding/removing custom visit types */
  CUSTOM_VISIT_TYPES: 'CUSTOM_VISIT_TYPES',
  /** Enables the create org functionality in the dashboard apps project */
  DASHBOARD_APPS_CREATE_ORGANIZATION: 'DASHBOARD_APPS_CREATE_ORGANIZATION',
  /** Allow user to view the new onboarding flow */
  DASHBOARD_APPS_ONBOARDING: 'DASHBOARD_APPS_ONBOARDING',
  /** Enables the new schedule tab in the dashboard apps project */
  DASHBOARD_APPS_SCHEDULE_TAB: 'DASHBOARD_APPS_SCHEDULE_TAB',
  /** Enables the dashboard deliveries tab */
  DELIVERIES_TAB: 'DELIVERIES_TAB',
  /** Enables desk issue reporting */
  DESK_ISSUE_REPORTING: 'DESK_ISSUE_REPORTING',
  /** Document agreements (NDAs, liability waivers, etc.) */
  DOCUMENT_AGREEMENTS: 'DOCUMENT_AGREEMENTS',
  /** Enables desk reservation edits */
  EDIT_DESK_RESERVATIONS: 'EDIT_DESK_RESERVATIONS',
  /** Enables the employee visits feature set */
  EMPLOYEE_VISITS: 'EMPLOYEE_VISITS',
  /** Enables the enforcement of workplace service licensing */
  ENFORCE_WORKPLACE_SERVICE_LICENSING: 'ENFORCE_WORKPLACE_SERVICE_LICENSING',
  /** Enables external event sync from OccasionGenius */
  EXTERNAL_OCCASION_GENIUS_EVENT_SYNC: 'EXTERNAL_OCCASION_GENIUS_EVENT_SYNC',
  /** Enables Global Hybrid Index page */
  HYBRID_INDEX: 'HYBRID_INDEX',
  /** Enables new analytics visualizations */
  INSIGHTS_UI_REDESIGN: 'INSIGHTS_UI_REDESIGN',
  /** Enables issue reporting V2 - report issues with spaces */
  ISSUE_REPORTING_V2: 'ISSUE_REPORTING_V2',
  /** Language selection feature flag for project Global */
  LANGUAGE_SELECTION_ENABLED: 'LANGUAGE_SELECTION_ENABLED',
  /** Enables the mobile week view home tab */
  MOBILE_HOME_TAB_WEEK_VIEW: 'MOBILE_HOME_TAB_WEEK_VIEW',
  /** Enables the meetings/space functionality on the Schedule tab in MS Teams */
  MS_TEAMS_SPACE_BOOKING: 'MS_TEAMS_SPACE_BOOKING',
  /** Enables the use of office activities */
  OFFICE_ACTIVITIES: 'OFFICE_ACTIVITIES',
  /** Enables the use of office activities for mobile */
  OFFICE_ACTIVITIES_MOBILE: 'OFFICE_ACTIVITIES_MOBILE',
  /** Enables components intented to improve the office tab performance */
  OFFICE_TAB_PERFORMANCE: 'OFFICE_TAB_PERFORMANCE',
  /** Enables the onboarding map upload flow */
  ONBOARDING_MAP_UPLOAD: 'ONBOARDING_MAP_UPLOAD',
  /** Enables passive check in */
  PASSIVE_CHECK_IN: 'PASSIVE_CHECK_IN',
  /** Enables the new People tab within insights */
  PEOPLE_INSIGHTS: 'PEOPLE_INSIGHTS',
  /** Optimizes people search */
  PEOPLE_SEARCH_OPTIMIZATION: 'PEOPLE_SEARCH_OPTIMIZATION',
  /** Enables people tab in dashboard apps */
  PEOPLE_TAB_DASHBOARD_APPS: 'PEOPLE_TAB_DASHBOARD_APPS',
  /** Enables team phoenix to toggle features that are in mid development and still release as needed */
  PHOENIX_DEV: 'PHOENIX_DEV',
  /** Enables Office Utilization insights page */
  REAL_ESTATE_OPTIMIZATION_INSIGHTS: 'REAL_ESTATE_OPTIMIZATION_INSIGHTS',
  /** Allow user to view the new schedule desk booking flow */
  SCHEDULE_DESK_BOOKING_ENABLED: 'SCHEDULE_DESK_BOOKING_ENABLED',
  /** Sharptooth team feature flag for development */
  SHARPTOOTH_DEVELOPMENT: 'SHARPTOOTH_DEVELOPMENT',
  /** Deprecate old work place service features across the platform */
  SHOW_LEGACY_WORKPLACE_SERVICE: 'SHOW_LEGACY_WORKPLACE_SERVICE',
  /** Enables suggested spaces on mobile */
  SPACE_SUGGESTIONS_MOBILE: 'SPACE_SUGGESTIONS_MOBILE',
  /** Enables space recommendations */
  SUGGESTED_SPACES: 'SUGGESTED_SPACES',
  /** Admins can create questions that accept file uploads */
  TICKET_FILE_UPLOADS: 'TICKET_FILE_UPLOADS',
  /** Enables the ability to capture images to be used on visitor badges */
  VISITOR_BADGE_IMAGES: 'VISITOR_BADGE_IMAGES',
  /** Enables the ability to add badge printing functionality to arrival displays */
  VISITOR_BADGE_PRINTING: 'VISITOR_BADGE_PRINTING',
  /** Enables visit list table csv export */
  VISITOR_CSV_EXPORT: 'VISITOR_CSV_EXPORT',
  /** Enables the ability to select a range of dates for a visitor to export */
  VISITOR_EXPORT_DATE_RANGE: 'VISITOR_EXPORT_DATE_RANGE',
  /** Visitor managment location enablement */
  VISITOR_LOCATION_ENABLEMENT: 'VISITOR_LOCATION_ENABLEMENT',
  /** Enables permissions checks to gate certain visitor management features */
  VISITOR_MANAGEMENT_PERMISSIONS: 'VISITOR_MANAGEMENT_PERMISSIONS',
  /** Enables who's in sidebar on week view page */
  WEEKVIEW_WHOSIN_SIDEBAR_ENABLED: 'WEEKVIEW_WHOSIN_SIDEBAR_ENABLED',
  /** Enables the ui for workplace services page and request forms to admins and users */
  WORKPLACE_SERVICES: 'WORKPLACE_SERVICES',
  /** Reveals features for managing work areas */
  WORK_AREAS: 'WORK_AREAS',
  /** Reveals feature for work areas on mobile */
  WORK_AREAS_MOBILE: 'WORK_AREAS_MOBILE',
  /** Reveals features for work area insights */
  WORK_AREA_INSIGHTS: 'WORK_AREA_INSIGHTS',
  /** Toggles the updated work week UX/UI */
  WORK_WEEK_IMPROVEMENT_ENABLED: 'WORK_WEEK_IMPROVEMENT_ENABLED',
  /** Toggles the updated (V2) work week UX/UI */
  WORK_WEEK_IMPROVEMENT_V2_ENABLED: 'WORK_WEEK_IMPROVEMENT_V2_ENABLED'
} as const;

export type FeatureFlagType = typeof FeatureFlagType[keyof typeof FeatureFlagType];
export const FeatureType = {
  ACTIVATED_USERS: 'ACTIVATED_USERS',
  ACTIVE_USERS: 'ACTIVE_USERS',
  BOOKABLE_SEATS: 'BOOKABLE_SEATS',
  BOOKABLE_SPACES: 'BOOKABLE_SPACES',
  EXPORTABLE_DATA_DAYS: 'EXPORTABLE_DATA_DAYS',
  FEATURE: 'Feature',
  LEVELS: 'LEVELS',
  LOCATIONS: 'LOCATIONS',
  RIPPLING_USERS: 'RIPPLING_USERS',
  USERS: 'USERS',
  VIEWABLE_DATA_DAYS: 'VIEWABLE_DATA_DAYS',
  VISITOR_ENABLED_LOCATIONS: 'VISITOR_ENABLED_LOCATIONS',
  WORKPLACE_SERVICES_ENABLED_LOCATIONS: 'WORKPLACE_SERVICES_ENABLED_LOCATIONS'
} as const;

export type FeatureType = typeof FeatureType[keyof typeof FeatureType];
export const FeedbackRating = {
  NEGATIVE: 'negative',
  POSITIVE: 'positive'
} as const;

export type FeedbackRating = typeof FeedbackRating[keyof typeof FeedbackRating];
export type Floor = {
  __typename?: 'Floor';
  building: Building;
  id: Scalars['ID'];
  label: Scalars['String'];
};

export type FloorNeighborhoodsResponse = {
  __typename?: 'FloorNeighborhoodsResponse';
  neighborhoods: Array<Neighborhood>;
  showNeighborhoodColors: Scalars['Boolean'];
};

/** https://developer.mozilla.org/en-US/docs/Web/API/FormData/entries */
export type FormDataField = {
  __typename?: 'FormDataField';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type ForwardPageInfo = {
  __typename?: 'ForwardPageInfo';
  /** Pass this into `after` to get results after this page. Null if no results. */
  endCursor?: Maybe<Scalars['String']>;
  /** True if there are more results after endCursor */
  hasNextPage: Scalars['Boolean'];
};

export const GallagherTenancy = {
  AU: 'AU',
  US: 'US'
} as const;

export type GallagherTenancy = typeof GallagherTenancy[keyof typeof GallagherTenancy];
export const GeneaTenancy = {
  US: 'US'
} as const;

export type GeneaTenancy = typeof GeneaTenancy[keyof typeof GeneaTenancy];
export type GenerateStickerBatchRequest = {
  count?: InputMaybe<Scalars['Int']>;
};

export type GenerateStickerBatchResponse = {
  __typename?: 'GenerateStickerBatchResponse';
  batch: StickerBatch;
};

export const GenericHealthCheckpointEntityType = {
  GUEST_INVITE: 'GUEST_INVITE'
} as const;

export type GenericHealthCheckpointEntityType = typeof GenericHealthCheckpointEntityType[keyof typeof GenericHealthCheckpointEntityType];
export type GenericHealthCheckpointResponse = {
  __typename?: 'GenericHealthCheckpointResponse';
  id: Scalars['ID'];
  status: GenericHealthCheckpointStatus;
};

export const GenericHealthCheckpointStatus = {
  COMPLETE: 'COMPLETE',
  FAILED: 'FAILED',
  INCOMPLETE: 'INCOMPLETE',
  PASSED: 'PASSED',
  UNKNOWN: 'UNKNOWN'
} as const;

export type GenericHealthCheckpointStatus = typeof GenericHealthCheckpointStatus[keyof typeof GenericHealthCheckpointStatus];
export const GeoJsonType = {
  FEATURE: 'Feature'
} as const;

export type GeoJsonType = typeof GeoJsonType[keyof typeof GeoJsonType];
export type Geometry = {
  __typename?: 'Geometry';
  coordinates: Array<Array<Array<Scalars['Float']>>>;
  type: GeometryType;
};

export type GeometryInput = {
  coordinates: Array<Array<Array<Scalars['Float']>>>;
  type: GeometryType;
};

export const GeometryType = {
  POLYGON: 'Polygon'
} as const;

export type GeometryType = typeof GeometryType[keyof typeof GeometryType];
export type GetActivityCoverImagesResponse = {
  __typename?: 'GetActivityCoverImagesResponse';
  forwardPageInfo: ForwardPageInfo;
  images: Array<ActivityImage>;
};

export type GetBadgeCsvUploadStatusForCurrentTenantError = {
  __typename?: 'GetBadgeCSVUploadStatusForCurrentTenantError';
  failedRecordsCount: Scalars['Int'];
  reason: Scalars['String'];
};

export type GetBadgeCsvUploadStatusInput = {
  uuid: Scalars['ID'];
};

export type GetBadgeCsvUploadStatusResponse = {
  __typename?: 'GetBadgeCSVUploadStatusResponse';
  errors: Array<BadgeCsvUploadStatusError>;
  status: Scalars['String'];
};

export type GetBadgeCsvUploadsForCurrentTenantPagination = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type GetBadgeCsvUploadsForCurrentTenantResponse = {
  __typename?: 'GetBadgeCSVUploadsForCurrentTenantResponse';
  pagination: PagedPaginationResponse;
  records: Array<GetBadgeCsvUploadsForCurrentTenantResponseRecords>;
};

export type GetBadgeCsvUploadsForCurrentTenantResponseRecords = {
  __typename?: 'GetBadgeCSVUploadsForCurrentTenantResponseRecords';
  canForceRetry: Scalars['Boolean'];
  downloadLink?: Maybe<Scalars['String']>;
  errors: Array<GetBadgeCsvUploadStatusForCurrentTenantError>;
  fileName: Scalars['String'];
  location?: Maybe<Location>;
  status: Scalars['String'];
  uploadedAt: Scalars['String'];
  uploader?: Maybe<AccountUser>;
  userActor: Scalars['Int'];
  uuid: Scalars['ID'];
};

export type GetBrivoAccountStatusForCurrentTenant = {
  __typename?: 'GetBrivoAccountStatusForCurrentTenant';
  isHealthy: Scalars['Boolean'];
  unhealthyReasons: Array<Scalars['String']>;
};

export type GetBrivoLocksForCurrentTenant = {
  __typename?: 'GetBrivoLocksForCurrentTenant';
  sites: Array<GetBrivoLocksForCurrentTenantLock>;
};

export type GetBrivoLocksForCurrentTenantLock = {
  __typename?: 'GetBrivoLocksForCurrentTenantLock';
  remoteLockId: Scalars['ID'];
  remoteLockName: Scalars['String'];
  remotePlaceId: Scalars['String'];
  remotePlaceName: Scalars['String'];
  robinLevelId?: Maybe<Scalars['Int']>;
  robinLocationId?: Maybe<Scalars['Int']>;
};

export type GetBuildingGeofenceInput = {
  buildingId: Scalars['ID'];
};

export type GetBuildingGeofenceResponse = {
  __typename?: 'GetBuildingGeofenceResponse';
  geofence: BuildingGeofence;
};

export type GetCredentialDetailsForCurrentTenantDoor = {
  __typename?: 'GetCredentialDetailsForCurrentTenantDoor';
  doorId: Scalars['String'];
  doorName: Scalars['String'];
  floorName?: Maybe<Scalars['String']>;
};

export type GetCredentialDetailsForCurrentTenantInput = {
  linkToken: Scalars['String'];
};

export type GetCredentialDetailsForCurrentTenantResponse = {
  __typename?: 'GetCredentialDetailsForCurrentTenantResponse';
  doors: Array<GetCredentialDetailsForCurrentTenantDoor>;
  endTime: Scalars['String'];
  startTime: Scalars['String'];
  vendor: Scalars['String'];
};

export type GetCredentialOrganizationAndLocationInfoForCurrentTenantInput = {
  linkToken: Scalars['String'];
};

export type GetCredentialOrganizationAndLocationInfoForCurrentTenantResponse = {
  __typename?: 'GetCredentialOrganizationAndLocationInfoForCurrentTenantResponse';
  organizationLogoUrl: Scalars['String'];
  organizationName: Scalars['String'];
  robinLocationName: Scalars['String'];
};

export type GetCurrentActorBadgePermissionsForCurrentTenantReponse = {
  __typename?: 'GetCurrentActorBadgePermissionsForCurrentTenantReponse';
  canManageKisi: Scalars['Boolean'];
  canUpload: Scalars['Boolean'];
};

export type GetDeskAvailabilityByLevelIdFiltersInput = {
  deskAmenityIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type GetDeskAvailabilityByLevelIdScopeInput = {
  levelId: Scalars['ID'];
};

export type GetDeskAvailabilityByLevelIdViewOptionsInput = {
  endTime: Scalars['ISODateTime'];
  startTime: Scalars['ISODateTime'];
};

export const GetEphemeralDownloadUrlForScannedTicketFileErrorReason = {
  STILL_SCANNING: 'STILL_SCANNING',
  UNKNOWN_SCAN_ERROR: 'UNKNOWN_SCAN_ERROR',
  VIRUS_DETECTED: 'VIRUS_DETECTED'
} as const;

export type GetEphemeralDownloadUrlForScannedTicketFileErrorReason = typeof GetEphemeralDownloadUrlForScannedTicketFileErrorReason[keyof typeof GetEphemeralDownloadUrlForScannedTicketFileErrorReason];
export type GetEphemeralDownloadUrlForScannedTicketFileErrorResponse = {
  __typename?: 'GetEphemeralDownloadUrlForScannedTicketFileErrorResponse';
  reason: GetEphemeralDownloadUrlForScannedTicketFileErrorReason;
};

export type GetEphemeralDownloadUrlForScannedTicketFileResponse = GetEphemeralDownloadUrlForScannedTicketFileErrorResponse | GetEphemeralDownloadUrlForScannedTicketFileSuccessResponse;

export type GetEphemeralDownloadUrlForScannedTicketFileSuccessResponse = {
  __typename?: 'GetEphemeralDownloadUrlForScannedTicketFileSuccessResponse';
  expiresAt: Scalars['ISODateTime'];
  url: Scalars['String'];
};

export type GetEventAuditLogsByEventIdInput = {
  eventId: Scalars['ID'];
  pagination: EventAuditLogPaginationInput;
};

export type GetEventAuditLogsByEventIdResponse = {
  __typename?: 'GetEventAuditLogsByEventIdResponse';
  logs: Array<EventAuditLog>;
  pagination: EventAuditLogPaginationOutput;
};

export type GetEventAuditLogsInput = {
  filter: EventAuditLogFilterInput;
  pagination: EventAuditLogPaginationInput;
  timeRange: EventAuditLogTimeRangeInput;
};

export type GetEventAuditLogsPaginatedResponse = {
  __typename?: 'GetEventAuditLogsPaginatedResponse';
  logs: Array<EventAuditLog>;
  pagination: EventAuditLogPaginationOutput;
};

export type GetEventsWithCheckInStatusForProxiedEventIdReponse = {
  __typename?: 'GetEventsWithCheckInStatusForProxiedEventIdReponse';
  events: Array<EventWithCheckInStatus>;
};

export type GetGallagherAccountForCurrentTenant = {
  __typename?: 'GetGallagherAccountForCurrentTenant';
  emailFieldIdentifier?: Maybe<Scalars['String']>;
  integrationUuid?: Maybe<Scalars['ID']>;
  isHealthy: Scalars['Boolean'];
  unhealthyReasons: Array<Scalars['String']>;
};

export type GetGallagherDoorsByIntegrationUuid = {
  __typename?: 'GetGallagherDoorsByIntegrationUuid';
  doors: Array<GetGallagherDoorsByIntegrationUuidDoor>;
};

export type GetGallagherDoorsByIntegrationUuidDoor = {
  __typename?: 'GetGallagherDoorsByIntegrationUuidDoor';
  remoteDoorId: Scalars['ID'];
  remoteDoorName: Scalars['String'];
  robinLevelId?: Maybe<Scalars['Int']>;
  robinLocationId?: Maybe<Scalars['Int']>;
};

export type GetGallagherDoorsByIntegrationUuidInput = {
  integrationUuid: Scalars['ID'];
};

export type GetGeneaAccountForCurrentTenant = {
  __typename?: 'GetGeneaAccountForCurrentTenant';
  integrationUuid?: Maybe<Scalars['ID']>;
  isHealthy: Scalars['Boolean'];
  unhealthyReasons: Array<Scalars['String']>;
};

export type GetGeneaDoorsForCurrentTenant = {
  __typename?: 'GetGeneaDoorsForCurrentTenant';
  doors: Array<GetGeneaDoorsForCurrentTenantLock>;
};

export type GetGeneaDoorsForCurrentTenantLock = {
  __typename?: 'GetGeneaDoorsForCurrentTenantLock';
  remoteDoorId: Scalars['ID'];
  remoteDoorName: Scalars['String'];
  remoteLocationId: Scalars['String'];
  remoteLocationName: Scalars['String'];
  robinLevelId?: Maybe<Scalars['Int']>;
  robinLocationId?: Maybe<Scalars['Int']>;
};

export type GetGenetecAccountForCurrentTenant = {
  __typename?: 'GetGenetecAccountForCurrentTenant';
  integrationUuid?: Maybe<Scalars['ID']>;
  isHealthy: Scalars['Boolean'];
  unhealthyReasons: Array<Scalars['String']>;
};

export type GetGenetecDoorsByIntegrationUuidDoor = {
  __typename?: 'GetGenetecDoorsByIntegrationUuidDoor';
  remoteDoorId: Scalars['ID'];
  remoteDoorName: Scalars['String'];
  robinLevelId?: Maybe<Scalars['Int']>;
  robinLocationId?: Maybe<Scalars['Int']>;
};

export type GetGenetecDoorsByIntegrationUuidInput = {
  integrationUuid: Scalars['ID'];
};

export type GetGenetecDoorsByIntegrationUuidResponse = {
  __typename?: 'GetGenetecDoorsByIntegrationUuidResponse';
  doors: Array<GetGenetecDoorsByIntegrationUuidDoor>;
};

export type GetKisiAccountStatusForCurrentTenant = {
  __typename?: 'GetKisiAccountStatusForCurrentTenant';
  isHealthy: Scalars['Boolean'];
  unhealthyReasons: Array<Scalars['String']>;
};

export type GetKisiLocksForCurrentTenant = {
  __typename?: 'GetKisiLocksForCurrentTenant';
  sites: Array<GetKisiLocksForCurrentTenantLock>;
};

export type GetKisiLocksForCurrentTenantLock = {
  __typename?: 'GetKisiLocksForCurrentTenantLock';
  isConfigured: Scalars['Boolean'];
  isOnline: Scalars['Boolean'];
  remoteLockId: Scalars['String'];
  remoteLockName: Scalars['String'];
  remotePlaceId: Scalars['String'];
  remotePlaceName: Scalars['String'];
  robinLevelId?: Maybe<Scalars['Int']>;
  robinLocationId?: Maybe<Scalars['Int']>;
};

export type GetMeetingServiceByIdResponse = {
  __typename?: 'GetMeetingServiceByIdResponse';
  /** null if meeting service with ID cannot be found */
  meetingService?: Maybe<MeetingService>;
};

export type GetMeetingServiceRequestByIdResponse = {
  __typename?: 'GetMeetingServiceRequestByIdResponse';
  meetingServiceRequest?: Maybe<MeetingServiceRequest>;
};

export type GetMeetingServiceRequestByIdentifierResponse = {
  __typename?: 'GetMeetingServiceRequestByIdentifierResponse';
  meetingServiceRequest?: Maybe<MeetingServiceRequest>;
};

export type GetMobileGeofencesForMeInTenantInput = {
  tenantId: Scalars['ID'];
};

export type GetMobileGeofencesForMeInTenantResponse = {
  __typename?: 'GetMobileGeofencesForMeInTenantResponse';
  geofences: Array<MobileGeofence>;
};

export type GetMyWaitlistResponse = {
  __typename?: 'GetMyWaitlistResponse';
  /** The active URL for actor to open up. It will change based on the current state of the waitlist and potentially will return different URLs based on actor's status in the queue. */
  activeUrl?: Maybe<Scalars['String']>;
  /** Same as status == NOT_ENABLED, but simpler for front-ends to filter by this. */
  isEnabled: Scalars['Boolean'];
  status: GetMyWaitlistStatus;
};

export const GetMyWaitlistStatus = {
  /** A waitlist is available and can be opened. */
  AVAILABLE: 'AVAILABLE',
  /** Waitlist not enabled. */
  NOT_ENABLED: 'NOT_ENABLED',
  /** Currently queued in a waitlist. */
  SCHEDULED: 'SCHEDULED'
} as const;

export type GetMyWaitlistStatus = typeof GetMyWaitlistStatus[keyof typeof GetMyWaitlistStatus];
export type GetMyWaitlistsResponse = {
  __typename?: 'GetMyWaitlistsResponse';
  /** Global flag indicating if waitlists are enabled for this context. */
  isEnabled: Scalars['Boolean'];
  waitlists: Array<GetMyWaitlistsResponseWaitlists>;
};

export type GetMyWaitlistsResponseWaitlists = {
  __typename?: 'GetMyWaitlistsResponseWaitlists';
  /** The active URL for actor to open up. It will change based on the current state of the waitlist and potentially will return different URLs based on actor's status in the queue. */
  activeUrl?: Maybe<Scalars['String']>;
  /** Waitlist name, usually shown in the UI. */
  name?: Maybe<Scalars['String']>;
  /** Current status of the waitlist. */
  status: GetMyWaitlistsStatus;
  /** Status byline shown in the UI. Can show estimated waiting time etc. */
  statusByline?: Maybe<Scalars['String']>;
};

export const GetMyWaitlistsStatus = {
  /** A waitlist is available and can be opened. */
  AVAILABLE: 'AVAILABLE',
  /** Waitlist not enabled. */
  NOT_ENABLED: 'NOT_ENABLED',
  /** Currently queued in a waitlist. */
  SCHEDULED: 'SCHEDULED'
} as const;

export type GetMyWaitlistsStatus = typeof GetMyWaitlistsStatus[keyof typeof GetMyWaitlistsStatus];
export type GetNeighborhoodByIdResponse = {
  __typename?: 'GetNeighborhoodByIdResponse';
  neighborhood: Neighborhood;
  showNeighborhoodColors: Scalars['Boolean'];
};

export type GetOpenpathAccountStatusForCurrentTenant = {
  __typename?: 'GetOpenpathAccountStatusForCurrentTenant';
  credentialProvisioningEnabled: Scalars['Boolean'];
  integrationUuid?: Maybe<Scalars['ID']>;
  isHealthy: Scalars['Boolean'];
  presenceReportingEnabled: Scalars['Boolean'];
  unhealthyReasons: Array<Scalars['String']>;
};

export type GetOpenpathLocksForCurrentTenant = {
  __typename?: 'GetOpenpathLocksForCurrentTenant';
  sites: Array<GetOpenpathLocksForCurrentTenantLock>;
};

export type GetOpenpathLocksForCurrentTenantLock = {
  __typename?: 'GetOpenpathLocksForCurrentTenantLock';
  remoteLockId: Scalars['String'];
  remoteLockName: Scalars['String'];
  remotePlaceId: Scalars['String'];
  remotePlaceName: Scalars['String'];
  robinLevelId?: Maybe<Scalars['Int']>;
  robinLocationId?: Maybe<Scalars['Int']>;
};

export type GetPublishedDraftResponse = {
  __typename?: 'GetPublishedDraftResponse';
  content: ReviewDraftChangesResponse;
  floor: Level;
  hasAuditLogs: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  reviewVersion: Scalars['Int'];
  settings: Array<DraftSettings>;
};

export type GetRipplingAccountStateResponse = {
  __typename?: 'GetRipplingAccountStateResponse';
  lastSync: Scalars['String'];
  state: SyncState;
  syncedUsers: Scalars['Int'];
};

export type GetSpaceSuggestableEventsForUserResponse = {
  __typename?: 'GetSpaceSuggestableEventsForUserResponse';
  events: Array<Event>;
};

export type GetSuggestedSpaceForEventsEventInput = {
  endTime: Scalars['ISODateTime'];
  id: Scalars['ID'];
  /** Represents the number of attendees that are in the office for the filtered location and also accepted the event */
  preferredSpaceCapacity?: InputMaybe<Scalars['Int']>;
  startTime: Scalars['ISODateTime'];
};

/** How to decide which spaces to suggest - for A/B testing */
export const GetSuggestedSpacesForEventsAlgorithm = {
  FRECENCY_V1: 'FRECENCY_V1',
  FRECENCY_V2: 'FRECENCY_V2'
} as const;

export type GetSuggestedSpacesForEventsAlgorithm = typeof GetSuggestedSpacesForEventsAlgorithm[keyof typeof GetSuggestedSpacesForEventsAlgorithm];
export type GetSuggestedSpacesForEventsInput = {
  algorithm?: InputMaybe<GetSuggestedSpacesForEventsAlgorithm>;
  events: Array<GetSuggestedSpaceForEventsEventInput>;
  spaceFilters: GetSuggestedSpacesForEventsSpaceFiltersInput;
  /** Loose preferences for spaces - attempt to fit criteria but no guarantees */
  spacePreferences?: InputMaybe<GetSuggestedSpacesForEventsSpacePreferencesInput>;
};

export type GetSuggestedSpacesForEventsResponse = {
  __typename?: 'GetSuggestedSpacesForEventsResponse';
  /** Nullable to force resilience in the face of changing enum values */
  algorithm?: Maybe<GetSuggestedSpacesForEventsAlgorithm>;
  suggestedSpaces: Array<SuggestedSpaceForEvent>;
};

export type GetSuggestedSpacesForEventsSpaceFiltersInput = {
  locationIds: Array<Scalars['ID']>;
};

export type GetSuggestedSpacesForEventsSpacePreferencesInput = {
  levelIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** How to decide which spaces to suggest - for A/B testing */
export const GetSuggestedSpacesForTimeFrameAlgorithm = {
  FRECENCY_V1: 'FRECENCY_V1',
  FRECENCY_V2: 'FRECENCY_V2'
} as const;

export type GetSuggestedSpacesForTimeFrameAlgorithm = typeof GetSuggestedSpacesForTimeFrameAlgorithm[keyof typeof GetSuggestedSpacesForTimeFrameAlgorithm];
export type GetSuggestedSpacesForTimeFrameFiltersInput = {
  locationIds: Array<Scalars['ID']>;
};

export type GetSuggestedSpacesForTimeFrameInput = {
  algorithm?: InputMaybe<GetSuggestedSpacesForEventsAlgorithm>;
  endTime: Scalars['ISODateTime'];
  filters: GetSuggestedSpacesForTimeFrameFiltersInput;
  /** Loose preferences for spaces - attempt to fit criteria but no guarantees */
  spacePreferences?: InputMaybe<GetSuggestedSpacesForTimeFramePreferencesInput>;
  startTime: Scalars['ISODateTime'];
};

export type GetSuggestedSpacesForTimeFramePreferencesInput = {
  levelIds?: InputMaybe<Array<Scalars['ID']>>;
  preferredSpaceCapacity?: InputMaybe<Scalars['Int']>;
};

export type GetSuggestedSpacesForTimeFrameResponse = {
  __typename?: 'GetSuggestedSpacesForTimeFrameResponse';
  /** Nullable to force resilience in the face of changing enum values */
  algorithm?: Maybe<GetSuggestedSpacesForTimeFrameAlgorithm>;
  suggestedSpaces: Array<Space>;
};

/** Filters for getPaginatedSurveyResponses */
export type GetSurveyResponsesFilters = {
  /** FIlter results by one or more building(s) */
  buildingIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** End of search window */
  inOfficeAtEnd: Scalars['ISODateTime'];
  /** Beginning of search window */
  inOfficeAtStart: Scalars['ISODateTime'];
  /** Include pending, expired, and dismissed survey responses */
  includeIncomplete?: InputMaybe<Scalars['Boolean']>;
  /** Filter results by one or more rating(s) */
  ratings?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Filter resuts by a user ID */
  userId?: InputMaybe<Scalars['String']>;
};

/** Input for sorting survey responses by different keys */
export type GetSurveyResponsesSort = {
  /** The key to sort responses by */
  key: SurveyResponseSortKey;
  /** The order to sort that key */
  order: SortOrder;
};

export type GetTimeZonesForRipplingAddressesInput = {
  addresses: Array<Scalars['String']>;
};

export type GetTimeZonesForRipplingAddressesResponse = {
  __typename?: 'GetTimeZonesForRipplingAddressesResponse';
  timezones: Array<GetTimeZonesForRipplingAddressesResponseTimeZone>;
};

export type GetTimeZonesForRipplingAddressesResponseTimeZone = {
  __typename?: 'GetTimeZonesForRipplingAddressesResponseTimeZone';
  address: Scalars['String'];
  zone?: Maybe<Scalars['String']>;
};

export type GetUpdatePermissionsForEventsResponse = {
  __typename?: 'GetUpdatePermissionsForEventsResponse';
  events: Array<Maybe<EventUpdatePermission>>;
};

export type GetVerkadaAccountForCurrentTenant = {
  __typename?: 'GetVerkadaAccountForCurrentTenant';
  integrationUuid?: Maybe<Scalars['ID']>;
  isHealthy: Scalars['Boolean'];
  unhealthyReasons: Array<Scalars['String']>;
};

export type GetVerkadaDoorsForCurrentTenant = {
  __typename?: 'GetVerkadaDoorsForCurrentTenant';
  doors: Array<GetVerkadaDoorsForCurrentTenantLock>;
};

export type GetVerkadaDoorsForCurrentTenantLock = {
  __typename?: 'GetVerkadaDoorsForCurrentTenantLock';
  remoteDoorId: Scalars['ID'];
  remoteDoorName: Scalars['String'];
  remotePlaceId: Scalars['String'];
  remotePlaceName: Scalars['String'];
  robinLevelId?: Maybe<Scalars['Int']>;
  robinLocationId?: Maybe<Scalars['Int']>;
};

/** Useful context to show appropriate waitlist url for an actor. */
export type GetWaitlistForMeContext = {
  /** A flag indicating if current platform is a mobile app */
  isMobile?: InputMaybe<Scalars['Boolean']>;
  /** Location ID of the current context. */
  locationId?: InputMaybe<Scalars['String']>;
};

/** Useful context to show appropriate waitlist url for an actor. */
export type GetWaitlistsForMeContext = {
  /** A flag indicating if current platform is a mobile app */
  isMobile?: InputMaybe<Scalars['Boolean']>;
  /** Location ID of the current context. */
  locationId?: InputMaybe<Scalars['String']>;
};

/** Response wrapper for level-based onsite data queries. */
export type GetWhoIsOnsiteByLevelResponse = {
  __typename?: 'GetWhoIsOnsiteByLevelResponse';
  /** Retrieves data for a specific day */
  day: GetWhoIsOnsiteByLocationResponseDay;
  days: Array<GetWhoIsOnsiteByLocationResponseDay>;
  id: Scalars['ID'];
  level: Level;
};


/** Response wrapper for level-based onsite data queries. */
export type GetWhoIsOnsiteByLevelResponseDayArgs = {
  date: Scalars['LocalDate'];
};


/** Response wrapper for level-based onsite data queries. */
export type GetWhoIsOnsiteByLevelResponseDaysArgs = {
  dates: Array<Scalars['LocalDate']>;
};

/** Response wrapper for location-based onsite data queries. */
export type GetWhoIsOnsiteByLocationResponse = {
  __typename?: 'GetWhoIsOnsiteByLocationResponse';
  /** Retrieves data for a specific day */
  day: GetWhoIsOnsiteByLocationResponseDay;
  days: Array<GetWhoIsOnsiteByLocationResponseDay>;
  id: Scalars['ID'];
  location: Location;
};


/** Response wrapper for location-based onsite data queries. */
export type GetWhoIsOnsiteByLocationResponseDayArgs = {
  date: Scalars['LocalDate'];
};


/** Response wrapper for location-based onsite data queries. */
export type GetWhoIsOnsiteByLocationResponseDaysArgs = {
  dates: Array<Scalars['LocalDate']>;
};

/** Contains all onsite data for a specific day. */
export type GetWhoIsOnsiteByLocationResponseDay = {
  __typename?: 'GetWhoIsOnsiteByLocationResponseDay';
  /** The date in ISO 8601 format (YYYY-MM-DD) in location's time zone. */
  date: Scalars['String'];
  /** The day of the week (e.g., "MONDAY", "TUESDAY") in location's timezone. */
  dayOfWeek?: Maybe<DayOfWeek>;
  /** The ID of the day's response. */
  id: Scalars['ID'];
  /** List of onsite entries for this day. Can be ordered and limited based on input parameters. */
  onsites: Array<GetWhoIsOnsiteByLocationResponseDayOnsites>;
  /** Total count of onsite entries for this day excluding the returned onsites */
  remainingOnsitesWithoutResolvedOnsites: Scalars['Int'];
  /** Total anonymous onsites */
  totalAnonymousOnsites: Scalars['Int'];
  /** Total count of onsite entries, which were confirmed locally, for this day */
  totalLocallyConfirmedOnsites: Scalars['Int'];
  /** Total count of onsite entries, which were confirmed locally, for this day which have desk reservations. If there are multiple desk reservations, the count is not additionally incremented. */
  totalLocallyConfirmedOnsitesWithDeskReservations: Scalars['Int'];
  /** Total count of onsite entries for this day */
  totalOnsites: Scalars['Int'];
  /** Total count of onsite entries for this day which have desk reservations. If there are multiple desk reservations, the count is not additionally incremented. */
  totalOnsitesWithDeskReservations: Scalars['Int'];
  /** Total count of onsite entries for this day excluding the current user */
  totalOnsitesWithoutCurrentUser: Scalars['Int'];
  /** Total count of onsite entries, which were confirmed remotely, for this day */
  totalRemotelyConfirmedOnsites: Scalars['Int'];
  /** Total count of onsite entries, which were confirmed remotely, for this day which have desk reservations. If there are multiple desk reservations, the count is not additionally incremented. */
  totalRemotelyConfirmedOnsitesWithDeskReservations: Scalars['Int'];
  /** Total count of onsite entries, which are scheduled for this day */
  totalScheduledOnsites: Scalars['Int'];
  /** Total count of onsite entries, which are scheduled for this day which have desk reservations. If there are multiple desk reservations, the count is not additionally incremented. */
  totalScheduledOnsitesWithDeskReservations: Scalars['Int'];
};


/** Contains all onsite data for a specific day. */
export type GetWhoIsOnsiteByLocationResponseDayOnsitesArgs = {
  departmentQuery?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<OnsitesLimit>;
  offset?: InputMaybe<OnsitesOffset>;
  onsiteTypes?: InputMaybe<Array<OnsiteType>>;
  orderBy?: InputMaybe<Array<GetWhoIsOnsiteByLocationResponseDayOnsitesOrderBy>>;
  query?: InputMaybe<Scalars['String']>;
};

/** Represents a single onsite entry containing user information. */
export type GetWhoIsOnsiteByLocationResponseDayOnsites = {
  __typename?: 'GetWhoIsOnsiteByLocationResponseDayOnsites';
  /** The desk reservations for this onsite entry */
  deskReservations: Array<Reservation>;
  /** The ID of the day's response. */
  id: Scalars['ID'];
  /** The method used to set the current onsite status. */
  onsiteConfirmationMethod: OnsiteConfirmationMethod;
  /** The type of onsite entry */
  onsiteType: OnsiteType;
  /** Onsite type set at timestamp. */
  onsiteTypeSetAt?: Maybe<Scalars['ISODateTime']>;
  /** The user account information for this onsite entry */
  user: AccountUser;
};

/** Input type for specifying ordering criteria of onsite entries. */
export type GetWhoIsOnsiteByLocationResponseDayOnsitesOrderBy = {
  /** The direction of ordering */
  direction: OrderDirection;
  /** The field to order by */
  field: GetWhoIsOnsiteByLocationResponseDayOnsitesOrderField;
};

/** Available fields for ordering onsite entries. */
export const GetWhoIsOnsiteByLocationResponseDayOnsitesOrderField = {
  /** Order by confirmation status Lowest to highest is "SCHEDULED", "REMOTE_CONFIRMATION", "ON_SITE_CONFIRMATION" */
  CONFIRMATION_STATUS: 'CONFIRMATION_STATUS',
  /** Order by current user */
  CURRENT_USER: 'CURRENT_USER',
  /** Order by whether the user is marked as favorite by the current user */
  IS_MY_FAVORITE: 'IS_MY_FAVORITE',
  /** Order by user name */
  USER_NAME: 'USER_NAME'
} as const;

export type GetWhoIsOnsiteByLocationResponseDayOnsitesOrderField = typeof GetWhoIsOnsiteByLocationResponseDayOnsitesOrderField[keyof typeof GetWhoIsOnsiteByLocationResponseDayOnsitesOrderField];
export type GoogleBuilding = {
  __typename?: 'GoogleBuilding';
  buildingId?: Maybe<Scalars['String']>;
  buildingName?: Maybe<Scalars['String']>;
};

export type GoogleToRobinInput = {
  locationId: Scalars['String'];
  remoteGoogleId?: InputMaybe<Scalars['String']>;
  remoteGoogleLabel?: InputMaybe<Scalars['String']>;
};

export const GoogleWorkingLocationSourceOfTruth = {
  GOOGLE: 'GOOGLE',
  ROBIN: 'ROBIN'
} as const;

export type GoogleWorkingLocationSourceOfTruth = typeof GoogleWorkingLocationSourceOfTruth[keyof typeof GoogleWorkingLocationSourceOfTruth];
export type GoogleWorkingLocationSyncSetting = {
  __typename?: 'GoogleWorkingLocationSyncSetting';
  organizationId: Scalars['ID'];
  sourceOfTruth?: Maybe<Scalars['String']>;
};

export type Group = {
  __typename?: 'Group';
  id: Scalars['ID'];
  members: Array<User>;
  name: Scalars['String'];
  slug: Scalars['String'];
};


export type GroupMembersArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']>;
};

export type GroupedResourceSaveUpdateInput = {
  bookingType: WeeklyBookingCommand;
  customResourceInstanceId: Scalars['ID'];
  floorId: Scalars['ID'];
  locationId: Scalars['ID'];
  name: Scalars['String'];
  originatingCustomResourceTemplateId: Scalars['ID'];
  resourceGroupId: Scalars['ID'];
};

export type GroupedUnhealthyCalendarLocation = {
  __typename?: 'GroupedUnhealthyCalendarLocation';
  hasMoreUnhealthyCalendars: Scalars['Boolean'];
  locationId: Scalars['ID'];
  locationName: Scalars['String'];
  unhealthyCalendars: Array<UnhealthyCalendar>;
};

export type GroupedUnhealthyCalendarOrg = {
  __typename?: 'GroupedUnhealthyCalendarOrg';
  locations: Array<GroupedUnhealthyCalendarLocation>;
  orgId: Scalars['Int'];
  orgName: Scalars['String'];
};

/** A Guest is someone who was invited to a Visit. A single guest may be invited to multiple Visits, via a GuestInvite that's unique for each visit. */
export type Guest = {
  __typename?: 'Guest';
  /** Email address of the guest */
  guestEmail: Scalars['String'];
  /** Name of the guest, ex Jeff Jefferson */
  guestName: Scalars['String'];
  /** Guest unique identifier */
  id: Scalars['ID'];
  /** URL of the guest's image */
  imageURL?: Maybe<Scalars['String']>;
  /** Guest personal identity information has been obfuscated */
  isObfuscated: Scalars['Boolean'];
  /** If this guest has been PII obfuscated, it occurred on this date and time */
  obfuscatedOn?: Maybe<Scalars['ISODateTime']>;
};

export type GuestInputType = {
  /** Custom fields for the guest */
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  /** Email address of the guest */
  guestEmail?: InputMaybe<Scalars['String']>;
  /** An optional, client-generated ID for this guest's invite record */
  guestInviteId?: InputMaybe<Scalars['ID']>;
  /** Name of the guest, ex Jeff Jefferson */
  guestName: Scalars['String'];
};

/** A GuestInvite is the pairing of a Guest with a particular visit. It contains details about that guest's visit. GuestInvite is unique to the Visit, but a Guest can be associated with multiple Visits as a part of different GuestInvites. */
export type GuestInvite = {
  __typename?: 'GuestInvite';
  /** The access credentials for the guest invite */
  accessCredentials?: Maybe<GuestInviteAccessCredentials>;
  /** Visit canceled by robin user */
  canceledBy?: Maybe<UserWithDefault>;
  /** Date and time of cancelation */
  canceledOn?: Maybe<Scalars['ISODateTime']>;
  /** Why the visit was canceled, if specified */
  canceledReason?: Maybe<GuestInviteCanceledReason>;
  /** Date and time of the check-in, null if never checked-in */
  checkinOn?: Maybe<Scalars['String']>;
  /** Date and time of the checkout, null if never checked-out */
  checkoutOn?: Maybe<Scalars['String']>;
  /** The custom fields for the guest invite */
  customFields?: Maybe<Array<CustomField>>;
  /** Invited Guest */
  guest: Guest;
  /** Indicates if the guest has access credentials */
  hasAccessCredentials?: Maybe<Scalars['Boolean']>;
  /** The health checkpoint survey response associated with the visit */
  healthCheckpointSurveyResponse?: Maybe<GenericHealthCheckpointResponse>;
  /** Guest Invite unique identifier */
  id: Scalars['ID'];
  /** The guest's magic link */
  magicLink: Scalars['String'];
  /** Whether email notifications should be sent to the guest */
  shouldSendEmailNotifications?: Maybe<Scalars['Boolean']>;
  /** Status of guest invitation */
  status: GuestInviteStatus;
  /** The visit the guest invite is for */
  visit?: Maybe<Visit>;
};

export type GuestInviteAccessCredentials = {
  __typename?: 'GuestInviteAccessCredentials';
  uuid: Scalars['ID'];
  webCredentialsLink: Scalars['String'];
};

export const GuestInviteCanceledReason = {
  CANCELED_BY_ADMIN: 'CANCELED_BY_ADMIN',
  FAILED_HEALTH_CHECKPOINT: 'FAILED_HEALTH_CHECKPOINT'
} as const;

export type GuestInviteCanceledReason = typeof GuestInviteCanceledReason[keyof typeof GuestInviteCanceledReason];
export const GuestInviteStatus = {
  CANCELED: 'CANCELED',
  CHECKED_IN: 'CHECKED_IN',
  CHECKED_OUT: 'CHECKED_OUT',
  COMPLETED_REQUIREMENTS: 'COMPLETED_REQUIREMENTS',
  EXPECTED: 'EXPECTED',
  INVITED: 'INVITED',
  PENDING_INVITE: 'PENDING_INVITE'
} as const;

export type GuestInviteStatus = typeof GuestInviteStatus[keyof typeof GuestInviteStatus];
export type HealthCheckpoint = {
  __typename?: 'HealthCheckpoint';
  answeredAt?: Maybe<Scalars['String']>;
  customizations?: Maybe<Customizations>;
  status: HealthCheckpointStatus;
  surveyId?: Maybe<Scalars['String']>;
  surveyUrl?: Maybe<Scalars['String']>;
};

export const HealthCheckpointStatus = {
  COMPLETE: 'COMPLETE',
  DISABLED: 'DISABLED',
  EXEMPT: 'EXEMPT',
  FAILED: 'FAILED',
  INCOMPLETE: 'INCOMPLETE',
  NOT_AVAILABLE: 'NOT_AVAILABLE',
  PASSED: 'PASSED'
} as const;

export type HealthCheckpointStatus = typeof HealthCheckpointStatus[keyof typeof HealthCheckpointStatus];
/** Health check diagnostics */
export type HealthChecks = {
  __typename?: 'HealthChecks';
  tokenExpired: Scalars['Boolean'];
  tokenExpiresAt: Scalars['String'];
};

/** Health status enumeration */
export const HealthStatus = {
  HEALTHY: 'HEALTHY',
  UNHEALTHY: 'UNHEALTHY'
} as const;

export type HealthStatus = typeof HealthStatus[keyof typeof HealthStatus];
export const HierarchyPermissionAction = {
  ASSIGNMENT: 'ASSIGNMENT',
  /** @deprecated Use DELEGATE instead */
  ASSIGNMENT_DELEGATE: 'ASSIGNMENT_DELEGATE',
  BOOK: 'BOOK',
  BYPASS_BOOKING_POLICIES: 'BYPASS_BOOKING_POLICIES',
  DELEGATE: 'DELEGATE',
  MANAGE_OFFICE_AND_MAPS: 'MANAGE_OFFICE_AND_MAPS',
  SKIP_BOOKING_CONFIRMATION: 'SKIP_BOOKING_CONFIRMATION'
} as const;

export type HierarchyPermissionAction = typeof HierarchyPermissionAction[keyof typeof HierarchyPermissionAction];
export type HierarchyPermissionCommand = {
  /** Role IDs to which this permission applies (users) */
  applyPermissionToRoleIds: Array<Scalars['ID']>;
  /** The actions permitted or denied by this permission */
  permissionActions: Array<HierarchyPermissionAction>;
  /** The hierarchical grouping of resources to which this permission applies */
  permissionHierarchyTarget: PermissionHierarchyTarget;
  /** The ID of the hierarchical element that this permission applies */
  permissionHierarchyTargetId: Scalars['ID'];
  /** Whether the specified actions are permitted (true) or explicitly denied (false). */
  permit: Scalars['Boolean'];
  /** ID of the resource category affected by this permission setting */
  resourceCategoryId: Scalars['ID'];
};

export const HomepageType = {
  OFFICE: 'OFFICE',
  SCHEDULE: 'SCHEDULE'
} as const;

export type HomepageType = typeof HomepageType[keyof typeof HomepageType];
export type HydratedNeighborhoodResource = Desk;

export type IcalInstanceReference = {
  /** e.g. '20240510T014500Z' */
  recurrenceId?: InputMaybe<Scalars['String']>;
  /** Likely a UUIDv4 but not necessarily */
  uid: Scalars['String'];
};

export const IconType = {
  CRC_LOCKERS: 'CRC_LOCKERS',
  FA_BICYCLE_SOLID: 'FA_BICYCLE_SOLID',
  FA_CAR_SOLID: 'FA_CAR_SOLID',
  FA_CHAIR_SOLID: 'FA_CHAIR_SOLID',
  FA_DUMBBELL_SOLID: 'FA_DUMBBELL_SOLID',
  FA_FLASK_SOLID: 'FA_FLASK_SOLID',
  FA_HAMMER_BRUSH_SOLID: 'FA_HAMMER_BRUSH_SOLID',
  FA_HOUSE_BUILDING_SOLID: 'FA_HOUSE_BUILDING_SOLID',
  FA_LAPTOP_SOLID: 'FA_LAPTOP_SOLID',
  FA_MOBILE_SCREEN_BUTTON_SOLID: 'FA_MOBILE_SCREEN_BUTTON_SOLID',
  FA_PAW_SOLID: 'FA_PAW_SOLID',
  FA_PRINT_SOLID: 'FA_PRINT_SOLID',
  FA_TABLET_SCREEN_BUTTON_SOLID: 'FA_TABLET_SCREEN_BUTTON_SOLID',
  FA_UTENSILS_SOLID: 'FA_UTENSILS_SOLID',
  HAMMER_1: 'HAMMER_1',
  PROJECTOR_1: 'PROJECTOR_1',
  ROUNDED_SQUARE_1: 'ROUNDED_SQUARE_1',
  SQUARE_1: 'SQUARE_1',
  TABLET_1: 'TABLET_1',
  TRIANGLE_1: 'TRIANGLE_1'
} as const;

export type IconType = typeof IconType[keyof typeof IconType];
export type InOfficeData = {
  __typename?: 'InOfficeData';
  peopleInTheOffice: Array<User>;
  totalNumberOfPeopleInTheOffice: Scalars['Int'];
};


export type InOfficeDataPeopleInTheOfficeArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  preferredUserIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type InOfficeDataByDay = {
  __typename?: 'InOfficeDataByDay';
  date: Scalars['ISODateTime'];
  inOfficeData: InOfficeData;
};

export type InitiateBrivoAccountConnectionForCurrentTenantInput = {
  apiKey: Scalars['String'];
  tenancy: BrivoTenancy;
};

export type InitiateBrivoAccountConnectionForCurrentTenantResponse = {
  __typename?: 'InitiateBrivoAccountConnectionForCurrentTenantResponse';
  url: Scalars['String'];
};

export type InitiateFullRipplingUserSyncInput = {
  organizationId: Scalars['ID'];
};

export type InitiateFullRipplingUserSyncResponse = {
  __typename?: 'InitiateFullRipplingUserSyncResponse';
  id: Scalars['ID'];
};

export type InitiateRipplingBuildingSyncInput = {
  id: Scalars['ID'];
};

export type InitiateRipplingBuildingSyncResponse = {
  __typename?: 'InitiateRipplingBuildingSyncResponse';
  id: Scalars['ID'];
};

export type InitiateRipplingConnectionAndSyncInput = {
  agreeToTosForCurrentActor?: InputMaybe<Scalars['Boolean']>;
  organizationId: Scalars['ID'];
};

export type InitiateRipplingConnectionAndSyncResponse = {
  __typename?: 'InitiateRipplingConnectionAndSyncResponse';
  buildingSyncId: Scalars['ID'];
};

export type InitiateRipplingUserSyncInput = {
  organizationId: Scalars['ID'];
};

export type InitiateRipplingUserSyncResponse = {
  __typename?: 'InitiateRipplingUserSyncResponse';
  syncId: Scalars['ID'];
};

export type InsightsAssistantConversationV1 = {
  __typename?: 'InsightsAssistantConversationV1';
  active: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  messages?: Maybe<Array<InsightsAssistantMessageV1>>;
  organizationId: Scalars['ID'];
  organizationSlug?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  userEmail?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
};

export type InsightsAssistantConversationV2 = {
  __typename?: 'InsightsAssistantConversationV2';
  active: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  organizationId: Scalars['ID'];
  organizationSlug?: Maybe<Scalars['String']>;
  threadId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userEmail?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
};

export type InsightsAssistantFeedbackInputV1 = {
  categories?: InputMaybe<Array<Scalars['String']>>;
  comment?: InputMaybe<Scalars['String']>;
  rating: FeedbackRating;
};

export type InsightsAssistantFeedbackV1 = {
  __typename?: 'InsightsAssistantFeedbackV1';
  categories?: Maybe<Array<Scalars['String']>>;
  comment?: Maybe<Scalars['String']>;
  conversationId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  messageId: Scalars['ID'];
  rating: FeedbackRating;
  updatedAt: Scalars['DateTime'];
};

export type InsightsAssistantFeedbackV2 = {
  __typename?: 'InsightsAssistantFeedbackV2';
  categories?: Maybe<Array<Scalars['String']>>;
  comment?: Maybe<Scalars['String']>;
  conversationId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  messageId: Scalars['ID'];
  rating: FeedbackRating;
  updatedAt: Scalars['DateTime'];
};

export type InsightsAssistantFeedbackV2Input = {
  categories?: InputMaybe<Array<Scalars['String']>>;
  comment?: InputMaybe<Scalars['String']>;
  rating: FeedbackRating;
};

export type InsightsAssistantMessageV1 = {
  __typename?: 'InsightsAssistantMessageV1';
  canceled: Scalars['Boolean'];
  conversationId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  feedback?: Maybe<InsightsAssistantFeedbackV1>;
  id: Scalars['ID'];
  parentMessageId?: Maybe<Scalars['ID']>;
  source: Scalars['String'];
  text: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type InstantAvailability = {
  __typename?: 'InstantAvailability';
  availability: Availability;
  reservation?: Maybe<Reservation>;
};

/** Integration error details with provider-specific information */
export type IntegrationError = {
  __typename?: 'IntegrationError';
  category: Scalars['String'];
  code: Scalars['String'];
  message: Scalars['String'];
  providerError?: Maybe<ProviderError>;
  resolution: ErrorResolution;
};

/** Integration health status details */
export type IntegrationStatus = {
  __typename?: 'IntegrationStatus';
  checks: HealthChecks;
  error?: Maybe<IntegrationError>;
  health: HealthStatus;
};

export type InternalCategoryPermission = {
  __typename?: 'InternalCategoryPermission';
  action: QueryablePermissionAction;
  categoryId: Scalars['ID'];
  id: Scalars['ID'];
  permitted: Scalars['Boolean'];
};

export type InternalPermissionUserOrgActions = {
  __typename?: 'InternalPermissionUserOrgActions';
  actions: Array<QueryablePermissionAction>;
  campus: Array<InternalCategoryPermission>;
  group: Array<InternalCategoryPermission>;
  id: Scalars['ID'];
  level: Array<InternalCategoryPermission>;
  location: Array<InternalCategoryPermission>;
  org: Array<InternalCategoryPermission>;
  organizationId: Scalars['ID'];
  resource: Array<InternalResourcePermission>;
  userId: Scalars['ID'];
};

export type InternalResource = {
  __typename?: 'InternalResource';
  campusId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  levelId: Scalars['ID'];
  locationId: Scalars['ID'];
  organizationId: Scalars['ID'];
  resourceCategoryID: Scalars['ID'];
  resourceGroupId?: Maybe<Scalars['ID']>;
};

export type InternalResourcePermission = {
  __typename?: 'InternalResourcePermission';
  action: QueryablePermissionAction;
  id: Scalars['ID'];
  permitted: Scalars['Boolean'];
};

export type InvalidCidrError = {
  __typename?: 'InvalidCidrError';
  cidr: Scalars['IPAddressCIDR'];
  message: Scalars['String'];
};

export type InviteeEvent = {
  __typename?: 'InviteeEvent';
  confirmation?: Maybe<EventConfirmation>;
  id: Scalars['ID'];
};

export type IsBrivoIntegrationEnabledForCurrentTenantReponse = {
  __typename?: 'IsBrivoIntegrationEnabledForCurrentTenantReponse';
  isEnabled: Scalars['Boolean'];
};

export type IsCsvUploadEnabledForCurrentTenantReponse = {
  __typename?: 'IsCSVUploadEnabledForCurrentTenantReponse';
  isEnabled: Scalars['Boolean'];
};

export type IsGallagherIntegrationEnabledForCurrentTenantReponse = {
  __typename?: 'IsGallagherIntegrationEnabledForCurrentTenantReponse';
  isEnabled: Scalars['Boolean'];
};

export type IsGeneaIntegrationEnabledForCurrentTenantReponse = {
  __typename?: 'IsGeneaIntegrationEnabledForCurrentTenantReponse';
  isEnabled: Scalars['Boolean'];
};

export type IsGenetecIntegrationEnabledForCurrentTenantReponse = {
  __typename?: 'IsGenetecIntegrationEnabledForCurrentTenantReponse';
  isEnabled: Scalars['Boolean'];
};

export type IsKisiIntegrationEnabledForCurrentTenantReponse = {
  __typename?: 'IsKisiIntegrationEnabledForCurrentTenantReponse';
  isEnabled: Scalars['Boolean'];
};

export type IsOpenpathIntegrationEnabledForCurrentTenantReponse = {
  __typename?: 'IsOpenpathIntegrationEnabledForCurrentTenantReponse';
  isEnabled: Scalars['Boolean'];
};

export type IsOpenpathLockProvisioningEnabledForCurrentTenantResponse = {
  __typename?: 'IsOpenpathLockProvisioningEnabledForCurrentTenantResponse';
  isEnabled: Scalars['Boolean'];
};

export type IsPassiveCheckInFeatureEnabledForBuildingInput = {
  buildingId: Scalars['ID'];
};

export type IsVerkadaIntegrationEnabledForCurrentTenantReponse = {
  __typename?: 'IsVerkadaIntegrationEnabledForCurrentTenantReponse';
  isEnabled: Scalars['Boolean'];
};

export type LayoutChangeEntity = {
  __typename?: 'LayoutChangeEntity';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  operation: LayoutParcelOperation;
  parcel?: Maybe<LayoutParcel>;
};

export type LayoutDraftInput = {
  levelId: Scalars['ID'];
  name: Scalars['String'];
  organizationId: Scalars['ID'];
};

export type LayoutParcel = {
  __typename?: 'LayoutParcel';
  geometry?: Maybe<Geometry>;
  properties?: Maybe<CustomResourceInstance>;
};

export type LayoutParcelInput = {
  geometry: GeometryInput;
  properties?: InputMaybe<CustomResourceInstanceInput>;
};

export const LayoutParcelOperation = {
  DELETE_RESOURCE: 'delete_resource',
  UPSERT_RESOURCE: 'upsert_resource',
  UPSERT_RESOURCE_GROUP: 'upsert_resource_group'
} as const;

export type LayoutParcelOperation = typeof LayoutParcelOperation[keyof typeof LayoutParcelOperation];
export type LayoutResourceGroupEntity = {
  __typename?: 'LayoutResourceGroupEntity';
  amenityIds?: Maybe<Array<Scalars['ID']>>;
  bookingType?: Maybe<ResourceWeeklyBookingType>;
  capacity?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isAccessible?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  operation: LayoutParcelOperation;
  policies?: Maybe<ResourcePolicy>;
  subCategory?: Maybe<Scalars['String']>;
};

export type LayoutResourcePolicyDurationInput = {
  type?: InputMaybe<LayoutResourcePolicyDurationType>;
  value: Scalars['Int'];
};

export const LayoutResourcePolicyDurationType = {
  DAYS: 'days',
  HOURS: 'hours',
  MINUTES: 'minutes',
  MONTHS: 'months',
  WEEKS: 'weeks',
  YEARS: 'years'
} as const;

export type LayoutResourcePolicyDurationType = typeof LayoutResourcePolicyDurationType[keyof typeof LayoutResourcePolicyDurationType];
export type LayoutResourcePolicyEnabledWithDurationInput = {
  duration?: InputMaybe<LayoutResourcePolicyDurationInput>;
  enabled: Scalars['Boolean'];
};

export type LayoutResourcePolicyInput = {
  abandonedResourceProtection?: InputMaybe<LayoutResourcePolicyEnabledWithDurationInput>;
  advanceCheckInWindow?: InputMaybe<LayoutResourcePolicyEnabledWithDurationInput>;
  advancedBookingThreshold?: InputMaybe<LayoutResourcePolicyEnabledWithDurationInput>;
  allowOverlappingBookings?: InputMaybe<Scalars['Boolean']>;
  localCheckInOnly?: InputMaybe<Scalars['Boolean']>;
  maxBookingLength?: InputMaybe<LayoutResourcePolicyEnabledWithDurationInput>;
  requireCheckIn?: InputMaybe<Scalars['Boolean']>;
  resourceSharing?: InputMaybe<Scalars['Boolean']>;
  restrictBookingToWorkingHours?: InputMaybe<Scalars['Boolean']>;
};

export type LegacyIntegration = {
  __typename?: 'LegacyIntegration';
  configuration: Scalars['Json'];
  createdAt: Scalars['String'];
  externalAccountId?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  organizationId: Scalars['Int'];
  resourceType: LegacyIntegrationResourceType;
  state: Scalars['String'];
  type: LegacyIntegrationType;
  updatedAt: Scalars['String'];
  user: User;
  userId: Scalars['Int'];
};

export const LegacyIntegrationResourceType = {
  CALENDAR: 'CALENDAR',
  EVENT: 'EVENT',
  NOTIFICATION: 'NOTIFICATION'
} as const;

export type LegacyIntegrationResourceType = typeof LegacyIntegrationResourceType[keyof typeof LegacyIntegrationResourceType];
export const LegacyIntegrationType = {
  BLUEJEANS: 'BLUEJEANS',
  BLUEJEANS_RELAY: 'BLUEJEANS_RELAY',
  SLACK: 'SLACK',
  TEAMS: 'TEAMS',
  ZOOM: 'ZOOM'
} as const;

export type LegacyIntegrationType = typeof LegacyIntegrationType[keyof typeof LegacyIntegrationType];
export type Level = {
  __typename?: 'Level';
  /** Total desks on the floor - excluding inactive. */
  activeDeskCount: Scalars['Int'];
  availableDeskAmenities: Array<MinimizedAmenityViewModel>;
  availableSpaceAmenities: Array<MinimizedAmenityViewModel>;
  campusId?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['Date']>;
  /** Total desks on the floor - including inactive. */
  deskCount: Scalars['Int'];
  /** Total desks within the level that fit within various scheduling type and status buckets */
  deskSchedulingAggregates: SchedulingAggregateOfDesks;
  desks: Array<Desk>;
  filteredDesksByAmenityIds: Array<Desk>;
  filteredSpacesByAmenityIds: Array<Space>;
  id: Scalars['ID'];
  levelLocation?: Maybe<LevelLocation>;
  levelNumber?: Maybe<Scalars['Int']>;
  locationId: Scalars['ID'];
  /** check whether the level has a map or not */
  mapIsAvailable?: Maybe<Scalars['Boolean']>;
  mapUploadStatus?: Maybe<MapUploadStatus>;
  maxCapacity: Scalars['Int'];
  name: Scalars['String'];
  neighborhoods: Array<Neighborhood>;
  organizationId: Scalars['ID'];
  spaces: Array<Space>;
  state: LevelState;
  timezone?: Maybe<Scalars['String']>;
  /** @deprecated Use `activeDeskCount` instead */
  totalDesks: Scalars['Int'];
  /** total spaces will be contextual to the filter */
  totalSpaces: Scalars['Int'];
  updatedAt?: Maybe<Scalars['Date']>;
  workAreas: Array<WorkArea>;
  /** Total desks within the location where booked counts are bound to the current workday and the configured hours of operation for the location */
  workplaceDeskSchedulingAggregates: BookedSchedulingAggregateOfDesks;
  zones: Array<Zone>;
};


export type LevelDesksArgs = {
  filters?: InputMaybe<Array<DeskFilters>>;
};


export type LevelFilteredDesksByAmenityIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type LevelFilteredSpacesByAmenityIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type LevelSpacesArgs = {
  filters?: InputMaybe<Array<SpaceFilters>>;
};


export type LevelStateArgs = {
  endTime: Scalars['Date'];
  evaluations?: InputMaybe<Evaluations>;
  recurrence?: InputMaybe<Scalars['String']>;
  startTime: Scalars['Date'];
};


export type LevelTotalSpacesArgs = {
  filters?: InputMaybe<Array<SpaceFilters>>;
};

export type LevelDeskReservation = {
  __typename?: 'LevelDeskReservation';
  levelId: Scalars['ID'];
  reservations: Array<Reservation>;
};

export type LevelLocation = {
  __typename?: 'LevelLocation';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type LevelState = {
  __typename?: 'LevelState';
  availability: PlaceAvailability;
  freeCapacity: Scalars['Int'];
};

export const LimitStrategy = {
  ADAPTIVE: 'ADAPTIVE',
  FIXED: 'FIXED'
} as const;

export type LimitStrategy = typeof LimitStrategy[keyof typeof LimitStrategy];
export type LinkKisiLockToRobinLocationInput = {
  remoteLockId: Scalars['String'];
  robinLocationId: Scalars['Int'];
};

export type LinkKisiLockToRobinLocationResponse = {
  __typename?: 'LinkKisiLockToRobinLocationResponse';
  uuid?: Maybe<Scalars['ID']>;
};

export type ListBuildingCidrsInput = {
  buildingId: Scalars['ID'];
};

export type ListBuildingCidrsResponse = {
  __typename?: 'ListBuildingCidrsResponse';
  cidrs: Array<Scalars['IPAddressCIDR']>;
};

export type ListBuildingsWhereUserCanManageMeetingServicesResponse = {
  __typename?: 'ListBuildingsWhereUserCanManageMeetingServicesResponse';
  buildings: Array<Maybe<Location>>;
};

export type ListMeetingServiceRequestsFiltersInput = {
  eventStartTimeBetween?: InputMaybe<TimeRangeInput>;
  /** userIds match filter transitively through group membership */
  hasAnyApprover?: InputMaybe<UsersAndGroupsInput>;
  /** userIds match filter transitively through group membership */
  hasAnyAssignee?: InputMaybe<UsersAndGroupsInput>;
  hasAnyRequesterUserId?: InputMaybe<Array<Scalars['ID']>>;
  hasAnyStatus?: InputMaybe<Array<MeetingServiceRequestStatus>>;
  /** 'CAT' matches 'CAT-123', 'CAT-456', but not 'CATS-123'. 'CAT-123' matches 'CAT-123' but not 'CAT-1234'. '123' matches 'CAT-123', 'DOG-123', but not 'CAT-1234'. */
  keyMatches?: InputMaybe<Scalars['String']>;
  regardingAnyBuildingIdsOrTheirDescendants?: InputMaybe<Array<Scalars['ID']>>;
  regardingAnySpaceIds?: InputMaybe<Array<Scalars['ID']>>;
  serviceBelongsToAnyCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  serviceHasAnyId?: InputMaybe<Array<Scalars['ID']>>;
};

export type ListMeetingServiceRequestsInput = {
  /** If after is provided, we only return results that come after the previous result set */
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<ListMeetingServiceRequestsFiltersInput>;
  /** Return only the first N results */
  first: Scalars['Int'];
  /** Skip N results, e.g. if you need to jump more than one page ahead. This stacks on top of `after` if provided. Avoid use if possible - prefer using `after` alone. */
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: ListMeetingServiceRequestsSortByInput;
};

export type ListMeetingServiceRequestsResponse = {
  __typename?: 'ListMeetingServiceRequestsResponse';
  forwardPageInfo: ForwardPageInfo;
  meetingServiceRequests: Array<MeetingServiceRequest>;
};

export const ListMeetingServiceRequestsSortByCriteria = {
  CREATED_AT: 'CREATED_AT',
  EVENT_START_TIME: 'EVENT_START_TIME',
  KEY: 'KEY',
  SERVICE_CATEGORY_NAME: 'SERVICE_CATEGORY_NAME',
  SERVICE_NAME: 'SERVICE_NAME',
  STATUS: 'STATUS',
  UPDATED_AT: 'UPDATED_AT'
} as const;

export type ListMeetingServiceRequestsSortByCriteria = typeof ListMeetingServiceRequestsSortByCriteria[keyof typeof ListMeetingServiceRequestsSortByCriteria];
export type ListMeetingServiceRequestsSortByInput = {
  criteria: ListMeetingServiceRequestsSortByCriteria;
  order: SortOrder;
};

export type ListMeetingServicesAvailableInSpaceFiltersInput = {
  spaceId: Scalars['ID'];
};

export type ListMeetingServicesAvailableInSpaceInput = {
  /** If after is provided, we only return results that come after the previous result set */
  after?: InputMaybe<Scalars['String']>;
  filters: ListMeetingServicesAvailableInSpaceFiltersInput;
  /** Return only the first N results */
  first: Scalars['Int'];
};

export type ListMeetingServicesAvailableInSpaceResponse = {
  __typename?: 'ListMeetingServicesAvailableInSpaceResponse';
  forwardPageInfo: ForwardPageInfo;
  meetingServices: Array<MeetingService>;
};

export type ListMeetingServicesCategoriesFiltersInput = {
  hasServicesAvailableInBuildingIds?: InputMaybe<Array<Scalars['ID']>>;
  nameContainsString?: InputMaybe<Scalars['String']>;
};

export type ListMeetingServicesCategoriesInput = {
  /** If after is provided, we only return results that come after the previous result set */
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<ListMeetingServicesCategoriesFiltersInput>;
  /** Return only the first N results */
  first: Scalars['Int'];
  /** Skip N results, e.g. if you need to jump more than one page ahead. This stacks on top of `after` if provided. Avoid use if possible - prefer using `after` alone. */
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: ListMeetingServicesCategoriesSortByInput;
};

export type ListMeetingServicesCategoriesResponse = {
  __typename?: 'ListMeetingServicesCategoriesResponse';
  forwardPageInfo: ForwardPageInfo;
  meetingServicesCategories: Array<MeetingServicesCategory>;
};

export const ListMeetingServicesCategoriesSortByCriteria = {
  KEY: 'KEY',
  NAME: 'NAME'
} as const;

export type ListMeetingServicesCategoriesSortByCriteria = typeof ListMeetingServicesCategoriesSortByCriteria[keyof typeof ListMeetingServicesCategoriesSortByCriteria];
export type ListMeetingServicesCategoriesSortByInput = {
  criteria: ListMeetingServicesCategoriesSortByCriteria;
  order: SortOrder;
};

export type ListMeetingServicesFiltersInput = {
  /** userIds match filter transitively through group membership */
  assignedToAny?: InputMaybe<UsersAndGroupsInput>;
  availableInAnyBuildingIdsOrTheirDescendants?: InputMaybe<Array<Scalars['ID']>>;
  belongsToAnyCategoryId?: InputMaybe<Array<Scalars['ID']>>;
  nameContainsString?: InputMaybe<Scalars['String']>;
};

export type ListMeetingServicesInput = {
  /** If after is provided, we only return results that come after the previous result set */
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<ListMeetingServicesFiltersInput>;
  /** Return only the first N results */
  first: Scalars['Int'];
  /** Skip N results, e.g. if you need to jump more than one page ahead. This stacks on top of `after` if provided. Avoid use if possible - prefer using `after` alone. */
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: ListMeetingServicesSortByInput;
};

export type ListMeetingServicesResponse = {
  __typename?: 'ListMeetingServicesResponse';
  forwardPageInfo: ForwardPageInfo;
  meetingServices: Array<MeetingService>;
};

export const ListMeetingServicesSortByCriteria = {
  CATEGORY_NAME: 'CATEGORY_NAME',
  SERVICE_NAME: 'SERVICE_NAME',
  UPDATED_AT: 'UPDATED_AT'
} as const;

export type ListMeetingServicesSortByCriteria = typeof ListMeetingServicesSortByCriteria[keyof typeof ListMeetingServicesSortByCriteria];
export type ListMeetingServicesSortByInput = {
  criteria: ListMeetingServicesSortByCriteria;
  order: SortOrder;
};

export type ListUniqueAssigneesForMeetingServicesFiltersInput = {
  serviceAvailableInAnyBuildingIdsOrTheirDescendants?: InputMaybe<Array<Scalars['ID']>>;
};

export type ListUniqueAssigneesForMeetingServicesInput = {
  /** If after is provided, we only return results that come after the previous result set */
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<ListUniqueAssigneesForMeetingServicesFiltersInput>;
  /** Return only the first N results */
  first: Scalars['Int'];
};

export type ListUniqueAssigneesForMeetingServicesResponse = {
  __typename?: 'ListUniqueAssigneesForMeetingServicesResponse';
  forwardPageInfo: ForwardPageInfo;
  uniqueAssignees: Array<Maybe<UserOrGroupUnion>>;
};

export type ListUniqueMeetingServiceRequestValuesFiltersInput = {
  eventStartTimeBetween?: InputMaybe<TimeRangeInput>;
  regardingAnyBuildingIdsOrTheirDescendants?: InputMaybe<Array<Scalars['ID']>>;
};

export type ListUniqueMeetingServiceRequestValuesInput = {
  filters?: InputMaybe<ListUniqueMeetingServiceRequestValuesFiltersInput>;
  /** Return only the first N results for each value */
  first: Scalars['Int'];
};

export type ListUniqueMeetingServiceRequestValuesResponse = {
  __typename?: 'ListUniqueMeetingServiceRequestValuesResponse';
  uniqueValues: UniqueMeetingServiceRequestValues;
};

export type LocalDateTimePair = {
  __typename?: 'LocalDateTimePair';
  localDate: Scalars['IsoDateOnlyString'];
  localTime: Scalars['IsoLocalTimeString'];
};

export type LocalTimePair = {
  __typename?: 'LocalTimePair';
  endTime: Scalars['IsoLocalTimeString'];
  startTime: Scalars['IsoLocalTimeString'];
};

export type LocaleDateTimePair = {
  localDate: Scalars['IsoDateOnlyString'];
  localTime: Scalars['IsoLocalTimeString'];
};

export type Location = {
  __typename?: 'Location';
  /** Total desks in the building - excluding inactive. */
  activeDeskCount?: Maybe<Scalars['Int']>;
  address?: Maybe<Scalars['String']>;
  allowsEmployeeCredentialProvisioning: Scalars['Boolean'];
  campus?: Maybe<Campus>;
  campusId?: Maybe<Scalars['ID']>;
  /** Excluding request-only and on-demand spaces. See SpaceScheduleConfiguration.SCHEDULED. */
  containsAtLeastOneScheduledSpace: Scalars['Boolean'];
  createdAt?: Maybe<Scalars['Date']>;
  /** customWorkingHours are limited to 100 entries and will only grab custom working hours from the current date of the location and upcoming custom working hours It paginates via optional `startFromDateTime` parameter This will grab custom working hours that has a date time greater than `startFromDateTime` provided Format expected is `YYYY-MM-DD HH:mm` */
  customWorkingHours: Array<CustomWorkingHours>;
  description?: Maybe<Scalars['String']>;
  /** Total desks in the building - including inactive. */
  deskCount: Scalars['Int'];
  /** Total desks within the location that fit within various scheduling type and status buckets */
  deskSchedulingAggregates: SchedulingAggregateOfDesks;
  employeeCredentialProvisioningProviders: Array<EmployeeCredentialProvisioningProvider>;
  geofenceFeatureEnabled: Scalars['Boolean'];
  /** Expects a `startDate` and `endDate` formated as YYYY-MM-DD `startDate` and `endDate` are inclusive */
  hoursForTimeRange: Array<DateSpecificWorkingHours>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  isHealthCheckpointRequired: Scalars['Boolean'];
  isVisitorManagementEnabled: Scalars['Boolean'];
  isWorkplaceServicesEnabled: Scalars['Boolean'];
  latitude?: Maybe<Scalars['Float']>;
  levels: Array<Level>;
  longitude?: Maybe<Scalars['Float']>;
  maxCapacity: Scalars['Int'];
  name: Scalars['String'];
  officeAccess: Array<OfficeAccess>;
  organizationId: Scalars['ID'];
  preferredLanguageTag?: Maybe<Scalars['String']>;
  remoteGoogleId?: Maybe<Scalars['ID']>;
  remoteGoogleLabel?: Maybe<Scalars['String']>;
  spaces: Array<Space>;
  state: LocationState;
  stateByDay: Array<LocationStateByDay>;
  timezone?: Maybe<Scalars['String']>;
  /** @deprecated Use `activeDeskCount` instead */
  totalDesks: Scalars['Int'];
  totalLevels: Scalars['Int'];
  /** total spaces will be contextual to the filter */
  totalSpaces: Scalars['Int'];
  updatedAt: Scalars['Date'];
  workingHours: Array<WorkingHours>;
  /** Total desks within the location where booked counts are bound to the current workday and the configured hours of operation for the location */
  workplaceDeskSchedulingAggregates: BookedSchedulingAggregateOfDesks;
};


export type LocationCustomWorkingHoursArgs = {
  startFromDateTime?: InputMaybe<Scalars['Date']>;
};


export type LocationHoursForTimeRangeArgs = {
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
};


export type LocationOfficeAccessArgs = {
  userId: Scalars['ID'];
};


export type LocationSpacesArgs = {
  filters?: InputMaybe<Array<SpaceFilters>>;
};


export type LocationStateArgs = {
  endTime: Scalars['Date'];
  evaluations?: InputMaybe<Evaluations>;
  recurrence?: InputMaybe<Scalars['String']>;
  startTime: Scalars['Date'];
  userId: Scalars['ID'];
};


export type LocationStateByDayArgs = {
  endTime: Scalars['Date'];
  evaluations?: InputMaybe<Evaluations>;
  recurrence?: InputMaybe<Scalars['String']>;
  startTime: Scalars['Date'];
};


export type LocationTotalSpacesArgs = {
  filters?: InputMaybe<Array<SpaceFilters>>;
};

export type LocationDeskReservation = {
  __typename?: 'LocationDeskReservation';
  locationId: Scalars['ID'];
  reservations: Array<Reservation>;
};

export type LocationFilters = {
  currentActorPermissions: Array<Scalars['String']>;
};

export type LocationState = {
  __typename?: 'LocationState';
  availability: PlaceAvailability;
  freeCapacity: Scalars['Int'];
  isOpen?: Maybe<Scalars['Boolean']>;
};

export type LocationStateByDay = {
  __typename?: 'LocationStateByDay';
  availability: PlaceAvailability;
  day: Scalars['Date'];
};

export type LogSuggestedSpaceBookedInput = {
  suggestedSpaceRecordId: Scalars['ID'];
};

export type LogSuggestedSpaceDismissedInput = {
  suggestedSpaceRecordId: Scalars['ID'];
};

export type LogSuggestedSpaceViewedInput = {
  suggestedSpaceRecordId: Scalars['ID'];
};

export type MapBuildingToRipplingWorkLocationInput = {
  buildingId: Scalars['ID'];
  organizationId: Scalars['ID'];
  ripplingWorkLocationId: Scalars['ID'];
};

export type MapBuildingToRipplingWorkLocationResponse = {
  __typename?: 'MapBuildingToRipplingWorkLocationResponse';
  id: Scalars['ID'];
};

export type MapBuildingsToRipplingWorkLocationsInput = {
  mappings: Array<MapBuildingsToRipplingWorkLocationsMappingsInput>;
  organizationId: Scalars['ID'];
};

export type MapBuildingsToRipplingWorkLocationsMappingsInput = {
  buildingId: Scalars['ID'];
  ripplingWorkLocationId: Scalars['ID'];
};

export type MapBuildingsToRipplingWorkLocationsResponse = {
  __typename?: 'MapBuildingsToRipplingWorkLocationsResponse';
  id: Scalars['ID'];
};

export type MapKisiLocksToRobinLocations = {
  mappings: Array<MapKisiLocksToRobinLocationsMapping>;
};

export type MapKisiLocksToRobinLocationsMapping = {
  isConfigured: Scalars['Boolean'];
  isOnline: Scalars['Boolean'];
  remoteLockId: Scalars['String'];
  remotePlaceId: Scalars['String'];
  remotePlaceName: Scalars['String'];
  robinFloorId?: InputMaybe<Scalars['Int']>;
  robinLocationId: Scalars['Int'];
};

export type MapKisiLocksToRobinLocationsResponse = {
  __typename?: 'MapKisiLocksToRobinLocationsResponse';
  uuid: Scalars['ID'];
};

export const MapUploadStatus = {
  AWAITING_UPLOAD: 'AWAITING_UPLOAD',
  UNKNOWN: 'UNKNOWN',
  UPLOADED: 'UPLOADED'
} as const;

export type MapUploadStatus = typeof MapUploadStatus[keyof typeof MapUploadStatus];
export type MeOrganization = {
  __typename?: 'MeOrganization';
  authMethods?: Maybe<Array<AuthMethod>>;
  avatar: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type MeetingService = {
  __typename?: 'MeetingService';
  /** Assignees are required when service is created, but could become null/empty due to user/group deletion. Can also be null when kind=SPACE_REQUEST_FORM. */
  assignees?: Maybe<UsersAndGroups>;
  /** A building-level summary of availability of this service. Use availabilityInSpacesOfBuilding for the availability of a specific building. */
  availabilityInBuildings: MeetingServiceAvailabilityInBuildings;
  /** Use availabilityInBuildings first to get the buildings where this service is available */
  availabilityInSpacesOfBuilding: MeetingServiceAvailabilityInSpacesOfBuilding;
  category: MeetingServicesCategory;
  /** The currency for all monetary amounts in this service, like on menu item unitPrice. New meeting services require this field, but old ones may be missing. */
  currencyCode?: Maybe<Scalars['CurrencyCodeISO4217']>;
  description?: Maybe<Scalars['Markdown']>;
  id: Scalars['ID'];
  kind: TicketWorkflowKind;
  /** null if approval is not required */
  multipleApprovers?: Maybe<UsersAndGroups>;
  name: Scalars['String'];
  /** @deprecated Not yet implemented as of 2024-11-05 */
  permissions?: Maybe<MeetingServicePermissions>;
  questions: Array<TicketQuestion>;
  /** If true, approver must approve creation/changes on requests before assignees are emailed */
  requestsNeedApproval: Scalars['Boolean'];
  /**
   * If true, approver must approve creation/changes on requests before assignees are emailed
   * @deprecated Use requestsNeedApproval instead
   */
  requireAdminApproval: Scalars['Boolean'];
  updatedAt: Scalars['ISODateTime'];
  versionId: Scalars['ID'];
  versionNumber: Scalars['Int'];
};


export type MeetingServiceAvailabilityInSpacesOfBuildingArgs = {
  buildingId: Scalars['ID'];
};

export type MeetingServiceAvailabilityInBuilding = {
  __typename?: 'MeetingServiceAvailabilityInBuilding';
  building?: Maybe<Location>;
  buildingId: Scalars['ID'];
  /** The number of spaces within this building where this service is available */
  spaceCount: Scalars['Int'];
};

export type MeetingServiceAvailabilityInBuildings = {
  __typename?: 'MeetingServiceAvailabilityInBuildings';
  /** The buildings containing at least one space where this service is available */
  buildingAvailability: Array<MeetingServiceAvailabilityInBuilding>;
  /** The number of buildings containing at least one space where this service is available */
  buildingCount: Scalars['Int'];
  /** The number of spaces across all buildings where this service is available */
  spaceCount: Scalars['Int'];
};

export type MeetingServiceAvailabilityInSpacesOfBuilding = {
  __typename?: 'MeetingServiceAvailabilityInSpacesOfBuilding';
  availableInSpaceIds: Array<Scalars['ID']>;
  availableInSpaces: Array<Maybe<Space>>;
  building?: Maybe<Location>;
};

export type MeetingServiceAvailableInSpacesByBuildingInput = {
  /** The ID of the building that contains all the spaceIds */
  buildingId: Scalars['ID'];
  spaceIds: Array<Scalars['ID']>;
};

export type MeetingServicePermissions = {
  __typename?: 'MeetingServicePermissions';
  /** Must have workplace_services:manage permssion in ALL of the service's buildings. If the service is not available in any building, anyone with workplace_services:manage permission in at least one building can delete. */
  canDelete: Scalars['Boolean'];
  /** Must have workplace_services:manage permission on AT LEAST ONE of the service's buildings. If the service is not available in any building, anyone with workplace_services:manage permission in at least one building can update. */
  canUpdate: Scalars['Boolean'];
};

export type MeetingServiceRequest = Ticket & {
  __typename?: 'MeetingServiceRequest';
  assignees?: Maybe<UsersAndGroups>;
  completedForm?: Maybe<CompletedTicketForm>;
  createdAt: Scalars['ISODateTime'];
  /** This may differ from the currencyCode on the meetingService if the meeting service was changed after this request was made. */
  currencyCode?: Maybe<Scalars['CurrencyCodeISO4217']>;
  id: Scalars['ID'];
  key: Scalars['String'];
  /** The ID of the latest change to this service request. Every time the service request is changed, this ID will change. Used for concurrency control on mutations like approveMeetingServiceRequest. */
  latestChangeId: Scalars['ID'];
  /** If you are looking for form questions, consult completedForm which shows questions as they were at the time of ticket creation. meetingService.questions are presented for *new* service requests. */
  meetingService: MeetingService;
  meetingServiceRequestStatus: MeetingServiceRequestStatus;
  multipleApprovers?: Maybe<UsersAndGroups>;
  permissions?: Maybe<MeetingServiceRequestPermissions>;
  regardsEventAtSpace: TicketRegardsEventAtSpace;
  /** If the service request has status REJECTED, this will contain the comment related to the rejection. Such a comment is optional, so this may be null even if the service request is rejected. */
  rejectionComment?: Maybe<Scalars['String']>;
  requester?: Maybe<User>;
  title: Scalars['String'];
  /** The total price of this service request (see menu choices), after any surcharges/taxes. */
  totalPrice?: Maybe<Money>;
  updatedAt: Scalars['ISODateTime'];
};

export type MeetingServiceRequestIdentifierInput = {
  id?: InputMaybe<Scalars['ID']>;
  key?: InputMaybe<Scalars['String']>;
};

export type MeetingServiceRequestPermissions = {
  __typename?: 'MeetingServiceRequestPermissions';
  canApproveOrReject: Scalars['Boolean'];
  canChangeAnswers: Scalars['Boolean'];
  canDeleteOrCancel: Scalars['Boolean'];
  canUpdateStatus: Scalars['Boolean'];
};

export const MeetingServiceRequestSpaceStatus = {
  /** The space has explicitly accepted the invitation. Some space calendars will never explicitly accept, and merely acquiesce. */
  ACCEPTED: 'ACCEPTED',
  /** The space has not explicitly accepted the invitation, but it also hasn't explicitly declined the invitation, nor are we awaiting any sort of approval. Robin considers this enough for the space to be successfully booked. */
  ACQUIESCED: 'ACQUIESCED',
  /** The space declined the invitation from the organizer. The most likely reason is that there was a conflict with another event. Can also happen due to disallowed cross-domain invitations or other policy violations. Or, this could be a request-only space and the request was denied by the admin. */
  DECLINED: 'DECLINED',
  /** We have seen the event (e.g. through other space calendars), but the space that this service request was intended for is missing. The service request may have been created for an event that was not saved yet, and the creator removed the space before saving the event. Could also happen if someone was editing an event, added a space, moved a service request to that space, but then removed (or failed to add) the space. */
  MISSING: 'MISSING',
  /** We have not seen anything related to this event. The service request may have been created for an event that was not saved yet, and the creator either never saved the event or removed all spaces before saving. */
  NOT_SYNCED: 'NOT_SYNCED',
  /** Either the event was cancelled by the organizer, or the space was disinvited from the event. It is difficult to tell the difference between the two situations. */
  REMOVED_OR_EVENT_CANCELLED: 'REMOVED_OR_EVENT_CANCELLED',
  /** The space has tentatively accepted the invitation, but we're still waiting for an admin to approve the request. */
  REQUESTED: 'REQUESTED'
} as const;

export type MeetingServiceRequestSpaceStatus = typeof MeetingServiceRequestSpaceStatus[keyof typeof MeetingServiceRequestSpaceStatus];
export const MeetingServiceRequestStatus = {
  BLOCKED: 'BLOCKED',
  CANCELLED: 'CANCELLED',
  DONE: 'DONE',
  IN_PROGRESS: 'IN_PROGRESS',
  NEEDS_APPROVAL: 'NEEDS_APPROVAL',
  REJECTED: 'REJECTED',
  TODO: 'TODO'
} as const;

export type MeetingServiceRequestStatus = typeof MeetingServiceRequestStatus[keyof typeof MeetingServiceRequestStatus];
export type MeetingServicesCategory = {
  __typename?: 'MeetingServicesCategory';
  id: Scalars['ID'];
  key: Scalars['String'];
  name: Scalars['String'];
  serviceCount: Scalars['Int'];
};

export type MetadataDeskObject = {
  __typename?: 'MetadataDeskObject';
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type MeteredFeature = {
  __typename?: 'MeteredFeature';
  billableTotal?: Maybe<Scalars['Int']>;
  feature: FeatureType;
  limit?: Maybe<Scalars['Int']>;
  overProvisioningLimit?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type MigrationProgress = {
  __typename?: 'MigrationProgress';
  migratedSpaceCount: Scalars['Int'];
  spaceCount: Scalars['Int'];
};

export type MigrationReportTotals = {
  __typename?: 'MigrationReportTotals';
  error: Scalars['Int'];
  rolledBack: Scalars['Int'];
  skipped: Scalars['Int'];
  success: Scalars['Int'];
};

export type MigrationReportWithTotals = {
  __typename?: 'MigrationReportWithTotals';
  reports: Array<MigrationSpaceReport>;
  totals: MigrationReportTotals;
};

export type MigrationSpaceReport = {
  __typename?: 'MigrationSpaceReport';
  calendarId: Scalars['String'];
  migratedAt: Scalars['String'];
  spaceId: Scalars['String'];
  spaceName: Scalars['String'];
  spaceResourceEmail: Scalars['String'];
  status: Scalars['Int'];
};

export type MinimizedAmenityViewModel = {
  __typename?: 'MinimizedAmenityViewModel';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export const MobileActivityType = {
  IN_VEHICLE: 'in_vehicle',
  ON_BICYCLE: 'on_bicycle',
  ON_FOOT: 'on_foot',
  RUNNING: 'running',
  STILL: 'still',
  UNKNOWN: 'unknown',
  WALKING: 'walking'
} as const;

export type MobileActivityType = typeof MobileActivityType[keyof typeof MobileActivityType];
export type MobileGeofence = {
  __typename?: 'MobileGeofence';
  /** Arbitrary key-values appended to the geofence event. */
  extras?: Maybe<Scalars['JSON']>;
  /** Unique geofence identifier. */
  identifier: Scalars['ID'];
  /** Latitude of geofence center. Not required when using `vertices` for polygon geofences. */
  latitude?: Maybe<Scalars['Float']>;
  /** Minimum time in milliseconds the device must "loiter" within this geofence before notifyOnDwell event fires. */
  loiteringDelay?: Maybe<Scalars['Int']>;
  /** Longitude of geofence center. Not required when using `vertices` for polygon geofences. */
  longitude?: Maybe<Scalars['Float']>;
  /** Set true to fire event when device "loiters" within this geofence for loiteringDelay milliseconds. */
  notifyOnDwell?: Maybe<Scalars['Boolean']>;
  /** Set true to fire event when device enters this geofence. */
  notifyOnEntry?: Maybe<Scalars['Boolean']>;
  /** Set true to fire event when device exits this geofence. */
  notifyOnExit?: Maybe<Scalars['Boolean']>;
  /** Radius of the circular geofence in meters. The minimum reliable radius is 200 meters. Not required when using `vertices` for polygon geofences. */
  radius?: Maybe<Scalars['Float']>;
  /** Optional: a list of vertices ([ [lat, lng],...]) defining a Polygon geofence. By default, geofences are circular. */
  vertices?: Maybe<Array<Array<Scalars['Float']>>>;
};

export const MobileGeofenceAction = {
  DWELL: 'DWELL',
  ENTER: 'ENTER',
  EXIT: 'EXIT'
} as const;

export type MobileGeofenceAction = typeof MobileGeofenceAction[keyof typeof MobileGeofenceAction];
export type MobileGeofenceEventBatteryInput = {
  is_charging: Scalars['Boolean'];
  level: Scalars['Float'];
};

export type MobileGeofenceEventCoordsInput = {
  accuracy: Scalars['Float'];
  altitude: Scalars['Float'];
  ellipsoidal_altitude?: InputMaybe<Scalars['Float']>;
  heading: Scalars['Float'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  speed: Scalars['Float'];
};

export type MobileGeofenceEventInput = {
  /** The transition type: ENTER, EXIT, DWELL. */
  action: MobileGeofenceAction;
  /** Optional Geofence extras. This can be any JSON object (it's implementation-defined). */
  extras?: InputMaybe<Scalars['JSON']>;
  /** The identifier of the geofence which fired. */
  identifier: Scalars['String'];
  /** The Location where the geofence transition occurred. */
  location: ReportMyPresenceViaMobileGeofenceEventLocationInput;
  /** The device system time when the Geofence event was received by the OS. Note: this can differ from the timestamp of the triggering location responsible for the geofence (the triggering location can be from the past). */
  timestamp: Scalars['String'];
};

export type MobileGeofenceEventMotionActivityInput = {
  confidence: Scalars['Int'];
  type: MobileActivityType;
};

export const MobileLocationEvent = {
  GEOFENCE: 'geofence',
  HEARTBEAT: 'heartbeat',
  MOTIONCHANGE: 'motionchange',
  PROVIDERCHANGE: 'providerchange'
} as const;

export type MobileLocationEvent = typeof MobileLocationEvent[keyof typeof MobileLocationEvent];
export type Money = {
  __typename?: 'Money';
  /** The number of major currency units in the amount. e.g. `"1.54"` in USD is one dollar and 54 cents. `"100"` in JPY is one hundred yen. Always serialized in fixed notation (i.e. not 1.24e4 exponential notation). */
  amountMajor: Scalars['Decimal'];
  currencyCode: Scalars['CurrencyCodeISO4217'];
};

export type MoneyInput = {
  /** The number of major currency units in the amount. e.g. `"1.54"` in USD is one dollar and 54 cents. `"100"` in JPY is one hundred yen. */
  amountMajor: Scalars['Decimal'];
  currencyCode: Scalars['CurrencyCodeISO4217'];
};

export type MultiPlacePassInput = {
  groups: Array<Scalars['ID']>;
  healthCheckpointRequired?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  places: Array<PassPlaceInput>;
  schedule: Array<Scalars['String']>;
  userChanges?: InputMaybe<PassUsersInput>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Requesting user acknowledges a given announcement for a given location */
  acknowledgeAnnouncement?: Maybe<Scalars['Void']>;
  acknowledgeAnnouncementForMultipleLocations?: Maybe<Scalars['Void']>;
  /** Acknowledge the handling of visit events to prevent duplication of event driven side-effects */
  acknowledgeVisitEventHandled?: Maybe<Scalars['Void']>;
  /** Adds a new custom resource template to the collection of templates for an organization */
  addCustomResourceTemplate?: Maybe<Scalars['Void']>;
  addCustomWorkingHours?: Maybe<Scalars['Void']>;
  /** Adds record to visit draft */
  addDraftVisitRecord: Scalars['ID'];
  addGuestBadgeImage?: Maybe<Scalars['Void']>;
  /** Add a host to an existing visit */
  addHostToVisit?: Maybe<Scalars['Void']>;
  /** Adds a message to a conversation. This is called by the UI when a user sends a message. (The source of the resulting message will be "user") */
  addInsightsAssistantInboundMessageToConversation: InsightsAssistantMessageV1;
  /** Adds a message to a conversation. This is called by the insights-nlq-chaperone when the LLM generates a response. (The source of the resulting message will be "model") */
  addInsightsAssistantOutboundMessageToConversation?: Maybe<Scalars['Void']>;
  addLevelToLocation?: Maybe<AddLevelToLocationResponse>;
  addLevelsToLocation?: Maybe<Array<Maybe<AddLevelsToLocationResponse>>>;
  addLevelsWithDetailsToLocation: Array<AddLevelsWithDetailsToLocationResponse>;
  addLocationToOrganization?: Maybe<AddLocationToOrganizationResponse>;
  /** Add a meeting service, e.g. 'Breakfast' */
  addMeetingService: AddMeetingServiceResponse;
  /** Add a category for meeting services, e.g. 'Catering'. Idempotent - if category already exists with same attributes, return old category. */
  addMeetingServicesCategory: AddMeetingServicesCategoryResponse;
  addNeighborhoodDraftChangesToDefaultDraft?: Maybe<Scalars['Void']>;
  addOfficeAdmin?: Maybe<Scalars['Void']>;
  addOrUpdateLevelSetting: Setting;
  addOrganization?: Maybe<AddOrganizationResponse>;
  addPinnedUserSpaces?: Maybe<Scalars['Void']>;
  addSpaceToEvent: UpdateEventResponse;
  /** Adds a new subcategory to a custom resource template. */
  addSubcategoryToCustomTemplate: EventTrackingOnlyResponse;
  addUserToAssignmentsQueue?: Maybe<Scalars['Void']>;
  addUserToFavorites?: Maybe<Scalars['Void']>;
  addUserToRole?: Maybe<Scalars['Void']>;
  /** Created a org_visit_type entry matching the given visitTypeName. If visit_type exists, simply enable it for given org. */
  addVisitTypeForOrg?: Maybe<Scalars['Void']>;
  /** Allows a robin administrator to register a guest for a visit at some location */
  administratorRegisterGuest?: Maybe<Scalars['Void']>;
  /** @deprecated Use the `autoAllocateStickersToOrg` operation instead */
  allocateStickersToOrg?: Maybe<Scalars['Void']>;
  /** @deprecated Use the `autoAllocateStickersToOrg` operation instead */
  allocateStickersToOrgByDisplayCode?: Maybe<Scalars['Void']>;
  /** Approve a meeting service request that has status "NEEDS_APPROVAL". Once approved, the status will change to "TODO". If the service request has changed since latestChangeId, this fails with "CONFLICT". Only permitted if MeetingServiceRequest.permissions.canApproveOrReject is true. */
  approveMeetingServiceRequest: ApproveMeetingServiceRequestResponse;
  /** Archive an announcement by ID. Changes the `status` to ARCHIVED. */
  archiveAnnouncement?: Maybe<Scalars['Void']>;
  /** Archive a SLACK announcement by ID. Changes the `status` to ARCHIVED. */
  archiveAnnouncementForSlack?: Maybe<Scalars['Void']>;
  /** Archives an integration by id */
  archiveIntegrationById?: Maybe<Scalars['Void']>;
  /** Recover your arrival display using a client signed certificate of authority */
  arrivalDisplayCertRecovery: ArrivalDisplayRescueResponse;
  /** Provided the expressed name and email, either find or create a guest record. Returns guest ID in all cases. */
  assertGuestIdentity: Scalars['ID'];
  /** Creates a new assigned desk reservation for a given user on your behalf. */
  assignDelegatedDesk: Reservation;
  /** Creates a new assigned desk reservation for the current user. */
  assignDeskToMe: Reservation;
  assignStickerToDeskByShortCode?: Maybe<AssignStickerToDeskByShortCodeResponse>;
  assignStickers: AssignStickerResponse;
  /** Associate a health checkpoint response record to a guest invite */
  associateHealthCheckpointWithVisit?: Maybe<Scalars['Void']>;
  /** Generate an authentication bearer token in exchange for a magic link token */
  authenticateVisitorWithMagicLink: VisitMagicLinkAuthResponse;
  autoAllocateStickersToMultipleOrgs?: Maybe<Scalars['Void']>;
  autoAllocateStickersToOrg?: Maybe<Scalars['Void']>;
  /** Batch report for issues with booking users in auto-desk-booking */
  autoDeskBookingBatchReportFailures?: Maybe<Scalars['Void']>;
  /** report for process failures in auto-desk-booking */
  autoDeskBookingReportProcessFailure?: Maybe<Scalars['Void']>;
  /** This mutation is used to unlink a Kisi locks from a Robin levels. If the locks are linked to a Robin location, they will not be unlinked from their locations. */
  batchUnlinkKisiLocksFromRobinLevels?: Maybe<BatchUnlinkKisiLocksFromRobinLevelsResponse>;
  batchUnlinkKisiLocksFromRobinLocations?: Maybe<BatchUnlinkKisiLocksFromRobinLocationsResponse>;
  /** Request pre-signed URLs for uploading files to answer a ticket question. The URLs can be used to upload files before submitting the answer. Client-provided UUIDs in the request will be returned in the response to match files with their URLs. */
  beginFileUploadsForTicketAnswer: BeginFileUploadsForTicketAnswerResponse;
  /** Archive multiple announcements by IDs, modifying it's status to ARCHIVED. If one announcement is unable to be processed, it fails the entire operation */
  bulkArchiveAnnouncements?: Maybe<Scalars['Void']>;
  /** Bulk updates custom working hours for a single location by overriding all the custom working hours to the custom working hour objects provided in the payload. There are three scenarios: If a custom working hour object in the payload has an ID, it updates that object in the db with the corresponding ID If no ID is provided with a custom working hour object, a new object is created in the db If there are objects in the db that is not defined in the payload, they are deleted If there is a failure for one of the objects, the entire operation fails and reverts to custom working hours before the request was made. */
  bulkUpdateCustomWorkingHours?: Maybe<Scalars['Void']>;
  cancelActivity?: Maybe<Scalars['Void']>;
  /** Cancel an existing employee visit */
  cancelEmployeeVisit?: Maybe<Scalars['Void']>;
  cancelEmployeeVisitsAtLocationForEmployee?: Maybe<Scalars['Void']>;
  cancelEmployeeVisitsForEmployee?: Maybe<Scalars['Void']>;
  /** Cancel event by event ID */
  cancelEvent?: Maybe<Scalars['Void']>;
  cancelGuestInvite?: Maybe<Scalars['Void']>;
  /** Marks a message as canceled. This is used to stop processing a question. */
  cancelInsightsAssistantMessage?: Maybe<Scalars['Void']>;
  cancelVisit?: Maybe<Scalars['Void']>;
  /** Change the answers to the questions on a meeting service request. The current CompletedTicketForm.id must be passed in to ensure that the client is working from the latest version. If someone else changes the answers in the meantime, the update will fail with "CONFLICT". */
  changeAnswersOnMeetingServiceRequest: ChangeAnswersOnMeetingServiceRequestResponse;
  /** Changes the Brivo lock links. Can add, change, or remove links. */
  changeBrivoLockLinks: ChangeBrivoLockLinksResponse;
  /** Changes the Gallagher door links. Can add, change, or remove links. */
  changeGallagherDoorLinksForIntegration: ChangeGallagherDoorLinksForIntegrationResponse;
  /** Changes the Genea lock links. Can add, change, or remove links. */
  changeGeneaDoorLinks: ChangeGeneaLockLinksResponse;
  /** Changes the Genetec door links. Can add, change, or remove links. */
  changeGenetecDoorLinksForIntegration: ChangeGenetecDoorLinksForIntegrationResponse;
  /** This mutation is used to change the Robin level a Kisi lock is linked to. It can also be used to create a new link between a Kisi lock and a Robin level. */
  changeKisiLockLinkToRobinLevel?: Maybe<ChangeKisiLockLinkToRobinLevelResponse>;
  changeKisiLockLinkToRobinLocation?: Maybe<ChangeKisiLockLinkToRobinLocationResponse>;
  /** Changes the Openpath lock links. Can add, change, or remove links. */
  changeOpenpathLockLinks: ChangeOpenpathLockLinksResponse;
  /** Changes the Verkada door links. Can add, change, or remove links. */
  changeVerkadaDoorLinks: ChangeVerkadaLockLinksResponse;
  /** check into a visit that was self-registered from the arrival display */
  checkIntoSelfRegisteredVisitFromArrivalDisplay?: Maybe<Scalars['Void']>;
  /**
   * check into a visit using a guest's magic link
   * @deprecated checkIntoVisit is deprecated. Use checkIntoVisitWithMagicLink instead.
   */
  checkIntoVisit?: Maybe<Scalars['Void']>;
  /** check into a visit for a location that does not require HCP from the arrival display */
  checkIntoVisitFromArrivalDisplay?: Maybe<Scalars['Void']>;
  checkIntoVisitFromDashboard?: Maybe<Scalars['Void']>;
  /**
   * check into a visit for a location that requires HCP from the arrival display
   * @deprecated Use checkIntoSelfRegisteredVisitFromArrivalDisplay instead
   */
  checkIntoVisitRequiringHCPFromArrivalDisplay?: Maybe<Scalars['Void']>;
  /** check into a visit using a guest's magic link */
  checkIntoVisitWithMagicLink?: Maybe<Scalars['Void']>;
  /** check out a guest from the arrival display */
  checkOutGuestFromArrivalDisplay?: Maybe<Scalars['Void']>;
  /** check out a guest from the visit admin dashboard */
  checkOutGuestFromDashboard?: Maybe<Scalars['Void']>;
  /** Complete a a survey response */
  completeSurveyResponse?: Maybe<SurveyResponse>;
  confirmDeskReservation?: Maybe<Scalars['Void']>;
  /** Confirm the desk reservation for the given user. Requires a token with elevated scopes. Allows bypassing confirmation checks, as this should be used when there's real user presence in the office. */
  confirmDeskReservationBypassingConfirmationWindowDelegated?: Maybe<Scalars['Void']>;
  /** Confirm the desk reservation for the given user. Requires a token with elevated scopes. */
  confirmDeskReservationDelegated?: Maybe<Scalars['Void']>;
  /** Confirm event by event ID */
  confirmEvent?: Maybe<Scalars['Void']>;
  /** Connects Gallagher account. */
  connectGallagherAccountForCurrentTenant: ConnectGallagherAccountForCurrentTenantResponse;
  /** Connects Genea account. */
  connectGeneaAccountForCurrentTenant: ConnectGeneaAccountForCurrentTenantResponse;
  connectGenericConnectorAccount: ConnectGenericConnectorAccountResponse;
  /** Connects Genetec account. */
  connectGenetecAccountForCurrentTenant: ConnectGenetecAccountForCurrentTenantResponse;
  /** Accepts Kisi admin created API and creates necessary event webhooks. */
  connectKisiAccount: ConnectKisiAccountResponse;
  /** Accepts OpenPath credentials and sets up the account. */
  connectOpenpathAccount: ConnectOpenpathAccountResponse;
  /** Connects Verkada account. */
  connectVerkadaAccountForCurrentTenant: ConnectVerkadaAccountForCurrentTenantResponse;
  /** Converts an existing API token to a JWT claims token and refresh token pair */
  convertApiTokenToJwtAuth: AuthorizationResponse;
  convertGroupToExternalRipplingGroup: ConvertGroupToExternalRipplingGroupResponse;
  createActivity: CreateActivityReturnType;
  /** Link a custom image and image name with the location of an activity. */
  createActivityCustomImage: Scalars['ID'];
  /** Create a new amenity (applies to neither spaces or desks if no configuration is provided) mutation returns the ID of the created amenity */
  createAmenity: Scalars['ID'];
  createAndMapBuildingsFromRippling: CreateAndMapBuildingsFromRipplingResponse;
  /** Create a new announcement for given locations. `status` is ACTIVE by default. - Note: only user actors are allowed to create announcements */
  createAnnouncement?: Maybe<Scalars['Void']>;
  /** Create a new announcement to be consumed by SLACK. `status` is ACTIVE by default. */
  createAnnouncementForSlack?: Maybe<Scalars['Void']>;
  /** From dashboard on creation of the new arrival display. Creates new device for the given tenant. In event land: Successful create causes event handler to generate new device authentication which is registered against this entity. */
  createArrivalDisplay: Scalars['ArrivalDisplayRegistrationKey'];
  /** Creates a badge CSV upload link, associated with given inputs. */
  createBadgeCSVUploadLink: CreateBadgeCsvUploadLinkResponse;
  /** From dashboard on creation of the new badge printer. Creates new device for the given tenant. */
  createBadgePrinter?: Maybe<Scalars['Void']>;
  createBookingWindowPolicyForLocation?: Maybe<Scalars['Void']>;
  /** Creates a new custom form from the input */
  createCustomVisitForm?: Maybe<CustomVisitForm>;
  createDefaultDraft: CreateDraftResponse;
  createDelivery?: Maybe<Delivery>;
  createDeliveryZone?: Maybe<DeliveryZone>;
  createDeskExclusions?: Maybe<Array<Scalars['ID']>>;
  createDisposableDraft: CreateDraftResponse;
  createDraft: CreateDraftResponse;
  /** Creates new visit draft. Also deletes old draft data if it exists */
  createDraftVisit: Scalars['ID'];
  /** Creates a new email configuration associated with the given location */
  createEmailConfiguration?: Maybe<EmailConfiguration>;
  createGenericHealthCheckpoint: CreateGenericHealthCheckpointResponse;
  createGroupAndMakeItExternalRipplingGroup: CreateGroupAndMakeItExternalRipplingGroupResponse;
  /** Creates a new integration */
  createIntegration?: Maybe<ExternalIntegration>;
  createLayoutDraft: CreateDraftResponse;
  createLegacyIntegration?: Maybe<LegacyIntegration>;
  /** @deprecated Use `persistNeighborhoods` instead */
  createNeighborhood?: Maybe<CreateNeighborhoodResponse>;
  createOfficeAdminRole?: Maybe<Scalars['Void']>;
  /** @deprecated createPass is deprecated. Use createPassForPlaces instead. */
  createPass?: Maybe<Scalars['Void']>;
  /** Creates a pass for one or more places */
  createPassForPlaces?: Maybe<Scalars['Void']>;
  createRobinOrganizationFromRipplingOAuthData: CreateRobinOrganizationFromRipplingOAuthDataResponse;
  createRole?: Maybe<Scalars['Void']>;
  /** Creates a Sigma user if it doesn't exist */
  createSigmaMember?: Maybe<Scalars['ID']>;
  /** Creates a new Sigma workbook in My Documents or Shared */
  createSigmaWorkbook?: Maybe<SigmaWorkbook>;
  /**
   * Internal method to create a new visit with zero side effects.
   * @deprecated Use createVisitWithCustomVisitType
   */
  createVisit?: Maybe<Scalars['Void']>;
  /** Internal method to create a new visit with zero side effects using a string visit type. */
  createVisitWithCustomVisitType?: Maybe<Scalars['Void']>;
  createWorkPolicy?: Maybe<Scalars['Void']>;
  customResourceInstancePrePublishDelete?: Maybe<Scalars['Void']>;
  /** Save new, or update existing custom resource instances in a pre-publish state. This method is intended to support progressive updates to an in-progress mapping of resources. Changes will be published after save if publishChangesAfterSave is set to true, otherwise the session will remain open and accept additional updates. */
  customResourceInstancePrePublishSave?: Maybe<Scalars['Void']>;
  /** Edit a recurring reservation series, modifying only future occurrences. Past reservation events are preserved and unmodified. Returns validation response to ensure the changes comply with resource policies. */
  customResourceRecurringReservationEdit: ScheduleRecurringReservationResponseType;
  /** Confirms multiple reservations in bulk on behalf of a user (internal service only) All reservations must be for the same organization and use the same confirmation timestamp/client type */
  customResourceReservationBulkConfirmInternal?: Maybe<BulkResourceReservationConfirmationResponse>;
  /** Cancel a resource reservation completely. Future single day reservations are canceled. Recurring reservation instances are canceled if the fall in the future. */
  customResourceReservationCompletelyCancel?: Maybe<CancelResourceReservationCompleteCancelResponseType>;
  /** Reschedule a reservation instance. This allows modifying a single occurrence of a recurring reservation. Or a single day reservation. Returns validation response to ensure the reschedule complies with resource policies. */
  customResourceReservationInstanceReschedule: ScheduleSingleDayReservationResponseType;
  /** Moves remaining reservations from the current resource to a new resource. A new reservation IDs are spawned from this activity. Existing reservations IDs are ended. */
  customResourceReservationMove: Array<ScheduleRecurringReservationResponseType>;
  /** Confirms reservation */
  customResourceReservationSelfConfirm?: Maybe<ResourceReservationConfirmationResponse>;
  /** Request to schedule a single day reservation of a resource by ID for another user */
  customResourceScheduleSingleDayDelegateReservation: ScheduleSingleDayReservationResponseType;
  /** Disable a org_visit_type entry matching the given visitTypeName. */
  deactivateVisitTypeForOrg?: Maybe<Scalars['Void']>;
  /**
   * Set a decision for a document for a visiting guest for one document within a specified workflow.
   * @deprecated Use decideOutcomeForVisitDocumentFromArrivalDisplay instead
   */
  decideOutcomeForVisitDocument?: Maybe<Scalars['Void']>;
  /** Set a decision from the Arrival Display for a document for a visiting guest for one document within a specified workflow. */
  decideOutcomeForVisitDocumentFromArrivalDisplay?: Maybe<Scalars['Void']>;
  /** Set a decision from the GuestUI for a document for a visiting guest for one document within a specified workflow. */
  decideOutcomeForVisitDocumentFromGuestUI?: Maybe<Scalars['Void']>;
  /** Ends or cancels a reservation and updates the user's participation status. Should be used to cancel actor's own reservation. */
  declineAndEndReservation: EndOrCancelReservationResponse;
  /** Soft delete a custom image associated with an activity's location. */
  deleteActivityCustomImage?: Maybe<Scalars['Void']>;
  /** Deletes a custom form with the given ID */
  deleteCustomVisitForm?: Maybe<Scalars['Void']>;
  deleteDeliveries?: Maybe<Scalars['Void']>;
  /** @deprecated use deleteDeliveries instead */
  deleteDelivery?: Maybe<Scalars['Void']>;
  deleteDeliveryZone?: Maybe<Scalars['Void']>;
  deleteDeskExclusions?: Maybe<Scalars['Void']>;
  deleteDraft?: Maybe<Scalars['Void']>;
  deleteDraftChangesForOrganization: Scalars['Boolean'];
  /** Deletes the email configuration associated with the given location */
  deleteEmailConfiguration?: Maybe<Scalars['Void']>;
  deleteExternalRipplingGroup: DeleteExternalRipplingGroupResponse;
  /** Deletes a legacy integration exists for the user by the given type and resource-type Tenant ID is also taken into account Returns the id of the deleted integration */
  deleteLegacyIntegrationByType?: Maybe<Scalars['Int']>;
  /** Soft deletes meeting services by ids. Idempotent. It does not cancel any meeting requests already created under those services. */
  deleteMeetingServices?: Maybe<Scalars['Void']>;
  /** Delete a meeting services category. Idempotent. Fails if the category has meeting services associated with it. */
  deleteMeetingServicesCategory: DeleteMeetingServicesCategoryResponse;
  /** Deletes a meeting service request by ID. Idempotent. */
  deleteOrCancelMeetingServiceRequest?: Maybe<Scalars['Void']>;
  deletePass?: Maybe<Scalars['Void']>;
  deleteWorkAreaDesks?: Maybe<Scalars['Void']>;
  disableAnonymityModeForOrg?: Maybe<Scalars['Void']>;
  disableGeofenceFeatureForBuilding?: Maybe<Scalars['Void']>;
  disableGeofenceFeatureForMe?: Maybe<Scalars['Void']>;
  disableOrganizationUser?: Maybe<Scalars['Void']>;
  disablePassiveCheckInFeatureForBuilding?: Maybe<Scalars['Void']>;
  disableSpaces: DisableSpacesResults;
  discardDefaultDraft?: Maybe<Scalars['Void']>;
  /** Disables Brivo integration for the current tenant. */
  disconnectBrivoAccountForCurrentTenant: DisconnectBrivoAccountResponse;
  /** Disables Gallagher integration by given UUID. */
  disconnectGallagherAccountByIntegrationUuid: DisconnectGallagherAccountByIntegrationUuidResponse;
  /** Disables Genea integration by given UUID. */
  disconnectGeneaAccountByIntegrationUuid: DisconnectGeneaAccountByIntegrationUuidResponse;
  /** Disables Genetec integration by given UUID. */
  disconnectGenetecAccountByIntegrationUuid: DisconnectGenetecAccountByIntegrationUuidResponse;
  /** Disables Kisi integration for the current tenant. */
  disconnectKisiAccount: DisconnnectKisiAccountResponse;
  /** Disables OpenPath integration for the current tenant. */
  disconnectOpenpathAccount: DisconnectOpenpathAccountResponse;
  /** Disables Verkada integration by given UUID. */
  disconnectVerkadaAccountByIntegrationUuid: DisconnectVerkadaAccountByIntegrationUuidResponse;
  /** Dismiss a survey response */
  dismissSurveyResponse?: Maybe<SurveyResponse>;
  editCustomResourceTemplate?: Maybe<Scalars['Void']>;
  /** Edits record to visit draft. If there are not guests in guests array the record will be deleted instead. */
  editDraftVisitRecord?: Maybe<Scalars['Void']>;
  /** Edit a meeting services category. Idempotent. Changing the name affects existing services. Changing the key affects existing services, but only applies to new requests going forward. Existing requests will continue to use the old key. */
  editMeetingServicesCategory: EditMeetingServicesCategoryResponse;
  employeeRegisteredForWaitlistVisit?: Maybe<Scalars['Void']>;
  employeeVisit: EmployeeVisitMutations;
  enableAnonymityModeForOrg?: Maybe<Scalars['Void']>;
  enableGeofenceFeatureForBuilding?: Maybe<Scalars['Void']>;
  enableGeofenceFeatureForMe?: Maybe<Scalars['Void']>;
  enableOrganizationUser?: Maybe<Scalars['Void']>;
  enablePassiveCheckInFeatureForBuilding?: Maybe<Scalars['Void']>;
  /** Terminates a conversation setting active to false. */
  endInsightsAssistantConversation?: Maybe<Scalars['Void']>;
  endInsightsAssistantConversationV2?: Maybe<Scalars['Void']>;
  /** Ends or cancels a reservation via delegation */
  endOrCancelDelegatedReservation: EndOrCancelReservationResponse;
  /** Ends or cancels a reservation. Should be used to cancel actor's own reservation. */
  endOrCancelReservation: EndOrCancelReservationResponse;
  endReservationOrVisitsInRange?: Maybe<EndReservationOrVisitInRangeResponse>;
  /** Accepts a list of records and force resolves them to a success state */
  forceResolveCSVUploadRecords: ForceResolveCsvUploadRecordsResponse;
  generateStickerBatch: GenerateStickerBatchResponse;
  /** A guest invite failed their health checkpoint */
  guestHealthCheckpointFailed?: Maybe<Scalars['Void']>;
  /** Called when a guest's invitation email has been sent */
  guestInvited?: Maybe<Scalars['Void']>;
  /** Initiates Brivo account connection. Will return an OAuth URL client should use. */
  initiateBrivoAccountConnectionForCurrentTenant: InitiateBrivoAccountConnectionForCurrentTenantResponse;
  initiateRipplingConnectionAndSync: InitiateRipplingConnectionAndSyncResponse;
  initiateRipplingUserSync: InitiateRipplingUserSyncResponse;
  inviteOfficeAdminUsers?: Maybe<Scalars['Void']>;
  inviteUsersToDraft?: Maybe<Scalars['Void']>;
  /** @deprecated Use inviteUsersToDraft instead */
  inviteUsersToDraftAsCollaborators?: Maybe<Scalars['Void']>;
  joinActivity?: Maybe<Scalars['Void']>;
  /** Perform whichever action makes sense to allow a user to "Join" the office. If there is a desk reservation reservation, confirm it if allowed. Otherwise, schedule an employee visit. */
  joinOffice?: Maybe<Scalars['Void']>;
  linkArrivalDisplayAndBadgePrinter?: Maybe<Scalars['Void']>;
  linkKisiLockToRobinLocation?: Maybe<LinkKisiLockToRobinLocationResponse>;
  logSpaceSuggestionBooked?: Maybe<Scalars['Void']>;
  logSpaceSuggestionDismissed?: Maybe<Scalars['Void']>;
  logSpaceSuggestionViewed?: Maybe<Scalars['Void']>;
  mapBuildingToRipplingWorkLocation: MapBuildingToRipplingWorkLocationResponse;
  mapBuildingsToRipplingWorkLocations: Array<MapBuildingsToRipplingWorkLocationsResponse>;
  /** Accepts a list of Kisi locks and maps it to Robin locations. */
  mapKisiLocksToRobinLocations?: Maybe<MapKisiLocksToRobinLocationsResponse>;
  modifyDraftCollaboratorAccessLevel?: Maybe<Scalars['Void']>;
  persistNeighborhoods?: Maybe<PersistNeighborhoodsResponse>;
  publishDraft?: Maybe<Scalars['Void']>;
  publishSharedScheduleForDesk?: Maybe<Scalars['Void']>;
  /** Attempts to publish all records tied to the given draft id */
  publishVisitDraft: Scalars['Boolean'];
  /** Accepts OpenPath credentials and updates the account connection. */
  reconnectOpenpathAccount: ReconnectOpenpathAccountResponse;
  refreshDeviceAuthorization: DeviceAuthorizationResponse;
  /** Refreshes an existing JWT claims token and refresh token pair */
  refreshJwtAuthToken: AuthorizationResponse;
  /** Register arrival display for service. Each key only works one time. */
  registerArrivalDisplay: ArrivalDisplayRegistrationResponse;
  /**
   * register a guest in a location that doesn't require HCP from the arrival display - automatically checks the visit in
   * @deprecated Use registerGuestWithoutHCPFromArrivalDisplay
   */
  registerGuestFromArrivalDisplay?: Maybe<Scalars['Void']>;
  /**
   * create a new visit from dashboard. guests listed will be upserted into the set of known guests, matched by email.
   * @deprecated This creation method will be replaced with a more open usage of visit type. Replaced by administratorRegisterGuest.
   */
  registerGuestFromDashboard?: Maybe<Scalars['Void']>;
  /**
   * register a guest in a location that requires a HCP from the arrival display
   * @deprecated Use registerGuestWithHCPFromArrivalDisplayWithCustomVisitType
   */
  registerGuestWithHCPFromArrivalDisplay?: Maybe<Scalars['Void']>;
  /** register a guest in a location that requires a HCP from the arrival display using a string visit type */
  registerGuestWithHCPFromArrivalDisplayWithCustomVisitType?: Maybe<Scalars['Void']>;
  /**
   * register a guest in a location that doesn't require HCP from the arrival display
   * @deprecated Use registerGuestWithoutHCPFromArrivalDisplayWithCustomVisitType
   */
  registerGuestWithoutHCPFromArrivalDisplay?: Maybe<Scalars['Void']>;
  /** register a guest in a location that doesn't require HCP from the arrival display using a string visit type */
  registerGuestWithoutHCPFromArrivalDisplayWithCustomVisitType?: Maybe<Scalars['Void']>;
  /** Reject a meeting service request that has status "NEEDS_APPROVAL". Once rejected, the status will change to "REJECTED", similar to "CANCELLED". If the service request has changed since latestChangeId, this fails with "CONFLICT". Only permitted if MeetingServiceRequest.permissions.canApproveOrReject is true. */
  rejectMeetingServiceRequest: RejectMeetingServiceRequestResponse;
  /** Unregister and de-authenticate all devices for location. */
  removeAllDevicesForLocation?: Maybe<Scalars['Void']>;
  /** Unregister and de-authenticate an arrival display. */
  removeArrivalDisplay?: Maybe<Scalars['Void']>;
  /** Unregister a badge printer. */
  removeBadgePrinter?: Maybe<Scalars['Void']>;
  removeBookingWindowPolicyForLocation?: Maybe<Scalars['Void']>;
  removeBuildingGeofence?: Maybe<Scalars['Void']>;
  /** Removes messages by ID from a chat on activity */
  removeChatMessagesFromActivity?: Maybe<Scalars['Void']>;
  removeCustomWorkingHours?: Maybe<Scalars['Void']>;
  /** Remove a host from a visit */
  removeHostFromVisit?: Maybe<Scalars['Void']>;
  removeOfficeAdmin?: Maybe<Scalars['Void']>;
  /** Remove permissions from roles for a specific target and category */
  removePermissionOnRole?: Maybe<Scalars['Void']>;
  removePinnedUserSpaces?: Maybe<Scalars['Void']>;
  removeSpaceFromEvent: RemoveSpaceFromEventResponse;
  removeUserFromFavorites?: Maybe<Scalars['Void']>;
  removeUserFromRole?: Maybe<Scalars['Void']>;
  removeUsersFromAssignmentsQueue?: Maybe<Scalars['Void']>;
  removeUsersFromDraftCollaborators?: Maybe<Scalars['Void']>;
  /** Extends the expiration period on an expired, unused arrival display registration. */
  renewArrivalDisplayRegistration?: Maybe<Scalars['Void']>;
  /** Used by arrival displays to report their status and to report the status of their connected badge printer. */
  reportDeviceStatus?: Maybe<Scalars['Void']>;
  /** Report an issue with a desk - chair is broken, monitor is busted, etc */
  reportIssueWithDesk: ReportIssueResponse;
  /** Report an issue with a space - TV isn't working, table is wobbly, etc */
  reportIssueWithSpace: ReportIssueResponse;
  /** Reports presence from a mobile client via a geofence event. */
  reportMyPresenceViaMobileGeofenceEvent: ReportMyPresenceViaMobileGeofenceEventResponse;
  /** Tells us the device's current IP address. From this, we can infer that the user is present with their device at a building associated with that IP address, and perform side effects like checking them in to their reservations at that building. Don't bother calling this if device is on a cellular data connection or a VPN. */
  reportUserPresenceAtIPAddress: ReportUserPresenceAtIpAddressResponse;
  /** Reports presence from a web client. Similar to reportUserPresenceAtIPAddress, but for web clients, which don't have a direct way to report their IP address. We will be conservative in trusting the remote IP. */
  reportUserPresenceFromWebClient: ReportUserPresenceFromWebClientResponse;
  /** Tells us that the user is present in a particular building at a particular time */
  reportUserPresenceInBuildingAtTime: ReportUserPresenceInBuildingAtTimeResponse;
  /** Creates a meeting service request for a draft event at a space. A "draft event" is one that has not yet been created, so neither Robin nor Google/MS know about it. Service requests created with this mutation are not "real" until we see the event sync back to Robin. Nobody will be emailed until that sync happens. If the draft Event is never saved, then we can have dangling service requests that should be cleaned up later. If the event has already been created, use requestMeetingServiceForExistingEventAtSpace instead. Requires permission to request services at the given spaceId (workplace_services:request). */
  requestMeetingServiceForDraftEventAtSpace: RequestMeetingServiceForDraftEventAtSpaceResponse;
  /** Creates a meeting service request for an existing event at a space. If the event has not been created yet, use requestMeetingServiceForDraftEventAtSpace instead. Requires permission to request services at the given spaceId (workplace_services:request). */
  requestMeetingServiceForExistingEventAtSpace: RequestMeetingServiceForExistingEventAtSpaceResponse;
  resendCollaboratorInvite?: Maybe<Scalars['Void']>;
  /** Creates a new hot/hoteled desk reservationfor a given user on your behalf. */
  reserveDelegatedDesk: Reservation;
  /** Creates a new hot/hoteled desk reservation for the current user. */
  reserveDeskForMe: Reservation;
  /** Reserve a space */
  reserveSpace: ReserveSpaceResponse;
  /** Assign a resource to a user */
  resourceRecurringAssignmentSchedule: ScheduleRecurringReservationResponseType;
  /** Request to schedule a recurring reservation for a specific user by resource ID */
  resourceRecurringReservationSchedule: ScheduleRecurringReservationResponseType;
  /** Sets the policy for a category of resources within a location. This policy change can optionally be applied to all existing resources matching the specified category currently in that location. */
  resourceSetCategoryPolicyOnLocation: ResourceMutationResponseTrackingType;
  rollbackMicrosoftMigration?: Maybe<Scalars['Void']>;
  rollbackNeighborhoods: RollbackNeighborhoodsResponse;
  rolloutNeighborhoods: RolloutNeighborhoodsResponse;
  rolloutNeighborhoodsForAllOrgs: RolloutNeighborhoodsResponse;
  saveMappedGoogleLocations?: Maybe<Scalars['Void']>;
  /** Save a new survey configuration */
  saveSurveyConfiguration?: Maybe<Survey>;
  scaffoldDemoFloorPlan?: Maybe<Scalars['Void']>;
  /** Create a new employee visit */
  scheduleEmployeeVisitAtLocation?: Maybe<Scalars['Void']>;
  /** Request to schedule a single day reservation for current user of a resource by ID */
  scheduleSingleDayReservation: ScheduleSingleDayReservationResponseType;
  /**
   * Add a chat message to an activity
   * @deprecated Deprecated in favor of `sendChatOnActivityWithId`
   */
  sendChatOnActivity?: Maybe<Scalars['Void']>;
  /** Add a chat message to an activity with client specified UUID identity */
  sendChatOnActivityWithId?: Maybe<Scalars['Void']>;
  /**
   * This mutation allows admins to retrigger a notification to a recipient.
   * @deprecated use sendDeliveryNotificationsToRecipients instead
   */
  sendDeliveryNotificationToRecipient?: Maybe<Scalars['Void']>;
  /** This mutation allows admins to retrigger notifications to many recipients. */
  sendDeliveryNotificationsToRecipients?: Maybe<Scalars['Void']>;
  /** Sets the auto desk booking setting for current (user) actor */
  setAutoDeskBooking?: Maybe<Scalars['Void']>;
  setAutoDeskBookingForOrg?: Maybe<Scalars['Void']>;
  /** Requires places:manage permission for the given building. Sets public CIDRs associated with the given building, for use with passive check-in. Idempotent. Number of CIDRs, size of subnet are both limited. Rejects CIDRs that might technically be valid but are likely user error: "1", "1.2", etc. Tries to reject bogons and martians: https://en.wikipedia.org/wiki/Bogon_filtering */
  setBuildingCidrs: SetBuildingCidrsResponse;
  setBuildingGeofenceAsPointWithRadius: SetBuildingGeofenceAsPointWithRadiusResponse;
  /** Sets a channel ID for a user's personal calendar integration. */
  setChannelAndResourceIdsForUserCalendar?: Maybe<Scalars['Void']>;
  setDefaultLocationForUser?: Maybe<Scalars['Void']>;
  /** Sets sentAt field for distribution and resolves sendResult to SUCCESS for all provided recipient ids. An error will be thrown if client tries to set send data of a distribution or recipient that has already been set. */
  setDistributionSendData?: Maybe<Scalars['Void']>;
  setEmployeeVisitsEnabledForOrg?: Maybe<Scalars['Void']>;
  /** Changes the Gallagher e-mail field indentifier. */
  setGallagherEmailFieldIdentifierForIntegration: SetGallagherEmailFieldIdentifierForIntegrationResponse;
  setGoogleWorkingLocationSyncSettingForOrg?: Maybe<Scalars['Void']>;
  /** Sets the sync google working locations setting user. 0 for off, org ID for on. */
  setGoogleWorkingLocationSyncSettingForUser?: Maybe<Scalars['Void']>;
  /** Sets the homepage preference for current (user) actor. */
  setMyHomepage?: Maybe<Scalars['Void']>;
  /** Sets a languge tag for current (user) actor */
  setMyLanguageTag?: Maybe<Scalars['Void']>;
  /** Sets working hours for current user */
  setMyWorkingHours?: Maybe<Scalars['Void']>;
  /** Update the given notification preference for the current user */
  setNotificationPreferenceForCurrentUser?: Maybe<Scalars['Void']>;
  setOpenpathCredentialProvisioningEnabledForIntegration: SetOpenpathCredentialProvisioningEnabledForIntegrationResponse;
  setOpenpathPresenceReportingEnabledForIntegration: SetOpenpathPresenceReportingEnabledForIntegrationResponse;
  setOrganization14Day100UsersTrial?: Maybe<Scalars['Void']>;
  /** Set resource permissions within hierarchy */
  setPermissionsOnHierarchy?: Maybe<Scalars['Void']>;
  /** Set resource permissions on one or more roles */
  setPermissionsOnRole?: Maybe<Scalars['Void']>;
  /** Updates startAt date for recurring distribution announcements and keeps the sentAt field set to null. Sent the startAt date as a ISODateTime */
  setRecurringAnnouncementData?: Maybe<Scalars['Void']>;
  /** Sets the show weekends setting for current (user) actor */
  setShowWeekendsForMe?: Maybe<Scalars['Void']>;
  setSuggestedSpacesEnabledForOrg?: Maybe<Scalars['Void']>;
  setTeamMembershipByName?: Maybe<Scalars['Void']>;
  /** Sets a user notification setting. */
  setUserNotificationSetting?: Maybe<Scalars['Void']>;
  /** Set the complete host list for a visit (replaces all existing hosts). The first host in the array becomes the primary host. Hosts not in the array will be removed (soft deleted). */
  setVisitHosts?: Maybe<Scalars['Void']>;
  /** Begins a new empty active conversation. */
  startInsightsAssistantConversation: InsightsAssistantConversationV1;
  /** Begins a new empty active V2 conversation and creates a thread. */
  startInsightsAssistantConversationV2: InsightsAssistantConversationV2;
  /** Temporary migration query which generates and returns the client secret for existing arrival displays */
  tempArrivalDisplayAuthMigration: ArrivalDisplayRegistrationResponse;
  toggleDraftLock: ToggleDraftLockResponse;
  triggerManualSyncOfSpaceCalendar?: Maybe<Scalars['Void']>;
  unassignSticker?: Maybe<Scalars['Void']>;
  unjoinActivity?: Maybe<Scalars['Void']>;
  unlinkArrivalDisplayAndBadgePrinter?: Maybe<Scalars['Void']>;
  /** This mutation is used to unlink a Kisi lock from a Robin level. If the lock is linked to a Robin location, it will not be unlinked from the location. */
  unlinkKisiLockFromRobinLevel?: Maybe<UnlinkKisiLockFromRobinLevelResponse>;
  unlinkKisiLockFromRobinLocation?: Maybe<UnlinkKisiLockFromRobinLocationResponse>;
  /** To be used when a location is deleted */
  unlinkLocationFromCustomForms?: Maybe<Scalars['Void']>;
  /** This mutation understands the input as the state of the activity, therefore it will update every field according to the input */
  updateActivity?: Maybe<Scalars['Void']>;
  /** Update a single (ACTIVE or SCHEDULED) announcement. Author cannot change. */
  updateAnnouncement?: Maybe<Scalars['Void']>;
  /** From the Dashboard, users can edit arrival displays they've already created. */
  updateArrivalDisplay?: Maybe<Scalars['Void']>;
  /** From the Dashboard, users can edit badge printers they've already created. */
  updateBadgePrinter?: Maybe<Scalars['Void']>;
  updateBookingWindowPolicyForLocation?: Maybe<Scalars['Void']>;
  /** Updates an existing custom resource template's associated amenities */
  updateCustomResourceTemplateAssociatedAmenities?: Maybe<Scalars['Void']>;
  /** Updates subcategories in a custom resource template. For each subcategory to be updated, you must provide both the original value and the new value to ensure proper replacement. */
  updateCustomResourceTemplateSubcategories: EventTrackingOnlyResponse;
  /** Updates a given custom form with the provided updates */
  updateCustomVisitForm?: Maybe<CustomVisitForm>;
  updateCustomWorkingHours?: Maybe<Scalars['Void']>;
  /** Updates the default pass setting */
  updateDefaultPass?: Maybe<Scalars['Void']>;
  updateDelivery?: Maybe<Delivery>;
  /** This route allows user's with magic links to update delivery status. */
  updateDeliveryStatusByMagicLink: Delivery;
  updateDeliveryZone: DeliveryZone;
  updateDistributionsByAnnouncementId?: Maybe<Scalars['Void']>;
  updateDraft: UpdateDraftResponse;
  updateDraftData: UpdateDraftDataResponse;
  /** Updates last heartbeat of given draft */
  updateDraftHeartbeat?: Maybe<Scalars['Void']>;
  updateDraftMetadata?: Maybe<Scalars['Void']>;
  updateDraftNeighborhood: UpdateDraftNeighborhoodResponse;
  /** Updates the email configuration associated with the given location */
  updateEmailConfiguration?: Maybe<EmailConfiguration>;
  /** Update host settings for a visit */
  updateHostSettings?: Maybe<Scalars['Void']>;
  /** Adds feedback for a given message. */
  updateInsightsAssistantFeedbackForMessage?: Maybe<Scalars['Void']>;
  updateInsightsAssistantFeedbackForMessageV2?: Maybe<Scalars['Void']>;
  updateLayoutDraft: UpdateLayoutDraftResponse;
  /** Change a meeting service, keeping the old versions of questions around for existing requests. Clients must have an accurate picture of previous state, so conflicting changes are rejected. Future iterations of this mutation might be diff-based (e.g. adding spaces instead of passing the whole list back and forth). Partial updates are supported by omitting fields, rather than explicitly setting them to null. */
  updateMeetingService: UpdateMeetingServiceResponse;
  /** Updates a ticket status based on current status. Idempotent. */
  updateMeetingServiceRequestStatus: UpdateMeetingServiceRequestStatusResponse;
  /** Updates the desk, start time, and end time for the current user's non-recurring desk reservation. */
  updateMyReservationDeskAndTimeFrame: UpdateDeskReservationResponse;
  /** @deprecated updatePass is deprecated. Use updatePassForPlaces instead. */
  updatePass?: Maybe<Scalars['Void']>;
  /** Updates a pass for one or more places */
  updatePassForPlaces?: Maybe<Scalars['Void']>;
  /** Updates the desk RDATES for the user's recurring desk reservation. */
  updateRecurringReservationDates?: Maybe<Scalars['Void']>;
  /** Updates the complete RDATE rule for the user's recurring desk reservation. */
  updateRecurringReservationRdate?: Maybe<Scalars['Void']>;
  /** Updates the visibility of a desk reservation. */
  updateReservationVisibility?: Maybe<Scalars['Void']>;
  updateShowNeighborhoodColor: UpdateShowNeighborhoodColorResponse;
  updateStandardWorkingHoursForLocation?: Maybe<Scalars['Void']>;
  /** Update an existing survey configuration */
  updateSurveyConfiguration?: Maybe<Survey>;
  /** Allows a robin administrator to update a visit */
  updateVisit?: Maybe<Scalars['Void']>;
  updateWorkAreas: Array<WorkArea>;
  updateWorkPolicy?: Maybe<Scalars['Void']>;
  /** Store data that user has viewed an announcement at the given location. */
  viewAnnouncement?: Maybe<Scalars['Void']>;
  viewAnnouncementForMultipleLocations?: Maybe<Scalars['Void']>;
  /** Add a new document task to visit workflows for the specified visit types and locations */
  visitAddDocumentTask?: Maybe<Scalars['Void']>;
  /** Archive an existing document. The specified document is removed from all live workflows. */
  visitArchiveDocument?: Maybe<Scalars['Void']>;
  /** Update the status of an async visit request. This mutation is only accessible using an internal service auth token. */
  visitAsyncRequestStatusReport?: Maybe<Scalars['Void']>;
  /**
   * Update a document task to apply to a new visit workflow for the specified visit types and locations
   * @deprecated Use visitChangeDocumentTaskAssociationsWithCustomVisitType instead
   */
  visitChangeDocumentTaskAssociations?: Maybe<Scalars['Void']>;
  /** Update a document task to apply to a new visit workflow for the specified visit types and locations */
  visitChangeDocumentTaskAssociationsWithCustomVisitType?: Maybe<Scalars['Void']>;
};


export type MutationAcknowledgeAnnouncementArgs = {
  announcementId: Scalars['ID'];
  locationId: Scalars['ID'];
};


export type MutationAcknowledgeAnnouncementForMultipleLocationsArgs = {
  announcementId: Scalars['ID'];
  locationIds: Array<Scalars['ID']>;
};


export type MutationAcknowledgeVisitEventHandledArgs = {
  eventType: VisitEventAcknowledgement;
  visitId: Scalars['ID'];
};


export type MutationAddCustomResourceTemplateArgs = {
  associatedAmenityIds?: InputMaybe<Array<Scalars['ID']>>;
  description?: InputMaybe<Scalars['String']>;
  icon?: InputMaybe<IconType>;
  organizationID: Scalars['ID'];
  policyConfiguration?: InputMaybe<CustomResourcePolicyDocumentCommand>;
  resourceCategory: Scalars['String'];
  resourceCategorySingular?: InputMaybe<Scalars['String']>;
  subCategories?: InputMaybe<Array<Scalars['CustomResourceSubCategoryType']>>;
  templateId: Scalars['ID'];
};


export type MutationAddCustomWorkingHoursArgs = {
  customWorkingHours: CustomWorkingHoursInput;
};


export type MutationAddDraftVisitRecordArgs = {
  arrivalInstructions?: InputMaybe<Scalars['String']>;
  arrivalLocationId: Scalars['ID'];
  checkInGuest?: InputMaybe<Scalars['Boolean']>;
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  eventUid: Scalars['String'];
  guests: Array<GuestInputType>;
  hostUserId: Scalars['ID'];
  provisionCredentials?: InputMaybe<Scalars['Boolean']>;
  sendGuestEmailInvite?: InputMaybe<Scalars['Boolean']>;
  startTime: Scalars['ISODateTime'];
  visitType: Scalars['String'];
};


export type MutationAddGuestBadgeImageArgs = {
  base64Image: Scalars['String'];
  guestInviteId: Scalars['ID'];
};


export type MutationAddHostToVisitArgs = {
  host: VisitHostInput;
  visitId: Scalars['ID'];
};


export type MutationAddInsightsAssistantInboundMessageToConversationArgs = {
  conversationId: Scalars['ID'];
  text: Scalars['String'];
};


export type MutationAddInsightsAssistantOutboundMessageToConversationArgs = {
  conversationId: Scalars['ID'];
  parentMessageId?: InputMaybe<Scalars['ID']>;
  text: Scalars['String'];
};


export type MutationAddLevelToLocationArgs = {
  locationId: Scalars['ID'];
  name: Scalars['String'];
};


export type MutationAddLevelsToLocationArgs = {
  locationId: Scalars['ID'];
  names: Array<Scalars['String']>;
};


export type MutationAddLevelsWithDetailsToLocationArgs = {
  levels: Array<CreateLevelInput>;
  locationId: Scalars['ID'];
};


export type MutationAddLocationToOrganizationArgs = {
  address: Scalars['String'];
  name: Scalars['String'];
  timeZone: Scalars['String'];
};


export type MutationAddMeetingServiceArgs = {
  input: AddMeetingServiceInput;
};


export type MutationAddMeetingServicesCategoryArgs = {
  input: AddMeetingServicesCategoryInput;
};


export type MutationAddNeighborhoodDraftChangesToDefaultDraftArgs = {
  levelId: Scalars['ID'];
  neighborhoodDraftChanges: Array<NeighborhoodChangeInput>;
};


export type MutationAddOfficeAdminArgs = {
  locationId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationAddOrUpdateLevelSettingArgs = {
  levelId: Scalars['ID'];
  setting: SettingInput;
};


export type MutationAddOrganizationArgs = {
  name: Scalars['String'];
  slug: Scalars['String'];
};


export type MutationAddPinnedUserSpacesArgs = {
  locationId: Scalars['String'];
  spaceIds: Array<Scalars['String']>;
};


export type MutationAddSpaceToEventArgs = {
  request?: InputMaybe<AddSpaceToEventRequest>;
};


export type MutationAddSubcategoryToCustomTemplateArgs = {
  organizationId: Scalars['ID'];
  subcategory: Scalars['CustomResourceSubCategoryType'];
  templateId: Scalars['ID'];
};


export type MutationAddUserToAssignmentsQueueArgs = {
  id: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationAddUserToFavoritesArgs = {
  userId: Scalars['String'];
};


export type MutationAddUserToRoleArgs = {
  roleSlug: Scalars['String'];
  userId: Scalars['ID'];
};


export type MutationAddVisitTypeForOrgArgs = {
  locationId?: InputMaybe<Scalars['ID']>;
  visitTypeName: Scalars['String'];
};


export type MutationAdministratorRegisterGuestArgs = {
  arrivalInstructions?: InputMaybe<Scalars['String']>;
  arrivalLocationId: Scalars['ID'];
  checkInGuest?: InputMaybe<Scalars['Boolean']>;
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  guests: Array<GuestInputType>;
  hosts?: InputMaybe<Array<VisitHostInput>>;
  provisionCredentials?: InputMaybe<Scalars['Boolean']>;
  sendGuestEmailInvite?: InputMaybe<Scalars['Boolean']>;
  startTime: Scalars['ISODateTime'];
  visitType: Scalars['String'];
};


export type MutationAllocateStickersToOrgArgs = {
  input: AllocateStickersToOrgRequest;
};


export type MutationAllocateStickersToOrgByDisplayCodeArgs = {
  input: AllocateStickersToOrgByDisplayCodeRequest;
};


export type MutationApproveMeetingServiceRequestArgs = {
  input: ApproveMeetingServiceRequestInput;
};


export type MutationArchiveAnnouncementArgs = {
  announcementId: Scalars['ID'];
};


export type MutationArchiveAnnouncementForSlackArgs = {
  announcementId: Scalars['ID'];
};


export type MutationArchiveIntegrationByIdArgs = {
  id: Scalars['ID'];
};


export type MutationAssertGuestIdentityArgs = {
  guestEmail: Scalars['String'];
  guestName: Scalars['String'];
};


export type MutationAssignDelegatedDeskArgs = {
  email: Scalars['String'];
  notify?: InputMaybe<Scalars['Boolean']>;
  seatId: Scalars['Int'];
  start: DateWithTimezone;
  visibility?: InputMaybe<DeskReservationVisibility>;
};


export type MutationAssignDeskToMeArgs = {
  notify?: InputMaybe<Scalars['Boolean']>;
  seatId: Scalars['Int'];
  start: DateWithTimezone;
  visibility?: InputMaybe<DeskReservationVisibility>;
};


export type MutationAssignStickerToDeskByShortCodeArgs = {
  input: AssignStickerToDeskByShortCodeRequest;
};


export type MutationAssignStickersArgs = {
  input: AssignStickerRequest;
};


export type MutationAssociateHealthCheckpointWithVisitArgs = {
  guestInviteId: Scalars['ID'];
  healthCheckpointId: Scalars['ID'];
};


export type MutationAuthenticateVisitorWithMagicLinkArgs = {
  magicLink: Scalars['String'];
};


export type MutationAutoAllocateStickersToMultipleOrgsArgs = {
  input: Array<AutoAllocateStickersToOrgRequest>;
};


export type MutationAutoAllocateStickersToOrgArgs = {
  input: AutoAllocateStickersToOrgRequest;
};


export type MutationAutoDeskBookingBatchReportFailuresArgs = {
  reports: Array<AutoDeskBookingUserBatchFailureReportCommand>;
};


export type MutationAutoDeskBookingReportProcessFailureArgs = {
  report?: InputMaybe<AutoDeskBookingProcessFailureReportCommand>;
};


export type MutationBatchUnlinkKisiLocksFromRobinLevelsArgs = {
  input: BatchUnlinkKisiLocksFromRobinLevelsInput;
};


export type MutationBatchUnlinkKisiLocksFromRobinLocationsArgs = {
  input: BatchUnlinkKisiLocksFromRobinLocationsInput;
};


export type MutationBeginFileUploadsForTicketAnswerArgs = {
  input: BeginFileUploadsForTicketAnswerInput;
};


export type MutationBulkArchiveAnnouncementsArgs = {
  announcementIds: Array<Scalars['ID']>;
};


export type MutationBulkUpdateCustomWorkingHoursArgs = {
  customWorkingHoursUpdates: Array<CustomWorkingHoursBulkUpdateInput>;
  locationId: Scalars['ID'];
};


export type MutationCancelActivityArgs = {
  activityId: Scalars['ID'];
};


export type MutationCancelEmployeeVisitArgs = {
  cancelReservations?: InputMaybe<Scalars['Boolean']>;
  employeeVisitId: Scalars['ID'];
  source?: InputMaybe<Scalars['String']>;
};


export type MutationCancelEmployeeVisitsAtLocationForEmployeeArgs = {
  cancelReservations?: InputMaybe<Scalars['Boolean']>;
  employeeId: Scalars['ID'];
  endTime: Scalars['ISODateTime'];
  locationId: Scalars['ID'];
  source?: InputMaybe<Scalars['String']>;
  startTime: Scalars['ISODateTime'];
};


export type MutationCancelEmployeeVisitsForEmployeeArgs = {
  cancelReservations?: InputMaybe<Scalars['Boolean']>;
  date: Scalars['LocalDate'];
  employeeId: Scalars['ID'];
  source?: InputMaybe<Scalars['String']>;
};


export type MutationCancelEventArgs = {
  id: Scalars['ID'];
};


export type MutationCancelGuestInviteArgs = {
  id: Scalars['ID'];
  reason?: InputMaybe<GuestInviteCanceledReason>;
};


export type MutationCancelInsightsAssistantMessageArgs = {
  conversationId: Scalars['ID'];
  messageId: Scalars['ID'];
};


export type MutationCancelVisitArgs = {
  id: Scalars['ID'];
  reason?: InputMaybe<GuestInviteCanceledReason>;
};


export type MutationChangeAnswersOnMeetingServiceRequestArgs = {
  input: ChangeAnswersOnMeetingServiceRequestInput;
};


export type MutationChangeBrivoLockLinksArgs = {
  input: ChangeBrivoLockLinksInput;
};


export type MutationChangeGallagherDoorLinksForIntegrationArgs = {
  input: ChangeGallagherDoorLinksForIntegrationInput;
};


export type MutationChangeGeneaDoorLinksArgs = {
  input: ChangeGeneaDoorLinksInput;
};


export type MutationChangeGenetecDoorLinksForIntegrationArgs = {
  input: ChangeGenetecDoorLinksForIntegrationInput;
};


export type MutationChangeKisiLockLinkToRobinLevelArgs = {
  input: ChangeKisiLockLinkToRobinLevelInput;
};


export type MutationChangeKisiLockLinkToRobinLocationArgs = {
  input: ChangeKisiLockLinkToRobinLocationInput;
};


export type MutationChangeOpenpathLockLinksArgs = {
  input: ChangeOpenpathLockLinksInput;
};


export type MutationChangeVerkadaDoorLinksArgs = {
  input: ChangeVerkadaDoorLinksInput;
};


export type MutationCheckIntoSelfRegisteredVisitFromArrivalDisplayArgs = {
  guestInviteId: Scalars['ID'];
};


export type MutationCheckIntoVisitArgs = {
  magicLink: Scalars['String'];
};


export type MutationCheckIntoVisitFromArrivalDisplayArgs = {
  guestInviteId: Scalars['ID'];
};


export type MutationCheckIntoVisitFromDashboardArgs = {
  guestInviteId: Scalars['ID'];
};


export type MutationCheckIntoVisitRequiringHcpFromArrivalDisplayArgs = {
  guestInviteId: Scalars['ID'];
};


export type MutationCheckIntoVisitWithMagicLinkArgs = {
  magicLink: Scalars['String'];
};


export type MutationCheckOutGuestFromArrivalDisplayArgs = {
  guestInviteId: Scalars['ID'];
};


export type MutationCheckOutGuestFromDashboardArgs = {
  guestInviteId: Scalars['ID'];
};


export type MutationCompleteSurveyResponseArgs = {
  comment?: InputMaybe<Scalars['String']>;
  isAnonymous: Scalars['Boolean'];
  rating: Scalars['Int'];
  reservationId?: InputMaybe<Scalars['String']>;
  surveyResponseId?: InputMaybe<Scalars['ID']>;
};


export type MutationConfirmDeskReservationArgs = {
  reservationId: Scalars['ID'];
  type: DeskConfirmationType;
};


export type MutationConfirmDeskReservationBypassingConfirmationWindowDelegatedArgs = {
  confirmedAt?: InputMaybe<Scalars['ISODateTime']>;
  reservationId: Scalars['ID'];
  type: DeskConfirmationType;
  userId: Scalars['ID'];
};


export type MutationConfirmDeskReservationDelegatedArgs = {
  confirmedAt?: InputMaybe<Scalars['ISODateTime']>;
  reservationId: Scalars['ID'];
  type: DeskConfirmationType;
  userId: Scalars['ID'];
};


export type MutationConfirmEventArgs = {
  id: Scalars['ID'];
};


export type MutationConnectGallagherAccountForCurrentTenantArgs = {
  input: ConnectGallagherAccountForCurrentTenantInput;
};


export type MutationConnectGeneaAccountForCurrentTenantArgs = {
  input: ConnectGeneaAccountForCurrentTenantInput;
};


export type MutationConnectGenericConnectorAccountArgs = {
  input: ConnectGenericConnectorAccountInput;
};


export type MutationConnectGenetecAccountForCurrentTenantArgs = {
  input: ConnectGenetecAccountForCurrentTenantInput;
};


export type MutationConnectKisiAccountArgs = {
  input: ConnectKisiAccountInput;
};


export type MutationConnectOpenpathAccountArgs = {
  input: ConnectOpenpathAccountInput;
};


export type MutationConnectVerkadaAccountForCurrentTenantArgs = {
  input: ConnectVerkadaAccountForCurrentTenantInput;
};


export type MutationConvertGroupToExternalRipplingGroupArgs = {
  input: ConvertGroupToExternalRipplingGroupInput;
};


export type MutationCreateActivityArgs = {
  input: CreateActivityInput;
};


export type MutationCreateActivityCustomImageArgs = {
  buildingId: Scalars['ID'];
  name: Scalars['String'];
  url: Scalars['String'];
};


export type MutationCreateAmenityArgs = {
  amenityName: Scalars['String'];
  configuration?: InputMaybe<AmenitySelectionConfiguration>;
  organizationId: Scalars['ID'];
};


export type MutationCreateAndMapBuildingsFromRipplingArgs = {
  input: CreateAndMapBuildingsFromRipplingInput;
};


export type MutationCreateAnnouncementArgs = {
  announcement: AnnouncementCreateInput;
};


export type MutationCreateAnnouncementForSlackArgs = {
  announcement: AnnouncementCreateInput;
};


export type MutationCreateArrivalDisplayArgs = {
  badgePrinterIPAddress?: InputMaybe<Scalars['String']>;
  badgePrinterId?: InputMaybe<Scalars['String']>;
  guestImageCaptureEnabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  locationId: Scalars['ID'];
  name: Scalars['String'];
  selfRegistrationEnabled?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateBadgeCsvUploadLinkArgs = {
  input: CreateBadgeCsvUploadLinkInput;
};


export type MutationCreateBadgePrinterArgs = {
  arrivalDisplayIds?: InputMaybe<Array<Scalars['ID']>>;
  badgePrinterIPAddress: Scalars['String'];
  locationId: Scalars['ID'];
  name: Scalars['String'];
};


export type MutationCreateBookingWindowPolicyForLocationArgs = {
  input: CreateBookingWindowPolicyInput;
};


export type MutationCreateCustomVisitFormArgs = {
  form?: InputMaybe<CustomVisitFormInput>;
};


export type MutationCreateDefaultDraftArgs = {
  levelId: Scalars['ID'];
};


export type MutationCreateDeliveryArgs = {
  input: CreateDeliveryInput;
};


export type MutationCreateDeliveryZoneArgs = {
  input: CreateDeliveryZoneInput;
};


export type MutationCreateDeskExclusionsArgs = {
  dates: Array<InputMaybe<DateRangeWithTimeZone>>;
  seriesId: Scalars['ID'];
};


export type MutationCreateDisposableDraftArgs = {
  levelId: Scalars['ID'];
};


export type MutationCreateDraftArgs = {
  draft: DraftInput;
};


export type MutationCreateDraftVisitArgs = {
  eventUid: Scalars['String'];
};


export type MutationCreateEmailConfigurationArgs = {
  input: EmailConfigurationInput;
  locationId: Scalars['ID'];
};


export type MutationCreateGenericHealthCheckpointArgs = {
  entityId: Scalars['ID'];
  entityType: GenericHealthCheckpointEntityType;
  id?: InputMaybe<Scalars['ID']>;
  locationId: Scalars['ID'];
};


export type MutationCreateGroupAndMakeItExternalRipplingGroupArgs = {
  input: CreateGroupAndMakeItExternalRipplingGroupInput;
};


export type MutationCreateIntegrationArgs = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  externalId: Scalars['String'];
  integrationJson?: InputMaybe<Scalars['Json']>;
  name: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationCreateLayoutDraftArgs = {
  draft: LayoutDraftInput;
};


export type MutationCreateLegacyIntegrationArgs = {
  configuration: Scalars['Json'];
  resourceType: Scalars['String'];
  state: Scalars['String'];
  type: Scalars['String'];
  userId: Scalars['String'];
};


export type MutationCreateNeighborhoodArgs = {
  neighborhood: NeighborhoodCreationInput;
};


export type MutationCreateOfficeAdminRoleArgs = {
  locationId: Scalars['ID'];
};


export type MutationCreatePassArgs = {
  input?: InputMaybe<PassInput>;
};


export type MutationCreatePassForPlacesArgs = {
  input?: InputMaybe<MultiPlacePassInput>;
};


export type MutationCreateRobinOrganizationFromRipplingOAuthDataArgs = {
  input: CreateRobinOrganizationFromRipplingOAuthDataInput;
};


export type MutationCreateRoleArgs = {
  input: RoleCreationInput;
};


export type MutationCreateSigmaWorkbookArgs = {
  location: SigmaLocationType;
  name: Scalars['String'];
};


export type MutationCreateVisitArgs = {
  guests: Array<GuestInputType>;
  organizerId: Scalars['ID'];
  organizerType: VisitOrganizerType;
  visitDetails: VisitWithIdInputType;
};


export type MutationCreateVisitWithCustomVisitTypeArgs = {
  arrivalLocationId: Scalars['ID'];
  guests: Array<GuestInputType>;
  hostUserId: Scalars['ID'];
  id: Scalars['ID'];
  organizerId: Scalars['ID'];
  organizerType: VisitOrganizerType;
  startTime: Scalars['ISODateTime'];
  visitType: Scalars['String'];
};


export type MutationCreateWorkPolicyArgs = {
  workPolicy: WorkPolicyInput;
};


export type MutationCustomResourceInstancePrePublishDeleteArgs = {
  customResourceInstanceIds: Array<Scalars['ID']>;
  mapId: Scalars['ID'];
  organizationID: Scalars['ID'];
  publicationSessionId: Scalars['ID'];
  publishChangesAfterSave?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCustomResourceInstancePrePublishSaveArgs = {
  deletedCustomResourceInstanceIds?: InputMaybe<Array<Scalars['ID']>>;
  groupedResourceInstances?: InputMaybe<Array<GroupedResourceSaveUpdateInput>>;
  mapId: Scalars['ID'];
  organizationID: Scalars['ID'];
  publicationSessionId: Scalars['ID'];
  publishChangesAfterSave?: InputMaybe<Scalars['Boolean']>;
  resourceGroups?: InputMaybe<Array<ResourceGroupSaveUpdateInput>>;
  ungroupedResourceInstances?: InputMaybe<Array<UngroupedResourceSaveUpdateInput>>;
};


export type MutationCustomResourceRecurringReservationEditArgs = {
  clientType: ClientType;
  duration: Scalars['ISO8601_Duration'];
  organizationId: Scalars['ID'];
  recurringReservationRequestExclusions?: InputMaybe<Array<RecurringReservationRequest>>;
  recurringReservationRequests: Array<RecurringReservationRequest>;
  requestReservationDates?: InputMaybe<Array<LocaleDateTimePair>>;
  reservationId: Scalars['ID'];
  reservationRequestDateExclusions?: InputMaybe<Array<LocaleDateTimePair>>;
  truncationDate: Scalars['IsoDateOnlyString'];
  truncationStartTime: Scalars['IsoLocalTimeString'];
};


export type MutationCustomResourceReservationBulkConfirmInternalArgs = {
  clientType: ConfirmationClientType;
  organizationId: Scalars['ID'];
  reservationIds: Array<Scalars['ID']>;
  userId: Scalars['ID'];
  utcConfirmationTime: Scalars['ISO8601Timestamp'];
};


export type MutationCustomResourceReservationCompletelyCancelArgs = {
  organizationId: Scalars['ID'];
  reservationId: Scalars['ID'];
  resourceId: Scalars['ID'];
};


export type MutationCustomResourceReservationInstanceRescheduleArgs = {
  clientType: ClientType;
  newDate: Scalars['IsoDateOnlyString'];
  newDuration?: InputMaybe<Scalars['ISO8601_Duration']>;
  newStartTime: Scalars['IsoLocalTimeString'];
  organizationId: Scalars['ID'];
  originalDate: Scalars['IsoDateOnlyString'];
  originalStartTime: Scalars['IsoLocalTimeString'];
  reservationId: Scalars['ID'];
};


export type MutationCustomResourceReservationMoveArgs = {
  clientType: ClientType;
  organizationId: Scalars['ID'];
  reservationResourcePairs: Array<ReservationResourcePairInput>;
};


export type MutationCustomResourceReservationSelfConfirmArgs = {
  clientType: ConfirmationClientType;
  organizationId: Scalars['ID'];
  reservationId: Scalars['ID'];
  startDate: Scalars['IsoDateOnlyString'];
  startTime: Scalars['IsoLocalTimeString'];
};


export type MutationCustomResourceScheduleSingleDayDelegateReservationArgs = {
  clientType: ClientType;
  date: Scalars['IsoDateOnlyString'];
  duration: Scalars['ISO8601_Duration'];
  endReservationIds?: InputMaybe<Array<Scalars['ID']>>;
  organizationId: Scalars['ID'];
  reservee: Scalars['ID'];
  resourceInstanceId: Scalars['ID'];
  startTime: Scalars['IsoLocalTimeString'];
};


export type MutationDeactivateVisitTypeForOrgArgs = {
  locationId?: InputMaybe<Scalars['ID']>;
  visitTypeName: Scalars['String'];
};


export type MutationDecideOutcomeForVisitDocumentArgs = {
  guestId: Scalars['ID'];
  outcomeId: Scalars['ID'];
  visitId: Scalars['ID'];
  visitInviteId: Scalars['ID'];
  workflowId: Scalars['ID'];
};


export type MutationDecideOutcomeForVisitDocumentFromArrivalDisplayArgs = {
  guestId: Scalars['ID'];
  outcomeId: Scalars['ID'];
  sendCopyToGuest?: InputMaybe<Scalars['Boolean']>;
  /** Base64 data-URI encoded signature image. Required when the document requires a signature. */
  base64Signature?: InputMaybe<Scalars['String']>;
  visitId: Scalars['ID'];
  visitInviteId: Scalars['ID'];
  workflowId: Scalars['ID'];
};


export type MutationDecideOutcomeForVisitDocumentFromGuestUiArgs = {
  guestId: Scalars['ID'];
  outcomeId: Scalars['ID'];
  sendCopyToGuest?: InputMaybe<Scalars['Boolean']>;
  visitId: Scalars['ID'];
  visitInviteId: Scalars['ID'];
  workflowId: Scalars['ID'];
};


export type MutationDeclineAndEndReservationArgs = {
  reservationId: Scalars['ID'];
};


export type MutationDeleteActivityCustomImageArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCustomVisitFormArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type MutationDeleteDeliveriesArgs = {
  clientOptions?: InputMaybe<ClientOptionsInput>;
  ids: Array<Scalars['ID']>;
};


export type MutationDeleteDeliveryArgs = {
  clientOptions?: InputMaybe<ClientOptionsInput>;
  id: Scalars['ID'];
};


export type MutationDeleteDeliveryZoneArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDeskExclusionsArgs = {
  exclusionIds: Array<Scalars['ID']>;
  seriesId: Scalars['ID'];
};


export type MutationDeleteDraftArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDraftChangesForOrganizationArgs = {
  changeType: Scalars['String'];
  organizationId: Scalars['ID'];
};


export type MutationDeleteEmailConfigurationArgs = {
  locationId: Scalars['ID'];
};


export type MutationDeleteExternalRipplingGroupArgs = {
  input: DeleteExternalRipplingGroupInput;
};


export type MutationDeleteLegacyIntegrationByTypeArgs = {
  resourceType: LegacyIntegrationResourceType;
  type: LegacyIntegrationType;
};


export type MutationDeleteMeetingServicesArgs = {
  meetingServiceIds: Array<Scalars['ID']>;
};


export type MutationDeleteMeetingServicesCategoryArgs = {
  meetingServicesCategoryId: Scalars['ID'];
};


export type MutationDeleteOrCancelMeetingServiceRequestArgs = {
  meetingServiceRequestId: Scalars['ID'];
};


export type MutationDeletePassArgs = {
  passId?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteWorkAreaDesksArgs = {
  deskIds: Array<Scalars['ID']>;
};


export type MutationDisableAnonymityModeForOrgArgs = {
  input: AnonymityModeToggleInput;
};


export type MutationDisableGeofenceFeatureForBuildingArgs = {
  input: DisableGeofenceFeatureForBuildingInput;
};


export type MutationDisableOrganizationUserArgs = {
  organizationId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationDisablePassiveCheckInFeatureForBuildingArgs = {
  input: SetPassiveCheckInFeatureForBuildingInput;
};


export type MutationDisableSpacesArgs = {
  spaceIds: Array<Scalars['ID']>;
};


export type MutationDiscardDefaultDraftArgs = {
  id: Scalars['ID'];
};


export type MutationDisconnectGallagherAccountByIntegrationUuidArgs = {
  input: DisconnectGallagherAccountByIntegrationUuidInput;
};


export type MutationDisconnectGeneaAccountByIntegrationUuidArgs = {
  input: DisconnectGeneaAccountByIntegrationUuidInput;
};


export type MutationDisconnectGenetecAccountByIntegrationUuidArgs = {
  input: DisconnectGenetecAccountByIntegrationUuidInput;
};


export type MutationDisconnectVerkadaAccountByIntegrationUuidArgs = {
  input: DisconnectVerkadaAccountByIntegrationUuidInput;
};


export type MutationDismissSurveyResponseArgs = {
  reservationId?: InputMaybe<Scalars['String']>;
  surveyResponseId?: InputMaybe<Scalars['ID']>;
};


export type MutationEditCustomResourceTemplateArgs = {
  associatedAmenityIds?: InputMaybe<Array<Scalars['ID']>>;
  description?: InputMaybe<Scalars['String']>;
  organizationID: Scalars['ID'];
  policyConfiguration?: InputMaybe<CustomResourcePolicyDocumentCommand>;
  resourceCategory: Scalars['String'];
  resourceCategorySingular?: InputMaybe<Scalars['String']>;
  subCategories?: InputMaybe<Array<Scalars['CustomResourceSubCategoryType']>>;
  templateId: Scalars['ID'];
};


export type MutationEditDraftVisitRecordArgs = {
  arrivalInstructions?: InputMaybe<Scalars['String']>;
  arrivalLocationId: Scalars['ID'];
  checkInGuest?: InputMaybe<Scalars['Boolean']>;
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  eventUid: Scalars['String'];
  guests: Array<GuestInputType>;
  hostUserId: Scalars['ID'];
  provisionCredentials?: InputMaybe<Scalars['Boolean']>;
  recordId: Scalars['ID'];
  sendGuestEmailInvite?: InputMaybe<Scalars['Boolean']>;
  startTime: Scalars['ISODateTime'];
  visitType: Scalars['String'];
};


export type MutationEditMeetingServicesCategoryArgs = {
  input: EditMeetingServicesCategoryInput;
};


export type MutationEmployeeRegisteredForWaitlistVisitArgs = {
  input: EmployeeRegisteredForWaitlistVisitInput;
};


export type MutationEnableAnonymityModeForOrgArgs = {
  input: AnonymityModeToggleInput;
};


export type MutationEnableGeofenceFeatureForBuildingArgs = {
  input: EnableGeofenceFeatureForBuildingInput;
};


export type MutationEnableOrganizationUserArgs = {
  organizationId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationEnablePassiveCheckInFeatureForBuildingArgs = {
  input: SetPassiveCheckInFeatureForBuildingInput;
};


export type MutationEndInsightsAssistantConversationArgs = {
  id: Scalars['ID'];
};


export type MutationEndInsightsAssistantConversationV2Args = {
  id: Scalars['ID'];
};


export type MutationEndOrCancelDelegatedReservationArgs = {
  notifyAssignee?: InputMaybe<Scalars['Boolean']>;
  reservationId: Scalars['ID'];
};


export type MutationEndOrCancelReservationArgs = {
  reservationId: Scalars['ID'];
};


export type MutationEndReservationOrVisitsInRangeArgs = {
  cancelFutureVisits?: InputMaybe<Scalars['Boolean']>;
  creationType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  end: Scalars['Date'];
  orgId: Scalars['ID'];
  start: Scalars['Date'];
  userId: Scalars['ID'];
};


export type MutationForceResolveCsvUploadRecordsArgs = {
  input: UploadCsvForcePushRecords;
};


export type MutationGenerateStickerBatchArgs = {
  input: GenerateStickerBatchRequest;
};


export type MutationGuestHealthCheckpointFailedArgs = {
  healthCheckpointResponseId: Scalars['ID'];
};


export type MutationGuestInvitedArgs = {
  magicLink: Scalars['String'];
};


export type MutationInitiateBrivoAccountConnectionForCurrentTenantArgs = {
  input: InitiateBrivoAccountConnectionForCurrentTenantInput;
};


export type MutationInitiateRipplingConnectionAndSyncArgs = {
  input: InitiateRipplingConnectionAndSyncInput;
};


export type MutationInitiateRipplingUserSyncArgs = {
  input: InitiateRipplingUserSyncInput;
};


export type MutationInviteOfficeAdminUsersArgs = {
  emailAddresses: Array<Scalars['String']>;
};


export type MutationInviteUsersToDraftArgs = {
  draftAccessLevel: DraftCollaboratorAccessLevel;
  draftId: Scalars['ID'];
  userIds: Array<Scalars['ID']>;
};


export type MutationInviteUsersToDraftAsCollaboratorsArgs = {
  draftId: Scalars['ID'];
  userIds: Array<Scalars['ID']>;
};


export type MutationJoinActivityArgs = {
  activityId: Scalars['ID'];
};


export type MutationJoinOfficeArgs = {
  endTime: Scalars['ISODateTime'];
  locationId: Scalars['ID'];
  startTime: Scalars['ISODateTime'];
  type: DeskConfirmationType;
  userId: Scalars['ID'];
};


export type MutationLinkArrivalDisplayAndBadgePrinterArgs = {
  arrivalDisplayId: Scalars['ID'];
  badgePrinterId: Scalars['ID'];
};


export type MutationLinkKisiLockToRobinLocationArgs = {
  input: LinkKisiLockToRobinLocationInput;
};


export type MutationLogSpaceSuggestionBookedArgs = {
  input: LogSuggestedSpaceBookedInput;
};


export type MutationLogSpaceSuggestionDismissedArgs = {
  input: LogSuggestedSpaceDismissedInput;
};


export type MutationLogSpaceSuggestionViewedArgs = {
  input: LogSuggestedSpaceViewedInput;
};


export type MutationMapBuildingToRipplingWorkLocationArgs = {
  input: MapBuildingToRipplingWorkLocationInput;
};


export type MutationMapBuildingsToRipplingWorkLocationsArgs = {
  input: MapBuildingsToRipplingWorkLocationsInput;
};


export type MutationMapKisiLocksToRobinLocationsArgs = {
  input: MapKisiLocksToRobinLocations;
};


export type MutationModifyDraftCollaboratorAccessLevelArgs = {
  draftAccessLevel: DraftCollaboratorAccessLevel;
  draftId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationPersistNeighborhoodsArgs = {
  floorId: Scalars['ID'];
  neighborhoods: Array<PersistNeighborhoodInput>;
  userId: Scalars['Int'];
};


export type MutationPublishDraftArgs = {
  id: Scalars['ID'];
  sendNotifications?: InputMaybe<Scalars['Boolean']>;
  version: Scalars['Int'];
};


export type MutationPublishSharedScheduleForDeskArgs = {
  input: SharedDeskSchedulesInput;
};


export type MutationPublishVisitDraftArgs = {
  draftId: Scalars['ID'];
};


export type MutationReconnectOpenpathAccountArgs = {
  input: ReconnectOpenpathAccountInput;
};


export type MutationRefreshDeviceAuthorizationArgs = {
  refreshToken: Scalars['String'];
};


export type MutationRefreshJwtAuthTokenArgs = {
  refreshToken: Scalars['String'];
};


export type MutationRegisterArrivalDisplayArgs = {
  key: Scalars['ArrivalDisplayRegistrationKey'];
  organizationId: Scalars['ID'];
};


export type MutationRegisterGuestFromArrivalDisplayArgs = {
  arrivalLocationId: Scalars['ID'];
  guestEmail: Scalars['String'];
  guestName: Scalars['String'];
  hostUserId: Scalars['ID'];
  startTime: Scalars['ISODateTime'];
  visitId?: InputMaybe<Scalars['ID']>;
  visitInviteId?: InputMaybe<Scalars['ID']>;
  visitType: VisitType;
};


export type MutationRegisterGuestFromDashboardArgs = {
  guests: Array<GuestInputType>;
  visitDetails: VisitInputType;
};


export type MutationRegisterGuestWithHcpFromArrivalDisplayArgs = {
  arrivalLocationId: Scalars['ID'];
  guestEmail: Scalars['String'];
  guestInviteId: Scalars['ID'];
  guestName: Scalars['String'];
  healthCheckpointId: Scalars['ID'];
  hostUserId: Scalars['ID'];
  startTime: Scalars['ISODateTime'];
  visitId: Scalars['ID'];
  visitType: VisitType;
};


export type MutationRegisterGuestWithHcpFromArrivalDisplayWithCustomVisitTypeArgs = {
  arrivalLocationId: Scalars['ID'];
  guestEmail: Scalars['String'];
  guestInviteId: Scalars['ID'];
  guestName: Scalars['String'];
  healthCheckpointId: Scalars['ID'];
  hostUserId: Scalars['ID'];
  startTime: Scalars['ISODateTime'];
  visitId: Scalars['ID'];
  visitType: Scalars['String'];
};


export type MutationRegisterGuestWithoutHcpFromArrivalDisplayArgs = {
  arrivalLocationId: Scalars['ID'];
  guestEmail: Scalars['String'];
  guestName: Scalars['String'];
  hostUserId: Scalars['ID'];
  startTime: Scalars['ISODateTime'];
  visitId: Scalars['ID'];
  visitInviteId: Scalars['ID'];
  visitType: VisitType;
};


export type MutationRegisterGuestWithoutHcpFromArrivalDisplayWithCustomVisitTypeArgs = {
  arrivalLocationId: Scalars['ID'];
  guestEmail: Scalars['String'];
  guestName: Scalars['String'];
  hostUserId: Scalars['ID'];
  startTime: Scalars['ISODateTime'];
  visitId: Scalars['ID'];
  visitInviteId: Scalars['ID'];
  visitType: Scalars['String'];
};


export type MutationRejectMeetingServiceRequestArgs = {
  input: RejectMeetingServiceRequestInput;
};


export type MutationRemoveAllDevicesForLocationArgs = {
  locationId: Scalars['ID'];
};


export type MutationRemoveArrivalDisplayArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveBadgePrinterArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveBookingWindowPolicyForLocationArgs = {
  input: RemoveBookingWindowPolicyInput;
};


export type MutationRemoveBuildingGeofenceArgs = {
  input: RemoveBuildingGeofenceInput;
};


export type MutationRemoveChatMessagesFromActivityArgs = {
  chatMessageIdentifiers: Array<Scalars['ID']>;
};


export type MutationRemoveCustomWorkingHoursArgs = {
  customWorkingHoursId: Scalars['ID'];
};


export type MutationRemoveHostFromVisitArgs = {
  hostUserId: Scalars['ID'];
  visitId: Scalars['ID'];
};


export type MutationRemoveOfficeAdminArgs = {
  locationId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationRemovePermissionOnRoleArgs = {
  actions: Array<HierarchyPermissionAction>;
  organizationId: Scalars['ID'];
  permissionHierarchyTarget: PermissionHierarchyTarget;
  permissionHierarchyTargetId: Scalars['ID'];
  resourceCategoryId: Scalars['ID'];
  roleIds: Array<Scalars['ID']>;
};


export type MutationRemovePinnedUserSpacesArgs = {
  spaceIds: Array<Scalars['String']>;
};


export type MutationRemoveSpaceFromEventArgs = {
  input: RemoveSpaceFromEventInput;
};


export type MutationRemoveUserFromFavoritesArgs = {
  userId: Scalars['String'];
};


export type MutationRemoveUserFromRoleArgs = {
  roleSlug: Scalars['String'];
  userId: Scalars['ID'];
};


export type MutationRemoveUsersFromAssignmentsQueueArgs = {
  id: Scalars['ID'];
  userIds: Array<Scalars['ID']>;
};


export type MutationRemoveUsersFromDraftCollaboratorsArgs = {
  draftId: Scalars['ID'];
  userIds: Array<Scalars['ID']>;
};


export type MutationRenewArrivalDisplayRegistrationArgs = {
  key: Scalars['ArrivalDisplayRegistrationKey'];
};


export type MutationReportDeviceStatusArgs = {
  arrivalDisplayStatus?: InputMaybe<DeviceStatusInput>;
  arrivalDisplayStatusMessage?: InputMaybe<Scalars['String']>;
  badgePrinterStatus?: InputMaybe<DeviceStatusInput>;
  badgePrinterStatusMessage?: InputMaybe<Scalars['String']>;
};


export type MutationReportIssueWithDeskArgs = {
  input: ReportIssueWithDeskInput;
};


export type MutationReportIssueWithSpaceArgs = {
  input: ReportIssueWithSpaceInput;
};


export type MutationReportMyPresenceViaMobileGeofenceEventArgs = {
  input: ReportMyPresenceViaMobileGeofenceEventInput;
};


export type MutationReportUserPresenceAtIpAddressArgs = {
  input: ReportUserPresenceAtIpAddressInput;
};


export type MutationReportUserPresenceFromWebClientArgs = {
  input: ReportUserPresenceFromWebClientInput;
};


export type MutationReportUserPresenceInBuildingAtTimeArgs = {
  input: ReportUserPresenceInBuildingAtTimeInput;
};


export type MutationRequestMeetingServiceForDraftEventAtSpaceArgs = {
  input: RequestMeetingServiceForDraftEventAtSpaceInput;
};


export type MutationRequestMeetingServiceForExistingEventAtSpaceArgs = {
  input: RequestMeetingServiceForExistingEventAtSpaceInput;
};


export type MutationResendCollaboratorInviteArgs = {
  draftId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationReserveDelegatedDeskArgs = {
  email: Scalars['String'];
  end: DateWithTimezone;
  notify?: InputMaybe<Scalars['Boolean']>;
  recurrence?: InputMaybe<Array<Scalars['String']>>;
  seatId: Scalars['Int'];
  start: DateWithTimezone;
  type: Scalars['String'];
  visibility?: InputMaybe<DeskReservationVisibility>;
};


export type MutationReserveDeskForMeArgs = {
  end: DateWithTimezone;
  notify?: InputMaybe<Scalars['Boolean']>;
  recurrence?: InputMaybe<Array<Scalars['String']>>;
  seatId: Scalars['Int'];
  start: DateWithTimezone;
  type: Scalars['String'];
  visibility?: InputMaybe<DeskReservationVisibility>;
};


export type MutationReserveSpaceArgs = {
  request: ReserveSpaceRequest;
};


export type MutationResourceRecurringAssignmentScheduleArgs = {
  clientType: ClientType;
  duration: Scalars['ISO8601_Duration'];
  endReservationIds?: InputMaybe<Array<Scalars['ID']>>;
  organizationId: Scalars['ID'];
  recurringReservationRequestExclusions?: InputMaybe<Array<RecurringReservationRequest>>;
  recurringReservationRequests: Array<RecurringReservationRequest>;
  requestReservationDates?: InputMaybe<Array<LocaleDateTimePair>>;
  reservationRequestDateExclusions?: InputMaybe<Array<LocaleDateTimePair>>;
  reservee: Scalars['ID'];
  resourceInstanceId: Scalars['ID'];
};


export type MutationResourceRecurringReservationScheduleArgs = {
  clientType: ClientType;
  duration: Scalars['ISO8601_Duration'];
  endReservationIds?: InputMaybe<Array<Scalars['ID']>>;
  organizationId: Scalars['ID'];
  recurringReservationRequestExclusions?: InputMaybe<Array<RecurringReservationRequest>>;
  recurringReservationRequests: Array<RecurringReservationRequest>;
  requestReservationDates?: InputMaybe<Array<LocaleDateTimePair>>;
  reservationRequestDateExclusions?: InputMaybe<Array<LocaleDateTimePair>>;
  reservee?: InputMaybe<Scalars['ID']>;
  resourceInstanceId: Scalars['ID'];
};


export type MutationResourceSetCategoryPolicyOnLocationArgs = {
  applyToExistingResources?: InputMaybe<Scalars['Boolean']>;
  locationId: Scalars['ID'];
  organizationId: Scalars['ID'];
  policyConfiguration: CustomResourcePolicyDocumentCommand;
  resourceCategoryId: Scalars['ID'];
};


export type MutationRollbackNeighborhoodsArgs = {
  organizationIds: Array<Scalars['ID']>;
  secret: Scalars['String'];
};


export type MutationRolloutNeighborhoodsArgs = {
  organizationIds: Array<Scalars['ID']>;
  secret: Scalars['String'];
};


export type MutationRolloutNeighborhoodsForAllOrgsArgs = {
  secret: Scalars['String'];
};


export type MutationSaveMappedGoogleLocationsArgs = {
  input?: InputMaybe<Array<InputMaybe<GoogleToRobinInput>>>;
};


export type MutationSaveSurveyConfigurationArgs = {
  allowAnonymous: Scalars['Boolean'];
  buildingIds: Array<Scalars['String']>;
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
};


export type MutationScaffoldDemoFloorPlanArgs = {
  locationId: Scalars['ID'];
};


export type MutationScheduleEmployeeVisitAtLocationArgs = {
  employeeId: Scalars['ID'];
  endTime: Scalars['ISODateTime'];
  locationId: Scalars['ID'];
  source?: InputMaybe<Scalars['String']>;
  startTime: Scalars['ISODateTime'];
};


export type MutationScheduleSingleDayReservationArgs = {
  clientType: ClientType;
  date: Scalars['IsoDateOnlyString'];
  duration: Scalars['ISO8601_Duration'];
  endReservationIds?: InputMaybe<Array<Scalars['ID']>>;
  organizationId: Scalars['ID'];
  resourceInstanceId: Scalars['ID'];
  startTime: Scalars['IsoLocalTimeString'];
};


export type MutationSendChatOnActivityArgs = {
  activityID: Scalars['ID'];
  message: Scalars['String'];
};


export type MutationSendChatOnActivityWithIdArgs = {
  activityID: Scalars['ID'];
  message: Scalars['String'];
  messageID: Scalars['ID'];
};


export type MutationSendDeliveryNotificationToRecipientArgs = {
  id: Scalars['ID'];
};


export type MutationSendDeliveryNotificationsToRecipientsArgs = {
  deliveryIds: Array<Scalars['ID']>;
};


export type MutationSetAutoDeskBookingArgs = {
  input: SetAutoDeskBookingInput;
};


export type MutationSetAutoDeskBookingForOrgArgs = {
  input: AutoDeskBookingOrgInput;
};


export type MutationSetBuildingCidrsArgs = {
  input: SetBuildingCidrsInput;
};


export type MutationSetBuildingGeofenceAsPointWithRadiusArgs = {
  input: SetBuildingGeofenceAsPointWithRadiusInput;
};


export type MutationSetChannelAndResourceIdsForUserCalendarArgs = {
  channelId?: InputMaybe<Scalars['String']>;
  expiration?: InputMaybe<Scalars['String']>;
  resourceId?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
};


export type MutationSetDefaultLocationForUserArgs = {
  levelId?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['Int']>;
  organizationSlug?: InputMaybe<Scalars['String']>;
};


export type MutationSetDistributionSendDataArgs = {
  distributionId: Scalars['ID'];
  recipientIds: Array<Scalars['ID']>;
};


export type MutationSetEmployeeVisitsEnabledForOrgArgs = {
  organizationId: Scalars['ID'];
  value?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSetGallagherEmailFieldIdentifierForIntegrationArgs = {
  input: SetGallagherEmailFieldIdentifierForIntegrationInput;
};


export type MutationSetGoogleWorkingLocationSyncSettingForOrgArgs = {
  organizationId: Scalars['ID'];
  value: Scalars['Boolean'];
};


export type MutationSetGoogleWorkingLocationSyncSettingForUserArgs = {
  organizationId: Scalars['String'];
  sourceOfTruth?: InputMaybe<GoogleWorkingLocationSourceOfTruth>;
  userId: Scalars['ID'];
};


export type MutationSetMyHomepageArgs = {
  input: SetMyHomepageInput;
};


export type MutationSetMyLanguageTagArgs = {
  input: SetMyLanguageTagInput;
};


export type MutationSetMyWorkingHoursArgs = {
  input: SetMyWorkingHoursInput;
};


export type MutationSetNotificationPreferenceForCurrentUserArgs = {
  isEnabled: Scalars['Boolean'];
  preferenceKey?: InputMaybe<NotificationPreferenceKey>;
};


export type MutationSetOpenpathCredentialProvisioningEnabledForIntegrationArgs = {
  input: SetOpenpathCredentialProvisioningEnabledForIntegrationInput;
};


export type MutationSetOpenpathPresenceReportingEnabledForIntegrationArgs = {
  input: SetOpenpathPresenceReportingEnabledForIntegrationInput;
};


export type MutationSetPermissionsOnHierarchyArgs = {
  organizationId: Scalars['ID'];
  permissionCommands: Array<HierarchyPermissionCommand>;
};


export type MutationSetPermissionsOnRoleArgs = {
  organizationId: Scalars['ID'];
  permissionCommands: Array<RolePermissionCommand>;
};


export type MutationSetRecurringAnnouncementDataArgs = {
  announcementId: Scalars['ID'];
  startAt: Scalars['String'];
};


export type MutationSetShowWeekendsForMeArgs = {
  input: SetShowWeekendsForMeInput;
};


export type MutationSetSuggestedSpacesEnabledForOrgArgs = {
  organizationId: Scalars['ID'];
  value: Scalars['Boolean'];
};


export type MutationSetTeamMembershipByNameArgs = {
  teamMemberUserIds: Array<Scalars['String']>;
  teamName: Scalars['String'];
};


export type MutationSetUserNotificationSettingArgs = {
  input: SetUserNotificationSettingInput;
};


export type MutationSetVisitHostsArgs = {
  hosts: Array<VisitHostInput>;
  visitId: Scalars['ID'];
};


export type MutationToggleDraftLockArgs = {
  draftId: Scalars['ID'];
};


export type MutationTriggerManualSyncOfSpaceCalendarArgs = {
  calendarId: Scalars['ID'];
};


export type MutationUnassignStickerArgs = {
  input: UnassignStickerRequest;
};


export type MutationUnjoinActivityArgs = {
  activityId: Scalars['ID'];
};


export type MutationUnlinkArrivalDisplayAndBadgePrinterArgs = {
  arrivalDisplayId: Scalars['ID'];
  badgePrinterId: Scalars['ID'];
};


export type MutationUnlinkKisiLockFromRobinLevelArgs = {
  input: UnlinkKisiLockFromRobinLevelInput;
};


export type MutationUnlinkKisiLockFromRobinLocationArgs = {
  input: UnlinkKisiLockFromRobinLocationInput;
};


export type MutationUnlinkLocationFromCustomFormsArgs = {
  locationId: Scalars['ID'];
};


export type MutationUpdateActivityArgs = {
  activityId: Scalars['ID'];
  input: UpdateActivityInput;
};


export type MutationUpdateAnnouncementArgs = {
  announcementId: Scalars['ID'];
  content: AnnouncementUpdateInput;
};


export type MutationUpdateArrivalDisplayArgs = {
  badgePrinterId?: InputMaybe<Scalars['String']>;
  guestImageCaptureEnabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  locationId: Scalars['ID'];
  name: Scalars['String'];
  selfRegistrationEnabled?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateBadgePrinterArgs = {
  arrivalDisplayIds?: InputMaybe<Array<Scalars['ID']>>;
  badgePrinterIPAddress?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  locationId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateBookingWindowPolicyForLocationArgs = {
  input: UpdateBookingWindowPolicyInput;
};


export type MutationUpdateCustomResourceTemplateAssociatedAmenitiesArgs = {
  associatedAmenityIds?: InputMaybe<Array<Scalars['ID']>>;
  organizationID: Scalars['ID'];
  templateId: Scalars['ID'];
};


export type MutationUpdateCustomResourceTemplateSubcategoriesArgs = {
  organizationId: Scalars['ID'];
  subcategoryUpdates: Array<SubcategoryUpdatePairInput>;
  templateId: Scalars['ID'];
};


export type MutationUpdateCustomVisitFormArgs = {
  id?: InputMaybe<Scalars['ID']>;
  update?: InputMaybe<CustomVisitFormInput>;
};


export type MutationUpdateCustomWorkingHoursArgs = {
  customWorkingHoursId: Scalars['ID'];
  customWorkingHoursUpdate: CustomWorkingHoursUpdateInput;
};


export type MutationUpdateDefaultPassArgs = {
  input: UpdateDefaultPassInput;
};


export type MutationUpdateDeliveryArgs = {
  clientOptions?: InputMaybe<ClientOptionsInput>;
  id: Scalars['ID'];
  input: UpdateDeliveryInput;
};


export type MutationUpdateDeliveryStatusByMagicLinkArgs = {
  magicLink: Scalars['String'];
  status: DeliveryStatus;
};


export type MutationUpdateDeliveryZoneArgs = {
  id: Scalars['ID'];
  input: UpdateDeliveryZoneInput;
};


export type MutationUpdateDistributionsByAnnouncementIdArgs = {
  announcementId: Scalars['ID'];
  distributions: Array<DistributionInput>;
};


export type MutationUpdateDraftArgs = {
  changes: Array<DeskChangeInput>;
  id: Scalars['ID'];
  resolvingConflict?: InputMaybe<Scalars['Boolean']>;
  version: Scalars['Int'];
};


export type MutationUpdateDraftDataArgs = {
  id: Scalars['ID'];
};


export type MutationUpdateDraftHeartbeatArgs = {
  eventUid: Scalars['String'];
};


export type MutationUpdateDraftMetadataArgs = {
  id: Scalars['ID'];
  name: Scalars['String'];
};


export type MutationUpdateDraftNeighborhoodArgs = {
  changes: Array<NeighborhoodChangeInput>;
  draftId: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationUpdateEmailConfigurationArgs = {
  input: EmailConfigurationInput;
  locationId: Scalars['ID'];
};


export type MutationUpdateHostSettingsArgs = {
  hostUserId: Scalars['ID'];
  isVisibleToGuests?: InputMaybe<Scalars['Boolean']>;
  sendNotifications?: InputMaybe<Scalars['Boolean']>;
  visitId: Scalars['ID'];
};


export type MutationUpdateInsightsAssistantFeedbackForMessageArgs = {
  conversationId: Scalars['ID'];
  input: InsightsAssistantFeedbackInputV1;
  messageId: Scalars['ID'];
};


export type MutationUpdateInsightsAssistantFeedbackForMessageV2Args = {
  conversationId: Scalars['ID'];
  input: InsightsAssistantFeedbackV2Input;
  messageId: Scalars['ID'];
};


export type MutationUpdateLayoutDraftArgs = {
  changes: DraftLayoutInputEntity;
  id: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationUpdateMeetingServiceArgs = {
  input: UpdateMeetingServiceInput;
};


export type MutationUpdateMeetingServiceRequestStatusArgs = {
  input: UpdateMeetingServiceRequestStatusInput;
};


export type MutationUpdateMyReservationDeskAndTimeFrameArgs = {
  input: UpdateMyReservationDeskAndTimeFrameInput;
};


export type MutationUpdatePassArgs = {
  input?: InputMaybe<PassInput>;
};


export type MutationUpdatePassForPlacesArgs = {
  input?: InputMaybe<MultiPlacePassInput>;
};


export type MutationUpdateRecurringReservationDatesArgs = {
  endInstancesInProgress?: InputMaybe<Scalars['Boolean']>;
  seriesId: Scalars['ID'];
  updatedDates: Array<Scalars['Date']>;
};


export type MutationUpdateRecurringReservationRdateArgs = {
  rdateRule: Scalars['String'];
  sendNotification?: InputMaybe<Scalars['Boolean']>;
  seriesId: Scalars['ID'];
};


export type MutationUpdateReservationVisibilityArgs = {
  reservationId: Scalars['ID'];
  visibility?: InputMaybe<DeskReservationVisibility>;
};


export type MutationUpdateShowNeighborhoodColorArgs = {
  draftId: Scalars['ID'];
  showNeighborhoodColor: Scalars['Boolean'];
  version: Scalars['Int'];
};


export type MutationUpdateStandardWorkingHoursForLocationArgs = {
  locationId: Scalars['ID'];
  workingHours: Array<WorkingHoursInput>;
};


export type MutationUpdateSurveyConfigurationArgs = {
  allowAnonymous?: InputMaybe<Scalars['Boolean']>;
  buildingIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  surveyId: Scalars['ID'];
};


export type MutationUpdateVisitArgs = {
  arrivalInstructions?: InputMaybe<Scalars['String']>;
  arrivalLocationId?: InputMaybe<Scalars['ID']>;
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  hosts?: InputMaybe<Array<VisitHostInput>>;
  id: Scalars['ID'];
  provisionCredentials?: InputMaybe<Scalars['Boolean']>;
  sendEmailNotifications?: InputMaybe<Scalars['Boolean']>;
  startTime?: InputMaybe<Scalars['ISODateTime']>;
  visitType?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateWorkAreasArgs = {
  input: UpdateWorkAreasInput;
  levelId: Scalars['ID'];
};


export type MutationUpdateWorkPolicyArgs = {
  workPolicy: WorkPolicyInput;
  workPolicyId: Scalars['String'];
};


export type MutationViewAnnouncementArgs = {
  announcementId: Scalars['ID'];
  locationId: Scalars['ID'];
};


export type MutationViewAnnouncementForMultipleLocationsArgs = {
  announcementId: Scalars['ID'];
  locationIds: Array<Scalars['ID']>;
};


export type MutationVisitAddDocumentTaskArgs = {
  documentBody: Scalars['DocumentBody'];
  documentName: Scalars['String'];
  locationIds?: InputMaybe<Array<Scalars['ID']>>;
  notificationEmails?: InputMaybe<Array<Scalars['WorkflowEmail']>>;
  visitTypes?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationVisitArchiveDocumentArgs = {
  documentId: Scalars['ID'];
};


export type MutationVisitAsyncRequestStatusReportArgs = {
  errorText?: InputMaybe<Array<Scalars['String']>>;
  status: VisitAsyncRequestReport;
  visitId: Scalars['ID'];
};


export type MutationVisitChangeDocumentTaskAssociationsArgs = {
  documentId: Scalars['ID'];
  locationIds: Array<Scalars['ID']>;
  notificationEmails: Array<Scalars['WorkflowEmail']>;
  visitTypes: Array<Scalars['String']>;
};


export type MutationVisitChangeDocumentTaskAssociationsWithCustomVisitTypeArgs = {
  documentId: Scalars['ID'];
  locationIds: Array<Scalars['ID']>;
  notificationEmails: Array<Scalars['WorkflowEmail']>;
  visitTypes: Array<Scalars['String']>;
};

export type MyAutoDeskBookingResponse = {
  __typename?: 'MyAutoDeskBookingResponse';
  autoDeskBooking: Scalars['Boolean'];
};

export type MyHomepageResponse = {
  __typename?: 'MyHomepageResponse';
  homepage: HomepageType;
};

export type MyLanguageTagResponse = {
  __typename?: 'MyLanguageTagResponse';
  languageTag?: Maybe<Scalars['String']>;
};

export type MyShowWeekendsResponse = {
  __typename?: 'MyShowWeekendsResponse';
  showWeekends: Scalars['Boolean'];
};

export type Neighborhood = {
  __typename?: 'Neighborhood';
  /** @deprecated Use `colorDefinition` instead */
  color: Scalars['String'];
  colorDefinition: NeighborhoodColorDefinition;
  deskSchedulingAggregates: SchedulingAggregateOfDesks;
  hydratedResources?: Maybe<Array<Maybe<HydratedNeighborhoodResource>>>;
  id: Scalars['ID'];
  name: Scalars['String'];
  resources: Array<NeighborhoodResource>;
};

export type NeighborhoodChangeInput = {
  id: Scalars['ID'];
  state?: InputMaybe<NeighborhoodStateInput>;
};

export type NeighborhoodColorChangedAuditMetadata = {
  __typename?: 'NeighborhoodColorChangedAuditMetadata';
  neighborhoodName: Scalars['String'];
  newNeighborhoodColor: PublishedNeighborhoodColor;
  oldNeighborhoodColor?: Maybe<PublishedNeighborhoodColor>;
};

export type NeighborhoodColorDefinition = {
  __typename?: 'NeighborhoodColorDefinition';
  base: Scalars['String'];
  dark: PartialNeighborhoodColorDefinition;
  id: Scalars['ID'];
  label: NeighborhoodLabelColors;
  type: NeighborhoodColorType;
};

export type NeighborhoodColorDefinitionInput = {
  id: Scalars['ID'];
};

export const NeighborhoodColorType = {
  NH_A: 'NH_A',
  NH_B: 'NH_B',
  NH_C: 'NH_C',
  NH_D: 'NH_D',
  NH_E: 'NH_E',
  NH_F: 'NH_F',
  NH_G: 'NH_G',
  NH_H: 'NH_H',
  NH_I: 'NH_I',
  NH_J: 'NH_J',
  NH_K: 'NH_K',
  NH_L: 'NH_L',
  NH_M: 'NH_M',
  NH_N: 'NH_N'
} as const;

export type NeighborhoodColorType = typeof NeighborhoodColorType[keyof typeof NeighborhoodColorType];
export type NeighborhoodCreatedAuditMetadata = {
  __typename?: 'NeighborhoodCreatedAuditMetadata';
  colorReference: PublishedNeighborhoodColor;
  neighborhoodName: Scalars['String'];
};

export type NeighborhoodCreationInput = {
  color: Scalars['String'];
  id: Scalars['ID'];
  levelId: Scalars['Int'];
  name: Scalars['String'];
  resources?: InputMaybe<Array<NeighborhoodResourceInput>>;
  rolloutId?: InputMaybe<Scalars['ID']>;
};

export type NeighborhoodDesksChangedAuditMetadata = {
  __typename?: 'NeighborhoodDesksChangedAuditMetadata';
  desks?: Maybe<Array<Maybe<MetadataDeskObject>>>;
  neighborhoodName: Scalars['String'];
};

export type NeighborhoodEntity = {
  __typename?: 'NeighborhoodEntity';
  data?: Maybe<NeighborhoodEntityData>;
  id: Scalars['ID'];
  previousState?: Maybe<NeighborhoodEntityState>;
  state?: Maybe<NeighborhoodEntityState>;
  type: EntityType;
};

export type NeighborhoodEntityData = {
  __typename?: 'NeighborhoodEntityData';
  id: Scalars['ID'];
};

export type NeighborhoodEntityState = {
  __typename?: 'NeighborhoodEntityState';
  color: Scalars['String'];
  colorDefinition: NeighborhoodColorDefinition;
  name: Scalars['String'];
  resources: Array<DraftNeighborhoodResource>;
};

export type NeighborhoodLabelColors = {
  __typename?: 'NeighborhoodLabelColors';
  background: Scalars['String'];
  text: Scalars['String'];
};

export type NeighborhoodRemovedAuditMetadata = {
  __typename?: 'NeighborhoodRemovedAuditMetadata';
  neighborhoodName: Scalars['String'];
};

export type NeighborhoodRenamedAuditMetadata = {
  __typename?: 'NeighborhoodRenamedAuditMetadata';
  neighborhoodName: Scalars['String'];
  newNeighborhoodName?: Maybe<Scalars['String']>;
  oldNeighborhoodName?: Maybe<Scalars['String']>;
};

export type NeighborhoodResource = {
  __typename?: 'NeighborhoodResource';
  resourceId: Scalars['ID'];
  type: NeighborhoodResourceType;
};

export type NeighborhoodResourceInput = {
  resourceId: Scalars['ID'];
  type: NeighborhoodResourceType;
};

export const NeighborhoodResourceType = {
  DESK: 'DESK'
} as const;

export type NeighborhoodResourceType = typeof NeighborhoodResourceType[keyof typeof NeighborhoodResourceType];
export type NeighborhoodReviewModel = {
  __typename?: 'NeighborhoodReviewModel';
  id: Scalars['ID'];
  new?: Maybe<NeighborhoodReviewModelState>;
  previous?: Maybe<NeighborhoodReviewModelState>;
};

export type NeighborhoodReviewModelState = {
  __typename?: 'NeighborhoodReviewModelState';
  state?: Maybe<NeighborhoodReviewState>;
  statistics?: Maybe<Statistics>;
  totalDesks?: Maybe<Scalars['Int']>;
};

export type NeighborhoodReviewState = {
  __typename?: 'NeighborhoodReviewState';
  color?: Maybe<Scalars['String']>;
  colorDefinition: ColorDefinition;
  name?: Maybe<Scalars['String']>;
  resources?: Maybe<Array<DraftNeighborhoodResource>>;
};

export type NeighborhoodStateColors = {
  __typename?: 'NeighborhoodStateColors';
  available: Scalars['String'];
  busy: Scalars['String'];
  forbidden: Scalars['String'];
};

export type NeighborhoodStateInput = {
  color: Scalars['String'];
  colorDefinition: NeighborhoodColorDefinitionInput;
  name: Scalars['String'];
  resources: Array<NeighborhoodResourceInput>;
};

export type NeighborhoodsInDraftForFloorDraft = {
  __typename?: 'NeighborhoodsInDraftForFloorDraft';
  createdAt: Scalars['String'];
  createdBy: Scalars['Int'];
  id: Scalars['ID'];
  levelId: Scalars['Int'];
  locationId: Scalars['Int'];
  name: Scalars['String'];
  neighborhoods: Array<NeighborhoodEntityState>;
  organizationId: Scalars['Int'];
  status: DraftStatus;
  updatedAt: Scalars['String'];
  updatedBy: Scalars['Int'];
  version: Scalars['Int'];
};

export type NeighborhoodsInDraftForFloorFloorResult = {
  __typename?: 'NeighborhoodsInDraftForFloorFloorResult';
  drafts: Array<NeighborhoodsInDraftForFloorDraft>;
  floorId: Scalars['Int'];
};

export type NeighborhoodsInDraftForFloorResult = {
  __typename?: 'NeighborhoodsInDraftForFloorResult';
  floors: Array<NeighborhoodsInDraftForFloorFloorResult>;
};

export type NextAvailableMeta = {
  __typename?: 'NextAvailableMeta';
  end?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['String']>;
};

export const NotificationPreferenceKey = {
  WHOS_IN_DIGEST_EMAIL: 'WHOS_IN_DIGEST_EMAIL'
} as const;

export type NotificationPreferenceKey = typeof NotificationPreferenceKey[keyof typeof NotificationPreferenceKey];
export type NotificationPreferences = {
  __typename?: 'NotificationPreferences';
  isSubscribedToWhosInDigestEmail: Scalars['Boolean'];
};

export const NotificationSettingType = {
  EMAIL: 'EMAIL',
  PUSH: 'PUSH',
  SLACK: 'SLACK',
  TEAMS: 'TEAMS'
} as const;

export type NotificationSettingType = typeof NotificationSettingType[keyof typeof NotificationSettingType];
export type OfficeAccess = {
  __typename?: 'OfficeAccess';
  /** @deprecated Deprecated. Please use `resolvedPlaces`. */
  campus?: Maybe<Campus>;
  groups: Array<Group>;
  healthCheckpointRequired: Scalars['Boolean'];
  id: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  /** @deprecated Deprecated. Please use `resolvedPlaces`. */
  location?: Maybe<Location>;
  name?: Maybe<Scalars['String']>;
  /** @deprecated Deprecated. Please use `resolvedPlaces`. */
  organization?: Maybe<Organization>;
  permissions: OfficeAccessPermissions;
  /** @deprecated Deprecated in favor of places */
  place?: Maybe<AccessPlace>;
  places?: Maybe<Array<Maybe<AccessPlace>>>;
  resolvedPlaces?: Maybe<Array<Maybe<AccessPassResolvedPlaces>>>;
  schedule: Array<Scalars['String']>;
  /** @deprecated Deprecated in favor of id */
  slug?: Maybe<Scalars['String']>;
  theme: Theme;
  users: Array<User>;
};


export type OfficeAccessGroupsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type OfficeAccessPermissions = {
  __typename?: 'OfficeAccessPermissions';
  canManage: Scalars['Boolean'];
  canView: Scalars['Boolean'];
};

export const OffsetStrategy = {
  FIXED: 'FIXED'
} as const;

export type OffsetStrategy = typeof OffsetStrategy[keyof typeof OffsetStrategy];
export const OnsiteConfirmationMethod = {
  /** Badge Reader */
  BADGE_READER: 'BADGE_READER',
  /** Geofence */
  GEOFENCE: 'GEOFENCE',
  /** IP Address */
  IP_ADDRESS: 'IP_ADDRESS',
  /** Other */
  OTHER: 'OTHER',
  /** QR Code */
  QR_CODE: 'QR_CODE',
  /** Seat Confirmation */
  SEAT_CONFIRMATION: 'SEAT_CONFIRMATION'
} as const;

export type OnsiteConfirmationMethod = typeof OnsiteConfirmationMethod[keyof typeof OnsiteConfirmationMethod];
export const OnsiteType = {
  ON_SITE_CONFIRMATION: 'ON_SITE_CONFIRMATION',
  REMOTE_CONFIRMATION: 'REMOTE_CONFIRMATION',
  SCHEDULED: 'SCHEDULED'
} as const;

export type OnsiteType = typeof OnsiteType[keyof typeof OnsiteType];
export type OnsitesLimit = {
  ceiling?: InputMaybe<Scalars['Int']>;
  floor?: InputMaybe<Scalars['Int']>;
  strategy: LimitStrategy;
  value?: InputMaybe<Scalars['Int']>;
};

export type OnsitesOffset = {
  strategy: OffsetStrategy;
  value: Scalars['Int'];
};

export const OperatingSystem = {
  ANDROID: 'ANDROID',
  IOS: 'IOS'
} as const;

export type OperatingSystem = typeof OperatingSystem[keyof typeof OperatingSystem];
/** Specifies the direction of ordering for query results. */
export const OrderDirection = {
  /** Ascending order (A-Z, 0-9, false-true) */
  ASC: 'ASC',
  /** Descending order (Z-A, 9-0, true-false) */
  DESC: 'DESC'
} as const;

export type OrderDirection = typeof OrderDirection[keyof typeof OrderDirection];
export const Ordinality = {
  ASC: 'ASC',
  DESC: 'DESC'
} as const;

export type Ordinality = typeof Ordinality[keyof typeof Ordinality];
export type Organization = EventAuditLogActor & {
  __typename?: 'Organization';
  /** Total desks on the floor - excluding inactive. */
  activeDeskCount?: Maybe<Scalars['Int']>;
  avatar?: Maybe<Scalars['String']>;
  campuses: Array<Campus>;
  createdAt?: Maybe<Scalars['Date']>;
  /**
   * Total number of booked desks within the organization
   * @deprecated Deprecated in favor of deskSchedulingAggregates
   */
  deskBookedTotal: Scalars['Int'];
  /** Total desks within the organization that fit within various scheduling type and status buckets */
  deskSchedulingAggregates: SchedulingAggregateOfDesks;
  /**
   * Total number of unavailable desks within the organization
   * @deprecated Deprecated in favor of deskSchedulingAggregates
   */
  deskUnavailableTotal: Scalars['Int'];
  features?: Maybe<OrganizationFeatures>;
  /** Indicates if organization has active locations (meaning any locations added to an org). */
  hasActiveLocations: Scalars['Boolean'];
  /** Indicates if organization has at least one active map (floorplan). */
  hasActiveMaps: Scalars['Boolean'];
  /** Indicates if organization has uploaded/submitted at least a single map (floorplan). */
  hasUploadedMaps: Scalars['Boolean'];
  id: Scalars['ID'];
  locations: Array<Location>;
  logo?: Maybe<Scalars['String']>;
  mapOnboardingStatus: OrganizationMapOnboardingStatus;
  monochromeLogo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  /** @deprecated Use `activeDeskCount` instead */
  totalDesks: Scalars['Int'];
  updatedAt: Scalars['Date'];
};


export type OrganizationLocationsArgs = {
  sortBy?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['String']>;
};

export type OrganizationExternalAccount = {
  __typename?: 'OrganizationExternalAccount';
  accessToken?: Maybe<Scalars['String']>;
  accountId: Scalars['ID'];
  domain?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  state?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type OrganizationFeatureLimits = {
  __typename?: 'OrganizationFeatureLimits';
  activatedUsers: MeteredFeature;
  activeUsers: MeteredFeature;
  bookableSeats: MeteredFeature;
  bookableSpaces: MeteredFeature;
  campuses: MeteredFeature;
  exportableDataDays: MeteredFeature;
  invitedUsers: MeteredFeature;
  levels: MeteredFeature;
  locations: MeteredFeature;
  ripplingUsers: MeteredFeature;
  viewableDataDays: MeteredFeature;
  visitorManagementLocations: MeteredFeature;
  workplaceServicesLocations: MeteredFeature;
};

export type OrganizationFeatures = {
  __typename?: 'OrganizationFeatures';
  adminOnlyBooking: Scalars['Boolean'];
  amenities: Scalars['Boolean'];
  announcements: Scalars['Boolean'];
  billingUIV1: Scalars['Boolean'];
  /** @deprecated Use `limits` instead */
  bookableSeatLimit?: Maybe<Scalars['Int']>;
  /** @deprecated Use `limits` instead */
  bookableSpaceLimit?: Maybe<Scalars['Int']>;
  campuses: Scalars['Boolean'];
  customLogo: Scalars['Boolean'];
  customRoles: Scalars['Boolean'];
  customThemes: Scalars['Boolean'];
  documentAgreements: Scalars['Boolean'];
  /** @deprecated Use `limits` instead */
  exportableDataLimitDays?: Maybe<Scalars['Int']>;
  hotSeatReservations: Scalars['Boolean'];
  hoteledSeatReservations: Scalars['Boolean'];
  insights: Scalars['Boolean'];
  insightsExportsApi: Scalars['Boolean'];
  issueReporting: Scalars['Boolean'];
  levels: Scalars['Boolean'];
  limits: OrganizationFeatureLimits;
  maps: Scalars['Boolean'];
  meetingApprovals: Scalars['Boolean'];
  meetingServices: Scalars['Boolean'];
  meridianMapping: Scalars['Boolean'];
  noPersonalCalendars: Scalars['Boolean'];
  overProvisioning: Scalars['Boolean'];
  peopleDirectory: Scalars['Boolean'];
  /** @deprecated Use `prioritySupport` instead. */
  premierSupport: Scalars['Boolean'];
  prioritySupport: Scalars['Boolean'];
  reverseHoteling: Scalars['Boolean'];
  ripplingIntegration: Scalars['Boolean'];
  samlAuthentication: Scalars['Boolean'];
  scim: Scalars['Boolean'];
  statusBoards: Scalars['Boolean'];
  /** @deprecated Use `limits` instead */
  userLimit?: Maybe<Scalars['Int']>;
  /** @deprecated Use `limits` instead */
  viewableDataLimitDays?: Maybe<Scalars['Int']>;
  visitorManagement: Scalars['Boolean'];
  workweek: Scalars['Boolean'];
};

export type OrganizationIdHashResponse = {
  __typename?: 'OrganizationIdHashResponse';
  hash?: Maybe<Scalars['String']>;
};

export type OrganizationLocation = {
  __typename?: 'OrganizationLocation';
  locationId?: Maybe<Scalars['String']>;
  orgId?: Maybe<Scalars['String']>;
};

/** Indicates the status for map upload onboarding. It also provides related entities which help drive the UIs. */
export type OrganizationMapOnboardingStatus = {
  __typename?: 'OrganizationMapOnboardingStatus';
  level?: Maybe<Level>;
  /** This location will be the one that has a level, if organization has a level at all. */
  location?: Maybe<Location>;
  shouldShowSetup: Scalars['Boolean'];
};

export type OrganizationNotificationsSetting = {
  __typename?: 'OrganizationNotificationsSetting';
  name: Scalars['String'];
  ownerId: Scalars['ID'];
  values: Array<Maybe<NotificationSettingType>>;
};

export type OrganizationRollbackResult = {
  __typename?: 'OrganizationRollbackResult';
  error?: Maybe<Scalars['String']>;
  organizationId: Scalars['ID'];
  status: RollbackStatus;
};

export type OrganizationRolloutResult = {
  __typename?: 'OrganizationRolloutResult';
  error?: Maybe<Scalars['String']>;
  organizationId: Scalars['ID'];
  status: RolloutStatus;
};

/** Maps organization IDs to their work areas */
export type OrganizationWorkAreasMap = {
  __typename?: 'OrganizationWorkAreasMap';
  organizationId: Scalars['ID'];
  workAreas: Array<WorkArea>;
};

export const OwnerType = {
  SEAT: 'SEAT',
  SPACE: 'SPACE',
  UNASSIGNED: 'UNASSIGNED'
} as const;

export type OwnerType = typeof OwnerType[keyof typeof OwnerType];
export type PagedApiUserResult = {
  __typename?: 'PagedApiUserResult';
  hasNextPage: Scalars['Boolean'];
  nextPageOffset?: Maybe<Scalars['Int']>;
  users: Array<User>;
  usersTotal: Scalars['Int'];
};

export type PagedPaginationResponse = {
  __typename?: 'PagedPaginationResponse';
  hasMore: Scalars['Boolean'];
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};

export type PagedUserFilterInput = {
  favoriteFilter?: InputMaybe<Scalars['Boolean']>;
  hasActivity?: InputMaybe<Scalars['Boolean']>;
  preferredLocationFilter?: InputMaybe<Scalars['ID']>;
  userNameFilter?: InputMaybe<Scalars['String']>;
};

export type PagedUserResult = {
  __typename?: 'PagedUserResult';
  accountUsers: Array<AccountUser>;
  accountUsersTotal: Scalars['Int'];
  hasNextPage: Scalars['Boolean'];
  nextPageOffset: Scalars['Int'];
  users: Array<User>;
};

export type PagedUserResultV2 = {
  __typename?: 'PagedUserResultV2';
  accountUsers: Array<AccountUser>;
  accountUsersTotal: Scalars['Int'];
  hasNextPage: Scalars['Boolean'];
  nextPageOffset: Scalars['Int'];
};

export type PaginatedUnhealthyCalendarsForNotificationsResponse = {
  __typename?: 'PaginatedUnhealthyCalendarsForNotificationsResponse';
  cursor?: Maybe<Scalars['ID']>;
  orgCalendars: Array<GroupedUnhealthyCalendarOrg>;
};

export type ParsedDeliveryText = {
  __typename?: 'ParsedDeliveryText';
  matchedUsers: Array<User>;
  parsedRecipients: Array<Scalars['String']>;
};

export type PartialNeighborhoodColorDefinition = {
  __typename?: 'PartialNeighborhoodColorDefinition';
  base: Scalars['String'];
  label: NeighborhoodLabelColors;
};

export const ParticipationStatus = {
  ACCEPTED: 'ACCEPTED',
  DECLINED: 'DECLINED',
  NOT_RESPONDED: 'NOT_RESPONDED',
  TENTATIVE: 'TENTATIVE',
  UNKNOWN: 'UNKNOWN'
} as const;

export type ParticipationStatus = typeof ParticipationStatus[keyof typeof ParticipationStatus];
export type PassInput = {
  groups: Array<Scalars['ID']>;
  healthCheckpointRequired?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  place: PassPlaceInput;
  schedule: Array<Scalars['String']>;
  userChanges?: InputMaybe<PassUsersInput>;
};

export type PassPlaceInput = {
  id: Scalars['ID'];
  type: AccessPlaceType;
};

export type PassUsersInput = {
  added?: InputMaybe<Array<Scalars['ID']>>;
  removed?: InputMaybe<Array<Scalars['ID']>>;
};

export type Permission = {
  __typename?: 'Permission';
  name: Scalars['String'];
  value: Scalars['Boolean'];
};

export const PermissionHierarchyTarget = {
  CAMPUS: 'CAMPUS',
  LEVEL: 'LEVEL',
  LOCATION: 'LOCATION',
  ORGANIZATION: 'ORGANIZATION',
  RESOURCE_GROUP: 'RESOURCE_GROUP',
  RESOURCE_INSTANCE: 'RESOURCE_INSTANCE'
} as const;

export type PermissionHierarchyTarget = typeof PermissionHierarchyTarget[keyof typeof PermissionHierarchyTarget];
export type PermissionScope = {
  __typename?: 'PermissionScope';
  allowedLocationIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** @deprecated No longer supported */
  allowedOrgIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type PersistNeighborhoodInput = {
  color: Scalars['String'];
  colorReference: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  resources: Array<NeighborhoodResourceInput>;
};

export type PersistNeighborhoodsResponse = {
  __typename?: 'PersistNeighborhoodsResponse';
  createdNeighborhoods: Array<Scalars['ID']>;
  deletedNeighborhoods: Array<Scalars['ID']>;
  updatedNeighborhoods: Array<Scalars['ID']>;
};

export type PinnedUserSpaceEntity = {
  __typename?: 'PinnedUserSpaceEntity';
  locationId: Scalars['String'];
  spaceIds: Array<Scalars['String']>;
};

export type PlaceAvailability = {
  __typename?: 'PlaceAvailability';
  status: PlaceAvailabilityType;
  unavailableReasons: Array<PlaceUnavailableReason>;
};

export const PlaceAvailabilityType = {
  AVAILABLE: 'AVAILABLE',
  UNAVAILABLE: 'UNAVAILABLE'
} as const;

export type PlaceAvailabilityType = typeof PlaceAvailabilityType[keyof typeof PlaceAvailabilityType];
export const PlaceType = {
  LOCATION: 'location'
} as const;

export type PlaceType = typeof PlaceType[keyof typeof PlaceType];
export const PlaceUnavailableReason = {
  /** The location is closed according to its working hours */
  BUILDING_CLOSED: 'BUILDING_CLOSED',
  /** The maxiumum number of flexible desks have been booked in this location */
  MAX_CAPACITY_REACHED: 'MAX_CAPACITY_REACHED',
  /** The user doesn't have a pass */
  NO_ACCESS: 'NO_ACCESS',
  /** The user has a pass but it doesn't grant access to the location */
  NO_LOCATION_ACCESS: 'NO_LOCATION_ACCESS',
  /** The user has a pass to the location, but it's not valid during the specified start and end times */
  SCHEDULE_VIOLATION: 'SCHEDULE_VIOLATION'
} as const;

export type PlaceUnavailableReason = typeof PlaceUnavailableReason[keyof typeof PlaceUnavailableReason];
export type Policy = {
  __typename?: 'Policy';
  is_allowed: Scalars['Boolean'];
  object_id: Scalars['String'];
  object_type: Scalars['String'];
  permission_operation: Scalars['String'];
};

export type PolicyEnabledWithDurationCommand = {
  duration?: InputMaybe<Scalars['ISO8601_Duration']>;
  enabled: Scalars['Boolean'];
};

export type PolicyEnabledWithDurationType = {
  __typename?: 'PolicyEnabledWithDurationType';
  duration?: Maybe<Scalars['ISO8601_Duration']>;
  enabled: Scalars['Boolean'];
};

export const PolicyType = {
  ABANDONED_RESOURCE_PROTECTION: 'ABANDONED_RESOURCE_PROTECTION',
  ADVANCED_BOOKING_THRESHOLD: 'ADVANCED_BOOKING_THRESHOLD',
  ADVANCE_CHECK_IN_WINDOW: 'ADVANCE_CHECK_IN_WINDOW',
  ALLOW_OVERLAPPING_BOOKINGS: 'ALLOW_OVERLAPPING_BOOKINGS',
  BOOKING_PRIVACY: 'BOOKING_PRIVACY',
  LOCAL_CHECK_IN_ONLY: 'LOCAL_CHECK_IN_ONLY',
  MAX_BOOKING_LENGTH: 'MAX_BOOKING_LENGTH',
  PREVENT_BOOKING_FROM_KIOSK: 'PREVENT_BOOKING_FROM_KIOSK',
  RECURRENCE: 'RECURRENCE',
  REQUIRE_CHECK_IN: 'REQUIRE_CHECK_IN',
  RESERVATION_TYPE: 'RESERVATION_TYPE',
  RESOURCE_BUSY: 'RESOURCE_BUSY',
  RESOURCE_SHARING: 'RESOURCE_SHARING',
  RESTRICT_BOOKING_TO_WORKING_HOURS: 'RESTRICT_BOOKING_TO_WORKING_HOURS'
} as const;

export type PolicyType = typeof PolicyType[keyof typeof PolicyType];
export type PrebuiltSigmaWorkbooksMap = {
  __typename?: 'PrebuiltSigmaWorkbooksMap';
  collab_score_demo: Scalars['String'];
  desk_insights: Scalars['String'];
  executive_insights_aa: Scalars['String'];
  inventory: Scalars['String'];
  landing_page: Scalars['String'];
  people_roster: Scalars['String'];
  presence: Scalars['String'];
  space_insights: Scalars['String'];
  workplace_insights: Scalars['String'];
};

export type PrimaryEmail = {
  __typename?: 'PrimaryEmail';
  email?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
};

export type PropertiesInput = {
  decorId: Scalars['ID'];
  name: Scalars['String'];
  ownerId: Scalars['ID'];
  ownerType: Scalars['String'];
  placedOnMap: Scalars['Boolean'];
  updated: Scalars['Boolean'];
  zoneId?: InputMaybe<Scalars['ID']>;
};

/** Provider-specific error information (e.g., AADSTS codes from Microsoft) */
export type ProviderError = {
  __typename?: 'ProviderError';
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export const ProxiedEventResponseStatus = {
  CANCELLED: 'CANCELLED',
  CONFIRMED: 'CONFIRMED',
  TENTATIVE: 'TENTATIVE',
  UNKNOWN: 'UNKNOWN'
} as const;

export type ProxiedEventResponseStatus = typeof ProxiedEventResponseStatus[keyof typeof ProxiedEventResponseStatus];
export type PublicArrivalDisplay = {
  __typename?: 'PublicArrivalDisplay';
  id: Scalars['ID'];
  location: PublicLocationOrDefault;
  name: Scalars['String'];
  organization: PublicOrganization;
};

export type PublicGuest = {
  __typename?: 'PublicGuest';
  email: Scalars['String'];
  id: Scalars['ID'];
  imageURL?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type PublicLocationOrDefault = {
  __typename?: 'PublicLocationOrDefault';
  address?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isHealthCheckpointRequired: Scalars['Boolean'];
  name: Scalars['String'];
  organizationId: Scalars['ID'];
  timezone?: Maybe<Scalars['String']>;
};

export type PublicOrganization = {
  __typename?: 'PublicOrganization';
  id: Scalars['ID'];
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

export type PublicUserWithDefault = {
  __typename?: 'PublicUserWithDefault';
  avatar?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type PublicUserWithEmail = {
  __typename?: 'PublicUserWithEmail';
  avatar?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

/** A PublicVisitHost represents a host assigned to a public visit (e.g., arrival display) */
export type PublicVisitHost = {
  __typename?: 'PublicVisitHost';
  /** Host robin user */
  host: PublicUserWithEmail;
  /** Host user ID */
  hostUserId: Scalars['ID'];
  /** Whether this host is visible to guests */
  isVisibleToGuests: Scalars['Boolean'];
};

/** PublicVisitResult represents the visit for a single GuestInvite. The result is "public" because it is available to the public via Arrival Display kiosk devices. A PublicVisitResult is the guest (GuestInvite) along with information about their associated Visit. */
export type PublicVisitResult = {
  __typename?: 'PublicVisitResult';
  arrivalInstructions?: Maybe<Scalars['String']>;
  arrivalLocation: PublicLocationOrDefault;
  arrivalLocationId: Scalars['String'];
  checkinOn?: Maybe<Scalars['String']>;
  checkoutOn?: Maybe<Scalars['String']>;
  customVisitType: Scalars['String'];
  guest: PublicGuest;
  healthCheckpointSurveyResponse?: Maybe<GenericHealthCheckpointResponse>;
  /**
   * Legacy single host - deprecated in favor of hosts array
   * @deprecated Use hosts array instead to support multiple hosts per visit
   */
  host: PublicUserWithEmail;
  /** All hosts assigned to this visit with their settings */
  hosts: Array<PublicVisitHost>;
  /** The ID of the GuestInvite */
  id: Scalars['ID'];
  inviteCustomFields?: Maybe<Array<CustomField>>;
  organization: PublicOrganization;
  startTime: Scalars['ISODateTime'];
  status: GuestInviteStatus;
  visitCustomFields?: Maybe<Array<CustomField>>;
  /** The ID of the associated visit */
  visitId: Scalars['ID'];
  /** @deprecated replaced by the more flexible customVisitType */
  visitType: VisitType;
};

export type PublishedNeighborhoodColor = {
  __typename?: 'PublishedNeighborhoodColor';
  base: Scalars['String'];
  id: Scalars['String'];
  type: Scalars['String'];
};

export type PublishedNeighborhoodColorDefinition = {
  __typename?: 'PublishedNeighborhoodColorDefinition';
  base: Scalars['String'];
  id: Scalars['ID'];
};

export const Query_Visit_Document_Sort_By = {
  ADDED_ON: 'ADDED_ON',
  NAME: 'NAME',
  STATUS: 'STATUS'
} as const;

export type Query_Visit_Document_Sort_By = typeof Query_Visit_Document_Sort_By[keyof typeof Query_Visit_Document_Sort_By];
export const Query_Workflow_Sort_Order = {
  ASCENDING: 'ASCENDING',
  DESCENDING: 'DESCENDING'
} as const;

export type Query_Workflow_Sort_Order = typeof Query_Workflow_Sort_Order[keyof typeof Query_Workflow_Sort_Order];
export type Query = {
  __typename?: 'Query';
  /** Allows arrival displays to self-rescue. If you know, you know. Vague by design. */
  arrivalDisplaySelfRescue: Array<Scalars['String']>;
  autoDeskBookingAttemptedForLocalDate: Array<AutoDeskBookingAttemptedResponseType>;
  /** Returns a array of AutoDeskBookingScheduleResponse based on the users schedule. It will search the full week starting from Sunday through Saturday and return the dates only in the users schedule and the auto desk booking status for that date, */
  autoDeskBookingAttemptsForUserSchedule: Array<AutoDeskBookingScheduleResponse>;
  /** Badge printer IP address */
  badgePrinterIPAddress: Scalars['String'];
  canUserDelegateDesk: Scalars['Boolean'];
  checkOrganizationNameAvailability?: Maybe<CheckOrganizationNameAvailabilityResponse>;
  checkUserEmails: EmailCheckResponse;
  /** Requires permission to manage services in at least one place. Can use with listMeetingServiceRequests to get total result count for pagination. */
  countMeetingServiceRequests: CountMeetingServiceRequestsResponse;
  /** Requires permission to manage services in at least one place. Can use with listMeetingServices to get total result count for pagination. */
  countMeetingServices: CountMeetingServicesResponse;
  countMeetingServicesCategories: CountMeetingServicesCategoriesResponse;
  /** Total count of filtered visit documents */
  countVisitFilteredDocuments: Scalars['Int'];
  /** Provides policy configuration documents for the specified location, filtered to the categories specified. */
  customResourceLocationCategoryPolicies: Array<CustomResourcePolicyDocument>;
  /** Provides the policy document configuration for a resource, or default if not configured */
  customResourcePolicies: CustomResourcePolicyDocument;
  /** Provides the policy document configuration for a prospective resource, or default if not configured */
  customResourceProspectivePolicies: CustomResourcePolicyDocument;
  /** Query for reservations for a set of custom resources over a range of dates */
  customResourceReservations: CustomResourceReservationsRangeResponseType;
  /** Query for reservations within a date range for the current user */
  customResourceReservationsForCurrentUserGroupedByDate: CustomResourceReservationsGroupedByDateResponseType;
  /** Query for reservations for a set of custom resources by time over a list of dates */
  customResourceReservationsGroupedByDate: CustomResourceReservationsGroupedByDateResponseType;
  /** Provides the policy document configuration for many resource, or default if not configured. If defaults are returned, they represent the default policies for the Robin-provided templates which differ from user-defined template policies. */
  customResourcesPolicies: Array<CustomResourcePolicyDocument>;
  /** Provides the default policy configuration for Robin-provided custom resource templates */
  defaultRobinCustomResourcePolicies: CustomResourcePolicyDocument;
  /** Provides the default policy configuration for user-created custom resource templates */
  defaultUserCustomResourcePolicies: CustomResourcePolicyDocument;
  /** Tells you if the current user is allowed to report issues on a desk */
  deskAllowsIssueReports: ResourceAllowsIssueReportsResponse;
  deskReservationChangedOnLevelToken: Array<ReservationLevelChangeDetectionResponse>;
  deskReservationMapQueryStateToken: Array<ReservationLevelChangeDetectionResponse>;
  doIHaveACalendar?: Maybe<Scalars['Boolean']>;
  employeeVisit: EmployeeVisitQueries;
  exportDraftChanges: Scalars['String'];
  getAccountUsersByIds?: Maybe<Array<Maybe<AccountUser>>>;
  /** Get all active announcements for a given location, within the specific location context & for current user. (e.g. viewedAt - when has the current user first viewed this announcement at provided location) */
  getActiveAnnouncementsByLocationId: Array<AnnouncementForLocation>;
  /** Get all active announcements for given locations, within the specific location context & for current user. (e.g. viewedAt - when has the current user first viewed this announcement at provided location) */
  getActiveAnnouncementsByLocationIds: Array<AnnouncementForLocation>;
  getActiveDistributionsByAuthorId: Array<Maybe<AnnouncementDistributionForLocation>>;
  getActiveDistributionsByOrganizationId: Array<Maybe<AnnouncementDistributionForLocation>>;
  /** Get list of active visit types for org */
  getActiveVisitTypesForOrg: Array<Scalars['String']>;
  getActivitiesSummaryForTimeRangeByLocationIds: Array<DailyActivitiesSummary>;
  /** Gets the latest messages for activity chat. Window from latest message ID. Retrieves messages newer than the referenced message. */
  getActivityChatNewerMessages: Array<ChatMessage>;
  /** Returns the set of message IDs in chat that have been removed after the specified timestamp. */
  getActivityChatRemovedMessagesSince: Array<Scalars['ID']>;
  /** Gets the latest messages for activity chat. Optional parameter @messagesPriorTo is the identity of the earliest ChatMessage of which the client is aware. Providing @messagesPriorTo retrieves the previous page of messages. Default @pageSize is 5. */
  getActivityChatTail: Array<ChatMessage>;
  getActivityCoverImages: GetActivityCoverImagesResponse;
  getActivityForCurrentUserById: ActivityForCurrentUser;
  getAllActivitiesForDateByLocationIds: Array<ActivitiesByLocation>;
  getAllActivitiesForDateRangeByLocationIds: Array<ActivitiesByLocation>;
  getAllJoinedUsersByActivityId: Array<Maybe<User>>;
  getAllNeighborhoodColors: Array<NeighborhoodColorDefinition>;
  getAllOrganizationLocations: Array<Maybe<OrganizationLocation>>;
  /** Returns filtered view of all visit data for the organization specified in the tenant ID header */
  getAllVisits: Array<Visit>;
  getAmenitiesByIds: Array<Amenity>;
  getAmenityById?: Maybe<Amenity>;
  getAnalyticsAuthorizationToken: AnalyticsAuthorizationResponse;
  /** Get a single announcement by ID */
  getAnnouncementById?: Maybe<Announcement>;
  /** Get a single announcement as type AnnouncementForLocation by ID */
  getAnnouncementForLocationById?: Maybe<AnnouncementForLocation>;
  getAnnouncementViewAcknowledgeCount?: Maybe<AnnouncementViewAcknowledgeCount>;
  /** Get all the announcements for an organization, filterable by location id and status */
  getAnnouncements: Array<Maybe<Announcement>>;
  getAnyDeskById?: Maybe<Desk>;
  getAnyDesksByIds: Array<Desk>;
  /** Get a list of arrival displays registered to the organization of the requesting user */
  getArrivalDisplay?: Maybe<ArrivalDisplay>;
  /** Arrival display settings (badge printer IP address, guest image capture enabled, guest self-registration enabled) */
  getArrivalDisplaySettings: ArrivalDisplaySettings;
  /** Get a list of arrival displays registered to the organization of the requesting user */
  getArrivalDisplays: Array<ArrivalDisplay>;
  getAuthedTeamUsersByName: Array<User>;
  /** Gets the auto desk booking setting for current (user) actor */
  getAutoDeskBooking: MyAutoDeskBookingResponse;
  /** Gets the auto desk booking setting for user */
  getAutoDeskBookingByUserId: AutoDeskBookingResponse;
  getAutoDeskBookingEnabledConfiguration: Array<AutoDeskBookingInternalResponse>;
  getAutoDeskBookingForOrg: AutoDeskBookingOrgResponse;
  getAvailableFloors: Array<Level>;
  /** Gets the status of a given badge CSV upload. */
  getBadgeCSVUploadStatus: GetBadgeCsvUploadStatusResponse;
  /** Gets a list of CSV uploads for the current tenant. */
  getBadgeCSVUploadsForCurrentTenant: GetBadgeCsvUploadsForCurrentTenantResponse;
  /** Gets a single badge printer via its id */
  getBadgePrinter?: Maybe<BadgePrinter>;
  /** Get a list of badge printers registered to the organization of the requesting user */
  getBadgePrinters: Array<BadgePrinter>;
  /** Get a badge printers for organization by locationId */
  getBadgePrintersByLocationId: Array<BadgePrinter>;
  getBookingWindowPoliciesById: Array<Maybe<BookingWindowPolicy>>;
  getBookingWindowPoliciesForLocation: Array<BookingWindowPolicy>;
  getBookingWindowPolicyById?: Maybe<BookingWindowPolicy>;
  /** Checks the Brivo account for current tenant */
  getBrivoAccountStatusForCurrentTenant: GetBrivoAccountStatusForCurrentTenant;
  /** Gets a list of Brivo locks for current tenant. */
  getBrivoLocksForCurrentTenant: GetBrivoLocksForCurrentTenant;
  getBuildingGeofence: GetBuildingGeofenceResponse;
  /** Get view count & acknowledge count for each given announcement ID */
  getBulkAnnouncementViewAcknowledgeCount: Array<AnnouncementViewAcknowledgeCountWithId>;
  getCampusById?: Maybe<Campus>;
  getCampusesByIds: Array<Campus>;
  /** Return a list of visits given a guest's partial email */
  getCheckedInVisitsByPartialEmail: Array<PublicVisitResult>;
  getCoverImagesForActivities: ActivityCoverImagesObject;
  /** Gets credentials details for current tenant */
  getCredentialDetailsForCurrentTenant: GetCredentialDetailsForCurrentTenantResponse;
  /** Gets organization and location information for credentials and current tenant */
  getCredentialOrganizationAndLocationInfoForCurrentTenant: GetCredentialOrganizationAndLocationInfoForCurrentTenantResponse;
  /** Query to determine if current actor's permissions with regards to badge domain. */
  getCurrentActorBadgePermissionsForCurrentTenant: GetCurrentActorBadgePermissionsForCurrentTenantReponse;
  getCurrentUserAndOrgs?: Maybe<CurrentUserAndOrgs>;
  /** Query custom resource templates by organization ID */
  getCustomResourceTemplates: Array<CustomResourceTemplate>;
  /** Used in conjunction with getCustomVisitForms for pagination */
  getCustomVisitFormCount?: Maybe<Scalars['Int']>;
  getCustomVisitFormLocations?: Maybe<CustomVisitFormLocationResponse>;
  getCustomVisitForms?: Maybe<Array<CustomVisitForm>>;
  /** Get days of week for resource reservations for the next 90 days */
  getDaysOfWeekGroupedByResourceReservation: Array<DaysOfWeekGroupedByResourceReservation>;
  getDeliveries: Array<Delivery>;
  getDeliveriesCount: Scalars['Int'];
  getDeliveriesEnabledLocations: Array<DeliveryLocation>;
  /** Returns locations that the user is able to view and manage */
  getDeliveriesPermittedLocations: DeliveriesPermittedLocations;
  getDeliveryById?: Maybe<Delivery>;
  getDeliveryZoneCount: Scalars['Int'];
  getDeliveryZones: Array<DeliveryZone>;
  getDeskAvailabilityByLevelIdForMe: DeskAvailabilityByLevelId;
  getDeskById?: Maybe<Desk>;
  getDeskExclusionById?: Maybe<Exclusion>;
  getDeskExclusionsByIds: Array<Exclusion>;
  getDeskReservationById?: Maybe<Reservation>;
  getDeskReservationInstancesById: Array<Reservation>;
  getDeskReservationInstancesBySeriesIds: Array<DeskReservationInstancesBySeriesId>;
  getDeskReservationsByIds: Array<Reservation>;
  getDeskReservationsByLevelId: LevelDeskReservation;
  getDeskReservationsByLocationId: LocationDeskReservation;
  getDeskReservationsBySeatId: Array<Reservation>;
  getDeskReservationsBySeatIds: Array<Reservation>;
  getDeskReservationsBySpaceIds: Array<ReservationsBySpacesForStatusBoard>;
  getDeskReservationsByUserId: UserDeskReservation;
  getDeskReservationsByUserIds: Array<UserDeskReservation>;
  getDeskReservationsByZoneId: ZoneDeskReservation;
  /** Query reservations for a set of users between two moments at a specific location. Results are grouped by date relative to the location ISO time offset. */
  getDeskReservationsForUsersAtLocationGroupedByDateAscending: DateGroupedUserReservations;
  /** Query reservations for a set of users between two moments. Results are grouped by date relative to the requesting users ISO time offset. */
  getDeskReservationsForUsersGroupedByDateAscending: DateGroupedUserReservations;
  getDesksByIds: Array<Desk>;
  getDesksWithAssigneesByLevelId: Array<DeskWithAssignees>;
  getDisabledDeskById?: Maybe<Desk>;
  getDisabledDesksByIds: Array<Desk>;
  getDistributionById: AnnouncementDistribution;
  getDistributionsByAnnouncementId: Array<AnnouncementDistribution>;
  getDraftAuditLogs: DraftAuditLogsResponse;
  getDraftCollaborators: Array<AccountUser>;
  getDraftConflicts: Array<DraftConflict>;
  getDraftStatus: DraftStatusResponse;
  getDraftsList: DraftPagingResult;
  /** Get all of an employee's visits during a specific time range at a specific location */
  getEmployeeVisitsAtLocationForEmployee: Array<EmployeeVisit>;
  /** Get all of the visits during a specific time range at a specific location for several employees */
  getEmployeeVisitsForUsersAtLocationGroupedByDateAscending: Array<EmployeeVisitsByDate>;
  /** Returns a very short-lived URL for downloading a file that has been scanned for malware. Only call this when the user indicates they want to download a file. Begin the download immediately. This should not be requested ahead of time or written to emails/HTML/etc. Clients that want to "permanently" link to a file should handle that themselves and make sure to have a fallback UI for the case where this fails. Returns an error if the file has not been scanned yet, failed to scan, or threats were found. */
  getEphemeralDownloadUrlForScannedTicketFile: GetEphemeralDownloadUrlForScannedTicketFileResponse;
  /** Get audit logs for events with filtering and pagination */
  getEventAuditLogs: GetEventAuditLogsPaginatedResponse;
  /** Get audit logs for a specific event by event ID */
  getEventAuditLogsByEventId: GetEventAuditLogsByEventIdResponse;
  getEventById?: Maybe<Event>;
  getEventsWithCheckInStatusForProxiedEventId: GetEventsWithCheckInStatusForProxiedEventIdReponse;
  /** Get the health status of a user's external account integration. Performs active token refresh validation and returns detailed status information. */
  getExternalAccountStatus: ExternalAccountStatus;
  getExternalEvents: Array<ExternalEvent>;
  /** Checks the Gallagher account for current tenant */
  getGallagherAccountForCurrentTenant: GetGallagherAccountForCurrentTenant;
  /** Gets a list of Gallagher locks by UUID. */
  getGallagherDoorsByIntegrationUuid: GetGallagherDoorsByIntegrationUuid;
  /** Checks the Genea account for current tenant */
  getGeneaAccountForCurrentTenant: GetGeneaAccountForCurrentTenant;
  /** Gets a list of Genea doors for current tenant. */
  getGeneaDoorsForCurrentTenant: GetGeneaDoorsForCurrentTenant;
  /** Checks the Genetec account for current tenant */
  getGenetecAccountForCurrentTenant: GetGenetecAccountForCurrentTenant;
  /** Gets a list of Genetec locks by UUID. */
  getGenetecDoorsByIntegrationUuid: GetGenetecDoorsByIntegrationUuidResponse;
  /** Gets all Google buildings tied to the provided external account ID. */
  getGoogleBuildings?: Maybe<Array<Maybe<GoogleBuilding>>>;
  getGoogleWorkingLocationSyncSettingForOrg: Scalars['Boolean'];
  /** Gets the sync google working locations setting user */
  getGoogleWorkingLocationSyncSettingForUser: GoogleWorkingLocationSyncSetting;
  getGroupsByKeyword: Array<Group>;
  getGuestInviteById?: Maybe<GuestInvite>;
  /** Returns a count of guest invites matching criteria */
  getGuestInviteCount: Scalars['Int'];
  /** Returns filtered view of all guest invites */
  getGuestInvites: Array<GuestInvite>;
  /** Get a guest invite of a visit by its ID */
  getGuestVisitById?: Maybe<PublicVisitResult>;
  /** Returns guests who visited specified locations based on a provided list of emails and location IDs */
  getGuestsByEmailsAndLocations: Array<PublicGuest>;
  /** @deprecated In office has been migrated to Whos In */
  getInOfficeDataByLocation: InOfficeData;
  /** @deprecated In office has been migrated to Whos In */
  getInOfficeDataByLocationByDay: Array<InOfficeDataByDay>;
  /** @deprecated In office has been migrated to Whos In */
  getInOfficeDataByUserIdsAndLocation: InOfficeData;
  getInitialWorkPolicyCreatedAt?: Maybe<Scalars['ISODateTime']>;
  /** Gets a external integration by externalId */
  getIntegrationByExternalId?: Maybe<Array<Maybe<ExternalIntegration>>>;
  /** Gets a external integration by id */
  getIntegrationById?: Maybe<ExternalIntegration>;
  /** Gets a external integration by orgId */
  getIntegrationByOrgId?: Maybe<Array<Maybe<ExternalIntegration>>>;
  /** Checks the Kisi account for current tenant */
  getKisiAccountStatusForCurrentTenant: GetKisiAccountStatusForCurrentTenant;
  /** Gets a list of Kisi locks for current tenant. */
  getKisiLocksForCurrentTenant?: Maybe<GetKisiLocksForCurrentTenant>;
  /** Returns a legacy integration from ACL by its userId */
  getLegacyIntegrationByUserId?: Maybe<LegacyIntegration>;
  /** Returns if a legacy integration exists for the user by the given type and resource-type Tenant ID is also taken into account */
  getLegacyIntegrationExistsByType?: Maybe<Scalars['Boolean']>;
  /** Returns a legacy integrations from ACL by it orgId */
  getLegacyIntegrationsByOrgId?: Maybe<Array<Maybe<LegacyIntegration>>>;
  getLevelById?: Maybe<Level>;
  getLevelSettings: Array<Setting>;
  getLevelsByIds: Array<Level>;
  getLocationById?: Maybe<Location>;
  getLocationByRemoteGoogleId?: Maybe<SimpleLocation>;
  getLocationsByFiltersInCurrentTenant: Array<Location>;
  getLocationsByIds: Array<Location>;
  /** Allows getting archived meeting services */
  getMeetingServiceById: GetMeetingServiceByIdResponse;
  getMeetingServiceRequestByIdentifier: GetMeetingServiceRequestByIdentifierResponse;
  getMicrosoftGraphEnabled: Scalars['Boolean'];
  getMicrosoftGraphMigrationProgress?: Maybe<MigrationProgress>;
  getMicrosoftGraphMigrationReport?: Maybe<MigrationReportWithTotals>;
  getMobileGeofencesForMeInTenant: GetMobileGeofencesForMeInTenantResponse;
  getMyDefaultLocationOrFallback?: Maybe<Location>;
  getMyEventsInTheRange: Array<Event>;
  getMyEventsInTheRangeWithCheckInStatus: Array<Event>;
  getMyHomepage: MyHomepageResponse;
  /** Gets a language tag for current (user) actor */
  getMyLanguageTag: MyLanguageTagResponse;
  getMyTeamNames: Array<Scalars['String']>;
  /** Returns the set of unacknowledged announcements for the requesting user for the given location. (Only PRIORITY announcements, as they can be acknowledged) */
  getMyUnacknowledgedActiveAnnouncementsByLocationId: Array<Announcement>;
  /** Returns the set of unacknowledged announcements for the requesting user for the given locations. (Only PRIORITY announcements, as they can be acknowledged) */
  getMyUnacknowledgedActiveAnnouncementsByLocationIds: Array<Announcement>;
  getMyWorkPolicyWithProgress?: Maybe<WorkPolicyWithProgress>;
  getNeighborhoodById?: Maybe<GetNeighborhoodByIdResponse>;
  getNeighborhoodColorDefinitionById?: Maybe<NeighborhoodColorDefinition>;
  getNeighborhoodsForFloor: FloorNeighborhoodsResponse;
  getNeighborhoodsInDraftForFloor: NeighborhoodsInDraftForFloorResult;
  getOfficeAdmins: Array<User>;
  /** Checks the Openpath account for current tenant */
  getOpenpathAccountStatusForCurrentTenant: GetOpenpathAccountStatusForCurrentTenant;
  /** Gets a list of Openpath locks for current tenant. */
  getOpenpathLocksForCurrentTenant: GetOpenpathLocksForCurrentTenant;
  getOrSuggestMyDefaultLocationOrLevel?: Maybe<DefaultLocationAndLevel>;
  getOrganizationById?: Maybe<Organization>;
  /** Gets a legacy integration by externalId and type */
  getOrganizationByIntegration?: Maybe<ApiOrganizationExternalAccount>;
  getOrganizationExternalAccount?: Maybe<OrganizationExternalAccount>;
  /** Gets an encoded version of an organization ID */
  getOrganizationIdHash: OrganizationIdHashResponse;
  getOrganizationNotificationSettings?: Maybe<Array<Maybe<OrganizationNotificationsSetting>>>;
  getOrganizationsByIds: Array<Organization>;
  getOrganizationsByUserEmail: Array<Maybe<MeOrganization>>;
  getPagedUsers: PagedUserResult;
  /** @deprecated Deprecated -- continue using getPagedUsers. This is being removed */
  getPagedUsersV2: PagedUserResult;
  /** Get all survey responses with pagination based on the filters By default returns only completed responses. */
  getPaginatedSurveyResponses?: Maybe<Array<Maybe<SurveyResponse>>>;
  getPaginatedSurveyResponsesTotalPageCount?: Maybe<Scalars['Int']>;
  getPassesByOrganizationId: Array<OfficeAccess>;
  /** Get the most recent pending survey response for a user */
  getPendingSurveyResponseForUser?: Maybe<SurveyResponse>;
  /** Get permissions for a specific role and resource category within a hierarchy type and hierarchy ID and organization */
  getPermissionsByHierarchyTypeAndId: Array<RolePermission>;
  getPermissionsByRoleIds: Array<RolePermission>;
  getPermissionsForCurrentUserByResourceIds: Array<ResourcePermissionCollection>;
  getPinnedUserSpacesByLocationIds: Array<PinnedUserSpaceEntity>;
  /** Returns a name, id mapping of the prebuilt workbooks */
  getPrebuiltSigmaWorkbookIds?: Maybe<PrebuiltSigmaWorkbooksMap>;
  getPublishedDraft: GetPublishedDraftResponse;
  getPublishedDrafts: DraftPagingResult;
  getRecipientById?: Maybe<Recipient>;
  getRecipients: Array<Recipient>;
  getReservationExclusions: Array<Exclusion>;
  /** Get reservations by resource instance ID grouped by day of week for the next 90 days */
  getReservationsByResourceInstanceIdGroupedByDayOfWeek: Array<ResourceReservationGroupedByDayOfWeek>;
  /** Get all of a user's reservations */
  getReservationsForUser: Array<Reservation>;
  /** Checks seat availability for multidays ONLY allows max 31 dates of availability to be checked at once. There is a real performance limitation here which we query seat state api for each date. Please re-evaluate before using this for high frequency use cases. Currently, this is only used for updating a reservation in a 30 day calendar modal. */
  getReservationsMultiDayAvailabilities: Array<DeskAvailabilityByDate>;
  getReservationsToCancel?: Maybe<Array<ReservationsToCancelResponse>>;
  getRipplingAccountState?: Maybe<GetRipplingAccountStateResponse>;
  getRipplingWorkLocationsAndExistingMappings?: Maybe<RipplingWorkLocationsWithMappings>;
  getRobinUserInfoBySlackId?: Maybe<RobinUserInfoForSlack>;
  getRole?: Maybe<Role>;
  /** Check if the current user has the specified role permission(s) */
  getRolePermissionsForCurrentUser: Array<UserRolePermissionResult>;
  getSeatIdByStickerShortCode?: Maybe<Scalars['ID']>;
  getSharedDesksSchedules?: Maybe<Array<Maybe<SharedDeskSchedule>>>;
  getShowNeighborhoodColorsSetting: Scalars['Boolean'];
  /**
   * Returns the appropriate embed mode for the user
   * @deprecated Use userHasAdvancedAnalyticsManage instead
   */
  getSigmaEmbedType?: Maybe<SigmaEmbedType>;
  /** Constructs a Sigma embed URL */
  getSigmaEmbedUrl?: Maybe<SigmaEmbedUrl>;
  /** Lists all favorited Sigma workbooks for a user */
  getSigmaFavorites?: Maybe<Array<Maybe<SigmaFile>>>;
  /** Constructs a Sigma JWT embed URL */
  getSigmaJwtEmbedUrl?: Maybe<SigmaEmbedUrl>;
  /** Returns the appropriate embed mode for the user */
  getSigmaMemberId?: Maybe<Scalars['ID']>;
  /** Get a Sigma workbook */
  getSigmaWorkbook?: Maybe<SigmaWorkbook>;
  /** Lists all Sigma workbooks accessable by a user */
  getSigmaWorkbooks?: Maybe<Array<Maybe<SigmaFile>>>;
  /** Get all of an employee's one-off visits during a specific time range within a specific org */
  getSingleDayEmployeeVisitsForEmployee: Array<EmployeeVisit>;
  getSpaceById?: Maybe<Space>;
  getSpaceCalendarsByOrgId: SpaceCalendarResponse;
  /** Returns user events which fall within the given time frame and which do not have a space associated with them. Also filters events which are not considered "meetings" and therefore do not warrent a space suggestion. Also makes sure the org has space suggestions enabled - if not, no events are returned. Also makes sure the specified building contains scheduled spaces. Finally, this also checks that the user has permission to modify the event, otherwise it will not be returned, as the use of this query is intended to inform the user that meetings are lacking spaces and to prompt them to add one. */
  getSpaceSuggestableEventsForUser: GetSpaceSuggestableEventsForUserResponse;
  getSpacesByIds: Array<Space>;
  getStickerBatchById?: Maybe<StickerBatch>;
  getStickerById?: Maybe<Sticker>;
  getStickerByShortCode?: Maybe<Sticker>;
  getStickersByOrgId: Array<Maybe<Sticker>>;
  getSuggestedDesksForUser: Array<SuggestedDesk>;
  getSuggestedSpacesEnabledForOrg: Scalars['Boolean'];
  /** Given a set of event IDs and space filter criteria, return a suggested space matching that filter criteria for each event. All suggested spaces are simultaneously reservable by the current user. * All returned spaces are available for their event's timeframe. * If events overlap in time, we try our best to return distinct spaces per overlapping event, but can return null if impossible * No other policies (e.g. max duration) prevent reservation */
  getSuggestedSpacesForEvents: GetSuggestedSpacesForEventsResponse;
  /** This is a query which calls the same underlying suggested spaces algorithm as the above, but doesn't consider existing events when querying for suggested spaces. Every other condition is the same, and it uses the same datasource as the above query. Use this one if you don't have an event for which you are querying suggested spaces. */
  getSuggestedSpacesForTimeFrame: GetSuggestedSpacesForTimeFrameResponse;
  /** Get all survey configurations for an organization */
  getSurveyConfigurations?: Maybe<Array<Maybe<Survey>>>;
  /** Get summary of the ratings of all survey responses with the given filters */
  getSurveyResponseRatingSummary?: Maybe<SurveyResponseRatingSummary>;
  /** Get summary of the statuses of all survey responses with the given filters */
  getSurveyResponseStatusSummary?: Maybe<SurveyResponseStatusSummary>;
  /** Get all survey responses based on the criteria. By default returns only completed responses. */
  getSurveyResponses?: Maybe<Array<Maybe<SurveyResponse>>>;
  /** @deprecated Deprecated -- use getAuthedTeamUsersByName instead to avoid getting invalid favorites */
  getTeamUsersByName: Array<User>;
  getTeamsUserNotificationSettings?: Maybe<Array<Maybe<UserNotificationsSetting>>>;
  /** Return associated tenant ID for a visit given a magic link */
  getTenantIdByMagicLink: Scalars['ID'];
  getTimeZonesForRipplingAddresses: GetTimeZonesForRipplingAddressesResponse;
  /** Gets publicly available information about a arrival display iff that display has not yet been registered */
  getUnauthorizedArrivalDisplayDetails?: Maybe<PublicArrivalDisplay>;
  /** Fetches unhealthy calendars as a batch orgLimit is defaulted to 10 with a MAX of 10 */
  getUnhealthySpaceCalendarsForNotifications: PaginatedUnhealthyCalendarsForNotificationsResponse;
  /** Returns whether the current user has access to update the passed through events. This is currently used to see whether we should allow them to add a space to these events. All events should fall within the time window. */
  getUpdatePermissionsForEvents: GetUpdatePermissionsForEventsResponse;
  /** Get a static list of all supported access control vendors. */
  getUploadCSVVendorList: Array<Maybe<UploadCsvVendor>>;
  /** Check if a user has acknowledged an announcement in a given location */
  getUserAcknowledgementByAnnouncementId?: Maybe<AnnouncementAcknowledgement>;
  getUserAssignments?: Maybe<Array<Maybe<UserAssignment>>>;
  getUserById?: Maybe<User>;
  /** Returns the user's desk reservations and visits per day. Should not be used in conjunction with Who's In queries beacuse those will not count deactivate users in its queries but getUserInOfficeDataByDay() will return a result for a deactivated user Reason being is the reservations and visits is not removed on deactivation. */
  getUserInOfficeDataByDay: Array<UserInOfficeByDay>;
  /** Get the notification preferences for the given user */
  getUserNotificationPreferences?: Maybe<NotificationPreferences>;
  getUserNotificationSettings?: Maybe<Array<Maybe<UserNotificationsSetting>>>;
  getUserSetting?: Maybe<UserSetting>;
  getUserSyncStatus?: Maybe<UserSyncStatus>;
  getUsersByEmails: Array<User>;
  getUsersByIds: Array<User>;
  getUsersByKeyword: Array<User>;
  getUsersByRole: Array<User>;
  getUsersForTeams: Array<Maybe<TeamsUserSearchResult>>;
  getUsersWithPermissionOnHierarchyResource: PagedApiUserResult;
  /** Checks the Verkada account for current tenant */
  getVerkadaAccountForCurrentTenant: GetVerkadaAccountForCurrentTenant;
  /** Gets a list of Verkada locks for current tenant. */
  getVerkadaDoorsForCurrentTenant: GetVerkadaDoorsForCurrentTenant;
  /** Gets the state of an asynchronous visit request */
  getVisitAsyncRequestStatus: VisitAsyncRequestStatusResponse;
  /** Get a visit by its ID */
  getVisitById?: Maybe<Visit>;
  /** Return details for a visit given a magic link */
  getVisitByMagicLink?: Maybe<UnauthenticatedVisitResult>;
  /** Returns a count of all visits matching the specified search. */
  getVisitCount: Scalars['Int'];
  /** Get list of visit types for org */
  getVisitTypeStates: Array<VisitTypeState>;
  /** Returns a user's visitor management permission scopes */
  getVisitorManagementPermissionScopes?: Maybe<VisitorManagementPermissionScopes>;
  /** Returns a user's visitor management permissions, contextualized to a location if an id is provided. */
  getVisitorManagementPermissions?: Maybe<VisitorManagementPermissions>;
  /** Return a list of visits given a guest's email */
  getVisitsByEmail: Array<PublicVisitResult>;
  /**
   * Get the waitlist and the status for current user.
   * @deprecated Use getWaitlistsForMe instead.
   */
  getWaitlistForMe: GetMyWaitlistResponse;
  /** Get the waitlists for current user, adjusted for given context. */
  getWaitlistsForMe: GetMyWaitlistsResponse;
  /** Retrieves onsite data for a specific level. Requires authentication and tenant ID header. */
  getWhoIsOnsiteByLevel: GetWhoIsOnsiteByLevelResponse;
  /** Retrieves onsite data for a specific location. Requires authentication and tenant ID header. */
  getWhoIsOnsiteByLocation: GetWhoIsOnsiteByLocationResponse;
  /** @deprecated Deprecated in favor of getWhosInDataByLocations */
  getWhosInDataByLocation: WhosInData;
  /** @deprecated Deprecated in favor of getWhosInDataByLocationsByDay */
  getWhosInDataByLocationByDay: Array<WhosInDataByDay>;
  getWhosInDataByLocationsByDay: Array<WhosInDataByDay>;
  getWhosInDataForLocations: WhosInData;
  getWorkAreaById?: Maybe<WorkArea>;
  getWorkAreasByLevel: Array<WorkArea>;
  getWorkAreasByOrganizationIds: Array<OrganizationWorkAreasMap>;
  getWorkPoliciesForOrganization: Array<WorkPolicy>;
  getWorkPolicyById?: Maybe<WorkPolicy>;
  /** Gets a single zone by its identifier */
  getZoneById?: Maybe<Zone>;
  /** Gets several zones by their identifiers */
  getZonesByIds: Array<Zone>;
  /** @deprecated Replaced with getInitialWorkPolicyCreatedAt for that check */
  hasVirtualWorkPolicy: Scalars['Boolean'];
  /** Returns metadata of a conversation as well as the list of all external messages for display in the UI. This endpoint is intended to be periodically polled by the UI when a message is in the process of being fulfilled. */
  insightsAssistantConversationV1?: Maybe<InsightsAssistantConversationV1>;
  /** Returns a list of all conversations for a given organization. This is only available to support users or users in the Chimera team. */
  insightsAssistantConversationsForOrganizationV1: Array<InsightsAssistantConversationV1>;
  insightsAssistantConversationsForOrganizationV2: Array<InsightsAssistantConversationV2>;
  /** Returns a list of all conversations for the given user. Used to supply UI navigation components, similar to how we display Sigma workbooks. */
  insightsAssistantConversationsV1?: Maybe<Array<InsightsAssistantConversationV1>>;
  insightsAssistantConversationsV2?: Maybe<Array<InsightsAssistantConversationV2>>;
  /** Returns feedback for a given message if it exists. */
  insightsAssistantFeedbackV1?: Maybe<InsightsAssistantFeedbackV1>;
  /** Returns a list of all messages for a given organization. This is only available to support users or users in the Chimera team. */
  insightsAssistantMessagesForOrganizationV1: Array<InsightsAssistantMessageV1>;
  /** Returns a list of all messages for a given conversation. */
  insightsAssistantMessagesV1: Array<InsightsAssistantMessageV1>;
  insightsPing: Scalars['String'];
  /** Internal query for reservations for a user in locations by UTC time. Automatically converts UTC to each location's local time before querying. This is intended for internal services (e.g., passive check-in lambda). */
  internalCustomResourceReservationsForUserInLocation: Array<ResourceReservation>;
  /** get internal model for user org permissions for action */
  internalPermissionUserOrgAction?: Maybe<InternalPermissionUserOrgActions>;
  /** get internal model for resource identity. Null if not found. */
  internalResource?: Maybe<InternalResource>;
  /** Returns whether or not advanced analytics is enabled for the particular organization. Includes the EAP allow list to grant individual users access to Sigma. */
  isAdvancedAnalyticsEnabled?: Maybe<Scalars['Boolean']>;
  /** Returns if the organization is in trial mode. */
  isAdvancedAnalyticsTrial?: Maybe<Scalars['Boolean']>;
  isAiEnabled: Scalars['Boolean'];
  /** Is the arrival display paired? Returns false if the device has been removed. */
  isArrivalDisplayPaired: Scalars['Boolean'];
  /** Checks if current tenant is integrated with Brivo. */
  isBrivoAccountConnectedForCurrentTenant: Scalars['Boolean'];
  /** Feature flag check to determine if Brivo integration is enabled for current tenant. */
  isBrivoIntegrationEnabledForCurrentTenant: IsBrivoIntegrationEnabledForCurrentTenantReponse;
  /** Feature flag check to determine if CSV upload is enabled for current tenant. */
  isCSVUploadEnabledForCurrentTenant: IsCsvUploadEnabledForCurrentTenantReponse;
  /**
   * Returns whether or not custom analytics is enabled for the particular organization. Includes the EAP allow list to grant individual users access to Sigma.
   * @deprecated Use isAdvancedAnalyticsEnabled instead
   */
  isCustomAnalyticsEnabled?: Maybe<Scalars['Boolean']>;
  /**
   * Returns if the organization is in trial mode.
   * @deprecated Use isAdvancedAnalyticsTrial instead
   */
  isCustomAnalyticsTrial?: Maybe<Scalars['Boolean']>;
  isFavoritesEnabled: Scalars['Boolean'];
  /** Is a feature available for a device's organization (guestUI, Arrival Display)? */
  isFeatureFlagEnabledForDeviceOrg: Scalars['Boolean'];
  isFeatureFlagEnabledForOrgOrMe: Scalars['Boolean'];
  /** Checks if current tenant is integrated with Gallagher. */
  isGallagherAccountConnectedForCurrentTenant: Scalars['Boolean'];
  /** Feature flag check to determine if Gallagher integration is enabled for current tenant. */
  isGallagherIntegrationEnabledForCurrentTenant: IsGallagherIntegrationEnabledForCurrentTenantReponse;
  /** Checks if current tenant is integrated with Genea. */
  isGeneaAccountConnectedForCurrentTenant: Scalars['Boolean'];
  /** Feature flag check to determine if Genea integration is enabled for current tenant. */
  isGeneaIntegrationEnabledForCurrentTenant: IsGeneaIntegrationEnabledForCurrentTenantReponse;
  /** Checks if current tenant is integrated with Genetec. */
  isGenetecAccountConnectedForCurrentTenant: Scalars['Boolean'];
  /** Feature flag check to determine if Genetec integration is enabled for current tenant. */
  isGenetecIntegrationEnabledForCurrentTenant: IsGenetecIntegrationEnabledForCurrentTenantReponse;
  /** Is guest image capture enabled for a device? */
  isGuestImageCaptureEnabled: Scalars['Boolean'];
  /** Is guest self-registration enabled for a device? */
  isGuestSelfRegistrationEnabled: Scalars['Boolean'];
  /** Checks if current tenant is integrated with Kisi. */
  isKisiAccountConnectedForCurrentTenant: Scalars['Boolean'];
  /** Feature flag check to determine if Kisi integration is enabled for current tenant. */
  isKisiIntegrationEnabledForCurrentTenant: IsKisiIntegrationEnabledForCurrentTenantReponse;
  /** Checks if current tenant is integrated with Openpath. */
  isOpenpathAccountConnectedForCurrentTenant: Scalars['Boolean'];
  /** Feature flag check to determine if Openpath integration is enabled for current tenant. */
  isOpenpathIntegrationEnabledForCurrentTenant: IsOpenpathIntegrationEnabledForCurrentTenantReponse;
  /** Feature flag check to determine if Openpath integration supports lock provisioning. */
  isOpenpathLockProvisioningEnabledForCurrentTenant: IsOpenpathLockProvisioningEnabledForCurrentTenantResponse;
  isPassiveCheckInFeatureEnabledForBuilding: Scalars['Boolean'];
  isRipplingAccountConnectedForOrganization: Scalars['Boolean'];
  /** Gets the show weekend setting for current (user) actor */
  isShowWeekendsEnabledForMe: MyShowWeekendsResponse;
  /** Checks if current tenant is integrated with Verkada. */
  isVerkadaAccountConnectedForCurrentTenant: Scalars['Boolean'];
  /** Feature flag check to determine if Verkada integration is enabled for current tenant. */
  isVerkadaIntegrationEnabledForCurrentTenant: IsVerkadaIntegrationEnabledForCurrentTenantReponse;
  /** Returns latest change date for all reservations indicating the latest reservation state change. If the returned timestamp changes in subsequent requests, it indicates that either a desk or space reservation has been created since last fetch. NULL response when no reservations exist for the specified level */
  levelChangeDetectionToken?: Maybe<Scalars['ISODateTime']>;
  listBuildingCidrs: ListBuildingCidrsResponse;
  listBuildingsWhereUserCanManageMeetingServices: ListBuildingsWhereUserCanManageMeetingServicesResponse;
  /** Requires permission to manage services in at least one place */
  listMeetingServiceRequests: ListMeetingServiceRequestsResponse;
  /** Requires permission to manage services in at least one place */
  listMeetingServices: ListMeetingServicesResponse;
  /** For showing a user which meeting services can be requested for a certain space. */
  listMeetingServicesAvailableInSpace: ListMeetingServicesAvailableInSpaceResponse;
  /** Requires permission to manage services in at least one place */
  listMeetingServicesCategories: ListMeetingServicesCategoriesResponse;
  /** Requires permission to manage services in at least one place List out all assignees for meeting services that match the filter. Intended for use in a filter panel for meeting services, so you can see all possible assignees and select the ones with which to filter meeting services. */
  listUniqueAssigneesForMeetingServices: ListUniqueAssigneesForMeetingServicesResponse;
  /** Requires permission to manage services in at least one place. Intended for listing unique values for filters you can pass to listMeetingServiceRequests. */
  listUniqueMeetingServiceRequestValues: ListUniqueMeetingServiceRequestValuesResponse;
  parseDeliveryText: ParsedDeliveryText;
  /** Checks seats for multidate reservation availability. */
  reservationsMultiDayGroupedByDate: Array<DeskAvailabilityLocalizedDate>;
  /** Get resource details for individual resources by ID */
  resourceDetails: Array<CustomResource>;
  /** Get resource details for individual resources by floor ID */
  resourceDetailsByFloor: Array<CustomResource>;
  /** Fetches the query model event consistency values for specified event types */
  resourceEventConsistency: Array<ResourceEventConsistencyQueryType>;
  /** Validation/availability of a request for a recurring reservation with selectable desired booking types */
  resourceMixedTypeRecurringValidate: ResourceMixedTypeRecurringValidateResponseType;
  resourceReservationExclusions: Array<ResourceReservationExclusion>;
  /** Query for reservations for a set of custom resource reservation instances by reservation ID */
  resourceReservationInstancesGroupedByReservationId: Array<ResourceReservationInstancesResponseType>;
  /** Validation/availability of a request for a recurring reservation */
  resourceReservationRecurringValidate: Array<ResourceReservationRecurringValidateResponseType>;
  /** Request validation of a request for a single day reservation */
  resourceReservationSingleDayValidate: ResourceReservationValidationResponse;
  reviewDraft: ReviewDraftResponse;
  reviewDraftChanges: ReviewDraftChangesResponse;
  /** Tells you if the current user is allowed to report issues on a space */
  spaceAllowsIssueReports: ResourceAllowsIssueReportsResponse;
  /** Is the user part of an organization with AA enabled and does that user have analytics:manage permissions */
  userHasAdvancedAnalyticsManage?: Maybe<Scalars['Boolean']>;
  userPermissionChangedInOrgToken?: Maybe<Scalars['String']>;
  /** Fetch visit document with agreement from user based on visit invite ID */
  visitDocumentAgreement: VisitDocumentAgreementResponse;
  /** Query for visit and document information associated with a decision ID (assumed to be document accept) */
  visitDocumentByDecisionId?: Maybe<VisitDocumentByDecisionResponse>;
  /** @deprecated Use visitDocumentByIdWithCustomVisitType instead */
  visitDocumentById?: Maybe<VisitDocumentResponse>;
  visitDocumentByIdWithCustomVisitType?: Maybe<VisitDocumentResponse>;
  /**
   * Query paged organizations documents available to workflows which can be applied to visits
   * @deprecated Use visitDocumentNameStatusAndTypesPageWithCustomVisitType instead
   */
  visitDocumentNameStatusAndTypesPage: Array<VisitDocumentNameStatusAndTypesQueryResponse>;
  /** Query paged organizations documents available to workflows which can be applied to visits */
  visitDocumentNameStatusAndTypesPageWithCustomVisitType: Array<VisitDocumentNameStatusAndTypesQueryResponse>;
  /**
   * Returns document agreement details for `documentID` or first document agreement if no `documentId` is specified. If response is NULL, no documents to agree with to for a visit.
   * @deprecated Use visitDocumentWithNextDocumentIdWithCustomVisitType instead
   */
  visitDocumentWithNextDocumentId?: Maybe<VisitDocumentAgreementWithNextDocumentResponse>;
  /** Returns document agreement details for `documentID` or first document agreement if no `documentId` is specified. If response is NULL, no documents to agree with to for a visit. */
  visitDocumentWithNextDocumentIdWithCustomVisitType?: Maybe<VisitDocumentAgreementWithNextDocumentResponse>;
  /**
   * Query for menu overview of documents required for a key pair of visit type and location ID.
   * @deprecated Use visitOverviewOfDocumentsWithCustomVisitType instead
   */
  visitOverviewOfDocuments?: Maybe<VisitWorkflowOverview>;
  /** Query for menu overview of documents required for a key pair of visit type and location ID. */
  visitOverviewOfDocumentsWithCustomVisitType?: Maybe<VisitWorkflowOverview>;
};


export type QueryAutoDeskBookingAttemptedForLocalDateArgs = {
  localStartDate: Scalars['LocalDate'];
  locationId: Scalars['ID'];
  numberOfDays: Scalars['Int'];
  userId: Scalars['ID'];
};


export type QueryAutoDeskBookingAttemptsForUserScheduleArgs = {
  locationId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type QueryCanUserDelegateDeskArgs = {
  deskId: Scalars['ID'];
  endTime: Scalars['ISODateTime'];
  startTime: Scalars['ISODateTime'];
};


export type QueryCheckOrganizationNameAvailabilityArgs = {
  name: Scalars['String'];
};


export type QueryCheckUserEmailsArgs = {
  emails: Array<Scalars['String']>;
};


export type QueryCountMeetingServiceRequestsArgs = {
  input: CountMeetingServiceRequestsInput;
};


export type QueryCountMeetingServicesArgs = {
  input: CountMeetingServicesInput;
};


export type QueryCountMeetingServicesCategoriesArgs = {
  input: CountMeetingServicesCategoriesInput;
};


export type QueryCountVisitFilteredDocumentsArgs = {
  filters?: InputMaybe<Array<VisitDocumentNameStatusAndTypesFilter>>;
};


export type QueryCustomResourceLocationCategoryPoliciesArgs = {
  categoryIds: Array<Scalars['ID']>;
  locationId: Scalars['ID'];
  organizationId: Scalars['ID'];
};


export type QueryCustomResourcePoliciesArgs = {
  organizationId: Scalars['ID'];
  resourceId: Scalars['ID'];
};


export type QueryCustomResourceProspectivePoliciesArgs = {
  locationId: Scalars['ID'];
  organizationId: Scalars['ID'];
  resourceId: Scalars['ID'];
  templateId: Scalars['ID'];
};


export type QueryCustomResourceReservationsArgs = {
  localRangeEndDate: Scalars['IsoDateOnlyString'];
  localRangeStartDate: Scalars['IsoDateOnlyString'];
  organizationId: Scalars['ID'];
  resourceInstanceIds: Array<Scalars['ID']>;
};


export type QueryCustomResourceReservationsForCurrentUserGroupedByDateArgs = {
  duration: Scalars['ISO8601_Duration'];
  localDates: Array<Scalars['IsoDateOnlyString']>;
  localStartTime: Scalars['IsoLocalTimeString'];
  organizationId: Scalars['ID'];
};


export type QueryCustomResourceReservationsGroupedByDateArgs = {
  duration: Scalars['ISO8601_Duration'];
  localDates: Array<Scalars['IsoDateOnlyString']>;
  localEndTime?: InputMaybe<Scalars['IsoLocalTimeString']>;
  localStartTime: Scalars['IsoLocalTimeString'];
  organizationId: Scalars['ID'];
  resourceInstanceIds: Array<Scalars['ID']>;
};


export type QueryCustomResourcesPoliciesArgs = {
  organizationId: Scalars['ID'];
  resourceIds: Array<Scalars['ID']>;
};


export type QueryDeskAllowsIssueReportsArgs = {
  deskId: Scalars['ID'];
};


export type QueryDeskReservationChangedOnLevelTokenArgs = {
  levelIds: Array<Scalars['ID']>;
};


export type QueryDeskReservationMapQueryStateTokenArgs = {
  levelIds: Array<Scalars['ID']>;
};


export type QueryDoIHaveACalendarArgs = {
  cacheRefresh?: InputMaybe<Scalars['Boolean']>;
};


export type QueryExportDraftChangesArgs = {
  id: Scalars['ID'];
};


export type QueryGetAccountUsersByIdsArgs = {
  filterBy?: InputMaybe<Scalars['String']>;
  ids: Array<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sortByField?: InputMaybe<Array<InputMaybe<UserSortBy>>>;
  sortOrder?: InputMaybe<UserSortOrder>;
};


export type QueryGetActiveAnnouncementsByLocationIdArgs = {
  locationId: Scalars['ID'];
};


export type QueryGetActiveAnnouncementsByLocationIdsArgs = {
  locationIds: Array<Scalars['ID']>;
};


export type QueryGetActiveDistributionsByAuthorIdArgs = {
  authorId: Scalars['ID'];
  service?: InputMaybe<Scalars['String']>;
};


export type QueryGetActiveDistributionsByOrganizationIdArgs = {
  organizationId: Scalars['ID'];
  service?: InputMaybe<Scalars['String']>;
};


export type QueryGetActiveVisitTypesForOrgArgs = {
  locationId?: InputMaybe<Scalars['String']>;
};


export type QueryGetActivitiesSummaryForTimeRangeByLocationIdsArgs = {
  input: ActivitiesForTimeRangeByLocationIdsInput;
  pagingInput?: InputMaybe<ActivitiesForTimeRangeByLocationIdsPagingInput>;
};


export type QueryGetActivityChatNewerMessagesArgs = {
  activityID: Scalars['ID'];
  messagesAfter: Scalars['ID'];
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type QueryGetActivityChatRemovedMessagesSinceArgs = {
  activityID: Scalars['ID'];
  since: Scalars['ISODateTime'];
};


export type QueryGetActivityChatTailArgs = {
  activityID: Scalars['ID'];
  messagesPriorTo?: InputMaybe<Scalars['ID']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type QueryGetActivityCoverImagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['ID']>;
  searchTerm?: InputMaybe<Scalars['String']>;
};


export type QueryGetActivityForCurrentUserByIdArgs = {
  id: Scalars['ID'];
  joinedLimit?: InputMaybe<Scalars['Int']>;
};


export type QueryGetAllActivitiesForDateByLocationIdsArgs = {
  input?: InputMaybe<ActivitiesForDateByLocationIdsInput>;
};


export type QueryGetAllActivitiesForDateRangeByLocationIdsArgs = {
  input?: InputMaybe<ActivitiesForDateRangeByLocationIdsInput>;
};


export type QueryGetAllJoinedUsersByActivityIdArgs = {
  activityId: Scalars['ID'];
};


export type QueryGetAllVisitsArgs = {
  dateFilter: DateFilterMandatoryInput;
  excludeCanceledVisits?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  locationIdFilter: Array<Scalars['ID']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryGetAmenitiesByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryGetAmenityByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetAnalyticsAuthorizationTokenArgs = {
  organizationId: Scalars['ID'];
};


export type QueryGetAnnouncementByIdArgs = {
  announcementId: Scalars['ID'];
};


export type QueryGetAnnouncementForLocationByIdArgs = {
  announcementId: Scalars['ID'];
  locationId: Scalars['ID'];
};


export type QueryGetAnnouncementViewAcknowledgeCountArgs = {
  announcementId: Scalars['ID'];
};


export type QueryGetAnnouncementsArgs = {
  locationId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<AnnouncementStatus>;
};


export type QueryGetAnyDeskByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetAnyDesksByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryGetArrivalDisplayArgs = {
  id: Scalars['ID'];
};


export type QueryGetArrivalDisplaysArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  isLinkedWithBadgePrinter?: InputMaybe<Scalars['Boolean']>;
  locationId?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  seekKey?: InputMaybe<Scalars['ID']>;
  sortKey?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['String']>;
};


export type QueryGetAuthedTeamUsersByNameArgs = {
  teamName: Scalars['String'];
};


export type QueryGetAutoDeskBookingByUserIdArgs = {
  userId: Scalars['ID'];
};


export type QueryGetAvailableFloorsArgs = {
  buildingId: Scalars['ID'];
};


export type QueryGetBadgeCsvUploadStatusArgs = {
  input: GetBadgeCsvUploadStatusInput;
};


export type QueryGetBadgeCsvUploadsForCurrentTenantArgs = {
  pagination?: InputMaybe<GetBadgeCsvUploadsForCurrentTenantPagination>;
};


export type QueryGetBadgePrinterArgs = {
  id: Scalars['ID'];
};


export type QueryGetBadgePrintersArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  locationId?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  seekKey?: InputMaybe<Scalars['ID']>;
  sortKey?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['String']>;
};


export type QueryGetBadgePrintersByLocationIdArgs = {
  locationId: Scalars['ID'];
};


export type QueryGetBookingWindowPoliciesByIdArgs = {
  locationId: Scalars['ID'];
  policyIds: Array<Scalars['ID']>;
};


export type QueryGetBookingWindowPoliciesForLocationArgs = {
  locationId: Scalars['ID'];
};


export type QueryGetBookingWindowPolicyByIdArgs = {
  locationId: Scalars['ID'];
  policyId: Scalars['ID'];
};


export type QueryGetBuildingGeofenceArgs = {
  input: GetBuildingGeofenceInput;
};


export type QueryGetBulkAnnouncementViewAcknowledgeCountArgs = {
  announcementIds: Array<Scalars['ID']>;
};


export type QueryGetCampusByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetCampusesByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryGetCheckedInVisitsByPartialEmailArgs = {
  email: Scalars['String'];
  includeCheckedOutVisits?: InputMaybe<Scalars['Boolean']>;
  locationId?: InputMaybe<Scalars['String']>;
  minutesAfter?: InputMaybe<Scalars['Int']>;
  minutesBefore?: InputMaybe<Scalars['Int']>;
  resultLimiter?: InputMaybe<Scalars['Int']>;
};


export type QueryGetCredentialDetailsForCurrentTenantArgs = {
  input: GetCredentialDetailsForCurrentTenantInput;
};


export type QueryGetCredentialOrganizationAndLocationInfoForCurrentTenantArgs = {
  input: GetCredentialOrganizationAndLocationInfoForCurrentTenantInput;
};


export type QueryGetCustomResourceTemplatesArgs = {
  organizationID: Scalars['ID'];
};


export type QueryGetCustomVisitFormCountArgs = {
  locationId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetCustomVisitFormsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['ID']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<CustomVisitFormOrderBy>;
};


export type QueryGetDaysOfWeekGroupedByResourceReservationArgs = {
  organizationId: Scalars['ID'];
  reservationIds: Array<Scalars['ID']>;
};


export type QueryGetDeliveriesArgs = {
  filters?: InputMaybe<DeliveryFilterOptions>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DeliveriesOrderBy>;
  searchTerm?: InputMaybe<Scalars['String']>;
};


export type QueryGetDeliveriesCountArgs = {
  filters?: InputMaybe<DeliveryFilterOptions>;
  searchTerm?: InputMaybe<Scalars['String']>;
};


export type QueryGetDeliveryByIdArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryGetDeliveryZoneCountArgs = {
  filters?: InputMaybe<DeliveryZoneFilterOptions>;
};


export type QueryGetDeliveryZonesArgs = {
  filters?: InputMaybe<DeliveryZoneFilterOptions>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryGetDeskAvailabilityByLevelIdForMeArgs = {
  filters?: InputMaybe<GetDeskAvailabilityByLevelIdFiltersInput>;
  scope: GetDeskAvailabilityByLevelIdScopeInput;
  viewOptions: GetDeskAvailabilityByLevelIdViewOptionsInput;
};


export type QueryGetDeskByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetDeskExclusionByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetDeskExclusionsByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryGetDeskReservationByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetDeskReservationInstancesByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetDeskReservationInstancesBySeriesIdsArgs = {
  seriesIds: Array<Scalars['ID']>;
};


export type QueryGetDeskReservationsByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryGetDeskReservationsByLevelIdArgs = {
  endTime: Scalars['Date'];
  levelId: Scalars['ID'];
  recurrence?: InputMaybe<Scalars['String']>;
  startTime: Scalars['Date'];
};


export type QueryGetDeskReservationsByLocationIdArgs = {
  endTime: Scalars['Date'];
  locationId: Scalars['ID'];
  recurrence?: InputMaybe<Scalars['String']>;
  startTime: Scalars['Date'];
};


export type QueryGetDeskReservationsBySeatIdArgs = {
  deskId: Scalars['ID'];
  duration: Scalars['Int'];
  filter?: InputMaybe<DeskReservationFilter>;
  startTime: Scalars['ISODateTime'];
};


export type QueryGetDeskReservationsBySeatIdsArgs = {
  deskIds: Array<Scalars['ID']>;
  duration: Scalars['Int'];
  filter?: InputMaybe<DeskReservationFilter>;
  startTime: Scalars['ISODateTime'];
};


export type QueryGetDeskReservationsBySpaceIdsArgs = {
  endTime: Scalars['ISODateTime'];
  spaceIds: Array<Scalars['ID']>;
  startTime: Scalars['ISODateTime'];
};


export type QueryGetDeskReservationsByUserIdArgs = {
  endTime: Scalars['Date'];
  id: Scalars['ID'];
  startTime: Scalars['Date'];
};


export type QueryGetDeskReservationsByUserIdsArgs = {
  endTime: Scalars['Date'];
  ids: Array<Scalars['ID']>;
  startTime: Scalars['Date'];
};


export type QueryGetDeskReservationsByZoneIdArgs = {
  endTime: Scalars['Date'];
  recurrence?: InputMaybe<Scalars['String']>;
  startTime: Scalars['Date'];
  zoneId: Scalars['ID'];
};


export type QueryGetDeskReservationsForUsersAtLocationGroupedByDateAscendingArgs = {
  endTime: Scalars['ISODateTime'];
  locationId: Scalars['ID'];
  startTime: Scalars['ISODateTime'];
  userIds: Array<Scalars['ID']>;
};


export type QueryGetDeskReservationsForUsersGroupedByDateAscendingArgs = {
  endTime: Scalars['Date'];
  ids: Array<Scalars['ID']>;
  startTime: Scalars['Date'];
};


export type QueryGetDesksByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryGetDesksWithAssigneesByLevelIdArgs = {
  levelId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type QueryGetDisabledDeskByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetDisabledDesksByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryGetDistributionByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetDistributionsByAnnouncementIdArgs = {
  announcementId: Scalars['ID'];
};


export type QueryGetDraftAuditLogsArgs = {
  draftId: Scalars['ID'];
  filters?: InputMaybe<DraftAuditLogFilters>;
  pagination?: InputMaybe<DraftAuditPaginationInput>;
};


export type QueryGetDraftCollaboratorsArgs = {
  draftId: Scalars['ID'];
};


export type QueryGetDraftConflictsArgs = {
  draftId: Scalars['ID'];
};


export type QueryGetDraftStatusArgs = {
  draftId: Scalars['ID'];
};


export type QueryGetDraftsListArgs = {
  filters?: InputMaybe<DraftFiltersInput>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  sortBy?: InputMaybe<DraftsSort>;
};


export type QueryGetEmployeeVisitsAtLocationForEmployeeArgs = {
  employeeId: Scalars['ID'];
  endTime: Scalars['ISODateTime'];
  filterSetting?: InputMaybe<EmployeeVisitFilterSetting>;
  locationId: Scalars['ID'];
  startTime: Scalars['ISODateTime'];
};


export type QueryGetEmployeeVisitsForUsersAtLocationGroupedByDateAscendingArgs = {
  endTime: Scalars['ISODateTime'];
  locationId: Scalars['ID'];
  startTime: Scalars['ISODateTime'];
  userIds: Array<Scalars['ID']>;
};


export type QueryGetEphemeralDownloadUrlForScannedTicketFileArgs = {
  fileId: Scalars['String'];
  ticketIdentifier: TicketIdentifierInput;
};


export type QueryGetEventAuditLogsArgs = {
  input: GetEventAuditLogsInput;
};


export type QueryGetEventAuditLogsByEventIdArgs = {
  input: GetEventAuditLogsByEventIdInput;
};


export type QueryGetEventByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetEventsWithCheckInStatusForProxiedEventIdArgs = {
  externalAccountType: Scalars['String'];
  proxiedEventId: Scalars['ID'];
  timeContext: Scalars['String'];
};


export type QueryGetExternalAccountStatusArgs = {
  type: ExternalAccountType;
  userId: Scalars['ID'];
};


export type QueryGetExternalEventsArgs = {
  endDate?: InputMaybe<Scalars['Date']>;
  startDate?: InputMaybe<Scalars['Date']>;
};


export type QueryGetGallagherDoorsByIntegrationUuidArgs = {
  input: GetGallagherDoorsByIntegrationUuidInput;
};


export type QueryGetGenetecDoorsByIntegrationUuidArgs = {
  input: GetGenetecDoorsByIntegrationUuidInput;
};


export type QueryGetGoogleBuildingsArgs = {
  externalAccountId: Scalars['String'];
};


export type QueryGetGoogleWorkingLocationSyncSettingForUserArgs = {
  userId: Scalars['ID'];
};


export type QueryGetGroupsByKeywordArgs = {
  keyword: Scalars['String'];
  organizationId: Scalars['ID'];
};


export type QueryGetGuestInviteByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetGuestInviteCountArgs = {
  dateFilter?: InputMaybe<DateFilterOptionalInput>;
  excludeCanceled?: InputMaybe<Scalars['Boolean']>;
  hostUserIds?: InputMaybe<Array<Scalars['ID']>>;
  locationIdFilter?: InputMaybe<Array<Scalars['ID']>>;
  status?: InputMaybe<GuestInviteStatus>;
  visitId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetGuestInvitesArgs = {
  dateFilter?: InputMaybe<DateFilterOptionalInput>;
  excludeCanceled?: InputMaybe<Scalars['Boolean']>;
  hostUserIds?: InputMaybe<Array<Scalars['ID']>>;
  limit?: InputMaybe<Scalars['Int']>;
  locationIdFilter?: InputMaybe<Array<Scalars['ID']>>;
  offset?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<GuestInviteStatus>;
  visitId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetGuestVisitByIdArgs = {
  guestVisitId: Scalars['ID'];
};


export type QueryGetGuestsByEmailsAndLocationsArgs = {
  emails: Array<Scalars['String']>;
  locationIds: Array<Scalars['String']>;
};


export type QueryGetInOfficeDataByLocationArgs = {
  endTime: Scalars['ISODateTime'];
  locationId: Scalars['ID'];
  startTime: Scalars['ISODateTime'];
};


export type QueryGetInOfficeDataByLocationByDayArgs = {
  dateRanges: Array<DateRangeInput>;
  locationId: Scalars['ID'];
};


export type QueryGetInOfficeDataByUserIdsAndLocationArgs = {
  endTime: Scalars['ISODateTime'];
  locationId: Scalars['ID'];
  startTime: Scalars['ISODateTime'];
  userIds: Array<Scalars['ID']>;
};


export type QueryGetIntegrationByExternalIdArgs = {
  externalId: Scalars['ID'];
};


export type QueryGetIntegrationByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetIntegrationByOrgIdArgs = {
  orgId: Scalars['ID'];
};


export type QueryGetLegacyIntegrationByUserIdArgs = {
  resourceType: Scalars['String'];
  type: Scalars['String'];
  userId: Scalars['ID'];
};


export type QueryGetLegacyIntegrationExistsByTypeArgs = {
  resourceType: LegacyIntegrationResourceType;
  type: LegacyIntegrationType;
};


export type QueryGetLegacyIntegrationsByOrgIdArgs = {
  orgId: Scalars['ID'];
  resourceType: Scalars['String'];
  type: Scalars['String'];
};


export type QueryGetLevelByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetLevelSettingsArgs = {
  levelId: Scalars['ID'];
};


export type QueryGetLevelsByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryGetLocationByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetLocationByRemoteGoogleIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetLocationsByFiltersInCurrentTenantArgs = {
  filters: LocationFilters;
};


export type QueryGetLocationsByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryGetMeetingServiceByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetMeetingServiceRequestByIdentifierArgs = {
  identifier: MeetingServiceRequestIdentifierInput;
};


export type QueryGetMicrosoftGraphMigrationProgressArgs = {
  organizationId: Scalars['ID'];
};


export type QueryGetMicrosoftGraphMigrationReportArgs = {
  orderBy: Scalars['String'];
  organizationId: Scalars['ID'];
  page: Scalars['Int'];
};


export type QueryGetMobileGeofencesForMeInTenantArgs = {
  input: GetMobileGeofencesForMeInTenantInput;
};


export type QueryGetMyEventsInTheRangeArgs = {
  endTime: Scalars['Date'];
  limit?: InputMaybe<Scalars['Int']>;
  startTime: Scalars['Date'];
};


export type QueryGetMyEventsInTheRangeWithCheckInStatusArgs = {
  endTime: Scalars['Date'];
  limit?: InputMaybe<Scalars['Int']>;
  startTime: Scalars['Date'];
  timeContext: Scalars['String'];
};


export type QueryGetMyUnacknowledgedActiveAnnouncementsByLocationIdArgs = {
  locationId: Scalars['ID'];
};


export type QueryGetMyUnacknowledgedActiveAnnouncementsByLocationIdsArgs = {
  locationIds: Array<Scalars['ID']>;
};


export type QueryGetMyWorkPolicyWithProgressArgs = {
  myTimezone: Scalars['String'];
};


export type QueryGetNeighborhoodByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetNeighborhoodColorDefinitionByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetNeighborhoodsForFloorArgs = {
  floorId: Scalars['ID'];
};


export type QueryGetNeighborhoodsInDraftForFloorArgs = {
  floorIds: Array<Scalars['Int']>;
};


export type QueryGetOfficeAdminsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locationId: Scalars['ID'];
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryGetOrganizationByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetOrganizationByIntegrationArgs = {
  externalId: Scalars['String'];
  type: Scalars['String'];
};


export type QueryGetOrganizationExternalAccountArgs = {
  externalId: Scalars['ID'];
  type?: InputMaybe<Scalars['String']>;
};


export type QueryGetOrganizationIdHashArgs = {
  organizationId: Scalars['ID'];
};


export type QueryGetOrganizationNotificationSettingsArgs = {
  organizationId: Scalars['ID'];
};


export type QueryGetOrganizationsByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryGetOrganizationsByUserEmailArgs = {
  email: Scalars['String'];
};


export type QueryGetPagedUsersArgs = {
  filters?: InputMaybe<PagedUserFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  organizationId: Scalars['ID'];
};


export type QueryGetPagedUsersV2Args = {
  filters?: InputMaybe<PagedUserFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  organizationId: Scalars['ID'];
};


export type QueryGetPaginatedSurveyResponsesArgs = {
  filters: GetSurveyResponsesFilters;
  page: Scalars['Int'];
  perPage: Scalars['Int'];
  sortBy?: InputMaybe<GetSurveyResponsesSort>;
  surveyId: Scalars['ID'];
};


export type QueryGetPaginatedSurveyResponsesTotalPageCountArgs = {
  filters: GetSurveyResponsesFilters;
  perPage: Scalars['Int'];
  surveyId: Scalars['ID'];
};


export type QueryGetPassesByOrganizationIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetPendingSurveyResponseForUserArgs = {
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryGetPermissionsByHierarchyTypeAndIdArgs = {
  hierarchyId: Scalars['ID'];
  hierarchyType: PermissionHierarchyTarget;
  organizationId: Scalars['ID'];
  roleId: Scalars['ID'];
  targetCategory: Scalars['ID'];
};


export type QueryGetPermissionsByRoleIdsArgs = {
  organizationId: Scalars['ID'];
  roleIds: Array<Scalars['ID']>;
};


export type QueryGetPermissionsForCurrentUserByResourceIdsArgs = {
  organizationId: Scalars['ID'];
  resourceIds: Array<Scalars['ID']>;
};


export type QueryGetPinnedUserSpacesByLocationIdsArgs = {
  locationIds: Array<Scalars['ID']>;
};


export type QueryGetPublishedDraftArgs = {
  draftId: Scalars['ID'];
};


export type QueryGetPublishedDraftsArgs = {
  filters?: InputMaybe<DraftFiltersInput>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  sortBy?: InputMaybe<DraftsSort>;
};


export type QueryGetRecipientByIdArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryGetRecipientsArgs = {
  queryString?: InputMaybe<Scalars['String']>;
};


export type QueryGetReservationExclusionsArgs = {
  endDate: Scalars['Date'];
  reservationSeriesId: Scalars['ID'];
  startDate: Scalars['Date'];
};


export type QueryGetReservationsByResourceInstanceIdGroupedByDayOfWeekArgs = {
  organizationId: Scalars['ID'];
  resourceInstanceId: Scalars['ID'];
};


export type QueryGetReservationsForUserArgs = {
  from?: InputMaybe<Scalars['Date']>;
  to?: InputMaybe<Scalars['Date']>;
  userId: Scalars['ID'];
};


export type QueryGetReservationsMultiDayAvailabilitiesArgs = {
  dates: Array<Scalars['LocalDate']>;
  deskId: Scalars['ID'];
  durationInMinutes: Scalars['Int'];
  excludedReservationIds?: InputMaybe<Array<Scalars['ID']>>;
  startTime: Scalars['LocalTime'];
  timezone: Scalars['IANATimezone'];
  userId: Scalars['Int'];
};


export type QueryGetReservationsToCancelArgs = {
  deskInputs: Array<ReservationsToCancelInput>;
};


export type QueryGetRipplingAccountStateArgs = {
  organizationId: Scalars['ID'];
};


export type QueryGetRipplingWorkLocationsAndExistingMappingsArgs = {
  organizationId: Scalars['ID'];
};


export type QueryGetRobinUserInfoBySlackIdArgs = {
  externalId: Scalars['String'];
};


export type QueryGetRoleArgs = {
  organizationId: Scalars['ID'];
  roleSlug: Scalars['String'];
};


export type QueryGetRolePermissionsForCurrentUserArgs = {
  organizationId: Scalars['ID'];
  rolePermissionActions: Array<RolePermissionAction>;
};


export type QueryGetSeatIdByStickerShortCodeArgs = {
  code: Scalars['String'];
};


export type QueryGetSharedDesksSchedulesArgs = {
  deskIds: Array<Scalars['ID']>;
};


export type QueryGetShowNeighborhoodColorsSettingArgs = {
  levelId: Scalars['ID'];
};


export type QueryGetSigmaEmbedUrlArgs = {
  edit?: InputMaybe<Scalars['Boolean']>;
  hideFolderNavigation?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['ID'];
  productionShadow?: InputMaybe<Scalars['Boolean']>;
  trial?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['ID'];
  workbookUrlId: Scalars['String'];
};


export type QueryGetSigmaJwtEmbedUrlArgs = {
  edit?: InputMaybe<Scalars['Boolean']>;
  hideFolderNavigation?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['ID'];
  productionShadow?: InputMaybe<Scalars['Boolean']>;
  trial?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['ID'];
  workbookUrlId: Scalars['String'];
};


export type QueryGetSigmaWorkbookArgs = {
  workbookId: Scalars['String'];
};


export type QueryGetSingleDayEmployeeVisitsForEmployeeArgs = {
  employeeId: Scalars['ID'];
  endTime: Scalars['ISODateTime'];
  startTime: Scalars['ISODateTime'];
};


export type QueryGetSpaceByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetSpaceCalendarsByOrgIdArgs = {
  filters?: InputMaybe<SpaceCalendarFiltersInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orgId: Scalars['ID'];
};


export type QueryGetSpaceSuggestableEventsForUserArgs = {
  buildingIdThatMustContainScheduledSpaces?: InputMaybe<Scalars['ID']>;
  endTime: Scalars['ISODateTime'];
  startTime: Scalars['ISODateTime'];
  userId: Scalars['ID'];
};


export type QueryGetSpacesByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryGetStickerBatchByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetStickerByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetStickerByShortCodeArgs = {
  code: Scalars['String'];
};


export type QueryGetStickersByOrgIdArgs = {
  orgId: Scalars['ID'];
};


export type QueryGetSuggestedDesksForUserArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locationId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type QueryGetSuggestedSpacesForEventsArgs = {
  input: GetSuggestedSpacesForEventsInput;
};


export type QueryGetSuggestedSpacesForTimeFrameArgs = {
  input: GetSuggestedSpacesForTimeFrameInput;
};


export type QueryGetSurveyResponseRatingSummaryArgs = {
  filters: GetSurveyResponsesFilters;
  surveyId: Scalars['ID'];
};


export type QueryGetSurveyResponseStatusSummaryArgs = {
  filters: GetSurveyResponsesFilters;
  surveyId: Scalars['ID'];
};


export type QueryGetSurveyResponsesArgs = {
  buildingIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  inOfficeAtEnd: Scalars['ISODateTime'];
  inOfficeAtStart: Scalars['ISODateTime'];
  includeIncomplete?: InputMaybe<Scalars['Boolean']>;
  ratings?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sortBy?: InputMaybe<GetSurveyResponsesSort>;
  surveyId: Scalars['ID'];
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryGetTeamUsersByNameArgs = {
  teamName: Scalars['String'];
};


export type QueryGetTeamsUserNotificationSettingsArgs = {
  userId: Scalars['ID'];
};


export type QueryGetTenantIdByMagicLinkArgs = {
  magicLink: Scalars['String'];
};


export type QueryGetTimeZonesForRipplingAddressesArgs = {
  input: GetTimeZonesForRipplingAddressesInput;
};


export type QueryGetUnauthorizedArrivalDisplayDetailsArgs = {
  orgId: Scalars['ID'];
  registrationCode: Scalars['ArrivalDisplayRegistrationKey'];
};


export type QueryGetUnhealthySpaceCalendarsForNotificationsArgs = {
  cursor?: InputMaybe<Scalars['ID']>;
  orgLimit?: InputMaybe<Scalars['Int']>;
};


export type QueryGetUpdatePermissionsForEventsArgs = {
  endTime: Scalars['ISODateTime'];
  eventIds: Array<Scalars['ID']>;
  startTime: Scalars['ISODateTime'];
};


export type QueryGetUserAcknowledgementByAnnouncementIdArgs = {
  announcementId: Scalars['ID'];
  locationId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type QueryGetUserAssignmentsArgs = {
  userIds: Array<InputMaybe<Scalars['ID']>>;
};


export type QueryGetUserByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetUserInOfficeDataByDayArgs = {
  dateRanges: Array<DateRangeInput>;
  id: Scalars['ID'];
};


export type QueryGetUserNotificationPreferencesArgs = {
  userId: Scalars['ID'];
};


export type QueryGetUserNotificationSettingsArgs = {
  userId: Scalars['ID'];
};


export type QueryGetUserSettingArgs = {
  settingSlug: Scalars['String'];
  userId: Scalars['ID'];
};


export type QueryGetUserSyncStatusArgs = {
  syncId: Scalars['ID'];
};


export type QueryGetUsersByEmailsArgs = {
  emails: Array<Scalars['String']>;
};


export type QueryGetUsersByIdsArgs = {
  filterBy?: InputMaybe<Scalars['String']>;
  ids: Array<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sortByField?: InputMaybe<Array<InputMaybe<UserSortBy>>>;
  sortOrder?: InputMaybe<UserSortOrder>;
};


export type QueryGetUsersByKeywordArgs = {
  keyword: Scalars['String'];
  organizationId: Scalars['ID'];
};


export type QueryGetUsersByRoleArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  organizationId: Scalars['ID'];
  roleQuery?: InputMaybe<Scalars['String']>;
  roleSlug?: InputMaybe<Scalars['String']>;
};


export type QueryGetUsersForTeamsArgs = {
  name: Scalars['String'];
  organizationId: Scalars['ID'];
};


export type QueryGetUsersWithPermissionOnHierarchyResourceArgs = {
  hierarchyType: Scalars['String'];
  orgId: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  permission: Scalars['String'];
  resourceId: Scalars['ID'];
};


export type QueryGetVisitAsyncRequestStatusArgs = {
  visitId: Scalars['ID'];
};


export type QueryGetVisitByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetVisitByMagicLinkArgs = {
  magicLink: Scalars['String'];
};


export type QueryGetVisitCountArgs = {
  dateFilter: DateFilterMandatoryInput;
  excludeCanceledVisits?: InputMaybe<Scalars['Boolean']>;
  locationIdFilter: Array<Scalars['ID']>;
};


export type QueryGetVisitorManagementPermissionsArgs = {
  locationId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetVisitsByEmailArgs = {
  email: Scalars['String'];
  locationId?: InputMaybe<Scalars['String']>;
  minutesAfter?: InputMaybe<Scalars['Int']>;
  minutesBefore?: InputMaybe<Scalars['Int']>;
};


export type QueryGetWaitlistForMeArgs = {
  context?: InputMaybe<GetWaitlistForMeContext>;
};


export type QueryGetWaitlistsForMeArgs = {
  context?: InputMaybe<GetWaitlistsForMeContext>;
};


export type QueryGetWhoIsOnsiteByLevelArgs = {
  levelId: Scalars['ID'];
};


export type QueryGetWhoIsOnsiteByLocationArgs = {
  locationId: Scalars['ID'];
};


export type QueryGetWhosInDataByLocationArgs = {
  date?: InputMaybe<Scalars['LocalDate']>;
  locationId: Scalars['ID'];
};


export type QueryGetWhosInDataByLocationByDayArgs = {
  dates?: InputMaybe<Array<Scalars['LocalDate']>>;
  locationId: Scalars['ID'];
};


export type QueryGetWhosInDataByLocationsByDayArgs = {
  dates: Array<Scalars['LocalDate']>;
  locationIds: Array<Scalars['ID']>;
};


export type QueryGetWhosInDataForLocationsArgs = {
  date?: InputMaybe<Scalars['LocalDate']>;
  locationIds: Array<Scalars['ID']>;
};


export type QueryGetWorkAreaByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetWorkAreasByLevelArgs = {
  levelId: Scalars['ID'];
};


export type QueryGetWorkAreasByOrganizationIdsArgs = {
  organizationIds: Array<Scalars['ID']>;
};


export type QueryGetWorkPolicyByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetZoneByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetZonesByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryInsightsAssistantConversationV1Args = {
  id: Scalars['ID'];
};


export type QueryInsightsAssistantConversationsForOrganizationV1Args = {
  organizationId: Scalars['ID'];
};


export type QueryInsightsAssistantConversationsForOrganizationV2Args = {
  organizationId: Scalars['ID'];
};


export type QueryInsightsAssistantFeedbackV1Args = {
  conversationId: Scalars['ID'];
  messageId: Scalars['ID'];
};


export type QueryInsightsAssistantMessagesForOrganizationV1Args = {
  conversationId: Scalars['ID'];
  createdAfter?: InputMaybe<Scalars['DateTime']>;
  organizationId: Scalars['ID'];
};


export type QueryInsightsAssistantMessagesV1Args = {
  conversationId: Scalars['ID'];
  createdAfter?: InputMaybe<Scalars['DateTime']>;
};


export type QueryInternalCustomResourceReservationsForUserInLocationArgs = {
  duration?: InputMaybe<Scalars['ISO8601_Duration']>;
  locationId: Scalars['ID'];
  organizationId: Scalars['ID'];
  unconfirmedOnly: Scalars['Boolean'];
  userId: Scalars['ID'];
  utcStartTime?: InputMaybe<Scalars['ISO8601Timestamp']>;
};


export type QueryInternalPermissionUserOrgActionArgs = {
  actions: Array<QueryablePermissionAction>;
  orgId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type QueryInternalResourceArgs = {
  id: Scalars['ID'];
  organizationId: Scalars['ID'];
};


export type QueryIsFeatureFlagEnabledForDeviceOrgArgs = {
  flagType?: InputMaybe<DeviceFeatureFlagType>;
};


export type QueryIsFeatureFlagEnabledForOrgOrMeArgs = {
  flagType?: InputMaybe<FeatureFlagType>;
};


export type QueryIsPassiveCheckInFeatureEnabledForBuildingArgs = {
  input: IsPassiveCheckInFeatureEnabledForBuildingInput;
};


export type QueryIsRipplingAccountConnectedForOrganizationArgs = {
  organizationId: Scalars['ID'];
};


export type QueryLevelChangeDetectionTokenArgs = {
  levelId: Scalars['ID'];
};


export type QueryListBuildingCidrsArgs = {
  input: ListBuildingCidrsInput;
};


export type QueryListMeetingServiceRequestsArgs = {
  input: ListMeetingServiceRequestsInput;
};


export type QueryListMeetingServicesArgs = {
  input: ListMeetingServicesInput;
};


export type QueryListMeetingServicesAvailableInSpaceArgs = {
  input: ListMeetingServicesAvailableInSpaceInput;
};


export type QueryListMeetingServicesCategoriesArgs = {
  input: ListMeetingServicesCategoriesInput;
};


export type QueryListUniqueAssigneesForMeetingServicesArgs = {
  input: ListUniqueAssigneesForMeetingServicesInput;
};


export type QueryListUniqueMeetingServiceRequestValuesArgs = {
  input: ListUniqueMeetingServiceRequestValuesInput;
};


export type QueryParseDeliveryTextArgs = {
  text: Scalars['String'];
  textType: DeliveryTextType;
};


export type QueryReservationsMultiDayGroupedByDateArgs = {
  dates: Array<Scalars['LocalDate']>;
  deskIds: Array<Scalars['ID']>;
  durationInMinutes: Scalars['Int'];
  startTime: Scalars['LocalTime'];
  timezone: Scalars['IANATimezone'];
  userId: Scalars['Int'];
};


export type QueryResourceDetailsArgs = {
  organizationId: Scalars['ID'];
  resourceIds: Array<Scalars['ID']>;
};


export type QueryResourceDetailsByFloorArgs = {
  floorId: Scalars['ID'];
  organizationId: Scalars['ID'];
};


export type QueryResourceEventConsistencyArgs = {
  eventTypes: Array<Scalars['ID']>;
  organizationId: Scalars['ID'];
};


export type QueryResourceMixedTypeRecurringValidateArgs = {
  clientType: ClientType;
  duration: Scalars['ISO8601_Duration'];
  endReservationIds?: InputMaybe<Array<Scalars['ID']>>;
  organizationId: Scalars['ID'];
  recurringReservationRequestExclusions?: InputMaybe<Array<RecurringReservationRequest>>;
  recurringReservationRequests: Array<RecurringReservationRequest>;
  requestReservationDates?: InputMaybe<Array<LocaleDateTimePair>>;
  reservationRequestDateExclusions?: InputMaybe<Array<LocaleDateTimePair>>;
  reservee: Scalars['ID'];
  resourceInstanceIds: Array<Scalars['ID']>;
};


export type QueryResourceReservationExclusionsArgs = {
  endDate: Scalars['IsoDateOnlyString'];
  organizationId: Scalars['ID'];
  reservationId: Scalars['ID'];
  startDate: Scalars['IsoDateOnlyString'];
};


export type QueryResourceReservationInstancesGroupedByReservationIdArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  organizationId: Scalars['ID'];
  reservationQueries: Array<ReservationInstanceQueryInput>;
};


export type QueryResourceReservationRecurringValidateArgs = {
  clientType: ClientType;
  duration: Scalars['ISO8601_Duration'];
  endReservationIds?: InputMaybe<Array<Scalars['ID']>>;
  organizationId: Scalars['ID'];
  recurringReservationRequestExclusions?: InputMaybe<Array<RecurringReservationRequest>>;
  recurringReservationRequests: Array<RecurringReservationRequest>;
  requestReservationDates?: InputMaybe<Array<LocaleDateTimePair>>;
  reservationRequestDateExclusions?: InputMaybe<Array<LocaleDateTimePair>>;
  reservationRequestType?: InputMaybe<BookingType>;
  reservee: Scalars['ID'];
  resourceInstanceIds: Array<Scalars['ID']>;
};


export type QueryResourceReservationSingleDayValidateArgs = {
  clientType: ClientType;
  date: Scalars['IsoDateOnlyString'];
  duration: Scalars['ISO8601_Duration'];
  endReservationIds?: InputMaybe<Array<Scalars['ID']>>;
  organizationId: Scalars['ID'];
  reservee: Scalars['ID'];
  resourceInstanceId: Scalars['ID'];
  startTime: Scalars['IsoLocalTimeString'];
};


export type QueryReviewDraftArgs = {
  draftId: Scalars['ID'];
};


export type QueryReviewDraftChangesArgs = {
  draftId: Scalars['ID'];
};


export type QuerySpaceAllowsIssueReportsArgs = {
  spaceId: Scalars['ID'];
};


export type QueryVisitDocumentAgreementArgs = {
  documentId: Scalars['ID'];
  visitInviteId: Scalars['ID'];
};


export type QueryVisitDocumentByDecisionIdArgs = {
  decisionId: Scalars['ID'];
};


export type QueryVisitDocumentByIdArgs = {
  id: Scalars['ID'];
};


export type QueryVisitDocumentByIdWithCustomVisitTypeArgs = {
  id: Scalars['ID'];
};


export type QueryVisitDocumentNameStatusAndTypesPageArgs = {
  filters?: InputMaybe<Array<VisitDocumentNameStatusAndTypesFilter>>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sortByField?: InputMaybe<Query_Visit_Document_Sort_By>;
  sortOrder?: InputMaybe<Query_Workflow_Sort_Order>;
};


export type QueryVisitDocumentNameStatusAndTypesPageWithCustomVisitTypeArgs = {
  filters?: InputMaybe<Array<VisitDocumentNameStatusAndTypesFilter>>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sortByField?: InputMaybe<Query_Visit_Document_Sort_By>;
  sortOrder?: InputMaybe<Query_Workflow_Sort_Order>;
};


export type QueryVisitDocumentWithNextDocumentIdArgs = {
  documentId?: InputMaybe<Scalars['ID']>;
  visitInviteId: Scalars['ID'];
  visitLocationId: Scalars['ID'];
  visitType: Scalars['String'];
};


export type QueryVisitDocumentWithNextDocumentIdWithCustomVisitTypeArgs = {
  documentId?: InputMaybe<Scalars['ID']>;
  visitInviteId: Scalars['ID'];
  visitLocationId: Scalars['ID'];
  visitType: Scalars['String'];
};


export type QueryVisitOverviewOfDocumentsArgs = {
  locationId: Scalars['ID'];
  visitInviteId: Scalars['ID'];
  visitType: Scalars['String'];
};


export type QueryVisitOverviewOfDocumentsWithCustomVisitTypeArgs = {
  locationId: Scalars['ID'];
  visitInviteId: Scalars['ID'];
  visitType: Scalars['String'];
};

export const QueryablePermissionAction = {
  ASSIGNMENT: 'ASSIGNMENT',
  /** @deprecated Use DELEGATE instead */
  ASSIGNMENT_DELEGATE: 'ASSIGNMENT_DELEGATE',
  BOOK: 'BOOK',
  BYPASS_BOOKING_POLICIES: 'BYPASS_BOOKING_POLICIES',
  CUSTOM_RESOURCE_CREATE: 'CUSTOM_RESOURCE_CREATE',
  DELEGATE: 'DELEGATE',
  MANAGE_OFFICE_AND_MAPS: 'MANAGE_OFFICE_AND_MAPS',
  SKIP_BOOKING_CONFIRMATION: 'SKIP_BOOKING_CONFIRMATION'
} as const;

export type QueryablePermissionAction = typeof QueryablePermissionAction[keyof typeof QueryablePermissionAction];
export type Recipient = {
  __typename?: 'Recipient';
  email: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  user?: Maybe<User>;
};

export type RecipientInput = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type ReconnectOpenpathAccountInput = {
  email: Scalars['String'];
  otp?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
};

export type ReconnectOpenpathAccountResponse = {
  __typename?: 'ReconnectOpenpathAccountResponse';
  uuid: Scalars['ID'];
};

export const RecurringReservationDayOfWeek = {
  FRIDAY: 'FRIDAY',
  MONDAY: 'MONDAY',
  SATURDAY: 'SATURDAY',
  SUNDAY: 'SUNDAY',
  THURSDAY: 'THURSDAY',
  TUESDAY: 'TUESDAY',
  WEDNESDAY: 'WEDNESDAY'
} as const;

export type RecurringReservationDayOfWeek = typeof RecurringReservationDayOfWeek[keyof typeof RecurringReservationDayOfWeek];
export const RecurringReservationFrequency = {
  DAILY: 'DAILY',
  HOURLY: 'HOURLY',
  MINUTELY: 'MINUTELY',
  MONTHLY: 'MONTHLY',
  SECONDLY: 'SECONDLY',
  WEEKLY: 'WEEKLY',
  YEARLY: 'YEARLY'
} as const;

export type RecurringReservationFrequency = typeof RecurringReservationFrequency[keyof typeof RecurringReservationFrequency];
export const RecurringReservationMonth = {
  APRIL: 'APRIL',
  AUGUST: 'AUGUST',
  DECEMBER: 'DECEMBER',
  FEBRUARY: 'FEBRUARY',
  JANUARY: 'JANUARY',
  JULY: 'JULY',
  JUNE: 'JUNE',
  MARCH: 'MARCH',
  MAY: 'MAY',
  NOVEMBER: 'NOVEMBER',
  OCTOBER: 'OCTOBER',
  SEPTEMBER: 'SEPTEMBER'
} as const;

export type RecurringReservationMonth = typeof RecurringReservationMonth[keyof typeof RecurringReservationMonth];
export type RecurringReservationRequest = {
  /** Hours to which the recurrence is applied. Default: undefined */
  byHour?: InputMaybe<Array<Scalars['Int']>>;
  /** Minutes to which the recurrence is applied. Default: undefined */
  byMinute?: InputMaybe<Array<Scalars['Int']>>;
  /** Months to which the recurrence is applied. Default: undefined */
  byMonth?: InputMaybe<Array<RecurringReservationMonth>>;
  /** Month-days to which the recurrence is applied. Default: undefined */
  byMonthDay?: InputMaybe<Array<Scalars['Int']>>;
  /** Seconds to which the recurrence is applied. Default: undefined */
  bySecond?: InputMaybe<Array<Scalars['Int']>>;
  /** Each given integer will specify an occurrence number, corresponding to the nth occurrence of the rule inside the frequency period. For example, a bySetPosition of [-1] if combined with a MONTHLY frequency, and a byWeekDay of [MONDAY, TUESDAY, WEDNESDAY, THURSDAY, FRIDAY], will result in the last work day of every month. */
  bySetPosition?: InputMaybe<Array<Scalars['Int']>>;
  /** Weekdays to which the recurrence is applied. Default: undefined */
  byWeekDay?: InputMaybe<Array<ByWeekDayValue>>;
  /** Week numbers to which the recurrence is applied. Default: undefined. Range 1 - 53. */
  byWeekNumber?: InputMaybe<Array<Scalars['Int']>>;
  /** Year-days to which the recurrence is applied. Default: undefined */
  byYearDay?: InputMaybe<Array<Scalars['Int']>>;
  /** Number of occurrences. Default 1 */
  count?: InputMaybe<Scalars['Int']>;
  endDateTime?: InputMaybe<LocaleDateTimePair>;
  frequency: RecurringReservationFrequency;
  /** Number of 'frequency' gaps between reservations. Default: 1 */
  interval?: InputMaybe<Scalars['Int']>;
  /** Default: Locale today, now */
  startDateTime?: InputMaybe<LocaleDateTimePair>;
  /** Default: MONDAY */
  weekStartDay?: InputMaybe<RecurringReservationDayOfWeek>;
};

export const RejectMeetingServiceRequestErrorReason = {
  CONFLICT: 'CONFLICT'
} as const;

export type RejectMeetingServiceRequestErrorReason = typeof RejectMeetingServiceRequestErrorReason[keyof typeof RejectMeetingServiceRequestErrorReason];
export type RejectMeetingServiceRequestErrorResponse = {
  __typename?: 'RejectMeetingServiceRequestErrorResponse';
  reason: RejectMeetingServiceRequestErrorReason;
};

export type RejectMeetingServiceRequestInput = {
  comment?: InputMaybe<Scalars['String']>;
  latestChangeId: Scalars['ID'];
  meetingServiceRequestId: Scalars['ID'];
};

export type RejectMeetingServiceRequestResponse = RejectMeetingServiceRequestErrorResponse | RejectMeetingServiceRequestSuccessResponse;

export type RejectMeetingServiceRequestSuccessResponse = {
  __typename?: 'RejectMeetingServiceRequestSuccessResponse';
  _?: Maybe<Scalars['Void']>;
};

export const RemoteTypeEnum = {
  /** Microsoft Exchange Calendar integration */
  EXCHANGE: 'EXCHANGE',
  /** Google Calendar integration */
  GOOGLE: 'GOOGLE',
  /** Microsoft Office 365 Calendar integration */
  OFFICE_365: 'OFFICE_365'
} as const;

export type RemoteTypeEnum = typeof RemoteTypeEnum[keyof typeof RemoteTypeEnum];
export type RemoveBookingWindowPolicyInput = {
  locationId: Scalars['ID'];
  policyId: Scalars['ID'];
};

export type RemoveBuildingGeofenceInput = {
  buildingId: Scalars['ID'];
};

export type RemoveSpaceFromEventError = {
  __typename?: 'RemoveSpaceFromEventError';
  message?: Maybe<Scalars['String']>;
  reason: RemoveSpaceFromEventErrorReasons;
};

export const RemoveSpaceFromEventErrorReasons = {
  LACKING_EVENT_UPDATE_PERMISSIONS: 'LACKING_EVENT_UPDATE_PERMISSIONS',
  UNKNOWN: 'UNKNOWN'
} as const;

export type RemoveSpaceFromEventErrorReasons = typeof RemoveSpaceFromEventErrorReasons[keyof typeof RemoveSpaceFromEventErrorReasons];
export type RemoveSpaceFromEventInput = {
  eventId: Scalars['String'];
  spaceId: Scalars['String'];
};

export type RemoveSpaceFromEventResponse = {
  __typename?: 'RemoveSpaceFromEventResponse';
  /** If the event has not been updated, an explanation will be provided */
  error?: Maybe<RemoveSpaceFromEventError>;
  /** True if event has been updated */
  eventUpdated: Scalars['Boolean'];
  /** Updated event model */
  updatedEvent?: Maybe<Event>;
};

export type ReportIssueInput = {
  description: Scalars['String'];
  isUnusable: Scalars['Boolean'];
};

export type ReportIssueResponse = {
  __typename?: 'ReportIssueResponse';
  id: Scalars['ID'];
};

export type ReportIssueWithDeskInput = {
  deskId: Scalars['ID'];
  issue: ReportIssueInput;
};

export type ReportIssueWithSpaceInput = {
  issue: ReportIssueInput;
  spaceId: Scalars['ID'];
};

export type ReportMyPresenceViaMobileGeofenceEventInput = {
  event: MobileGeofenceEventInput;
};

export type ReportMyPresenceViaMobileGeofenceEventLocationInput = {
  /** Device motion-activity when this location was recorded (eg: still, on_foot, in_vehicle). */
  activity: MobileGeofenceEventMotionActivityInput;
  /** The age of the location in milliseconds, relative to the Device system-time when the location was received. For example, if the reported age is 10000, that location was recorded 10s ago, relative to the system-time. location.timestamp + location.age = Device system-time when location was recorded. */
  age: Scalars['Int'];
  /** Device battery level when the location was recorded. */
  battery: MobileGeofenceEventBatteryInput;
  /** latitude, longitude, speed, heading, etc. */
  coords: MobileGeofenceEventCoordsInput;
  /** Event responsible for generating this location (motionchange, providerchange, geofence, heartbeat). */
  event?: InputMaybe<MobileLocationEvent>;
  /** Optional arbitrary meta-data attached to this location. */
  extras?: InputMaybe<Scalars['JSON']>;
  /** true if location was recorded while plugin is in the moving state. */
  is_moving: Scalars['Boolean'];
  /** Present (and true) if the location was generated by a "Fake Location" application or simulator. */
  mock?: InputMaybe<Scalars['Boolean']>;
  /** Distance-traveled in meters. */
  odometer: Scalars['Float'];
  /** true if the plugin is currently waiting for the best possible location to arrive. Samples are recorded when the plugin is transitioning between motion-states (moving vs stationary) or BackgroundGeolocation.getCurrentPosition. If you're manually posting location to your server, you should not persist these "samples". */
  sample?: InputMaybe<Scalars['Boolean']>;
  /** ISO-8601 UTC timestamp provided by the native location API. */
  timestamp: Scalars['ISODateTime'];
  /** Universally Unique Identifier. You can use this to match locations recorded at your server with those in the logs. It can also be used to ensure if the plugin has ever posted the same location twice. */
  uuid: Scalars['String'];
};

export type ReportMyPresenceViaMobileGeofenceEventResponse = {
  __typename?: 'ReportMyPresenceViaMobileGeofenceEventResponse';
  uuid?: Maybe<Scalars['ID']>;
};

export type ReportUserPresenceAtIpAddressInput = {
  /** Version of the app in use, e.g. 'v3.28.3 (v1)' */
  appVersion?: InputMaybe<Scalars['String']>;
  /** Unique identifier associated with user's personal device */
  deviceUuid: Scalars['ID'];
  /** Purely for logging/debugging, X-Forwarded-For or source IP is the source of truth */
  ipAddressGuess?: InputMaybe<Scalars['IPAddress']>;
  operatingSystem: OperatingSystem;
  /** e.g. the '10' in Android 10, but intentionally loose like a 'User-Agent' string. For logging/debugging. */
  operatingSystemVersion: Scalars['String'];
  /** Unique identifier for this request, for client/server log correlation */
  requestUuid: Scalars['ID'];
  /** Arbitrary string to describe what triggered this report, e.g. 'background fetch', 'background push', etc. */
  trigger?: InputMaybe<Scalars['String']>;
};

export type ReportUserPresenceAtIpAddressResponse = {
  __typename?: 'ReportUserPresenceAtIPAddressResponse';
  /** Zero or more building IDs associated with this IP address. IP addresses can be assigned to multiple buildings. */
  buildingIds: Array<Scalars['ID']>;
  /** What we think the IP address is, ignoring the provided guess. Could be null if we get malformed headers (rare). */
  ipAddress?: Maybe<Scalars['IPAddress']>;
  /** True if reported IP address matches a known IP address associated with a building */
  matchesBuilding: Scalars['Boolean'];
};

export type ReportUserPresenceFromWebClientInput = {
  clientName: Scalars['String'];
  /** Purely for logging/debugging, X-Forwarded-For or source IP is the source of truth */
  ipAddressGuess?: InputMaybe<Scalars['IPAddress']>;
};

export type ReportUserPresenceFromWebClientResponse = {
  __typename?: 'ReportUserPresenceFromWebClientResponse';
  uuid?: Maybe<Scalars['ID']>;
};

export type ReportUserPresenceInBuildingAtTimeInput = {
  buildingId: Scalars['ID'];
  timestamp: Scalars['ISODateTime'];
  trigger?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
};

export type ReportUserPresenceInBuildingAtTimeResponse = {
  __typename?: 'ReportUserPresenceInBuildingAtTimeResponse';
  uuid?: Maybe<Scalars['ID']>;
};

export const RequestMeetingServiceForDraftEventAtSpaceErrorReason = {
  /** Admin could archive the service while requester is filling out form */
  MEETING_SERVICE_IS_ARCHIVED: 'MEETING_SERVICE_IS_ARCHIVED',
  /** Admin could change availability while requester is filling out form */
  MEETING_SERVICE_NOT_AVAILABLE: 'MEETING_SERVICE_NOT_AVAILABLE',
  /** Admin published a new version while requester is filling out form. Old versions are allowed to be created for a short period of time, but that time has passed. */
  MEETING_SERVICE_VERSION_OUTDATED: 'MEETING_SERVICE_VERSION_OUTDATED'
} as const;

export type RequestMeetingServiceForDraftEventAtSpaceErrorReason = typeof RequestMeetingServiceForDraftEventAtSpaceErrorReason[keyof typeof RequestMeetingServiceForDraftEventAtSpaceErrorReason];
export type RequestMeetingServiceForDraftEventAtSpaceErrorResponse = {
  __typename?: 'RequestMeetingServiceForDraftEventAtSpaceErrorResponse';
  reason: RequestMeetingServiceForDraftEventAtSpaceErrorReason;
};

export type RequestMeetingServiceForDraftEventAtSpaceInput = {
  /** The answers to the questions on the MeetingService */
  answers: Array<AnsweredTicketQuestionInput>;
  /** The expected end time of the event instance - okay if this is wrong, will be updated on sync */
  eventEnd: DateWithTimezone;
  /** The expected start time of the event instance - okay if this is wrong, will be updated on sync */
  eventStart: DateWithTimezone;
  /** The UID that the draft Event will be created with. It is *very* important that this same UID makes it onto the Event, otherwise we cannot sync changes on the Event back to the service request. */
  eventUid: Scalars['ID'];
  meetingServiceId: Scalars['ID'];
  /** If this is a recurring event, this identifies which instance the service is requested for. If this is omitted, it is assumed that the service is requested for the first instance. */
  recurrenceId?: InputMaybe<Scalars['ID']>;
  spaceId: Scalars['ID'];
  /** The version of the MeetingService you're requesting - could be different from the latest version */
  versionId: Scalars['ID'];
};

export type RequestMeetingServiceForDraftEventAtSpaceResponse = RequestMeetingServiceForDraftEventAtSpaceErrorResponse | RequestMeetingServiceForDraftEventAtSpaceSuccessResponse;

export type RequestMeetingServiceForDraftEventAtSpaceSuccessResponse = {
  __typename?: 'RequestMeetingServiceForDraftEventAtSpaceSuccessResponse';
  meetingServiceRequestId: Scalars['ID'];
};

export const RequestMeetingServiceForExistingEventAtSpaceErrorReason = {
  /** Not fixable, must start over and create a new event. Ideally, client would prevent getting this far in the first place. */
  EVENT_HAS_NO_UID: 'EVENT_HAS_NO_UID',
  /** Admin could archive the service while requester is filling out form */
  MEETING_SERVICE_IS_ARCHIVED: 'MEETING_SERVICE_IS_ARCHIVED',
  /** Admin could change availability while requester is filling out form */
  MEETING_SERVICE_NOT_AVAILABLE: 'MEETING_SERVICE_NOT_AVAILABLE',
  /** Admin published a new version while requester is filling out form. Old versions are allowed to be created for a short period of time, but that time has passed. */
  MEETING_SERVICE_VERSION_OUTDATED: 'MEETING_SERVICE_VERSION_OUTDATED'
} as const;

export type RequestMeetingServiceForExistingEventAtSpaceErrorReason = typeof RequestMeetingServiceForExistingEventAtSpaceErrorReason[keyof typeof RequestMeetingServiceForExistingEventAtSpaceErrorReason];
export type RequestMeetingServiceForExistingEventAtSpaceErrorResponse = {
  __typename?: 'RequestMeetingServiceForExistingEventAtSpaceErrorResponse';
  reason: RequestMeetingServiceForExistingEventAtSpaceErrorReason;
};

export type RequestMeetingServiceForExistingEventAtSpaceInput = {
  /** The answers to the questions on the MeetingService */
  answers: Array<AnsweredTicketQuestionInput>;
  /** Event.id for the event that the service is being requested for. Could be an internal robin event ID or a proxied event ID. Must identify a specific instance - recurring service requests are not supported. */
  eventId: Scalars['ID'];
  meetingServiceId: Scalars['ID'];
  spaceId: Scalars['ID'];
  /** The version of the MeetingService you're requesting - could be different from the latest version */
  versionId: Scalars['ID'];
};

export type RequestMeetingServiceForExistingEventAtSpaceResponse = RequestMeetingServiceForExistingEventAtSpaceErrorResponse | RequestMeetingServiceForExistingEventAtSpaceSuccessResponse;

export type RequestMeetingServiceForExistingEventAtSpaceSuccessResponse = {
  __typename?: 'RequestMeetingServiceForExistingEventAtSpaceSuccessResponse';
  meetingServiceRequestId: Scalars['ID'];
};

export type Reservation = {
  __typename?: 'Reservation';
  accountReservee?: Maybe<AccountReservee>;
  canCheckInNow?: Maybe<Scalars['Boolean']>;
  confirmation?: Maybe<DeskConfirmation>;
  creationType?: Maybe<EventCreationType>;
  endTime?: Maybe<Scalars['String']>;
  exclusions: Array<Exclusion>;
  hasStarted?: Maybe<Scalars['Boolean']>;
  healthCheckpoint?: Maybe<HealthCheckpoint>;
  /** Reservation Id */
  id: Scalars['ID'];
  isCheckedIn?: Maybe<Scalars['Boolean']>;
  isDeclined?: Maybe<Scalars['Boolean']>;
  isFullDay?: Maybe<Scalars['Boolean']>;
  recurrence?: Maybe<Scalars['String']>;
  /** @deprecated use the account reservee, it will be scoped to the reservations org */
  reservee?: Maybe<Reservee>;
  seat: Desk;
  seriesId?: Maybe<Scalars['ID']>;
  startTime: Scalars['String'];
  timeZone?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  visibility: DeskReservationVisibility;
};

export type ReservationEdge = {
  __typename?: 'ReservationEdge';
  confirmation?: Maybe<DeskConfirmation>;
  endTime?: Maybe<Scalars['String']>;
  healthCheckpoint?: Maybe<HealthCheckpoint>;
  /** Reservation Id */
  id: Scalars['ID'];
  recurrence?: Maybe<Scalars['String']>;
  reservee?: Maybe<Reservee>;
  seat: Desk;
  seriesId?: Maybe<Scalars['ID']>;
  startTime: Scalars['String'];
  timeZone?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type ReservationInfo = {
  __typename?: 'ReservationInfo';
  desk: Scalars['String'];
  deskId: Scalars['ID'];
  end: DateTimezone;
  neighborhood?: Maybe<Scalars['String']>;
  reservee: Scalars['String'];
  start: DateTimezone;
  zone: Scalars['String'];
};

export type ReservationInstanceQueryInput = {
  /** For fetching the next page of a series, plug in the last returned cursor value to fetch the next set of data */
  fromCursor?: InputMaybe<Scalars['ID']>;
  /** ID of reservation to query */
  reservationId: Scalars['ID'];
};

/** Reservation invitee. One of the fields must be specified. */
export type ReservationInvitee = {
  /** Invitee email */
  email?: InputMaybe<Scalars['String']>;
  /** Invitee slug */
  slug?: InputMaybe<Scalars['String']>;
  /** Robin user ID */
  userId?: InputMaybe<Scalars['ID']>;
};

export type ReservationLevelChangeDetectionResponse = {
  __typename?: 'ReservationLevelChangeDetectionResponse';
  levelId: Scalars['ID'];
  token?: Maybe<Scalars['String']>;
};

export type ReservationResourcePairInput = {
  reservationId: Scalars['ID'];
  resourceId: Scalars['ID'];
};

export type ReservationSummary = {
  __typename?: 'ReservationSummary';
  reservationDatesConsecutive: Scalars['Boolean'];
  reservationDistinctTimePairs: Array<LocalTimePair>;
  reservationId: Scalars['ID'];
};

/** Visibility of reservation */
export const ReservationVisibility = {
  CONFIDENTIAL: 'CONFIDENTIAL',
  DEFAULT: 'DEFAULT',
  PERSONAL: 'PERSONAL',
  PRIVATE: 'PRIVATE',
  PUBLIC: 'PUBLIC'
} as const;

export type ReservationVisibility = typeof ReservationVisibility[keyof typeof ReservationVisibility];
/** The ID of the reservation and if it is visible to the current user. Intended use is by the Status Board to use as a reference for which reservations to hide */
export type ReservationsBySpacesForStatusBoard = {
  __typename?: 'ReservationsBySpacesForStatusBoard';
  id: Scalars['ID'];
  visibility: DeskReservationVisibility;
};

export type ReservationsToCancelInput = {
  deskId: Scalars['ID'];
  isReservable: Scalars['Boolean'];
  reservationTypes: Array<DeskType>;
  schedules: Array<SharedScheduleInput>;
};

export type ReservationsToCancelResponse = {
  __typename?: 'ReservationsToCancelResponse';
  deskId: Scalars['ID'];
  reservations: Array<Reservation>;
};

export type ReserveSpaceRequest = {
  /** Event end time (ISO format) */
  endTime?: InputMaybe<Scalars['Date']>;
  /** True if the event creator is invited to the event */
  eventCreatorIsInvited: Scalars['Boolean'];
  /** The description of the event. Defaults to empty string */
  eventDescription?: InputMaybe<Scalars['String']>;
  /** The title of the event. Defaults to empty string */
  eventTitle?: InputMaybe<Scalars['String']>;
  /** Set of included integration IDs */
  includedIntegrations: Array<Scalars['ID']>;
  /** Event invitees */
  invitees: Array<ReservationInvitee>;
  /** Is the event an all-day event? Default false */
  isAllDay?: InputMaybe<Scalars['Boolean']>;
  /** The name of the location where the event will take place. Defaults to empty string */
  locationName?: InputMaybe<Scalars['String']>;
  /** Is event pre-confirmed */
  preConfirm?: InputMaybe<Scalars['Boolean']>;
  /** ID of the reserved space */
  spaceId: Scalars['ID'];
  /** Event start time (ISO format) */
  startTime?: InputMaybe<Scalars['Date']>;
  /** Event visibility */
  visibility: ReservationVisibility;
};

/** Reservation response */
export type ReserveSpaceResponse = {
  __typename?: 'ReserveSpaceResponse';
  /** If the space has not been reserved, an explanation will be provided */
  reason?: Maybe<Scalars['String']>;
  /** True if space has been reserved */
  spaceReserved: Scalars['Boolean'];
};

export type Reservee = {
  __typename?: 'Reservee';
  email: Scalars['String'];
  participationStatus?: Maybe<ParticipationStatus>;
  user?: Maybe<User>;
  visitorId?: Maybe<Scalars['ID']>;
};

export type ResourceAllowsIssueReportsResponse = {
  __typename?: 'ResourceAllowsIssueReportsResponse';
  allowed: Scalars['Boolean'];
};

export type ResourceEventConsistencyQueryType = {
  __typename?: 'ResourceEventConsistencyQueryType';
  eventType: Scalars['ID'];
  organizationId: Scalars['ID'];
  value: Scalars['Int'];
};

export type ResourceGroupInput = {
  amenityIds?: InputMaybe<Array<Scalars['ID']>>;
  bookingType?: InputMaybe<ResourceWeeklyBookingTypeInput>;
  capacity?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  imageUrl?: InputMaybe<Scalars['String']>;
  isAccessible?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  policies?: InputMaybe<LayoutResourcePolicyInput>;
  subCategory?: InputMaybe<Scalars['String']>;
};

export type ResourceGroupSaveUpdateInput = {
  amenityIds: Array<Scalars['ID']>;
  bookingType?: InputMaybe<WeeklyBookingCommand>;
  capacity: Scalars['Int'];
  groupName?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isAccessible?: InputMaybe<Scalars['Boolean']>;
  note?: InputMaybe<Scalars['String']>;
  policyConfiguration?: InputMaybe<CustomResourcePolicyDocumentCommand>;
  resourceGroupId: Scalars['ID'];
  subCategory?: InputMaybe<Scalars['String']>;
};

export type ResourceMixedTypeRecurringValidateResponseType = {
  __typename?: 'ResourceMixedTypeRecurringValidateResponseType';
  assigned: Array<ResourceReservationRecurringValidateResponseType>;
  reservable: Array<ResourceReservationRecurringValidateResponseType>;
};

export type ResourceMutationResponseTrackingType = {
  __typename?: 'ResourceMutationResponseTrackingType';
  eventType: Scalars['ID'];
  organizationId: Scalars['ID'];
  value: Scalars['Int'];
};

export type ResourcePermission = {
  __typename?: 'ResourcePermission';
  action: ResourcePermissionAction;
  permit: Scalars['Boolean'];
};

export const ResourcePermissionAction = {
  ASSIGN: 'ASSIGN',
  BOOK: 'BOOK',
  DELEGATE: 'DELEGATE',
  SKIP_BOOKING_CONFIRMATION: 'SKIP_BOOKING_CONFIRMATION'
} as const;

export type ResourcePermissionAction = typeof ResourcePermissionAction[keyof typeof ResourcePermissionAction];
export type ResourcePermissionCollection = {
  __typename?: 'ResourcePermissionCollection';
  permissions: Array<ResourcePermission>;
  resourceId: Scalars['ID'];
};

export type ResourcePolicy = {
  __typename?: 'ResourcePolicy';
  abandonedResourceProtection?: Maybe<ResourcePolicyEnabledWithDuration>;
  advanceCheckInWindow?: Maybe<ResourcePolicyEnabledWithDuration>;
  advancedBookingThreshold?: Maybe<ResourcePolicyEnabledWithDuration>;
  allowOverlappingBookings?: Maybe<Scalars['Boolean']>;
  localCheckInOnly?: Maybe<Scalars['Boolean']>;
  maxBookingLength?: Maybe<ResourcePolicyEnabledWithDuration>;
  requireCheckIn?: Maybe<Scalars['Boolean']>;
  resourceSharing?: Maybe<Scalars['Boolean']>;
  restrictBookingToWorkingHours?: Maybe<Scalars['Boolean']>;
};

export type ResourcePolicyDuration = {
  __typename?: 'ResourcePolicyDuration';
  type: LayoutResourcePolicyDurationType;
  value: Scalars['Int'];
};

export type ResourcePolicyEnabledWithDuration = {
  __typename?: 'ResourcePolicyEnabledWithDuration';
  duration?: Maybe<ResourcePolicyDuration>;
  enabled: Scalars['Boolean'];
};

export type ResourceReservation = {
  __typename?: 'ResourceReservation';
  accountReservedBy: AccountUser;
  accountReservee: AccountUser;
  confirmationClient?: Maybe<ConfirmationClientType>;
  confirmationTimestamp?: Maybe<Scalars['ISO8601Timestamp']>;
  confirmationValidationState?: Maybe<ResourceReservationConfirmationErrorResponse>;
  date: Scalars['IsoDateOnlyString'];
  daysOfWeek: Array<RecurringReservationDayOfWeek>;
  duration: Scalars['ISO8601_Duration'];
  id: Scalars['ID'];
  isAssigned: Scalars['Boolean'];
  isConfirmed: Scalars['Boolean'];
  requestReservationDateEndDate?: Maybe<Scalars['IsoDateOnlyString']>;
  requestReservationDateStartDate?: Maybe<Scalars['IsoDateOnlyString']>;
  reservationClient?: Maybe<ClientType>;
  /** @deprecated Use reservedByUser instead */
  reservedBy: Scalars['ID'];
  reservedById: Scalars['ID'];
  reservedByUser: User;
  /** @deprecated Use reserveeUser instead */
  reservee: Scalars['ID'];
  reserveeId: Scalars['ID'];
  reserveeUser: User;
  resource: CustomResource;
  resourceInstanceId: Scalars['ID'];
  startTime: Scalars['IsoLocalTimeString'];
};

export const ResourceReservationConfirmationErrorCode = {
  ADVANCED_CONFIRMATION_WINDOW_TOO_EARLY: 'ADVANCED_CONFIRMATION_WINDOW_TOO_EARLY',
  LOCAL_CONFIRMATION_REQUIRED: 'LOCAL_CONFIRMATION_REQUIRED',
  RESERVATION_ALREADY_CONFIRMED: 'RESERVATION_ALREADY_CONFIRMED',
  RESERVATION_CONFIRMATION_WINDOW_EXPIRED: 'RESERVATION_CONFIRMATION_WINDOW_EXPIRED',
  RESERVATION_DOES_NOT_EXIST: 'RESERVATION_DOES_NOT_EXIST',
  RESERVATION_PREVIOUSLY_CANCELED: 'RESERVATION_PREVIOUSLY_CANCELED',
  TIMEZONE_CONVERSION_FAILED: 'TIMEZONE_CONVERSION_FAILED'
} as const;

export type ResourceReservationConfirmationErrorCode = typeof ResourceReservationConfirmationErrorCode[keyof typeof ResourceReservationConfirmationErrorCode];
export type ResourceReservationConfirmationErrorResponse = {
  __typename?: 'ResourceReservationConfirmationErrorResponse';
  detailedErrors: Array<ResourceReservationDetailedErrors>;
  errorCodes: Array<ResourceReservationConfirmationErrorCode>;
  id: Scalars['ID'];
};

export type ResourceReservationConfirmationResponse = ResourceReservationConfirmationErrorResponse | ResourceReservationConfirmationSuccessResponse;

export type ResourceReservationConfirmationSuccessResponse = {
  __typename?: 'ResourceReservationConfirmationSuccessResponse';
  /** eventType is null when no state is updated but result is still successful */
  eventType?: Maybe<Scalars['ID']>;
  reservationId: Scalars['ID'];
  /** value is -1 when no state is updated but result is still successful */
  value: Scalars['Int'];
};

export type ResourceReservationDetailedErrors = {
  __typename?: 'ResourceReservationDetailedErrors';
  failureCode: ResourceReservationConfirmationErrorCode;
  meta?: Maybe<Scalars['String']>;
};

export type ResourceReservationExclusion = {
  __typename?: 'ResourceReservationExclusion';
  id: Scalars['ID'];
  localDateTimePairs: Array<LocalDateTimePair>;
  reservationId: Scalars['ID'];
  reservee: Scalars['ID'];
};

export type ResourceReservationGroupedByDayOfWeek = {
  __typename?: 'ResourceReservationGroupedByDayOfWeek';
  dayOfWeek: RecurringReservationDayOfWeek;
  reservationIds: Array<Scalars['ID']>;
};

export type ResourceReservationInstancesResponseType = {
  __typename?: 'ResourceReservationInstancesResponseType';
  id: Scalars['ID'];
  /** Cursor used to load the next set of resource instance reservations. Null is returned at end of set. */
  nextCursor?: Maybe<Scalars['ID']>;
  reservationId: Scalars['ID'];
  resourceInstanceReservations: Array<ResourceReservation>;
  /** Total number of reservations instances contained in this reservation */
  totalReservationInstanceCount: Scalars['Int'];
};

export type ResourceReservationRecurringValidateResponseType = {
  __typename?: 'ResourceReservationRecurringValidateResponseType';
  resourceId: Scalars['ID'];
  validationResponse: ResourceReservationValidationResponse;
};

export type ResourceReservationValidationFailure = {
  __typename?: 'ResourceReservationValidationFailure';
  /** Only one field exists for now. This will probably change later so leaving room for additions. */
  failureType: ResourceReservationValidationFailureType;
  id: Scalars['ID'];
  meta?: Maybe<Scalars['String']>;
};

export const ResourceReservationValidationFailureType = {
  BOOKING_OVERLAPS: 'BOOKING_OVERLAPS',
  CANT_BOOK_FROM_KIOSK: 'CANT_BOOK_FROM_KIOSK',
  EXCEEDS_ADVANCED_BOOKING_THRESHOLD: 'EXCEEDS_ADVANCED_BOOKING_THRESHOLD',
  EXCEEDS_MAXIMUM_BOOKING_LENGTH: 'EXCEEDS_MAXIMUM_BOOKING_LENGTH',
  INCOHERENT_REQUEST_TO_EDIT_RESERVATION_SERIES: 'INCOHERENT_REQUEST_TO_EDIT_RESERVATION_SERIES',
  INVALID_REQUEST_TO_EDIT_PAST_RECURRING_RESERVATION_INSTANCE: 'INVALID_REQUEST_TO_EDIT_PAST_RECURRING_RESERVATION_INSTANCE',
  INVALID_REQUEST_TO_RESCHEDULE_RECURRING_RESERVATION: 'INVALID_REQUEST_TO_RESCHEDULE_RECURRING_RESERVATION',
  INVALID_REQUEST_TO_RESCHEDULE_SINGLE_DAY_RESERVATION: 'INVALID_REQUEST_TO_RESCHEDULE_SINGLE_DAY_RESERVATION',
  MISSING_BOOKING_PERMISSION: 'MISSING_BOOKING_PERMISSION',
  OUTSIDE_OF_WORKING_HOURS: 'OUTSIDE_OF_WORKING_HOURS',
  RECURRENCE_NOT_ALLOWED: 'RECURRENCE_NOT_ALLOWED',
  RESERVATION_DOES_NOT_EXIST: 'RESERVATION_DOES_NOT_EXIST',
  RESERVATION_HAS_ENDED: 'RESERVATION_HAS_ENDED',
  RESERVATION_TYPE_NOT_ALLOWED: 'RESERVATION_TYPE_NOT_ALLOWED',
  RESOURCE_BUSY: 'RESOURCE_BUSY',
  RESOURCE_DOES_NOT_EXIST: 'RESOURCE_DOES_NOT_EXIST',
  SCHEDULE_DOES_NOT_EXIST: 'SCHEDULE_DOES_NOT_EXIST',
  VIOLATES_MAXIMUM_BOOKING_THRESHOLD: 'VIOLATES_MAXIMUM_BOOKING_THRESHOLD'
} as const;

export type ResourceReservationValidationFailureType = typeof ResourceReservationValidationFailureType[keyof typeof ResourceReservationValidationFailureType];
export type ResourceReservationValidationResponse = {
  __typename?: 'ResourceReservationValidationResponse';
  errors: Array<ResourceReservationValidationFailure>;
  id: Scalars['ID'];
  policiesEvaluated: Array<PolicyType>;
  userHasPermissionToReserve: Scalars['Boolean'];
};

export type ResourceWeeklyBookingType = {
  __typename?: 'ResourceWeeklyBookingType';
  friday: BookingStatus;
  monday: BookingStatus;
  saturday: BookingStatus;
  sunday: BookingStatus;
  thursday: BookingStatus;
  tuesday: BookingStatus;
  wednesday: BookingStatus;
};

export type ResourceWeeklyBookingTypeInput = {
  friday: BookingStatus;
  monday: BookingStatus;
  saturday: BookingStatus;
  sunday: BookingStatus;
  thursday: BookingStatus;
  tuesday: BookingStatus;
  wednesday: BookingStatus;
};

export type ReviewDraftChangesResponse = {
  __typename?: 'ReviewDraftChangesResponse';
  v1: ReviewDraftChangesV1Payload;
};

export type ReviewDraftChangesV1Payload = {
  __typename?: 'ReviewDraftChangesV1Payload';
  assignments?: Maybe<Array<UserAssignmentData>>;
  deskStatistics?: Maybe<DeskStatistics>;
  desksCount?: Maybe<Scalars['Int']>;
  neighborhoods?: Maybe<Array<NeighborhoodReviewModel>>;
  reservationsToCancel?: Maybe<Array<Maybe<ReservationInfo>>>;
  settings?: Maybe<SettingsComparison>;
};

export type ReviewDraftResponse = {
  __typename?: 'ReviewDraftResponse';
  deskStatistics: DeskStatistics;
  desksCount: Scalars['Int'];
  entities: Array<Entity>;
  reservationsToCancel?: Maybe<Array<Maybe<ReservationInfo>>>;
};

export type RipplingAccount = {
  __typename?: 'RipplingAccount';
  id: Scalars['ID'];
};

export type RipplingWorkLocationWithMappingToRobinBuilding = {
  __typename?: 'RipplingWorkLocationWithMappingToRobinBuilding';
  ripplingWorkLocationAddress?: Maybe<Scalars['String']>;
  ripplingWorkLocationId: Scalars['ID'];
  ripplingWorkLocationName: Scalars['String'];
  robinBuildingId?: Maybe<Scalars['ID']>;
};

export type RipplingWorkLocationsWithMappings = {
  __typename?: 'RipplingWorkLocationsWithMappings';
  locationsWithMappings: Array<RipplingWorkLocationWithMappingToRobinBuilding>;
};

export type RobinUserInfoForSlack = {
  __typename?: 'RobinUserInfoForSlack';
  token: Scalars['String'];
  userId: Scalars['ID'];
};

export type Role = {
  __typename?: 'Role';
  created_at: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  is_default: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  organization_id: Scalars['ID'];
  policies: Array<Policy>;
  /** `schedule` is used to distinguish access roles from other roles, and has value of null (which may have distinguished meaning from empty array) by default. */
  schedule?: Maybe<Array<Scalars['String']>>;
  slug: Scalars['String'];
  updated_at?: Maybe<Scalars['String']>;
};

export type RoleCreationInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  policies?: InputMaybe<Array<RolePolicyInput>>;
  slug: Scalars['String'];
};

export type RolePermission = {
  __typename?: 'RolePermission';
  action: QueryablePermissionAction;
  categoryId?: Maybe<Scalars['ID']>;
  permit: Scalars['Boolean'];
  roleId: Scalars['ID'];
  target: PermissionHierarchyTarget;
  targetId: Scalars['ID'];
};

export const RolePermissionAction = {
  CUSTOM_RESOURCE_CREATE: 'CUSTOM_RESOURCE_CREATE'
} as const;

export type RolePermissionAction = typeof RolePermissionAction[keyof typeof RolePermissionAction];
export type RolePermissionCommand = {
  /** The actions permitted or denied by this permission */
  permissionActions: Array<RolePermissionAction>;
  /** The hierarchical grouping of resources to which this permission applies */
  permissionHierarchyTarget: PermissionHierarchyTarget;
  /** The ID of the hierarchical element that this permission applies */
  permissionHierarchyTargetId: Scalars['ID'];
  /** Whether the specified actions are permitted (true) or explicitly denied (false). */
  permit: Scalars['Boolean'];
  /** Role IDs to which this permission applies */
  roleIds: Array<Scalars['ID']>;
};

export type RolePolicyInput = {
  is_allowed: Scalars['Boolean'];
  object_id: Scalars['ID'];
  object_type?: InputMaybe<Scalars['String']>;
  permission_operation: Scalars['String'];
};

export type RollbackNeighborhoodsResponse = {
  __typename?: 'RollbackNeighborhoodsResponse';
  results: Array<OrganizationRollbackResult>;
  rollbackId: Scalars['ID'];
};

export const RollbackStatus = {
  FAILED: 'FAILED',
  ROLLED_BACK: 'ROLLED_BACK'
} as const;

export type RollbackStatus = typeof RollbackStatus[keyof typeof RollbackStatus];
export type RolloutNeighborhoodsResponse = {
  __typename?: 'RolloutNeighborhoodsResponse';
  results: Array<OrganizationRolloutResult>;
  rolloutId: Scalars['ID'];
};

export const RolloutStatus = {
  FAILED: 'FAILED',
  MIGRATED: 'MIGRATED',
  SKIPPED: 'SKIPPED'
} as const;

export type RolloutStatus = typeof RolloutStatus[keyof typeof RolloutStatus];
export type ScheduleRecurringReservationResponseType = ResourceReservationValidationResponse | ScheduleRecurringReservationSuccessType;

export type ScheduleRecurringReservationSuccessType = {
  __typename?: 'ScheduleRecurringReservationSuccessType';
  /** eventType is null when no state is updated but result is still successful */
  eventType?: Maybe<Scalars['ID']>;
  reservationId: Scalars['ID'];
  totalReservationEvents: Scalars['Int'];
  /** value is -1 when no state is updated but result is still successful */
  value: Scalars['Int'];
};

export type ScheduleSingleDayReservationResponseType = ResourceReservationValidationResponse | ScheduleSingleDayReservationSuccessType;

export type ScheduleSingleDayReservationSuccessType = {
  __typename?: 'ScheduleSingleDayReservationSuccessType';
  /** eventType is null when no state is updated but result is still successful */
  eventType?: Maybe<Scalars['ID']>;
  reservationId: Scalars['ID'];
  /** value is -1 when no state is updated but result is still successful */
  value: Scalars['Int'];
};

export const ScheduleSourceType = {
  GOOGLE: 'google',
  USER: 'user'
} as const;

export type ScheduleSourceType = typeof ScheduleSourceType[keyof typeof ScheduleSourceType];
export type SchedulingAggregateOfDesks = {
  __typename?: 'SchedulingAggregateOfDesks';
  /** Total number of desks of type Assigned that are available within the parent */
  deskAssignedAvailableTotal: Scalars['Int'];
  /** Total number of desks of type Assigned that are booked within the parent */
  deskAssignedBookedTotal: Scalars['Int'];
  /** Total number of desks of type Assigned within the parent */
  deskAssignedTotal: Scalars['Int'];
  /** Total number of desks of type Assigned that are unavailable within the parent */
  deskAssignedUnavailableTotal: Scalars['Int'];
  /** Total number of available desks within the parent */
  deskAvailableTotal: Scalars['Int'];
  /** Total number of booked desks within the parent */
  deskBookedTotal: Scalars['Int'];
  /** Total number of desks of type Hot that are available within the parent */
  deskHotAvailableTotal: Scalars['Int'];
  /** Total number of desks of type Hot that are booked within the parent */
  deskHotBookedTotal: Scalars['Int'];
  /** Total number of desks of type Hot within the parent */
  deskHotTotal: Scalars['Int'];
  /** Total number of desks of type Hot that are unavailable within the parent */
  deskHotUnavailableTotal: Scalars['Int'];
  /** Total number of desks of type Hotel that are available within the parent */
  deskHotelAvailableTotal: Scalars['Int'];
  /** Total number of desks of type Hotel that are booked within the parent */
  deskHotelBookedTotal: Scalars['Int'];
  /** Total number of desks of type Hotel within the parent */
  deskHotelTotal: Scalars['Int'];
  /** Total number of desks of type Hotel that are unavailable within the parent */
  deskHotelUnavailableTotal: Scalars['Int'];
  /** Total number of desks of type Shared that are available within the parent */
  deskSharedAvailableTotal: Scalars['Int'];
  /** Total number of desks of type Shared that are booked within the parent */
  deskSharedBookedTotal: Scalars['Int'];
  /** Total number of desks of type Shared within the parent */
  deskSharedTotal: Scalars['Int'];
  /** Total number of desks of type Shared that are unavailable within the parent */
  deskSharedUnavailableTotal: Scalars['Int'];
  /** Total number of unavailable desks within the parent */
  deskUnavailableTotal: Scalars['Int'];
};

export type SetAutoDeskBookingInput = {
  autoDeskBooking: Scalars['Boolean'];
};

export type SetBuildingCidrsInput = {
  buildingId: Scalars['ID'];
  cidrs: Array<Scalars['IPAddressCIDR']>;
};

export type SetBuildingCidrsResponse = {
  __typename?: 'SetBuildingCidrsResponse';
  buildingCidrsUpdated: Scalars['Boolean'];
  invalidCidrErrors: Array<InvalidCidrError>;
};

export type SetBuildingGeofenceAsPointWithRadiusInput = {
  buildingId: Scalars['ID'];
  center: SetBuildingGeofenceAsPointWithRadiusInputCenter;
  radius: Scalars['Float'];
};

export type SetBuildingGeofenceAsPointWithRadiusInputCenter = {
  lat: Scalars['Float'];
  lng: Scalars['Float'];
};

export type SetBuildingGeofenceAsPointWithRadiusResponse = {
  __typename?: 'SetBuildingGeofenceAsPointWithRadiusResponse';
  uuid?: Maybe<Scalars['ID']>;
};

export type SetMyHomepageInput = {
  homepage: HomepageType;
};

export type SetMyLanguageTagInput = {
  languageTag: Scalars['String'];
};

export type SetMyWorkingHoursInput = {
  workingHours: Array<UserWorkingHourInput>;
};

export type SetOrganizationNotificationSettingInput = {
  name: Scalars['String'];
  ownerId: Scalars['ID'];
  values: Array<InputMaybe<NotificationSettingType>>;
};

export type SetPassiveCheckInFeatureForBuildingInput = {
  buildingId: Scalars['ID'];
};

export type SetShowWeekendsForMeInput = {
  showWeekends: Scalars['Boolean'];
};

export type SetUserNotificationSettingInput = {
  name: Scalars['String'];
  ownerId: Scalars['ID'];
  values: Array<InputMaybe<NotificationSettingType>>;
};

export type SetWeeklyScheduleInput = {
  fri: Scalars['Boolean'];
  id?: InputMaybe<Scalars['ID']>;
  instanceEndTime?: InputMaybe<Scalars['LocalEndTime']>;
  instanceStartTime?: InputMaybe<Scalars['LocalEndTime']>;
  locationId: Scalars['String'];
  mon: Scalars['Boolean'];
  recurrenceEndDate?: InputMaybe<Scalars['LocalDate']>;
  recurrenceStartDate?: InputMaybe<Scalars['LocalDate']>;
  sat: Scalars['Boolean'];
  source: ScheduleSourceType;
  sun: Scalars['Boolean'];
  thu: Scalars['Boolean'];
  tue: Scalars['Boolean'];
  userId: Scalars['String'];
  wed: Scalars['Boolean'];
};

export type Setting = {
  __typename?: 'Setting';
  slug: Scalars['String'];
  value: Scalars['String'];
};

export type SettingChange = {
  __typename?: 'SettingChange';
  next: Scalars['Boolean'];
  previous: Scalars['Boolean'];
};

export const SettingDataType = {
  BOOLEAN: 'BOOLEAN',
  INTEGER: 'INTEGER',
  JSON: 'JSON',
  STRING: 'STRING'
} as const;

export type SettingDataType = typeof SettingDataType[keyof typeof SettingDataType];
export type SettingInput = {
  type: Scalars['String'];
  value: Scalars['String'];
};

export const SettingOwnerType = {
  USER: 'USER'
} as const;

export type SettingOwnerType = typeof SettingOwnerType[keyof typeof SettingOwnerType];
export const SettingValueType = {
  BOOLEAN: 'boolean',
  NUMBER: 'number',
  STRING: 'string'
} as const;

export type SettingValueType = typeof SettingValueType[keyof typeof SettingValueType];
export type SettingsComparison = {
  __typename?: 'SettingsComparison';
  showNeighborhoodColor?: Maybe<SettingChange>;
};

export type SharedDeskSchedule = {
  __typename?: 'SharedDeskSchedule';
  id: Scalars['ID'];
  schedule: Array<DeskSchedule>;
};

export type SharedDeskSchedulesInput = {
  deskId: Scalars['ID'];
  notifyUnassigned: Scalars['Boolean'];
  sharedSchedules: Array<SharedScheduleInput>;
};

export type SharedScheduleInput = {
  email?: InputMaybe<Scalars['String']>;
  recurrence: Scalars['String'];
  userId?: InputMaybe<Scalars['ID']>;
};

export const SigmaEmbedType = {
  CREATOR: 'CREATOR',
  VIEWER: 'VIEWER'
} as const;

export type SigmaEmbedType = typeof SigmaEmbedType[keyof typeof SigmaEmbedType];
export type SigmaEmbedUrl = {
  __typename?: 'SigmaEmbedUrl';
  url?: Maybe<Scalars['String']>;
};

export type SigmaFile = {
  __typename?: 'SigmaFile';
  badge: Scalars['String'];
  createdAt: Scalars['String'];
  createdBy: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['String'];
  isArchived: Scalars['Boolean'];
  name: Scalars['String'];
  parentId: Scalars['String'];
  parentUrlId: Scalars['String'];
  path: Scalars['String'];
  permission: Scalars['String'];
  type: Scalars['String'];
  updatedAt: Scalars['String'];
  updatedBy: Scalars['String'];
  urlId: Scalars['String'];
};

export const SigmaLocationType = {
  PERSONAL: 'PERSONAL',
  SHARED: 'SHARED'
} as const;

export type SigmaLocationType = typeof SigmaLocationType[keyof typeof SigmaLocationType];
export type SigmaTag = {
  __typename?: 'SigmaTag';
  name: Scalars['String'];
  versionTagId: Scalars['String'];
};

export type SigmaWorkbook = {
  __typename?: 'SigmaWorkbook';
  createdAt: Scalars['String'];
  createdBy: Scalars['String'];
  isArchived: Scalars['Boolean'];
  latestVersion: Scalars['Int'];
  name: Scalars['String'];
  path: Scalars['String'];
  tags?: Maybe<Array<Maybe<SigmaTag>>>;
  updatedAt: Scalars['String'];
  updatedBy: Scalars['String'];
  url: Scalars['String'];
  workbookId: Scalars['String'];
  workbookUrlId: Scalars['String'];
};

export type SimpleLocation = {
  __typename?: 'SimpleLocation';
  accountId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  remoteGoogleId?: Maybe<Scalars['String']>;
  remoteGoogleLabel?: Maybe<Scalars['String']>;
  timeZone?: Maybe<Scalars['String']>;
};

export const SnapTo = {
  FIFTEEN: 'FIFTEEN',
  SIXTY: 'SIXTY',
  THIRTY: 'THIRTY',
  ZERO: 'ZERO'
} as const;

export type SnapTo = typeof SnapTo[keyof typeof SnapTo];
export const SortDirection = {
  ASC: 'ASC',
  DESC: 'DESC'
} as const;

export type SortDirection = typeof SortDirection[keyof typeof SortDirection];
/** The order with which to sort */
export const SortOrder = {
  ASCENDING: 'ASCENDING',
  DESCENDING: 'DESCENDING'
} as const;

export type SortOrder = typeof SortOrder[keyof typeof SortOrder];
export type Space = {
  __typename?: 'Space';
  amenities: Array<SpaceAmenity>;
  /** Availability of space for the next half hour. GREEN: available for the next half hour. YELLOW: event scheduled within the next thirty minutes. RED: Event currently being held */
  availableAt?: Maybe<Availability>;
  behaviors: Array<Scalars['String']>;
  calendar?: Maybe<Calendar>;
  /** Capacity is unsigned 32bit integer. */
  capacity?: Maybe<Scalars['BigInt']>;
  /** @deprecated Deprecated in favor of confirmedAvailabilityMultiDay */
  confirmedAvailability?: Maybe<SpaceAvailability>;
  confirmedAvailabilityMultiDay?: Maybe<SpaceAvailability>;
  createdAt?: Maybe<Scalars['Date']>;
  /** Whether the current user can request meeting services in this space. Note that this does not check if the user has permission to modify the event. This is okay if the user is working on a draft event, because they will be the organizer and have permission to do anything to that event. See currentUserCanRequestMeetingServicesForEvent. */
  currentUserCanRequestMeetingServices?: Maybe<Scalars['Boolean']>;
  currentUserCanRequestMeetingServicesForEvent?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  /** @deprecated Deprecated because this field is no longer retrievable from API */
  disabledAt?: Maybe<Scalars['Date']>;
  discoveryRadius?: Maybe<Scalars['Float']>;
  eventWithCheckInStatus?: Maybe<EventWithCheckInStatus>;
  filteredDesksByAmenityIds: Array<Desk>;
  hasAnyAvailableMeetingServices?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  isAccessible?: Maybe<Scalars['Boolean']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  isManaged: Scalars['Boolean'];
  legacyAvailableWorkplaceServiceTypes: Array<Scalars['String']>;
  levelId?: Maybe<Scalars['ID']>;
  locationId: Scalars['Int'];
  meetingRoomWindowedAvailability: Array<SpaceWindowAvailability>;
  /** Returns non-cancelled meeting service requests for this space on the given event. Excludes draft requests, except those requested by the current user. null if current user lacks permission to see requests */
  meetingServiceRequests?: Maybe<Array<MeetingServiceRequest>>;
  /**
   * null if current user lacks permission to see requests
   * @deprecated Use meetingServiceRequests instead
   */
  meetingServiceRequestsForDraftEvent?: Maybe<Array<MeetingServiceRequest>>;
  name: Scalars['String'];
  permissions: Array<Permission>;
  /** A MeetingService with kind=SPACE_REQUEST_FORM that describes the form that must be completed in order to request a space with scheduleConfiguration=REQUEST_ONLY. Clients should disallow events from being created without this form being filled out. The completed form for a given space/event can be found with Space.meetingServiceRequests. */
  requestForm?: Maybe<MeetingService>;
  reservationPolicies: SpaceReservationPolicies;
  scheduleConfiguration?: Maybe<SpaceScheduleConfiguration>;
  /** The total price of all meeting service requests in this space during the given event, after any surcharges/taxes. Multiple prices can be returned if the service requests are in different currencies - no currency conversion happens. Currency codes are unique. Empty list if none of the meeting service requests have prices. */
  totalPriceOfMeetingServiceRequests?: Maybe<Array<Money>>;
  type?: Maybe<SpaceType>;
  updatedAt?: Maybe<Scalars['Date']>;
  /** @deprecated Deprecated in favor of meetingRoomWindowedAvailability */
  windowedAvailability: Array<SpaceWindowAvailability>;
  zones: Array<Zone>;
};


export type SpaceAvailableAtArgs = {
  time?: InputMaybe<Scalars['Date']>;
};


export type SpaceConfirmedAvailabilityArgs = {
  durationInMinutes?: InputMaybe<Scalars['Int']>;
  time?: InputMaybe<Scalars['ISODateTime']>;
};


export type SpaceConfirmedAvailabilityMultiDayArgs = {
  dates?: InputMaybe<Array<InputMaybe<Scalars['ISODateTime']>>>;
  durationInMinutes?: InputMaybe<Scalars['Int']>;
  time?: InputMaybe<Scalars['ISODateTime']>;
};


export type SpaceCurrentUserCanRequestMeetingServicesForEventArgs = {
  eventInstance: EventInstanceReference;
};


export type SpaceFilteredDesksByAmenityIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type SpaceMeetingRoomWindowedAvailabilityArgs = {
  firstWindowSplit?: InputMaybe<SnapTo>;
  meetingDurationInMinutes?: InputMaybe<Scalars['Int']>;
  numberOfWindows?: InputMaybe<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['Date']>;
};


export type SpaceMeetingServiceRequestsArgs = {
  eventInstance: EventInstanceReference;
};


export type SpaceMeetingServiceRequestsForDraftEventArgs = {
  eventUid: Scalars['UUIDv4'];
  recurrenceId?: InputMaybe<Scalars['ID']>;
};


export type SpaceTotalPriceOfMeetingServiceRequestsArgs = {
  eventInstance: EventInstanceReference;
};


export type SpaceWindowedAvailabilityArgs = {
  firstWindowSplit?: InputMaybe<SnapTo>;
  intervalInMinutes?: InputMaybe<Scalars['Int']>;
  meetingDurationInMinutes?: InputMaybe<Scalars['Int']>;
  numberOfWindows?: InputMaybe<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['Date']>;
};

export type SpaceAmenity = {
  __typename?: 'SpaceAmenity';
  amenityId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  name: Scalars['String'];
  quantity: Scalars['Int'];
  updatedAt: Scalars['Date'];
};

export const SpaceAvailability = {
  /** Currently available */
  AVAILABLE: 'AVAILABLE',
  /** Resource has been booked and confirmed */
  BOOKED_CONFIRMED: 'BOOKED_CONFIRMED',
  /** Resource has been booked and not confirmed */
  BOOKED_UNCONFIRMED: 'BOOKED_UNCONFIRMED',
  /** Resource marked as unavailable for booking */
  UNAVAILABLE: 'UNAVAILABLE',
  /** Resource schedule not found */
  UNKNOWN: 'UNKNOWN'
} as const;

export type SpaceAvailability = typeof SpaceAvailability[keyof typeof SpaceAvailability];
export type SpaceCalendar = {
  __typename?: 'SpaceCalendar';
  calendarId: Scalars['String'];
  createdAt: Scalars['String'];
  id: Scalars['Int'];
  isHealthy?: Maybe<Scalars['Boolean']>;
  lastNotifiedAt?: Maybe<Scalars['String']>;
  lastSyncedAt?: Maybe<Scalars['String']>;
  location?: Maybe<Location>;
  remoteType: Scalars['String'];
  space?: Maybe<Space>;
  spaceResourceEmail?: Maybe<Scalars['String']>;
  spaceResourceId?: Maybe<Scalars['String']>;
  subscriberChannelId?: Maybe<Scalars['String']>;
  subscriberExpiresAt?: Maybe<Scalars['String']>;
  subscriberId?: Maybe<Scalars['String']>;
  subscriptionAttempts: Scalars['Int'];
};

/** Input type for filtering space calendars */
export type SpaceCalendarFiltersInput = {
  /** Filter by calendar health status */
  calendarHealth?: InputMaybe<CalendarHealthEnum>;
  /** Filter by whether space has an associated resource */
  hasResource?: InputMaybe<Scalars['Boolean']>;
  /** Filter by disabled status */
  isDisabled?: InputMaybe<Scalars['Boolean']>;
  /** Filter by level ID */
  levelId?: InputMaybe<Scalars['String']>;
  /** Filter by location ID */
  locationId?: InputMaybe<Scalars['String']>;
  /** Filter by remote calendar type */
  remoteType?: InputMaybe<RemoteTypeEnum>;
  /** Filter by space name (case-insensitive partial match) */
  spaceName?: InputMaybe<Scalars['String']>;
};

export type SpaceCalendarResponse = {
  __typename?: 'SpaceCalendarResponse';
  calendarInfo: Array<SpaceCalendar>;
  offset: Scalars['Int'];
  total: Scalars['Int'];
};

export const SpaceFilters = {
  DISABLED: 'DISABLED',
  ENABLED: 'ENABLED',
  SCHEDULING: 'SCHEDULING'
} as const;

export type SpaceFilters = typeof SpaceFilters[keyof typeof SpaceFilters];
export type SpaceReservationPolicies = {
  __typename?: 'SpaceReservationPolicies';
  /** Automatically remove ghost meetings from the room's calendar if nobody checks in. */
  abandonedMeetingProtection: Scalars['Boolean'];
  /** Time to wait before an unconfirmed meeting is canceled. */
  abandonedThreshold: Scalars['ISO8601Duration'];
  /** Restrict how far in advance this space can be booked. */
  advanceBookingThreshold?: Maybe<Scalars['ISO8601Duration']>;
  allowRecurringEvents: Scalars['Boolean'];
  id: Scalars['ID'];
  maxReservationLength?: Maybe<Scalars['ISO8601Duration']>;
  /** Show a check-in button for each meeting */
  meetingCheckins: Scalars['Boolean'];
  restrictBookingToWorkingHours: Scalars['Boolean'];
  /** The number of consecutive abandoned meetings before the space is permanently removed from the series. */
  strikesForRecurringEvents?: Maybe<Scalars['Int']>;
};

export const SpaceScheduleConfiguration = {
  ON_DEMAND: 'ON_DEMAND',
  REQUEST_ONLY: 'REQUEST_ONLY',
  SCHEDULED: 'SCHEDULED'
} as const;

export type SpaceScheduleConfiguration = typeof SpaceScheduleConfiguration[keyof typeof SpaceScheduleConfiguration];
export const SpaceType = {
  BREAKOUT: 'BREAKOUT',
  BREAK_ROOM: 'BREAK_ROOM',
  CAFE: 'CAFE',
  CAFETERIA: 'CAFETERIA',
  CALL: 'CALL',
  CLASSROOM: 'CLASSROOM',
  CONFERENCE: 'CONFERENCE',
  EVENT: 'EVENT',
  FITNESS: 'FITNESS',
  HUDDLE: 'HUDDLE',
  INTERVIEW: 'INTERVIEW',
  KITCHEN: 'KITCHEN',
  LAB: 'LAB',
  LACTATION: 'LACTATION',
  LISTENING: 'LISTENING',
  LOBBY: 'LOBBY',
  LOUNGE: 'LOUNGE',
  MEETING: 'MEETING',
  OFFICE: 'OFFICE',
  OTHER: 'OTHER',
  PARKING: 'PARKING',
  PROJECT: 'PROJECT',
  RESTROOM: 'RESTROOM',
  RESTROOM_FEMALE: 'RESTROOM_FEMALE',
  RESTROOM_MALE: 'RESTROOM_MALE',
  STUDIO: 'STUDIO',
  STUDY_ROOM: 'STUDY_ROOM',
  THEATER: 'THEATER',
  UTILITY: 'UTILITY',
  WORK: 'WORK'
} as const;

export type SpaceType = typeof SpaceType[keyof typeof SpaceType];
export type SpaceWindowAvailability = {
  __typename?: 'SpaceWindowAvailability';
  end?: Maybe<Scalars['Date']>;
  isConfirmed?: Maybe<Scalars['Boolean']>;
  /** @deprecated Deprecated because the end becomes representing the pillEnd */
  pillEnd?: Maybe<Scalars['Date']>;
  start?: Maybe<Scalars['Date']>;
  status?: Maybe<Availability>;
  unbookableReasons: Array<Maybe<UnbookableReasonType>>;
};

export type StandardWorkingHours = DateSpecificWorkingHours & {
  __typename?: 'StandardWorkingHours';
  date: Scalars['Date'];
  timeFrames: Array<TimeFrame>;
};

export type Statistics = {
  __typename?: 'Statistics';
  assigned?: Maybe<Scalars['Int']>;
  assignedBookability?: Maybe<AssignedBookability>;
  assignedToUsers?: Maybe<Scalars['Int']>;
  available?: Maybe<Scalars['Int']>;
  hot?: Maybe<Scalars['Int']>;
  hoteled?: Maybe<Scalars['Int']>;
  notAssignedToUsers?: Maybe<Scalars['Int']>;
  unavailable?: Maybe<Scalars['Int']>;
};

export type Sticker = {
  __typename?: 'Sticker';
  associatedDeskId?: Maybe<Scalars['ID']>;
  batchId: Scalars['ID'];
  /** @deprecated Deprecated due to the potential circular queries that can be made via the fields on this type. Please use the `associatedDeskId` field and make a second query for desk information. */
  desk?: Maybe<Desk>;
  displayCode: Scalars['Int'];
  id: Scalars['ID'];
  shortCode: Scalars['String'];
  shortUrl: Scalars['String'];
};

export type StickerAssignment = {
  __typename?: 'StickerAssignment';
  seatId: Scalars['Int'];
  stickerId: Scalars['ID'];
};

export type StickerAssignmentInput = {
  seatId: Scalars['Int'];
  stickerId: Scalars['ID'];
};

export type StickerBatch = {
  __typename?: 'StickerBatch';
  id: Scalars['ID'];
  stickers: Array<Sticker>;
};

export type SubcategoryUpdatePairInput = {
  newValue: Scalars['CustomResourceSubCategoryType'];
  oldValue: Scalars['CustomResourceSubCategoryType'];
};

export type SuggestedDesk = {
  __typename?: 'SuggestedDesk';
  desk: Desk;
  locationId: Scalars['String'];
  organizationId: Scalars['String'];
  score?: Maybe<Scalars['Int']>;
  userId: Scalars['String'];
};

export type SuggestedSpaceForEvent = {
  __typename?: 'SuggestedSpaceForEvent';
  eventId: Scalars['ID'];
  space?: Maybe<Space>;
  suggestedSpaceRecordId?: Maybe<Scalars['String']>;
};

/** Survey configuration */
export type Survey = {
  __typename?: 'Survey';
  /** Boolean value indicating if the survey allows anonymous responses */
  allowAnonymous: Scalars['Boolean'];
  /** List of buildings associated with the survey */
  buildings?: Maybe<Array<Maybe<Location>>>;
  /** Date the survey was created */
  createdAt: Scalars['ISODateTime'];
  /** User that created the survey */
  createdBy: User;
  /** Unique identifier */
  id: Scalars['ID'];
  /** Boolean value indicating if the survey is active */
  isActive: Scalars['Boolean'];
  /** Survey name */
  name: Scalars['String'];
  /** Organization associated with the survey */
  organization: Organization;
  /** Date the survey was last updated */
  updatedAt: Scalars['ISODateTime'];
  /** User that last updated the survey */
  updatedBy: User;
};

/** Survey configuration without building links */
export type SurveyEdge = {
  __typename?: 'SurveyEdge';
  /** Boolean value indicating if the survey allows anonymous responses */
  allowAnonymous: Scalars['Boolean'];
  /** Date the survey was created */
  createdAt: Scalars['ISODateTime'];
  /** User that created the survey */
  createdBy: User;
  /** Unique identifier */
  id: Scalars['ID'];
  /** Boolean value indicating if the survey is active */
  isActive: Scalars['Boolean'];
  /** Survey name */
  name: Scalars['String'];
  /** Organization associated with the survey */
  organization: Organization;
  /** Date the survey was last updated */
  updatedAt: Scalars['ISODateTime'];
  /** User that last updated the survey */
  updatedBy: User;
};

/** Response to a sentiment survey */
export type SurveyResponse = {
  __typename?: 'SurveyResponse';
  /** Building of the reservation */
  building?: Maybe<Location>;
  /** Response comment */
  comment?: Maybe<Scalars['String']>;
  /** Date the response was created */
  createdAt: Scalars['ISODateTime'];
  /** Unique identifier */
  id: Scalars['ID'];
  /** Date the user was in the office */
  inOfficeAt: Scalars['ISODateTime'];
  /** Boolean that indicates if the response was anonymous */
  isAnonymous: Scalars['Boolean'];
  /** Organization associated with the survey response */
  organization: Organization;
  /** Sentiment rating */
  rating?: Maybe<Scalars['Int']>;
  /** Reservation associated with the survey response */
  reservation?: Maybe<Reservation>;
  /** Status of the survey response */
  status: SurveyResponseStatus;
  /** Date the response was submitted */
  submittedAt?: Maybe<Scalars['ISODateTime']>;
  /** Survey that was responded to */
  survey: SurveyEdge;
  /** Date the resopnse was last updated */
  updatedAt: Scalars['ISODateTime'];
  /** User that responded */
  user?: Maybe<User>;
};

/** Survey response rating summary */
export type SurveyResponseRatingSummary = {
  __typename?: 'SurveyResponseRatingSummary';
  /** Total number of negative responses */
  negativeCount: Scalars['Int'];
  /** Total number of neutral responses */
  neutralCount: Scalars['Int'];
  /** Total number of positive responses */
  positiveCount: Scalars['Int'];
  /** Total number of completed responses */
  totalCount: Scalars['Int'];
};

/** The key to sort survey responses by */
export const SurveyResponseSortKey = {
  IN_OFFICE_AT: 'IN_OFFICE_AT',
  RATING: 'RATING'
} as const;

export type SurveyResponseSortKey = typeof SurveyResponseSortKey[keyof typeof SurveyResponseSortKey];
/** Status of the survey response */
export const SurveyResponseStatus = {
  COMPLETED: 'COMPLETED',
  DISMISSED: 'DISMISSED',
  EXPIRED: 'EXPIRED',
  PENDING: 'PENDING'
} as const;

export type SurveyResponseStatus = typeof SurveyResponseStatus[keyof typeof SurveyResponseStatus];
/** Survey response status summary */
export type SurveyResponseStatusSummary = {
  __typename?: 'SurveyResponseStatusSummary';
  /** Total number of COMPLETED responses */
  completedCount: Scalars['Int'];
  /** Total number of DISMISSED responses */
  dismissedCount: Scalars['Int'];
  /** Total number of EXPIRED responses */
  expiredCount: Scalars['Int'];
  /** Total number of PENDING responses */
  pendingCount: Scalars['Int'];
  /** Total number of responses */
  totalCount: Scalars['Int'];
};

export const SyncState = {
  DONE: 'DONE',
  IN_PROGRESS: 'IN_PROGRESS',
  NEVER_HAPPENED: 'NEVER_HAPPENED'
} as const;

export type SyncState = typeof SyncState[keyof typeof SyncState];
export type TeamsUserSearchResult = {
  __typename?: 'TeamsUserSearchResult';
  avatar?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type Theme = {
  __typename?: 'Theme';
  color?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
};

export type Ticket = {
  /** Can be null if nobody is assigned */
  assignees?: Maybe<UsersAndGroups>;
  completedForm?: Maybe<CompletedTicketForm>;
  id: Scalars['ID'];
  /** human-friendly identifier like 'CAT-123' */
  key: Scalars['String'];
  requester?: Maybe<User>;
  title: Scalars['String'];
};

export type TicketAnswerExpectingChoicesInput = {
  optionIds: Array<Scalars['ID']>;
  questionId: Scalars['ID'];
};

export type TicketAnswerExpectingFilesInput = {
  /** The same IDs passed in as input to beginFileUploadsForTicketAnswer */
  fileIds: Array<Scalars['ID']>;
  questionId: Scalars['ID'];
};

export type TicketAnswerExpectingMenuChoicesInput = {
  choices: Array<TicketAnswerMenuChoiceInput>;
  questionId: Scalars['ID'];
};

export type TicketAnswerExpectingTextInput = {
  answer: Scalars['String'];
  questionId: Scalars['ID'];
};

export type TicketAnswerMenuChoice = {
  __typename?: 'TicketAnswerMenuChoice';
  option: TicketQuestionMenuOption;
  /** Required if option.quantifiable is true */
  quantity?: Maybe<Scalars['Int']>;
  /** The subtotal price for the entire quantity, before any surcharges/taxes. On a receipt, this is what shows up to the right of each line item: "3 Crab Rangoon: 7.50". */
  subtotalPrice?: Maybe<Money>;
};

export type TicketAnswerMenuChoiceInput = {
  optionId: Scalars['ID'];
  quantity?: InputMaybe<Scalars['Int']>;
};

export type TicketFile = {
  __typename?: 'TicketFile';
  id: Scalars['ID'];
  mimeType: Scalars['MimeType'];
  name: Scalars['String'];
  sizeBytes: Scalars['Int'];
};

/** Allows uploading the file with the given ID exactly once. Cannot be reused, or used with files with different IDs. */
export type TicketFileUploadDestination = {
  __typename?: 'TicketFileUploadDestination';
  /** Upload must be completed before this time - will be short! */
  expiresAt: Scalars['ISODateTime'];
  /** The same ID passed in as input */
  id: Scalars['ID'];
  /** Form fields that must be included in the POST request */
  postFields: Array<FormDataField>;
  /** URL to POST the file contents to */
  postUrl: Scalars['String'];
};

/** Information about a file the client intends to upload. Must not change - if a new file is chosen, a new input must be used. */
export type TicketFileUploadInput = {
  /** Client-generated UUID to identify this file that client should keep for later */
  id: Scalars['UUIDv4'];
  /** MIME type of the file, e.g. image/jpeg */
  mimeType: Scalars['MimeType'];
  /** The filename of the file, e.g. image.jpg */
  name: Scalars['String'];
  /** Size of file in bytes */
  sizeBytes: Scalars['Int'];
};

export type TicketIdentifierInput = {
  id?: InputMaybe<Scalars['ID']>;
  key?: InputMaybe<Scalars['String']>;
};

export type TicketQuestion = {
  id: Scalars['ID'];
  prompt: Scalars['String'];
  required: Scalars['Boolean'];
};

export type TicketQuestionExpectingChoices = AbstractTicketQuestionExpectingChoices & TicketQuestion & {
  __typename?: 'TicketQuestionExpectingChoices';
  chooseOnlyOneOption: Scalars['Boolean'];
  id: Scalars['ID'];
  options: Array<TicketQuestionOption>;
  /** e.g. 'Which way do you want the room to be set up?' */
  prompt: Scalars['String'];
  required: Scalars['Boolean'];
};

export type TicketQuestionExpectingChoicesInput = {
  chooseOnlyOneOption: Scalars['Boolean'];
  options: Array<TicketQuestionOptionInput>;
  /** e.g. 'Which way do you want the room to be set up?' */
  prompt: Scalars['String'];
  required: Scalars['Boolean'];
};

export type TicketQuestionExpectingFiles = TicketQuestion & {
  __typename?: 'TicketQuestionExpectingFiles';
  id: Scalars['ID'];
  prompt: Scalars['String'];
  required: Scalars['Boolean'];
};

export type TicketQuestionExpectingFilesInput = {
  /** 'Provide the purchase order PDF' */
  prompt: Scalars['String'];
  required: Scalars['Boolean'];
};

export type TicketQuestionExpectingMenuChoices = AbstractTicketQuestionExpectingChoices & TicketQuestion & {
  __typename?: 'TicketQuestionExpectingMenuChoices';
  chooseOnlyOneOption: Scalars['Boolean'];
  id: Scalars['ID'];
  options: Array<TicketQuestionMenuOption>;
  /** e.g. 'Which way do you want the room to be set up?' */
  prompt: Scalars['String'];
  required: Scalars['Boolean'];
};

export type TicketQuestionExpectingMenuChoicesInput = {
  chooseOnlyOneOption: Scalars['Boolean'];
  options: Array<TicketQuestionMenuOptionInput>;
  /** e.g. 'Appetizers' */
  prompt: Scalars['String'];
  required: Scalars['Boolean'];
};

export type TicketQuestionExpectingText = TicketQuestion & {
  __typename?: 'TicketQuestionExpectingText';
  id: Scalars['ID'];
  multilineAnswer: Scalars['Boolean'];
  /** 'What is your expense code?' */
  prompt: Scalars['String'];
  required: Scalars['Boolean'];
};

export type TicketQuestionExpectingTextInput = {
  multilineAnswer: Scalars['Boolean'];
  /** 'What is your expense code?' */
  prompt: Scalars['String'];
  required: Scalars['Boolean'];
};

export type TicketQuestionInput = {
  expectingChoices?: InputMaybe<TicketQuestionExpectingChoicesInput>;
  expectingFiles?: InputMaybe<TicketQuestionExpectingFilesInput>;
  expectingMenuChoices?: InputMaybe<TicketQuestionExpectingMenuChoicesInput>;
  expectingText?: InputMaybe<TicketQuestionExpectingTextInput>;
};

export type TicketQuestionMenuOption = AbstractTicketQuestionOption & {
  __typename?: 'TicketQuestionMenuOption';
  /** 'A perfectly adequate sandwich with cheese' */
  description?: Maybe<Scalars['Markdown']>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  /** 'Sandwich' */
  name: Scalars['String'];
  quantifiable: Scalars['Boolean'];
  /** The price of each unit, such that the subtotalPrice for this choice is quantity * unitPrice. If the option is not quantifiable, this is a flat price like if quantity were always 1. The currency code will always match the one on the MeetingService. 0 - 99_999_999 major currency units. Amounts are rounded to the nearest minor currency unit. */
  unitPrice?: Maybe<Money>;
};

export type TicketQuestionMenuOptionInput = {
  /** 'Two pieces of bread with meat in between - yum!' */
  description?: InputMaybe<Scalars['Markdown']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  /** 'Sandwich' */
  name: Scalars['String'];
  quantifiable: Scalars['Boolean'];
  /** The price of each unit, such that the total price for this option is quantity * unitPrice. If this option is not quantifiable, this is a flat price like if quantity were always 1. The currency code must match the one on the meeting service - you cannot mix currencies on the same service. */
  unitPrice?: InputMaybe<MoneyInput>;
};

export type TicketQuestionOption = AbstractTicketQuestionOption & {
  __typename?: 'TicketQuestionOption';
  /** 'We'll set up tables facing in *one* direction, evenly spaced' */
  description?: Maybe<Scalars['Markdown']>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  /** 'Classroom' */
  name: Scalars['String'];
};

export type TicketQuestionOptionInput = {
  /** 'We'll set up tables facing in *one* direction, evenly spaced' */
  description?: InputMaybe<Scalars['Markdown']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  /** 'Classroom' */
  name: Scalars['String'];
};

export type TicketRegardsEventAtSpace = {
  __typename?: 'TicketRegardsEventAtSpace';
  event?: Maybe<Event>;
  eventEnd: Scalars['ISODateTime'];
  eventStart: Scalars['ISODateTime'];
  space?: Maybe<Space>;
  /** null if ticket will still be changed when event changes. Actions like rejecting or cancelling a ticket will unsubscribe from event changes. This keeps a frozen record of what the ticket looked like when it was resolved. It also prevents people from getting emails about changes to events whose tickets are resolved. */
  unsubscribedAt?: Maybe<Scalars['ISODateTime']>;
};

export const TicketWorkflowKind = {
  MEETING_SERVICE: 'MEETING_SERVICE',
  /** This workflow describes a form that must be completed in order to request a request-only space. */
  SPACE_REQUEST_FORM: 'SPACE_REQUEST_FORM'
} as const;

export type TicketWorkflowKind = typeof TicketWorkflowKind[keyof typeof TicketWorkflowKind];
export type TimeFrame = {
  __typename?: 'TimeFrame';
  end: Scalars['String'];
  start: Scalars['String'];
};

export type TimeFrameInput = {
  end: Scalars['LocalEndTime'];
  start: Scalars['LocalEndTime'];
};

export const TimeInclusivityType = {
  EXCLUSIVE: 'EXCLUSIVE',
  INCLUSIVE: 'INCLUSIVE'
} as const;

export type TimeInclusivityType = typeof TimeInclusivityType[keyof typeof TimeInclusivityType];
export type TimeRangeInput = {
  end: Scalars['ISODateTime'];
  start: Scalars['ISODateTime'];
};

export type ToggleDraftLockResponse = {
  __typename?: 'ToggleDraftLockResponse';
  id: Scalars['ID'];
  isLocked: Scalars['Boolean'];
};

export type UnansweredTicketQuestion = AnsweredTicketQuestion & {
  __typename?: 'UnansweredTicketQuestion';
  question: TicketQuestion;
};

export type UnansweredTicketQuestionInput = {
  questionId: Scalars['ID'];
};

export type UnassignStickerRequest = {
  stickerId: Scalars['ID'];
};

export type UnauthenticatedGuest = {
  __typename?: 'UnauthenticatedGuest';
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** UnauthenticatedVisitResult represents the visit for a single GuestInvite. The result is "unauthenticated" because it is available to unauthenticated queries. A UnauthenticatedVisitResult is the guest (GuestInvite) along with information about their associated Visit. */
export type UnauthenticatedVisitResult = {
  __typename?: 'UnauthenticatedVisitResult';
  arrivalInstructions?: Maybe<Scalars['String']>;
  arrivalLocation: PublicLocationOrDefault;
  arrivalLocationId: Scalars['String'];
  checkinOn?: Maybe<Scalars['String']>;
  checkoutOn?: Maybe<Scalars['String']>;
  customVisitType: Scalars['String'];
  guest: UnauthenticatedGuest;
  healthCheckpointSurveyResponse?: Maybe<GenericHealthCheckpointResponse>;
  host: PublicUserWithEmail;
  /** The ID of the GuestInvite */
  id: Scalars['ID'];
  organization: PublicOrganization;
  startTime: Scalars['ISODateTime'];
  status: GuestInviteStatus;
  /** The ID of the associated visit */
  visitId: Scalars['ID'];
  /** @deprecated replaced by the more flexible customVisitType */
  visitType: VisitType;
};

export const UnbookableReasonType = {
  ADMIN_ONLY_BOOKING: 'ADMIN_ONLY_BOOKING',
  CONFLICT_WITH_ANOTHER_MEETING: 'CONFLICT_WITH_ANOTHER_MEETING',
  LACKING_SPACE_BOOKING_PERMISSIONS: 'LACKING_SPACE_BOOKING_PERMISSIONS',
  OUTSIDE_WORKING_HOURS: 'OUTSIDE_WORKING_HOURS',
  OVER_MAX_LENGTH: 'OVER_MAX_LENGTH',
  RECURRENCE_NOT_ALLOWED: 'RECURRENCE_NOT_ALLOWED',
  TOO_FAR_IN_FUTURE: 'TOO_FAR_IN_FUTURE'
} as const;

export type UnbookableReasonType = typeof UnbookableReasonType[keyof typeof UnbookableReasonType];
export type UnconfirmableReason = {
  __typename?: 'UnconfirmableReason';
  reason: UnconfirmableReasonType;
  value?: Maybe<Scalars['String']>;
};

export const UnconfirmableReasonType = {
  CANNOT_CONFIRM_SERIES_MASTER: 'CANNOT_CONFIRM_SERIES_MASTER',
  CANNOT_CONFIRM_SHARED_DESK: 'CANNOT_CONFIRM_SHARED_DESK',
  CHECKIN_DISABLED: 'CHECKIN_DISABLED',
  MISSING_RESERVATION_END_TIME: 'MISSING_RESERVATION_END_TIME',
  OUTSIDE_OF_CHECK_IN_WINDOW: 'OUTSIDE_OF_CHECK_IN_WINDOW'
} as const;

export type UnconfirmableReasonType = typeof UnconfirmableReasonType[keyof typeof UnconfirmableReasonType];
export type UngroupedResourceSaveUpdateInput = {
  amenityIds: Array<Scalars['ID']>;
  bookingType: WeeklyBookingCommand;
  capacity: Scalars['Int'];
  customResourceInstanceId: Scalars['ID'];
  floorId: Scalars['ID'];
  imageUrl?: InputMaybe<Scalars['String']>;
  isAccessible?: InputMaybe<Scalars['Boolean']>;
  locationId: Scalars['ID'];
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  originatingCustomResourceTemplateId: Scalars['ID'];
  policyConfiguration?: InputMaybe<CustomResourcePolicyDocumentCommand>;
  subCategory: Scalars['String'];
};

export type UnhealthyCalendar = {
  __typename?: 'UnhealthyCalendar';
  daysSinceSpaceUpdated: Scalars['Int'];
  daysSinceSynced: Scalars['Int'];
  id: Scalars['ID'];
  spaceId: Scalars['ID'];
  spaceName: Scalars['String'];
};

export type UniqueMeetingServiceRequestValues = {
  __typename?: 'UniqueMeetingServiceRequestValues';
  approvers: Array<Maybe<UserOrGroupUnion>>;
  assignees: Array<Maybe<UserOrGroupUnion>>;
  meetingServices: Array<MeetingService>;
  meetingServicesCategories: Array<MeetingServicesCategory>;
  regardingSpaces: Array<Maybe<Space>>;
  requesters: Array<Maybe<User>>;
};

export type Unknown = EventAuditLogActor & {
  __typename?: 'Unknown';
  id?: Maybe<Scalars['ID']>;
};

export type UnlinkKisiLockFromRobinLevelInput = {
  remoteLockId: Scalars['String'];
};

export type UnlinkKisiLockFromRobinLevelResponse = {
  __typename?: 'UnlinkKisiLockFromRobinLevelResponse';
  uuid?: Maybe<Scalars['ID']>;
};

export type UnlinkKisiLockFromRobinLocationInput = {
  remoteLockId: Scalars['String'];
};

export type UnlinkKisiLockFromRobinLocationResponse = {
  __typename?: 'UnlinkKisiLockFromRobinLocationResponse';
  uuid?: Maybe<Scalars['ID']>;
};

export const UpdatableMeetingServiceRequestStatus = {
  BLOCKED: 'BLOCKED',
  CANCELLED: 'CANCELLED',
  DONE: 'DONE',
  IN_PROGRESS: 'IN_PROGRESS',
  TODO: 'TODO'
} as const;

export type UpdatableMeetingServiceRequestStatus = typeof UpdatableMeetingServiceRequestStatus[keyof typeof UpdatableMeetingServiceRequestStatus];
export type UpdateActivityInput = {
  activityLocation?: InputMaybe<Scalars['String']>;
  /** The ID of the image to link to the activity */
  coverImageId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  end: Scalars['ISODateTime'];
  start: Scalars['ISODateTime'];
  timezone: Scalars['String'];
  title: Scalars['String'];
  virtualLocation?: InputMaybe<Scalars['String']>;
};

export type UpdateBookingWindowPolicyInput = {
  locationId: Scalars['ID'];
  policy?: InputMaybe<BookingWindowPolicyDefinitionInput>;
  policyId: Scalars['ID'];
};

export type UpdateDefaultPassInput = {
  isDefaultAccessPassEnabled: Scalars['Boolean'];
};

export type UpdateDeliveryInput = {
  additionalNotes?: InputMaybe<Scalars['String']>;
  carrier?: InputMaybe<Scalars['String']>;
  deliveryZoneId?: InputMaybe<Scalars['String']>;
  recipient?: InputMaybe<RecipientInput>;
  status?: InputMaybe<DeliveryStatus>;
};

export type UpdateDeliveryZoneInput = {
  levelId?: InputMaybe<Scalars['ID']>;
  locationId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  spaceId?: InputMaybe<Scalars['ID']>;
};

export type UpdateDeskReservationResponse = {
  __typename?: 'UpdateDeskReservationResponse';
  updatedReservations: Array<UpdatedReservation>;
};

export type UpdateDraftDataResponse = {
  __typename?: 'UpdateDraftDataResponse';
  deskEntities: Array<Maybe<DeskEntity>>;
  draftAccessLevel: DraftAccessLevel;
  entities: Array<Maybe<Entity>>;
  floor: Level;
  id: Scalars['ID'];
  metadata: DraftMetadata;
  neighborhoodEntities: Array<Maybe<NeighborhoodEntity>>;
  queue: Array<Maybe<DraftAccountUser>>;
  reviewVersion: Scalars['Int'];
  settings: Array<DraftSettings>;
  showNeighborhoodColor: Scalars['Boolean'];
};

export type UpdateDraftNeighborhoodResponse = {
  __typename?: 'UpdateDraftNeighborhoodResponse';
  id: Scalars['ID'];
};

export type UpdateDraftResponse = {
  __typename?: 'UpdateDraftResponse';
  affectedUsers: Array<Maybe<DraftAccountUser>>;
  entities: Array<Maybe<Entity>>;
  id: Scalars['ID'];
  metadata: DraftMetadata;
};

export type UpdateEventError = {
  __typename?: 'UpdateEventError';
  message?: Maybe<Scalars['String']>;
  reason?: Maybe<EventUpdateFailReasons>;
};

/** Reservation response */
export type UpdateEventResponse = {
  __typename?: 'UpdateEventResponse';
  /** If the event has not been updated, an explanation will be provided */
  error?: Maybe<UpdateEventError>;
  /** True if event has been updated */
  eventUpdated: Scalars['Boolean'];
  /** Updated event model */
  updatedEvent?: Maybe<Event>;
};

export type UpdateLayoutDraftResponse = {
  __typename?: 'UpdateLayoutDraftResponse';
  entities: Array<Maybe<LayoutChangeEntity>>;
  groupEntities: Array<Maybe<LayoutResourceGroupEntity>>;
  id: Scalars['ID'];
  metadata: DraftMetadata;
};

export type UpdateMeetingServiceChangesInput = {
  assignees?: InputMaybe<UsersAndGroupsInput>;
  /** Use null to make unavailable everywhere, omit to avoid changes. Unlike other collections on this input, this field supports partial updates. Buildings not listed here will be unchanged. To make unavailable in an entire building, send an empty array of space IDs for that building. To change the spaces in a building, send up the entire new array of space IDs for that building. This frees the client from grabbing every space ID in every building up front, which could be an expensive operation for services available in large orgs. To make sure these rules are understood by the client, empty array is not allowed and the name is different than the addMeetingService input. Omit the field to avoid changes. */
  availableInSpacesByBuildingChanges?: InputMaybe<Array<MeetingServiceAvailableInSpacesByBuildingInput>>;
  categoryId?: InputMaybe<Scalars['ID']>;
  currencyCode?: InputMaybe<Scalars['CurrencyCodeISO4217']>;
  description?: InputMaybe<Scalars['Markdown']>;
  multipleApprovers?: InputMaybe<UsersAndGroupsInput>;
  name?: InputMaybe<Scalars['String']>;
  /** Empty array and null have the same effect: remove all questions */
  questions?: InputMaybe<Array<TicketQuestionInput>>;
};

export type UpdateMeetingServiceErrorResponse = {
  __typename?: 'UpdateMeetingServiceErrorResponse';
  reason?: Maybe<UpdateMeetingServiceErrorResponseReason>;
};

export const UpdateMeetingServiceErrorResponseReason = {
  CATEGORY_MISSING: 'CATEGORY_MISSING',
  /** meeting service version ID is not the latest version for the meeting service */
  CONFLICT: 'CONFLICT',
  /** This meeting service has kind=SPACE_REQUEST_FORM, and one of its spaces already has a request form */
  SPACE_ALREADY_HAS_REQUEST_FORM: 'SPACE_ALREADY_HAS_REQUEST_FORM'
} as const;

export type UpdateMeetingServiceErrorResponseReason = typeof UpdateMeetingServiceErrorResponseReason[keyof typeof UpdateMeetingServiceErrorResponseReason];
export type UpdateMeetingServiceInput = {
  changes: UpdateMeetingServiceChangesInput;
  meetingServiceId: Scalars['ID'];
  /** The latest version ID for the meeting service you want to change. If this is not the latest version, say because someone edited the service out from under you, then the update will fail. The user should consult the latest version to avoid blowing away updates made by other people. */
  meetingServiceVersionId: Scalars['ID'];
};

export const UpdateMeetingServiceRequestStatusErrorReason = {
  /** Events that have ended can only change to Canceled/Done */
  EVENT_ALREADY_ENDED: 'EVENT_ALREADY_ENDED',
  /** Cannot un-cancel status because event or space no longer exists */
  EVENT_OR_SPACE_NO_LONGER_EXISTS: 'EVENT_OR_SPACE_NO_LONGER_EXISTS',
  /** Another user already changed the status */
  STATUS_ALREADY_CHANGED: 'STATUS_ALREADY_CHANGED',
  /** The user is not assigned to the ticket */
  USER_NOT_ASSIGNEE: 'USER_NOT_ASSIGNEE'
} as const;

export type UpdateMeetingServiceRequestStatusErrorReason = typeof UpdateMeetingServiceRequestStatusErrorReason[keyof typeof UpdateMeetingServiceRequestStatusErrorReason];
export type UpdateMeetingServiceRequestStatusErrorResponse = {
  __typename?: 'UpdateMeetingServiceRequestStatusErrorResponse';
  reason: UpdateMeetingServiceRequestStatusErrorReason;
};

export type UpdateMeetingServiceRequestStatusInput = {
  meetingServiceRequestId: Scalars['ID'];
  updatableMeetingServiceRequestStatus: UpdatableMeetingServiceRequestStatus;
};

export type UpdateMeetingServiceRequestStatusSuccessResponse = {
  __typename?: 'UpdateMeetingServiceRequestStatusSuccessResponse';
  _?: Maybe<Scalars['Void']>;
  /** @deprecated Does not change */
  meetingServiceRequestId: Scalars['ID'];
  /** @deprecated Refetch status with getMeetingServiceRequestByIdentifier instead */
  meetingServiceRequestStatus: MeetingServiceRequestStatus;
};

export type UpdateMeetingServiceResponse = UpdateMeetingServiceErrorResponse | UpdateMeetingServiceSuccessResponse;

export type UpdateMeetingServiceSuccessResponse = {
  __typename?: 'UpdateMeetingServiceSuccessResponse';
  meetingServiceVersionId: Scalars['ID'];
};

/** Set a field to null to avoid changing it on the reservation. */
export type UpdateMyReservationDeskAndTimeFrameInput = {
  end?: InputMaybe<DateWithTimezone>;
  reservationId: Scalars['ID'];
  seatId?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<DateWithTimezone>;
};

export type UpdateShowNeighborhoodColorResponse = {
  __typename?: 'UpdateShowNeighborhoodColorResponse';
  id: Scalars['ID'];
  showNeighborhoodColor: Scalars['Boolean'];
  version: Scalars['Int'];
};

export type UpdateWorkAreaInput = {
  deskIds: Array<Scalars['ID']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateWorkAreasInput = {
  workAreasToCreate: Array<CreateWorkAreaInput>;
  workAreasToDelete: Array<Scalars['ID']>;
  workAreasToUpdate: Array<UpdateWorkAreaInput>;
};

export type UpdatedReservation = {
  __typename?: 'UpdatedReservation';
  id: Scalars['ID'];
};

export type UploadCsvForcePushRecords = {
  uuid: Scalars['ID'];
};

export type UploadCsvVendor = {
  __typename?: 'UploadCSVVendor';
  name: Scalars['ID'];
};

export type User = EventAuditLogActor & {
  __typename?: 'User';
  avatar?: Maybe<Scalars['String']>;
  canAndShouldAskForPresencePermissionInMobile: CanAndShouldAskForPresencePermissionInMobileResponse;
  createdAt?: Maybe<Scalars['String']>;
  defaultLocation?: Maybe<Scalars['String']>;
  /** @deprecated Deprecated in favor of primary_email */
  email?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  geofenceFeatureEnabled: Scalars['Boolean'];
  givenName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  locationState: LocationState;
  name?: Maybe<Scalars['String']>;
  notificationPreferences: NotificationPreferences;
  officeAccess: Array<OfficeAccess>;
  primaryEmail?: Maybe<Email>;
  reservations: Array<Reservation>;
  reservationsAtLocationGroupedByDateAscending: Array<UserDeskReservationByDate>;
  reservationsGroupedByDate: Array<UserDeskReservationByDate>;
  slug?: Maybe<Scalars['String']>;
  timeZone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  workingHours?: Maybe<Array<Maybe<UserWorkingHour>>>;
};


export type UserLocationStateArgs = {
  campusId?: InputMaybe<Scalars['ID']>;
  endTime: Scalars['Date'];
  locationId: Scalars['ID'];
  recurrence?: InputMaybe<Scalars['String']>;
  startTime: Scalars['Date'];
};


export type UserReservationsArgs = {
  endTime: Scalars['Date'];
  startTime: Scalars['Date'];
};


export type UserReservationsAtLocationGroupedByDateAscendingArgs = {
  endTime: Scalars['ISODateTime'];
  locationId: Scalars['ID'];
  startTime: Scalars['ISODateTime'];
};


export type UserReservationsGroupedByDateArgs = {
  endTime: Scalars['Date'];
  startTime: Scalars['Date'];
};

export type UserAssignment = {
  __typename?: 'UserAssignment';
  assignments: Array<Maybe<DeskAssignmentSchedule>>;
  avatarUrl?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
};

export type UserAssignmentChangedAuditMetadata = {
  __typename?: 'UserAssignmentChangedAuditMetadata';
  desk: MetadataDeskObject;
  recurrence?: Maybe<Scalars['String']>;
  user: AuditUserObject;
};

export type UserAssignmentData = {
  __typename?: 'UserAssignmentData';
  assignee: Assignee;
  id: Scalars['ID'];
  schedules: Array<AssignmentData>;
};

export const UserDefaultRoleSlug = {
  ADMIN: 'ADMIN',
  MEMBER: 'MEMBER',
  OWNER: 'OWNER'
} as const;

export type UserDefaultRoleSlug = typeof UserDefaultRoleSlug[keyof typeof UserDefaultRoleSlug];
export type UserDeskReservation = {
  __typename?: 'UserDeskReservation';
  reservations: Array<Reservation>;
  userId: Scalars['ID'];
};

export type UserDeskReservationByDate = {
  __typename?: 'UserDeskReservationByDate';
  date: Scalars['Date'];
  reservations: Array<UserTruncatedReservation>;
};

export type UserInOffice = {
  __typename?: 'UserInOffice';
  deskReservations: Array<Reservation>;
  employeeVisits: Array<EmployeeVisit>;
  userId: Scalars['ID'];
};

export type UserInOfficeByDay = {
  __typename?: 'UserInOfficeByDay';
  date: Scalars['String'];
  userInOffice?: Maybe<UserInOffice>;
};

export type UserNotificationsSetting = {
  __typename?: 'UserNotificationsSetting';
  name: Scalars['String'];
  ownerId: Scalars['ID'];
  values: Array<Maybe<NotificationSettingType>>;
};

export type UserOrGroup = {
  __typename?: 'UserOrGroup';
  userOrGroup?: Maybe<UserOrGroupUnion>;
};

/** Either a group ID or a user ID is required */
export type UserOrGroupInput = {
  groupId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type UserOrGroupUnion = Group | User;

export type UserRolePermissionResult = {
  __typename?: 'UserRolePermissionResult';
  action: RolePermissionAction;
  permit: Scalars['Boolean'];
};

export type UserSetting = {
  __typename?: 'UserSetting';
  dataType: SettingDataType;
  ownerId: Scalars['ID'];
  ownerType: SettingOwnerType;
  slug: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export const UserSortBy = {
  FAVORITE: 'FAVORITE',
  NAME: 'NAME'
} as const;

export type UserSortBy = typeof UserSortBy[keyof typeof UserSortBy];
export const UserSortOrder = {
  ASCENDING: 'ASCENDING',
  DESCENDING: 'DESCENDING'
} as const;

export type UserSortOrder = typeof UserSortOrder[keyof typeof UserSortOrder];
export type UserSyncStatus = {
  __typename?: 'UserSyncStatus';
  state: SyncState;
  userCount: Scalars['Int'];
};

export type UserTimeFrame = {
  __typename?: 'UserTimeFrame';
  end?: Maybe<Scalars['Date']>;
  start?: Maybe<Scalars['Date']>;
};

export type UserTimeFrameInput = {
  end: Scalars['String'];
  start: Scalars['String'];
};

export type UserTruncatedDeskConfirmation = {
  __typename?: 'UserTruncatedDeskConfirmation';
  confirmedAt?: Maybe<Scalars['String']>;
  deviceId?: Maybe<Scalars['ID']>;
  seatReservationId: Scalars['ID'];
};

export type UserTruncatedReservation = {
  __typename?: 'UserTruncatedReservation';
  /** @deprecated Broken, use `truncatedConfirmation` */
  confirmation?: Maybe<DeskConfirmation>;
  endTime?: Maybe<Scalars['String']>;
  healthCheckpointAnsweredAt?: Maybe<Scalars['String']>;
  healthCheckpointStatus?: Maybe<HealthCheckpointStatus>;
  /** Reservation Id */
  id: Scalars['ID'];
  recurrence?: Maybe<Scalars['String']>;
  reservee: UserTruncatedReservee;
  seat: Desk;
  seriesId?: Maybe<Scalars['ID']>;
  startTime: Scalars['String'];
  truncatedConfirmation?: Maybe<UserTruncatedDeskConfirmation>;
  type: Scalars['String'];
  visibility: DeskReservationVisibility;
};

export type UserTruncatedReservee = {
  __typename?: 'UserTruncatedReservee';
  email: Scalars['String'];
  participationStatus?: Maybe<ParticipationStatus>;
  userId?: Maybe<Scalars['ID']>;
  visitorId?: Maybe<Scalars['ID']>;
};

export type UserWithDefault = {
  __typename?: 'UserWithDefault';
  avatar?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  defaultLocation?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** If true, no user by this ID can be found in the user system */
  isDefault: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  primaryEmail?: Maybe<Email>;
  slug?: Maybe<Scalars['String']>;
  timeZone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  workingHours?: Maybe<Array<Maybe<UserWorkingHour>>>;
};

export type UserWorkingHour = {
  __typename?: 'UserWorkingHour';
  day?: Maybe<Scalars['Int']>;
  timeFrames: Array<Maybe<UserTimeFrame>>;
};

export type UserWorkingHourInput = {
  day: Scalars['Int'];
  timeFrames: Array<UserTimeFrameInput>;
};

export type UsersAndGroups = {
  __typename?: 'UsersAndGroups';
  groups: Array<Maybe<Group>>;
  /** Users and Groups in one list - use fragments to select fields */
  usersAndGroups: Array<Maybe<UserOrGroupUnion>>;
  /** groups also contain users, but these are in addition to the users from the groups */
  usersOutsideOfGroups: Array<Maybe<User>>;
};

export type UsersAndGroupsInput = {
  groupIds: Array<Scalars['ID']>;
  userIds: Array<Scalars['ID']>;
};

export const Visit_Document_Status = {
  ARCHIVED: 'ARCHIVED',
  INACTIVE: 'INACTIVE',
  LIVE: 'LIVE'
} as const;

export type Visit_Document_Status = typeof Visit_Document_Status[keyof typeof Visit_Document_Status];
export const VerkadaTenancy = {
  AU: 'AU',
  EU: 'EU',
  GOV: 'GOV',
  US: 'US'
} as const;

export type VerkadaTenancy = typeof VerkadaTenancy[keyof typeof VerkadaTenancy];
export type Visit = {
  __typename?: 'Visit';
  /** What does the guest need to do when they arrive?. Default to null */
  arrivalInstructions?: Maybe<Scalars['String']>;
  /** Arrival location */
  arrivalLocation: Location;
  /** ID of the location where the guests should arrive and check-in */
  arrivalLocationId: Scalars['ID'];
  /** The custom fields for the visit */
  customFields?: Maybe<Array<CustomField>>;
  /** Custom reason for this visit */
  customVisitType?: Maybe<Scalars['String']>;
  /** A custom email configuration associated with the visit's location */
  emailConfiguration?: Maybe<EmailConfiguration>;
  /** Number of guests in the visit */
  guestCount?: Maybe<Scalars['Int']>;
  /** Guest invitations */
  guestInvites: Array<GuestInvite>;
  /** Guests for this visit */
  guests: Array<Guest>;
  /**
   * Host robin user
   * @deprecated Use hosts field instead for multiple host support
   */
  host: UserWithDefault;
  /**
   * ID of user acting as host for this visit
   * @deprecated Use hosts field instead for multiple host support
   */
  hostUserId: Scalars['ID'];
  /** Hosts for this visit with configurable settings */
  hosts: Array<VisitHost>;
  /** Visit unique identifier */
  id: Scalars['ID'];
  /** Organization */
  organization: Organization;
  /** How was the visit created? */
  organizer: VisitOrganizer;
  /** Start time of visit represented by ISO 8601 date-time */
  startTime: Scalars['ISODateTime'];
  /**
   * Reason for this visit
   * @deprecated replaced by the more flexible customVisitType
   */
  visitType: VisitType;
};


export type VisitGuestInvitesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type VisitGuestsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export const VisitAsyncRequestReport = {
  DONE: 'DONE',
  ERROR: 'ERROR',
  HCP_CREATED: 'HCP_CREATED',
  VISIT_CREATED: 'VISIT_CREATED'
} as const;

export type VisitAsyncRequestReport = typeof VisitAsyncRequestReport[keyof typeof VisitAsyncRequestReport];
export const VisitAsyncRequestStatus = {
  COMPLETE: 'COMPLETE',
  ERROR: 'ERROR',
  IN_PROGRESS: 'IN_PROGRESS',
  REQUEST_RECEIVED: 'REQUEST_RECEIVED'
} as const;

export type VisitAsyncRequestStatus = typeof VisitAsyncRequestStatus[keyof typeof VisitAsyncRequestStatus];
export type VisitAsyncRequestStatusResponse = {
  __typename?: 'VisitAsyncRequestStatusResponse';
  errorText: Array<Scalars['String']>;
  status?: Maybe<VisitAsyncRequestStatus>;
};

export type VisitDocumentAgreementOutcome = {
  __typename?: 'VisitDocumentAgreementOutcome';
  id: Scalars['ID'];
  outcome: VisitDocumentAgreementStatus;
};

export type VisitDocumentAgreementResponse = {
  __typename?: 'VisitDocumentAgreementResponse';
  completionStatus: VisitDocumentCompletionStatus;
  documentBody: Scalars['DocumentBody'];
  documentName: Scalars['String'];
  id: Scalars['ID'];
  isRequired: Scalars['Boolean'];
  possibleOutcomes: Array<VisitDocumentAgreementOutcome>;
  selectedOutcome?: Maybe<VisitDocumentAgreementOutcome>;
};

export const VisitDocumentAgreementStatus = {
  ACCEPT: 'ACCEPT'
} as const;

export type VisitDocumentAgreementStatus = typeof VisitDocumentAgreementStatus[keyof typeof VisitDocumentAgreementStatus];
export type VisitDocumentAgreementWithNextDocumentResponse = {
  __typename?: 'VisitDocumentAgreementWithNextDocumentResponse';
  completionStatus: VisitDocumentCompletionStatus;
  documentBody: Scalars['DocumentBody'];
  documentName: Scalars['String'];
  id: Scalars['ID'];
  isRequired: Scalars['Boolean'];
  /** Whether the guest must provide a drawn signature when agreeing to this document */
  isSignatureRequired: Scalars['Boolean'];
  /** If NULL, there is no next document */
  nextDocumentId?: Maybe<Scalars['ID']>;
  possibleOutcomes: Array<VisitDocumentAgreementOutcome>;
  selectedOutcome?: Maybe<VisitDocumentAgreementOutcome>;
  workflowId: Scalars['ID'];
};

export type VisitDocumentByDecisionResponse = {
  __typename?: 'VisitDocumentByDecisionResponse';
  /** Date and time the document was accepted for specified decision */
  agreedOn: Scalars['ISODateTime'];
  /** Document body */
  body: Scalars['DocumentBody'];
  /** ID of document associated with descition */
  id: Scalars['ID'];
  /** Document name */
  name: Scalars['String'];
  /** Email addresses of individuals notified via email */
  notificationEmails: Array<Scalars['String']>;
  /** Associated visit model */
  visit: VisitOrDefault;
};

export const VisitDocumentCompletionStatus = {
  COMPLETE: 'COMPLETE',
  INCOMPLETE: 'INCOMPLETE'
} as const;

export type VisitDocumentCompletionStatus = typeof VisitDocumentCompletionStatus[keyof typeof VisitDocumentCompletionStatus];
export const VisitDocumentNameStatusAndTypesField = {
  LOCATION_ID: 'LOCATION_ID',
  STATUS: 'STATUS',
  VISIT_TYPE: 'VISIT_TYPE'
} as const;

export type VisitDocumentNameStatusAndTypesField = typeof VisitDocumentNameStatusAndTypesField[keyof typeof VisitDocumentNameStatusAndTypesField];
export type VisitDocumentNameStatusAndTypesFilter = {
  filterOn: VisitDocumentNameStatusAndTypesField;
  filterValues: Array<Scalars['String']>;
};

export type VisitDocumentNameStatusAndTypesQueryResponse = {
  __typename?: 'VisitDocumentNameStatusAndTypesQueryResponse';
  /** ISO encoded timestamp representing date/time when this document was added */
  addedOn: Scalars['ISODateTime'];
  id: Scalars['ID'];
  /** Name of the document */
  name: Scalars['String'];
  /** Association status of this document to active or archived workflows */
  status: Visit_Document_Status;
  /** The types of visits, if any, which are actively associated with this document */
  visitTypes: Array<Scalars['String']>;
};

export type VisitDocumentResponse = {
  __typename?: 'VisitDocumentResponse';
  /** The full body text of the document. */
  documentBody: Scalars['String'];
  /** The unique name of the document */
  documentName: Scalars['String'];
  id: Scalars['ID'];
  /** The locations which are associated with this document */
  locationIds: Array<Scalars['String']>;
  /** Notification emails associated with document */
  notificationEmails: Array<Scalars['String']>;
  /** Association status of this document to active or archived workflows */
  status: Visit_Document_Status;
  /** The types of visits which are associated with this document */
  visitTypes: Array<Scalars['String']>;
};

export const VisitEventAcknowledgement = {
  VISIT_STARTING_SOON: 'VISIT_STARTING_SOON'
} as const;

export type VisitEventAcknowledgement = typeof VisitEventAcknowledgement[keyof typeof VisitEventAcknowledgement];
/** A VisitHost represents a host assigned to a visit with configurable settings */
export type VisitHost = {
  __typename?: 'VisitHost';
  /** Host robin user */
  host: UserWithDefault;
  /** Host user ID */
  hostUserId: Scalars['ID'];
  /** Whether this host is visible to guests */
  isVisibleToGuests: Scalars['Boolean'];
  /** Whether this host receives notifications */
  sendNotifications: Scalars['Boolean'];
};

/** Input type for configuring a visit host */
export type VisitHostInput = {
  /** ID of user acting as host for this visit */
  hostUserId: Scalars['ID'];
  /** Whether this host is visible to guests */
  isVisibleToGuests?: InputMaybe<Scalars['Boolean']>;
  /** Whether this host receives notifications */
  sendNotifications?: InputMaybe<Scalars['Boolean']>;
};

export type VisitInputType = {
  /** What does the guest need to do when they arrive?. Default to null */
  arrivalInstructions?: InputMaybe<Scalars['String']>;
  /** ID of the location where the guests should arrive and check-in */
  arrivalLocationId: Scalars['ID'];
  /** ID of user acting as host for this visit */
  hostUserId: Scalars['ID'];
  /** Start time of visit represented by ISO 8601 date-time */
  startTime: Scalars['ISODateTime'];
  /** Reason for this visit */
  visitType: VisitType;
};

export type VisitMagicLinkAuthResponse = {
  __typename?: 'VisitMagicLinkAuthResponse';
  id: Scalars['ID'];
  tenantId: Scalars['String'];
  token: Scalars['String'];
  type: Scalars['String'];
};

export type VisitOrDefault = {
  __typename?: 'VisitOrDefault';
  /** What does the guest need to do when they arrive?. Default to null */
  arrivalInstructions?: Maybe<Scalars['String']>;
  /** Arrival location */
  arrivalLocation?: Maybe<Location>;
  /** Visit unique identifier */
  arrivalLocationId?: Maybe<Scalars['ID']>;
  /** Number of guests in the visit */
  guestCount?: Maybe<Scalars['Int']>;
  /** Guest invitations */
  guestInvites?: Maybe<Array<GuestInvite>>;
  /** Guests for this visit */
  guests?: Maybe<Array<Guest>>;
  /** Host robin user */
  host?: Maybe<UserWithDefault>;
  /** ID of user acting as host for this visit */
  hostUserId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  /** Organization */
  organization?: Maybe<Organization>;
  /** How was the visit created? */
  organizer?: Maybe<VisitOrganizer>;
  /** Start time of visit represented by ISO 8601 date-time */
  startTime?: Maybe<Scalars['ISODateTime']>;
  /** Reason for this visit */
  visitType?: Maybe<VisitType>;
};


export type VisitOrDefaultGuestInvitesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type VisitOrDefaultGuestsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type VisitOrganizer = {
  __typename?: 'VisitOrganizer';
  /** The arrival display that the visit was created on, if exists */
  arrivalDisplay?: Maybe<PublicArrivalDisplay>;
  /** The ID of the entity from where the visit was created */
  id: Scalars['ID'];
  /** How the visit was created */
  type: VisitOrganizerType;
};

export const VisitOrganizerType = {
  ARRIVAL_DISPLAY: 'ARRIVAL_DISPLAY',
  USER: 'USER'
} as const;

export type VisitOrganizerType = typeof VisitOrganizerType[keyof typeof VisitOrganizerType];
export const VisitType = {
  CUSTOMER_VISIT: 'CUSTOMER_VISIT',
  EVENT: 'EVENT',
  JOB_INTERVIEW: 'JOB_INTERVIEW',
  MAINTENANCE: 'MAINTENANCE',
  OTHER: 'OTHER',
  VIP_VISIT: 'VIP_VISIT'
} as const;

export type VisitType = typeof VisitType[keyof typeof VisitType];
export const VisitTypeSource = {
  DEFAULT: 'DEFAULT',
  LOCATION: 'LOCATION',
  ORGANIZATION: 'ORGANIZATION'
} as const;

export type VisitTypeSource = typeof VisitTypeSource[keyof typeof VisitTypeSource];
export type VisitTypeState = {
  __typename?: 'VisitTypeState';
  activeLocationOverrides: Array<Scalars['ID']>;
  id: Scalars['ID'];
  inactiveLocationOverrides: Array<Scalars['ID']>;
  isActiveOrgWide: Scalars['Boolean'];
  isDefault: Scalars['Boolean'];
  name: Scalars['String'];
};

export type VisitWithIdInputType = {
  /** ID of the location where the guests should arrive and check-in */
  arrivalLocationId: Scalars['ID'];
  /** ID of user acting as host for this visit */
  hostUserId: Scalars['ID'];
  /** ID of the visit */
  id: Scalars['ID'];
  /** Start time of visit represented by ISO 8601 date-time */
  startTime: Scalars['ISODateTime'];
  /** Reason for this visit */
  visitType: VisitType;
};

export type VisitWorkflowOverview = {
  __typename?: 'VisitWorkflowOverview';
  /** Workflow documents */
  documents: Array<WorkflowDocumentOverviewForVisitor>;
  /** Workflow ID */
  id: Scalars['ID'];
};

export type VisitorManagementPermissionScopes = {
  __typename?: 'VisitorManagementPermissionScopes';
  /** A user with this permission has read/write access to any visit */
  canManageAllVisits?: Maybe<PermissionScope>;
  /** A user with this permission has read/write access to any visit they host */
  canManageOwnVisits?: Maybe<PermissionScope>;
  /** A user with this permission can manage visitor management itself */
  canManageVisits?: Maybe<PermissionScope>;
  /** A user with this permission has read access to any visit */
  canViewAllVisits?: Maybe<PermissionScope>;
  /** A user with this permission has read access to any visit they host */
  canViewOwnVisits?: Maybe<PermissionScope>;
};

export type VisitorManagementPermissions = {
  __typename?: 'VisitorManagementPermissions';
  canManageAllVisits?: Maybe<Scalars['Boolean']>;
  canManageOwnVisits?: Maybe<Scalars['Boolean']>;
  canManageVisits?: Maybe<Scalars['Boolean']>;
  canViewAllVisits?: Maybe<Scalars['Boolean']>;
  canViewOwnVisits?: Maybe<Scalars['Boolean']>;
  /** @deprecated No longer supported */
  canViewVisits?: Maybe<Scalars['Boolean']>;
};

export type WeeklyBookingCommand = {
  friday: BookingType;
  monday: BookingType;
  saturday: BookingType;
  sunday: BookingType;
  thursday: BookingType;
  tuesday: BookingType;
  wednesday: BookingType;
};

export type WeeklyBookingType = {
  __typename?: 'WeeklyBookingType';
  friday: BookingType;
  monday: BookingType;
  saturday: BookingType;
  sunday: BookingType;
  thursday: BookingType;
  tuesday: BookingType;
  wednesday: BookingType;
};

export type WeeklyScheduleResult = {
  __typename?: 'WeeklyScheduleResult';
  fri: Scalars['Boolean'];
  id: Scalars['String'];
  instanceEndTime: Scalars['UtcTime'];
  instanceStartTime: Scalars['UtcTime'];
  location?: Maybe<Location>;
  mon: Scalars['Boolean'];
  sat: Scalars['Boolean'];
  sun: Scalars['Boolean'];
  thu: Scalars['Boolean'];
  tue: Scalars['Boolean'];
  wed: Scalars['Boolean'];
};

export type WhosInData = {
  __typename?: 'WhosInData';
  byLocation?: Maybe<Array<WhosInDataByLocation>>;
  totalNumberOfWhosIn: Scalars['Int'];
  whosIn?: Maybe<Array<WhosInUser>>;
};


export type WhosInDataTotalNumberOfWhosInArgs = {
  userIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type WhosInDataWhosInArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  preferredUserIds?: InputMaybe<Array<Scalars['ID']>>;
  userIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type WhosInDataByDay = {
  __typename?: 'WhosInDataByDay';
  date: Scalars['ISODateTime'];
  whosInData?: Maybe<WhosInData>;
  /** @deprecated Deprecated in favor of whosInData.byLocation */
  whosInDataByLocation?: Maybe<Array<WhosInDataByLocation>>;
};

export type WhosInDataByLocation = {
  __typename?: 'WhosInDataByLocation';
  locationId: Scalars['ID'];
  totalNumberOfWhosIn: Scalars['Int'];
  whosIn?: Maybe<Array<WhosInUser>>;
  /** @deprecated Deprecated in favor of totalNumberOfWhosIn and whosIn */
  whosInData: WhosInData;
};


export type WhosInDataByLocationWhosInArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  preferredUserIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type WhosInUser = {
  __typename?: 'WhosInUser';
  deskReservationIds: Array<Scalars['String']>;
  employeeVisitId?: Maybe<Scalars['String']>;
  isAnonymous: Scalars['Boolean'];
  locationId: Scalars['ID'];
  userEmail?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type WindowAvailability = {
  __typename?: 'WindowAvailability';
  end?: Maybe<Scalars['Date']>;
  /** @deprecated Deprecated because the end becomes representing the pillEnd */
  pillEnd?: Maybe<Scalars['Date']>;
  start?: Maybe<Scalars['Date']>;
  status?: Maybe<Availability>;
};

export type WorkArea = {
  __typename?: 'WorkArea';
  /** Total desks within the level that fit within various scheduling type and status buckets */
  deskSchedulingAggregates: SchedulingAggregateOfDesks;
  desks: Array<Desk>;
  id: Scalars['ID'];
  level: Level;
  name: Scalars['String'];
};

export type WorkPolicy = {
  __typename?: 'WorkPolicy';
  createdAt?: Maybe<Scalars['ISODateTime']>;
  id: Scalars['ID'];
  interval: WorkPolicyInterval;
  isDefault: Scalars['Boolean'];
  message?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  rank?: Maybe<Scalars['Int']>;
  status: WorkPolicyStatus;
  tooltipMessage?: Maybe<Scalars['String']>;
};

export type WorkPolicyInput = {
  interval: WorkPolicyIntervalInput;
  message?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  status: WorkPolicyStatus;
  tooltipMessage?: InputMaybe<Scalars['String']>;
};

export type WorkPolicyInterval = {
  __typename?: 'WorkPolicyInterval';
  frequency?: Maybe<Scalars['Int']>;
  intervalType: WorkPolicyIntervalType;
  specificDays?: Maybe<Array<Scalars['Int']>>;
};

export type WorkPolicyIntervalInput = {
  frequency?: InputMaybe<Scalars['Int']>;
  intervalType: WorkPolicyIntervalType;
  specificDays?: InputMaybe<Array<Scalars['Int']>>;
};

export const WorkPolicyIntervalType = {
  MONTHLY: 'MONTHLY',
  SPECIFIC_DAYS: 'SPECIFIC_DAYS',
  WEEKLY: 'WEEKLY'
} as const;

export type WorkPolicyIntervalType = typeof WorkPolicyIntervalType[keyof typeof WorkPolicyIntervalType];
export const WorkPolicyStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  SCHEDULED: 'SCHEDULED'
} as const;

export type WorkPolicyStatus = typeof WorkPolicyStatus[keyof typeof WorkPolicyStatus];
export type WorkPolicyWithProgress = {
  __typename?: 'WorkPolicyWithProgress';
  id: Scalars['ID'];
  interval: WorkPolicyInterval;
  message?: Maybe<Scalars['String']>;
  minimumDaysProgress?: Maybe<Scalars['Int']>;
  /** @deprecated Use minimumDaysProgress instead. */
  progress: Scalars['Int'];
  specificDaysProgress?: Maybe<Array<Scalars['Int']>>;
  tooltipMessage?: Maybe<Scalars['String']>;
};

export type WorkflowDocumentOverviewForVisitor = {
  __typename?: 'WorkflowDocumentOverviewForVisitor';
  /** Is document complete for this visit */
  completionStatus: VisitDocumentCompletionStatus;
  id: Scalars['ID'];
  /** Is document required in workflow */
  isRequired: Scalars['Boolean'];
  /** Name of the document */
  name: Scalars['String'];
};

export type WorkingHours = {
  __typename?: 'WorkingHours';
  day?: Maybe<Scalars['Int']>;
  timeFrames: Array<TimeFrame>;
};

export type WorkingHoursInput = {
  day?: InputMaybe<DayOfWeek>;
  timeFrames: Array<TimeFrameInput>;
};

/** A zone is an area within a space that represents a collection of desks or a table */
export type Zone = {
  __typename?: 'Zone';
  desks: Array<Desk>;
  filteredDesksByAmenityIds: Array<Desk>;
  /** Zone ID is a unique identifier for the zone */
  id: Scalars['ID'];
  /** Name of the zone */
  name: Scalars['String'];
  /** Identifies the type of this zone. Zones can be Pods or Table */
  type: ZoneType;
};


/** A zone is an area within a space that represents a collection of desks or a table */
export type ZoneDesksArgs = {
  filters?: InputMaybe<Array<DeskFilters>>;
};


/** A zone is an area within a space that represents a collection of desks or a table */
export type ZoneFilteredDesksByAmenityIdsArgs = {
  ids: Array<Scalars['ID']>;
};

export type ZoneDeskReservation = {
  __typename?: 'ZoneDeskReservation';
  reservations: Array<Reservation>;
  zoneId: Scalars['ID'];
};

/** Describes the type of zone */
export const ZoneType = {
  /** A pod is a collection of desks */
  POD: 'POD',
  /** A zone with the table type is typically a large table with many seats */
  TABLE: 'TABLE'
} as const;

export type ZoneType = typeof ZoneType[keyof typeof ZoneType];
export type CanAndShouldAskForPresencePermissionInMobileResponse = {
  __typename?: 'canAndShouldAskForPresencePermissionInMobileResponse';
  shouldAsk: Scalars['Boolean'];
};

export type ForceResolveCsvUploadRecordsResponse = {
  __typename?: 'forceResolveCSVUploadRecordsResponse';
  status: Scalars['String'];
  uuid: Scalars['String'];
};

export type SetGallagherEmailFieldIdentifierForIntegrationInput = {
  emailFieldIdentifier: Scalars['String'];
  integrationUuid: Scalars['ID'];
};

export type SetGallagherEmailFieldIdentifierForIntegrationResponse = {
  __typename?: 'setGallagherEmailFieldIdentifierForIntegrationResponse';
  uuid: Scalars['ID'];
};

export type SetOpenpathCredentialProvisioningEnabledForIntegrationInput = {
  integrationUuid: Scalars['ID'];
  isEnabled: Scalars['Boolean'];
};

export type SetOpenpathCredentialProvisioningEnabledForIntegrationResponse = {
  __typename?: 'setOpenpathCredentialProvisioningEnabledForIntegrationResponse';
  uuid: Scalars['ID'];
};

export type SetOpenpathPresenceReportingEnabledForIntegrationInput = {
  integrationUuid: Scalars['ID'];
  isEnabled: Scalars['Boolean'];
};

export type SetOpenpathPresenceReportingEnabledForIntegrationResponse = {
  __typename?: 'setOpenpathPresenceReportingEnabledForIntegrationResponse';
  uuid: Scalars['ID'];
};

export type UpdateMeetingServiceRequestStatusResponse = UpdateMeetingServiceRequestStatusErrorResponse | UpdateMeetingServiceRequestStatusSuccessResponse;
